
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var $cd2a3739fedbc9f0$exports = {};
!function(n) {
    "use strict";
    function r(n, r, t) {
        return t.a = n, t.f = r, t;
    }
    function F2(n) {
        return r(2, n, function(r) {
            return function(t) {
                return n(r, t);
            };
        });
    }
    function F3(n) {
        return r(3, n, function(r) {
            return function(t) {
                return function(e) {
                    return n(r, t, e);
                };
            };
        });
    }
    function F4(n) {
        return r(4, n, function(r) {
            return function(t) {
                return function(e) {
                    return function(u) {
                        return n(r, t, e, u);
                    };
                };
            };
        });
    }
    function F5(n) {
        return r(5, n, function(r) {
            return function(t) {
                return function(e) {
                    return function(u) {
                        return function(a) {
                            return n(r, t, e, u, a);
                        };
                    };
                };
            };
        });
    }
    function F6(n) {
        return r(6, n, function(r) {
            return function(t) {
                return function(e) {
                    return function(u) {
                        return function(a) {
                            return function(c) {
                                return n(r, t, e, u, a, c);
                            };
                        };
                    };
                };
            };
        });
    }
    function F7(n) {
        return r(7, n, function(r) {
            return function(t) {
                return function(e) {
                    return function(u) {
                        return function(a) {
                            return function(c) {
                                return function(i) {
                                    return n(r, t, e, u, a, c, i);
                                };
                            };
                        };
                    };
                };
            };
        });
    }
    function A2(n, r, t) {
        return 2 === n.a ? n.f(r, t) : n(r)(t);
    }
    function A3(n, r, t, e) {
        return 3 === n.a ? n.f(r, t, e) : n(r)(t)(e);
    }
    function A4(n, r, t, e, u) {
        return 4 === n.a ? n.f(r, t, e, u) : n(r)(t)(e)(u);
    }
    function A5(n, r, t, e, u, a) {
        return 5 === n.a ? n.f(r, t, e, u, a) : n(r)(t)(e)(u)(a);
    }
    function A6(n, r, t, e, u, a, c) {
        return 6 === n.a ? n.f(r, t, e, u, a, c) : n(r)(t)(e)(u)(a)(c);
    }
    function A7(n, r, t, e, u, a, c, i) {
        return 7 === n.a ? n.f(r, t, e, u, a, c, i) : n(r)(t)(e)(u)(a)(c)(i);
    }
    function t(n, r) {
        for(var t, u = [], a = e(n, r, 0, u); a && (t = u.pop()); a = e(t.a, t.b, 0, u));
        return a;
    }
    function e(n, r, t, u) {
        if (t > 100) return u.push(o(n, r)), !0;
        if (n === r) return !0;
        if ("object" != typeof n || null === n || null === r) return "function" == typeof n && x(5), !1;
        for(var a in 0 > n.$ && (n = Sr(n), r = Sr(r)), n)if (!e(n[a], r[a], t + 1, u)) return !1;
        return !0;
    }
    var u = F2(t), a = F2(function(n, r) {
        return !t(n, r);
    });
    function c(n, r, t) {
        if ("object" != typeof n) return n === r ? 0 : r > n ? -1 : 1;
        if (void 0 === n.$) return (t = c(n.a, r.a)) || (t = c(n.b, r.b)) ? t : c(n.c, r.c);
        for(; n.b && r.b && !(t = c(n.a, r.a)); n = n.b, r = r.b);
        return t || (n.b ? 1 : r.b ? -1 : 0);
    }
    var i = F2(function(n, r) {
        var t = c(n, r);
        return 0 > t ? Cr : t ? Er : jr;
    });
    function o(n, r) {
        return {
            a: n,
            b: r
        };
    }
    function f(n, r, t) {
        return {
            a: n,
            b: r,
            c: t
        };
    }
    function s(n) {
        return n;
    }
    function b(n, r) {
        var t = {};
        for(var e in n)t[e] = n[e];
        for(var e in r)t[e] = r[e];
        return t;
    }
    function v(n, r) {
        if ("string" == typeof n) return n + r;
        if (!n.b) return r;
        var t = l(n.a, r);
        n = n.b;
        for(var e = t; n.b; n = n.b)e = e.b = l(n.a, r);
        return t;
    }
    var d = {
        $: 0
    };
    function l(n, r) {
        return {
            $: 1,
            a: n,
            b: r
        };
    }
    var $ = F2(l);
    function h(n) {
        for(var r = d, t = n.length; t--;)r = l(n[t], r);
        return r;
    }
    function g(n) {
        for(var r = []; n.b; n = n.b)r.push(n.a);
        return r;
    }
    var p = F3(function(n, r, t) {
        for(var e = []; r.b && t.b; r = r.b, t = t.b)e.push(A2(n, r.a, t.a));
        return h(e);
    }), m = F2(function(n, r) {
        return h(g(r).sort(function(r, t) {
            return c(n(r), n(t));
        }));
    }), w = F3(function(n, r, t) {
        for(var e = Array(n), u = 0; n > u; u++)e[u] = t(r + u);
        return e;
    }), y = F2(function(n, r) {
        for(var t = Array(n), e = 0; n > e && r.b; e++)t[e] = r.a, r = r.b;
        return t.length = e, o(t, r);
    }), k = F3(function(n, r, t) {
        for(var e = t.length - 1; e >= 0; e--)r = A2(n, t[e], r);
        return r;
    });
    function x(n) {
        throw Error("https://github.com/elm/core/blob/1.0.0/hints/" + n + ".md");
    }
    var I = F2(Math.pow), A = F2(function(n, r) {
        var t = r % n;
        return 0 === n ? x(11) : t > 0 && 0 > n || 0 > t && n > 0 ? t + n : t;
    }), j = Math.ceil, E = Math.floor, C = Math.log, Y = F2(function(n, r) {
        return n + r;
    }), _ = F3(function(n, r, t) {
        for(var e = t.length, u = 0; e > u;){
            var a = t[u], c = t.charCodeAt(u);
            u++, 55296 > c || c > 56319 || (a += t[u], u++), r = A2(n, s(a), r);
        }
        return r;
    }), S = F3(function(n, r, t) {
        for(var e = t.length; e--;){
            var u = t[e], a = t.charCodeAt(e);
            56320 > a || a > 57343 || (u = t[--e] + u), r = A2(n, s(u), r);
        }
        return r;
    }), q = F2(function(n, r) {
        return r.join(n);
    }), T = F3(function(n, r, t) {
        return t.slice(n, r);
    }), N = F2(function(n, r) {
        return r.indexOf(n) > -1;
    }), O = F2(function(n, r) {
        return 0 === r.indexOf(n);
    }), z = F2(function(n, r) {
        return r.length >= n.length && r.lastIndexOf(n) === r.length - n.length;
    });
    function M(n) {
        return {
            $: 2,
            b: n
        };
    }
    M(function(n) {
        return "number" != typeof n ? X("an INT", n) : n > -2147483647 && 2147483647 > n && (0 | n) === n ? Lr(n) : !isFinite(n) || n % 1 ? X("an INT", n) : Lr(n);
    });
    var Z = M(function(n) {
        return "boolean" == typeof n ? Lr(n) : X("a BOOL", n);
    }), L = (M(function(n) {
        return "number" == typeof n ? Lr(n) : X("a FLOAT", n);
    }), M(function(n) {
        return Lr(n);
    })), R = M(function(n) {
        return "string" == typeof n ? Lr(n) : n instanceof String ? Lr(n + "") : X("a STRING", n);
    }), B = F2(function(n, r) {
        return {
            $: 6,
            d: n,
            b: r
        };
    });
    function D(n, r) {
        return {
            $: 9,
            f: n,
            g: r
        };
    }
    var F = F2(function(n, r) {
        return D(n, [
            r
        ]);
    }), U = F3(function(n, r, t) {
        return D(n, [
            r,
            t
        ]);
    }), P = F5(function(n, r, t, e, u) {
        return D(n, [
            r,
            t,
            e,
            u
        ]);
    }), Q = F2(function(n, r) {
        return W(n, r);
    });
    function W(n, r) {
        switch(n.$){
            case 2:
                return n.b(r);
            case 5:
                return null === r ? Lr(n.c) : X("null", r);
            case 3:
                return G(r) ? H(n.b, r, h) : X("a LIST", r);
            case 4:
                return G(r) ? H(n.b, r, V) : X("an ARRAY", r);
            case 6:
                var t = n.d;
                if ("object" != typeof r || null === r || !(t in r)) return X("an OBJECT with a field named `" + t + "`", r);
                var e = W(n.b, r[t]);
                return It(e) ? e : Or(A2(Mr, t, e.a));
            case 7:
                var u = n.e;
                return G(r) ? r.length > u ? (e = W(n.b, r[u]), It(e) ? e : Or(A2(Zr, u, e.a))) : X("a LONGER array. Need index " + u + " but only see " + r.length + " entries", r) : X("an ARRAY", r);
            case 8:
                if ("object" != typeof r || null === r || G(r)) return X("an OBJECT", r);
                var a = d;
                for(var c in r)if (r.hasOwnProperty(c)) {
                    if (e = W(n.b, r[c]), !It(e)) return Or(A2(Mr, c, e.a));
                    a = l(o(c, e.a), a);
                }
                return Lr(tt(a));
            case 9:
                for(var i = n.f, f = n.g, s = 0; f.length > s; s++){
                    if (e = W(f[s], r), !It(e)) return e;
                    i = i(e.a);
                }
                return Lr(i);
            case 10:
                return e = W(n.b, r), It(e) ? W(n.h(e.a), r) : e;
            case 11:
                for(var b = d, v = n.g; v.b; v = v.b){
                    if (e = W(v.a, r), It(e)) return e;
                    b = l(e.a, b);
                }
                return Or(Rr(tt(b)));
            case 1:
                return Or(A2(zr, n.a, r));
            case 0:
                return Lr(n.a);
        }
    }
    function H(n, r, t) {
        for(var e = r.length, u = Array(e), a = 0; e > a; a++){
            var c = W(n, r[a]);
            if (!It(c)) return Or(A2(Zr, a, c.a));
            u[a] = c.a;
        }
        return Lr(t(u));
    }
    function G(n) {
        return Array.isArray(n) || "undefined" != typeof FileList && n instanceof FileList;
    }
    function V(n) {
        return A2(xt, n.length, function(r) {
            return n[r];
        });
    }
    function X(n, r) {
        return Or(A2(zr, "Expecting " + n, r));
    }
    function J(n, r) {
        if (n === r) return !0;
        if (n.$ !== r.$) return !1;
        switch(n.$){
            case 0:
            case 1:
                return n.a === r.a;
            case 2:
                return n.b === r.b;
            case 5:
                return n.c === r.c;
            case 3:
            case 4:
            case 8:
                return J(n.b, r.b);
            case 6:
                return n.d === r.d && J(n.b, r.b);
            case 7:
                return n.e === r.e && J(n.b, r.b);
            case 9:
                return n.f === r.f && K(n.g, r.g);
            case 10:
                return n.h === r.h && J(n.b, r.b);
            case 11:
                return K(n.g, r.g);
        }
    }
    function K(n, r) {
        var t = n.length;
        if (t !== r.length) return !1;
        for(var e = 0; t > e; e++)if (!J(n[e], r[e])) return !1;
        return !0;
    }
    function nn(n) {
        return n;
    }
    function rn(n) {
        return n;
    }
    function tn(n) {
        return {
            $: 0,
            a: n
        };
    }
    function en(n) {
        return {
            $: 2,
            b: n,
            c: null
        };
    }
    var un = F2(function(n, r) {
        return {
            $: 3,
            b: n,
            d: r
        };
    }), an = 0;
    function cn(n) {
        var r = {
            $: 0,
            e: an++,
            f: n,
            g: null,
            h: []
        };
        return dn(r), r;
    }
    function on(n) {
        return en(function(r) {
            r(tn(cn(n)));
        });
    }
    function fn(n, r) {
        n.h.push(r), dn(n);
    }
    var sn = F2(function(n, r) {
        return en(function(t) {
            fn(n, r), t(tn(0));
        });
    }), bn = !1, vn = [];
    function dn(n) {
        if (vn.push(n), !bn) {
            for(bn = !0; n = vn.shift();)ln(n);
            bn = !1;
        }
    }
    function ln(n) {
        for(; n.f;){
            var r = n.f.$;
            if (0 === r || 1 === r) {
                for(; n.g && n.g.$ !== r;)n.g = n.g.i;
                if (!n.g) return;
                n.f = n.g.b(n.f.a), n.g = n.g.i;
            } else {
                if (2 === r) return void (n.f.c = n.f.b(function(r) {
                    n.f = r, dn(n);
                }));
                if (5 === r) {
                    if (0 === n.h.length) return;
                    n.f = n.f.b(n.h.shift());
                } else n.g = {
                    $: 3 === r ? 0 : 1,
                    b: n.f.b,
                    i: n.g
                }, n.f = n.f.d;
            }
        }
    }
    function $n(n) {
        return en(function(r) {
            var t = setTimeout(function() {
                r(tn(0));
            }, n);
            return function() {
                clearTimeout(t);
            };
        });
    }
    var hn = {};
    function gn(n, r, t, e, u) {
        return {
            b: n,
            c: r,
            d: t,
            e: e,
            f: u
        };
    }
    function pn(n, r) {
        var t = {
            g: r,
            h: void 0
        }, e = n.c, u = n.d, a = n.e, c = n.f;
        function i(n) {
            return A2(un, i, {
                $: 5,
                b: function(r) {
                    var i = r.a;
                    return 0 === r.$ ? A3(u, t, i, n) : a && c ? A4(e, t, i.i, i.j, n) : A3(e, t, a ? i.i : i.j, n);
                }
            });
        }
        return t.h = cn(A2(un, i, n.b));
    }
    var mn = F2(function(n, r) {
        return en(function(t) {
            n.g(r), t(tn(0));
        });
    }), wn = F2(function(n, r) {
        return A2(sn, n.h, {
            $: 0,
            a: r
        });
    });
    function yn(n) {
        return function(r) {
            return {
                $: 1,
                k: n,
                l: r
            };
        };
    }
    function kn(n) {
        return {
            $: 2,
            m: n
        };
    }
    function xn(n, r, t) {
        var e = {};
        for(var u in In(!0, r, e, null), In(!1, t, e, null), n)fn(n[u], {
            $: "fx",
            a: e[u] || {
                i: d,
                j: d
            }
        });
    }
    function In(n, r, t, e) {
        switch(r.$){
            case 1:
                var u = r.k, a = function(n, r, t, e) {
                    function u(n) {
                        for(var r = t; r; r = r.q)n = r.p(n);
                        return n;
                    }
                    return A2(n ? hn[r].e : hn[r].f, u, e);
                }(n, u, e, r.l);
                return void (t[u] = function(n, r, t) {
                    return t = t || {
                        i: d,
                        j: d
                    }, n ? t.i = l(r, t.i) : t.j = l(r, t.j), t;
                }(n, a, t[u]));
            case 2:
                for(var c = r.m; c.b; c = c.b)In(n, c.a, t, e);
                return;
            case 3:
                return void In(n, r.o, t, {
                    p: r.n,
                    q: e
                });
        }
    }
    function An(n) {
        hn[n] && x(3);
    }
    function jn(n, r) {
        return An(n), hn[n] = {
            e: En,
            r: r,
            a: Cn
        }, yn(n);
    }
    var En = F2(function(n, r) {
        return r;
    });
    function Cn(n) {
        var r = [], t = hn[n].r, e = $n(0);
        return hn[n].b = e, hn[n].c = F3(function(n, u) {
            for(; u.b; u = u.b)for(var a = r, c = rn(t(u.a)), i = 0; a.length > i; i++)a[i](c);
            return e;
        }), {
            subscribe: function(n) {
                r.push(n);
            },
            unsubscribe: function(n) {
                var t = (r = r.slice()).indexOf(n);
                0 > t || r.splice(t, 1);
            }
        };
    }
    function Yn(n, r) {
        return An(n), hn[n] = {
            f: _n,
            r: r,
            a: Sn
        }, yn(n);
    }
    var _n = F2(function(n, r) {
        return function(t) {
            return n(r(t));
        };
    });
    function Sn(n, r) {
        var t = d, e = hn[n].r, u = tn(null);
        return hn[n].b = u, hn[n].c = F3(function(n, r) {
            return t = r, u;
        }), {
            send: function(n) {
                var u = A2(Q, e, n);
                It(u) || x(4);
                for(var a = u.a, c = t; c.b; c = c.b)r(c.a(a));
            }
        };
    }
    var qn = "undefined" != typeof document ? document : {};
    function Tn(n, r) {
        n.appendChild(r);
    }
    function Nn(n) {
        return {
            $: 0,
            a: n
        };
    }
    var On = F2(function(n, r) {
        return F2(function(t, e) {
            for(var u = [], a = 0; e.b; e = e.b){
                var c = e.a;
                a += c.b || 0, u.push(c);
            }
            return a += u.length, {
                $: 1,
                c: r,
                d: Dn(t),
                e: u,
                f: n,
                b: a
            };
        });
    })(void 0);
    F2(function(n, r) {
        return F2(function(t, e) {
            for(var u = [], a = 0; e.b; e = e.b){
                var c = e.a;
                a += c.b.b || 0, u.push(c);
            }
            return a += u.length, {
                $: 2,
                c: r,
                d: Dn(t),
                e: u,
                f: n,
                b: a
            };
        });
    })(void 0);
    var zn, Mn = F2(function(n, r) {
        return {
            $: "a0",
            n: n,
            o: r
        };
    }), Zn = F2(function(n, r) {
        return {
            $: "a1",
            n: n,
            o: r
        };
    }), Ln = F2(function(n, r) {
        return {
            $: "a2",
            n: n,
            o: r
        };
    }), Rn = F2(function(n, r) {
        return {
            $: "a3",
            n: n,
            o: r
        };
    });
    function Bn(n) {
        return /^\s*(javascript:|data:text\/html)/i.test(n) ? "" : n;
    }
    function Dn(n) {
        for(var r = {}; n.b; n = n.b){
            var t = n.a, e = t.$, u = t.n, a = t.o;
            if ("a2" !== e) {
                var c = r[e] || (r[e] = {});
                "a3" === e && "class" === u ? Fn(c, u, a) : c[u] = a;
            } else "className" === u ? Fn(r, u, rn(a)) : r[u] = rn(a);
        }
        return r;
    }
    function Fn(n, r, t) {
        var e = n[r];
        n[r] = e ? e + " " + t : t;
    }
    function Un(n, r) {
        var t = n.$;
        if (5 === t) return Un(n.k || (n.k = n.m()), r);
        if (0 === t) return qn.createTextNode(n.a);
        if (4 === t) {
            for(var e = n.k, u = n.j; 4 === e.$;)"object" != typeof u ? u = [
                u,
                e.j
            ] : u.push(e.j), e = e.k;
            var a = {
                j: u,
                p: r
            };
            return (c = Un(e, a)).elm_event_node_ref = a, c;
        }
        if (3 === t) return Pn(c = n.h(n.g), r, n.d), c;
        var c = n.f ? qn.createElementNS(n.f, n.c) : qn.createElement(n.c);
        Pn(c, r, n.d);
        for(var i = n.e, o = 0; i.length > o; o++)Tn(c, Un(1 === t ? i[o] : i[o].b, r));
        return c;
    }
    function Pn(n, r, t) {
        for(var e in t){
            var u = t[e];
            "a1" === e ? Qn(n, u) : "a0" === e ? Gn(n, r, u) : "a3" === e ? Wn(n, u) : "a4" === e ? Hn(n, u) : ("value" !== e && "checked" !== e || n[e] !== u) && (n[e] = u);
        }
    }
    function Qn(n, r) {
        var t = n.style;
        for(var e in r)t[e] = r[e];
    }
    function Wn(n, r) {
        for(var t in r){
            var e = r[t];
            void 0 !== e ? n.setAttribute(t, e) : n.removeAttribute(t);
        }
    }
    function Hn(n, r) {
        for(var t in r){
            var e = r[t], u = e.f, a = e.o;
            void 0 !== a ? n.setAttributeNS(u, t, a) : n.removeAttributeNS(u, t);
        }
    }
    function Gn(n, r, t) {
        var e = n.elmFs || (n.elmFs = {});
        for(var u in t){
            var a = t[u], c = e[u];
            if (a) {
                if (c) {
                    if (c.q.$ === a.$) {
                        c.q = a;
                        continue;
                    }
                    n.removeEventListener(u, c);
                }
                c = Vn(r, a), n.addEventListener(u, c, zn && {
                    passive: 2 > Ct(a)
                }), e[u] = c;
            } else n.removeEventListener(u, c), e[u] = void 0;
        }
    }
    try {
        window.addEventListener("t", null, Object.defineProperty({}, "passive", {
            get: function() {
                zn = !0;
            }
        }));
    } catch (n) {}
    function Vn(n, r) {
        function t(r) {
            var e = t.q, u = W(e.a, r);
            if (It(u)) {
                for(var a, c = Ct(e), i = u.a, o = c ? 3 > c ? i.a : i.z : i, f = 1 == c ? i.b : 3 == c && i.aT, s = (f && r.stopPropagation(), (2 == c ? i.b : 3 == c && i.aP) && r.preventDefault(), n); a = s.j;){
                    if ("function" == typeof a) o = a(o);
                    else for(var b = a.length; b--;)o = a[b](o);
                    s = s.p;
                }
                s(o, f);
            }
        }
        return t.q = r, t;
    }
    function Xn(n, r) {
        return n.$ == r.$ && J(n.a, r.a);
    }
    function Jn(n, r, t, e) {
        var u = {
            $: r,
            r: t,
            s: e,
            t: void 0,
            u: void 0
        };
        return n.push(u), u;
    }
    function Kn(n, r, t, e) {
        if (n !== r) {
            var u = n.$, a = r.$;
            if (u !== a) {
                if (1 !== u || 2 !== a) return void Jn(t, 0, e, r);
                r = function(n) {
                    for(var r = n.e, t = r.length, e = Array(t), u = 0; t > u; u++)e[u] = r[u].b;
                    return {
                        $: 1,
                        c: n.c,
                        d: n.d,
                        e: e,
                        f: n.f,
                        b: n.b
                    };
                }(r), a = 1;
            }
            switch(a){
                case 5:
                    for(var c = n.l, i = r.l, o = c.length, f = o === i.length; f && o--;)f = c[o] === i[o];
                    if (f) return void (r.k = n.k);
                    r.k = r.m();
                    var s = [];
                    return Kn(n.k, r.k, s, 0), void (s.length > 0 && Jn(t, 1, e, s));
                case 4:
                    for(var b = n.j, v = r.j, d = !1, l = n.k; 4 === l.$;)d = !0, "object" != typeof b ? b = [
                        b,
                        l.j
                    ] : b.push(l.j), l = l.k;
                    for(var $ = r.k; 4 === $.$;)d = !0, "object" != typeof v ? v = [
                        v,
                        $.j
                    ] : v.push($.j), $ = $.k;
                    return d && b.length !== v.length ? void Jn(t, 0, e, r) : ((d ? function(n, r) {
                        for(var t = 0; n.length > t; t++)if (n[t] !== r[t]) return !1;
                        return !0;
                    }(b, v) : b === v) || Jn(t, 2, e, v), void Kn(l, $, t, e + 1));
                case 0:
                    return void (n.a !== r.a && Jn(t, 3, e, r.a));
                case 1:
                    return void nr(n, r, t, e, tr);
                case 2:
                    return void nr(n, r, t, e, er);
                case 3:
                    if (n.h !== r.h) return void Jn(t, 0, e, r);
                    var h = rr(n.d, r.d);
                    h && Jn(t, 4, e, h);
                    var g = r.i(n.g, r.g);
                    return void (g && Jn(t, 5, e, g));
            }
        }
    }
    function nr(n, r, t, e, u) {
        if (n.c === r.c && n.f === r.f) {
            var a = rr(n.d, r.d);
            a && Jn(t, 4, e, a), u(n, r, t, e);
        } else Jn(t, 0, e, r);
    }
    function rr(n, r, t) {
        var e;
        for(var u in n)if ("a1" !== u && "a0" !== u && "a3" !== u && "a4" !== u) {
            if (u in r) {
                var a = n[u], c = r[u];
                a === c && "value" !== u && "checked" !== u || "a0" === t && Xn(a, c) || ((e = e || {})[u] = c);
            } else (e = e || {})[u] = t ? "a1" === t ? "" : "a0" === t || "a3" === t ? void 0 : {
                f: n[u].f,
                o: void 0
            } : "string" == typeof n[u] ? "" : null;
        } else {
            var i = rr(n[u], r[u] || {}, u);
            i && ((e = e || {})[u] = i);
        }
        for(var o in r)o in n || ((e = e || {})[o] = r[o]);
        return e;
    }
    function tr(n, r, t, e) {
        var u = n.e, a = r.e, c = u.length, i = a.length;
        c > i ? Jn(t, 6, e, {
            v: i,
            i: c - i
        }) : i > c && Jn(t, 7, e, {
            v: c,
            e: a
        });
        for(var o = i > c ? c : i, f = 0; o > f; f++){
            var s = u[f];
            Kn(s, a[f], t, ++e), e += s.b || 0;
        }
    }
    function er(n, r, t, e) {
        for(var u = [], a = {}, c = [], i = n.e, o = r.e, f = i.length, s = o.length, b = 0, v = 0, d = e; f > b && s > v;){
            var l = (j = i[b]).a, $ = (E = o[v]).a, h = j.b, g = E.b, p = void 0, m = void 0;
            if (l !== $) {
                var w = i[b + 1], y = o[v + 1];
                if (w) {
                    var k = w.a, x = w.b;
                    m = $ === k;
                }
                if (y) {
                    var I = y.a, A = y.b;
                    p = l === I;
                }
                if (p && m) Kn(h, A, u, ++d), ar(a, u, l, g, v, c), d += h.b || 0, cr(a, u, l, x, ++d), d += x.b || 0, b += 2, v += 2;
                else if (p) d++, ar(a, u, $, g, v, c), Kn(h, A, u, d), d += h.b || 0, b += 1, v += 2;
                else if (m) cr(a, u, l, h, ++d), d += h.b || 0, Kn(x, g, u, ++d), d += x.b || 0, b += 2, v += 1;
                else {
                    if (!w || k !== I) break;
                    cr(a, u, l, h, ++d), ar(a, u, $, g, v, c), d += h.b || 0, Kn(x, A, u, ++d), d += x.b || 0, b += 2, v += 2;
                }
            } else Kn(h, g, u, ++d), d += h.b || 0, b++, v++;
        }
        for(; f > b;){
            var j;
            d++, cr(a, u, (j = i[b]).a, h = j.b, d), d += h.b || 0, b++;
        }
        for(; s > v;){
            var E, C = C || [];
            ar(a, u, (E = o[v]).a, E.b, void 0, C), v++;
        }
        (u.length > 0 || c.length > 0 || C) && Jn(t, 8, e, {
            w: u,
            x: c,
            y: C
        });
    }
    var ur = "_elmW6BL";
    function ar(n, r, t, e, u, a) {
        var c = n[t];
        if (!c) return a.push({
            r: u,
            A: c = {
                c: 0,
                z: e,
                r: u,
                s: void 0
            }
        }), void (n[t] = c);
        if (1 === c.c) {
            a.push({
                r: u,
                A: c
            }), c.c = 2;
            var i = [];
            return Kn(c.z, e, i, c.r), c.r = u, void (c.s.s = {
                w: i,
                A: c
            });
        }
        ar(n, r, t + ur, e, u, a);
    }
    function cr(n, r, t, e, u) {
        var a = n[t];
        if (a) {
            if (0 === a.c) {
                a.c = 2;
                var c = [];
                return Kn(e, a.z, c, u), void Jn(r, 9, u, {
                    w: c,
                    A: a
                });
            }
            cr(n, r, t + ur, e, u);
        } else {
            var i = Jn(r, 9, u, void 0);
            n[t] = {
                c: 1,
                z: e,
                r: u,
                s: i
            };
        }
    }
    function ir(n, r, t, e) {
        or(n, r, t, 0, 0, r.b, e);
    }
    function or(n, r, t, e, u, a, c) {
        for(var i = t[e], o = i.r; o === u;){
            var f = i.$;
            if (1 === f) ir(n, r.k, i.s, c);
            else if (8 === f) i.t = n, i.u = c, (s = i.s.w).length > 0 && or(n, r, s, 0, u, a, c);
            else if (9 === f) {
                i.t = n, i.u = c;
                var s, b = i.s;
                b && (b.A.s = n, (s = b.w).length > 0 && or(n, r, s, 0, u, a, c));
            } else i.t = n, i.u = c;
            if (!(i = t[++e]) || (o = i.r) > a) return e;
        }
        var v = r.$;
        if (4 === v) {
            for(var d = r.k; 4 === d.$;)d = d.k;
            return or(n, d, t, e, u + 1, a, n.elm_event_node_ref);
        }
        for(var l = r.e, $ = n.childNodes, h = 0; l.length > h; h++){
            u++;
            var g = 1 === v ? l[h] : l[h].b, p = u + (g.b || 0);
            if (!(u > o || o > p || (i = t[e = or($[h], g, t, e, u, p, c)]) && (o = i.r) <= a)) return e;
            u = p;
        }
        return e;
    }
    function fr(n, r) {
        for(var t = 0; r.length > t; t++){
            var e = r[t], u = e.t, a = sr(u, e);
            u === n && (n = a);
        }
        return n;
    }
    function sr(n, r) {
        switch(r.$){
            case 0:
                return function(n, r, t) {
                    var e = n.parentNode, u = Un(r, t);
                    return u.elm_event_node_ref || (u.elm_event_node_ref = n.elm_event_node_ref), e && u !== n && e.replaceChild(u, n), u;
                }(n, r.s, r.u);
            case 4:
                return Pn(n, r.u, r.s), n;
            case 3:
                return n.replaceData(0, n.length, r.s), n;
            case 1:
                return fr(n, r.s);
            case 2:
                return n.elm_event_node_ref ? n.elm_event_node_ref.j = r.s : n.elm_event_node_ref = {
                    j: r.s,
                    p: r.u
                }, n;
            case 6:
                for(var t = r.s, e = 0; t.i > e; e++)n.removeChild(n.childNodes[t.v]);
                return n;
            case 7:
                for(var u = (t = r.s).e, a = n.childNodes[e = t.v]; u.length > e; e++)n.insertBefore(Un(u[e], r.u), a);
                return n;
            case 9:
                if (!(t = r.s)) return n.parentNode.removeChild(n), n;
                var c = t.A;
                return void 0 !== c.r && n.parentNode.removeChild(n), c.s = fr(n, t.w), n;
            case 8:
                return function(n, r) {
                    var t = r.s, e = function(n, r) {
                        if (n) {
                            for(var t = qn.createDocumentFragment(), e = 0; n.length > e; e++){
                                var u = n[e].A;
                                Tn(t, 2 === u.c ? u.s : Un(u.z, r.u));
                            }
                            return t;
                        }
                    }(t.y, r);
                    n = fr(n, t.w);
                    for(var u = t.x, a = 0; u.length > a; a++){
                        var c = u[a], i = c.A, o = 2 === i.c ? i.s : Un(i.z, r.u);
                        n.insertBefore(o, n.childNodes[c.r]);
                    }
                    return e && Tn(n, e), n;
                }(n, r);
            case 5:
                return r.s(n);
            default:
                x(10);
        }
    }
    function br(n) {
        if (3 === n.nodeType) return Nn(n.textContent);
        if (1 !== n.nodeType) return Nn("");
        for(var r = d, t = n.attributes, e = t.length; e--;){
            var u = t[e];
            r = l(A2(Rn, u.name, u.value), r);
        }
        var a = n.tagName.toLowerCase(), c = d, i = n.childNodes;
        for(e = i.length; e--;)c = l(br(i[e]), c);
        return A3(On, a, r, c);
    }
    var vr = F4(function(n, r, t, e) {
        return function(n, r, t, e, u, a) {
            var c = A2(Q, n, r ? r.flags : void 0);
            It(c) || x(2);
            var i = {}, o = (c = t(c.a)).a, f = a(b, o), s = function(n, r) {
                var t;
                for(var e in hn){
                    var u = hn[e];
                    u.a && ((t = t || {})[e] = u.a(e, r)), n[e] = pn(u, r);
                }
                return t;
            }(i, b);
            function b(n, r) {
                f(o = (c = A2(e, n, o)).a, r), xn(i, c.b, u(o));
            }
            return xn(i, c.b, u(o)), s ? {
                ports: s
            } : {};
        }(r, e, n.cb, n.cD, n.cz, function(r, t) {
            var u = n.cE, a = e.node, c = br(a);
            return function(n, r) {
                r(n);
                var t = 0;
                function e() {
                    t = 1 === t ? 0 : (dr(e), r(n), 1);
                }
                return function(u, a) {
                    n = u, a ? (r(n), 2 === t && (t = 1)) : (0 === t && dr(e), t = 2);
                };
            }(t, function(n) {
                var t = u(n), e = function(n, r) {
                    var t = [];
                    return Kn(n, r, t, 0), t;
                }(c, t);
                a = function(n, r, t, e) {
                    return 0 === t.length ? n : (ir(n, r, t, e), fr(n, t));
                }(a, c, e, r), c = t;
            });
        });
    }), dr = ("undefined" != typeof cancelAnimationFrame && cancelAnimationFrame, "undefined" != typeof requestAnimationFrame ? requestAnimationFrame : function(n) {
        return setTimeout(n, 1e3 / 60);
    });
    "undefined" != typeof document && document, "undefined" != typeof window && window;
    var lr = F3(function(n, r, t) {
        return en(function(e) {
            function u(n) {
                e(r(t.bc.a(n)));
            }
            var a = new XMLHttpRequest;
            a.addEventListener("error", function() {
                u(ce);
            }), a.addEventListener("timeout", function() {
                u(fe);
            }), a.addEventListener("load", function() {
                u(function(n, r) {
                    return A2(r.status >= 200 && 300 > r.status ? ae : ee, function(n) {
                        return {
                            bQ: n.responseURL,
                            cw: n.status,
                            cx: n.statusText,
                            bg: $r(n.getAllResponseHeaders())
                        };
                    }(r), n(r.response));
                }(t.bc.b, a));
            }), ve(t.bM) && function(n, r, t) {
                r.upload.addEventListener("progress", function(e) {
                    r.c || cn(A2(de, n, o(t, oe({
                        cv: e.loaded,
                        bI: e.total
                    }))));
                }), r.addEventListener("progress", function(e) {
                    r.c || cn(A2(de, n, o(t, ie({
                        cs: e.loaded,
                        bI: e.lengthComputable ? Br(e.total) : Dr
                    }))));
                });
            }(n, a, t.bM.a);
            try {
                a.open(t.cj, t.bQ, !0);
            } catch (n) {
                return u(ue(t.bQ));
            }
            return function(n, r) {
                for(var t = r.bg; t.b; t = t.b)n.setRequestHeader(t.a.a, t.a.b);
                n.timeout = r.cB.a || 0, n.responseType = r.bc.d, n.withCredentials = r.bW;
            }(a, t), t.bY.a && a.setRequestHeader("Content-Type", t.bY.a), a.send(t.bY.b), function() {
                a.c = !0, a.abort();
            };
        });
    });
    function $r(n) {
        if (!n) return be;
        for(var r = be, t = n.split("\r\n"), e = t.length; e--;){
            var u = t[e], a = u.indexOf(": ");
            if (a > 0) {
                var c = u.substring(0, a), i = u.substring(a + 2);
                r = A3(Ee, c, function(n) {
                    return Br(ve(n) ? i + ", " + n.a : i);
                }, r);
            }
        }
        return r;
    }
    var hr = F3(function(n, r, t) {
        return {
            $: 0,
            d: n,
            b: r,
            a: t
        };
    }), gr = F2(function(n, r) {
        return {
            $: 0,
            d: r.d,
            b: r.b,
            a: function(t) {
                return n(r.a(t));
            }
        };
    }), pr = F5(function(n, r, t, e, u) {
        for(var a = n.length, c = u.length >= r + a, i = 0; c && a > i;){
            var o = u.charCodeAt(r);
            c = n[i++] === u[r++] && (10 === o ? (t++, e = 1) : (e++, 55296 == (63488 & o) ? n[i++] === u[r++] : 1));
        }
        return f(c ? r : -1, t, e);
    }), mr = F3(function(n, r, t) {
        return t.length > r ? 55296 == (63488 & t.charCodeAt(r)) ? n(t.substr(r, 2)) ? r + 2 : -1 : n(t[r]) ? "\n" === t[r] ? -2 : r + 1 : -1 : -1;
    }), wr = F5(function(n, r, t, e, u) {
        for(var a = u.indexOf(n, r), c = 0 > a ? u.length : a + n.length; c > r;){
            var i = u.charCodeAt(r++);
            10 === i ? (e = 1, t++) : (e++, 55296 == (63488 & i) && r++);
        }
        return f(a, t, e);
    }), yr = F2(function(n, r) {
        var t = "g";
        n.ck && (t += "m"), n.bZ && (t += "i");
        try {
            return Br(RegExp(r, t));
        } catch (n) {
            return Dr;
        }
    }), kr = F2(function(n, r) {
        return null !== r.match(n);
    }), xr = F3(function(n, r, t) {
        for(var e, u = [], a = 0, c = t, i = r.lastIndex, o = -1; a++ < n && (e = r.exec(c)) && o != r.lastIndex;){
            for(var f = e.length - 1, s = Array(f); f > 0;){
                var b = e[f];
                s[--f] = b ? Br(b) : Dr;
            }
            u.push(A4(Yf, e[0], e.index, a, h(s))), o = r.lastIndex;
        }
        return r.lastIndex = i, h(u);
    }), Ir = F4(function(n, r, t, e) {
        var u = 0;
        return e.replace(r, function(r) {
            if (u++ >= n) return r;
            for(var e = arguments.length - 3, a = Array(e); e > 0;){
                var c = arguments[e];
                a[--e] = c ? Br(c) : Dr;
            }
            return t(A4(Yf, r, arguments[arguments.length - 2], u, h(a)));
        });
    }), Ar = 1 / 0, jr = 1, Er = 2, Cr = 0, Yr = $, _r = F3(function(n, r, t) {
        for(;;){
            if (-2 === t.$) return r;
            var e = t.d, u = n, a = A3(n, t.b, t.c, A3(_r, n, r, t.e));
            n = u, r = a, t = e;
        }
    }), Sr = function(n) {
        return A3(_r, F3(function(n, r, t) {
            return A2(Yr, o(n, r), t);
        }), d, n);
    }, qr = k, Tr = F3(function(n, r, t) {
        var e = t.c, u = t.d, a = F2(function(r, t) {
            return A3(qr, r.$ ? n : a, t, r.a);
        });
        return A3(qr, a, A3(qr, n, r, u), e);
    }), Nr = function(n) {
        return A3(Tr, Yr, d, n);
    }, Or = function(n) {
        return {
            $: 1,
            a: n
        };
    }, zr = F2(function(n, r) {
        return {
            $: 3,
            a: n,
            b: r
        };
    }), Mr = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), Zr = F2(function(n, r) {
        return {
            $: 1,
            a: n,
            b: r
        };
    }), Lr = function(n) {
        return {
            $: 0,
            a: n
        };
    }, Rr = function(n) {
        return {
            $: 2,
            a: n
        };
    }, Br = function(n) {
        return {
            $: 0,
            a: n
        };
    }, Dr = {
        $: 1
    }, Fr = function(n) {
        return n + "";
    }, Ur = F2(function(n, r) {
        return A2(q, n, g(r));
    }), Pr = F3(function(n, r, t) {
        for(;;){
            if (!t.b) return r;
            var e = t.b, u = n, a = A2(n, t.a, r);
            n = u, r = a, t = e;
        }
    }), Qr = function(n) {
        return A3(Pr, F2(function(n, r) {
            return r + 1;
        }), 0, n);
    }, Wr = p, Hr = F3(function(n, r, t) {
        for(;;){
            if (c(n, r) >= 1) return t;
            var e = n, u = r - 1, a = A2(Yr, r, t);
            n = e, r = u, t = a;
        }
    }), Gr = F2(function(n, r) {
        return A3(Hr, n, r, d);
    }), Vr = F2(function(n, r) {
        return A3(Wr, n, A2(Gr, 0, Qr(r) - 1), r);
    }), Xr = function(n) {
        var r = n.charCodeAt(0);
        return 55296 > r || r > 56319 ? r : 1024 * (r - 55296) + n.charCodeAt(1) - 56320 + 65536;
    }, Jr = function(n) {
        var r = Xr(n);
        return r >= 97 && 122 >= r;
    }, Kr = function(n) {
        var r = Xr(n);
        return 90 >= r && r >= 65;
    }, nt = function(n) {
        return Jr(n) || Kr(n);
    }, rt = function(n) {
        var r = Xr(n);
        return 57 >= r && r >= 48;
    }, tt = function(n) {
        return A3(Pr, Yr, d, n);
    }, et = 32, ut = F4(function(n, r, t, e) {
        return {
            $: 0,
            a: n,
            b: r,
            c: t,
            d: e
        };
    }), at = [], ct = j, it = F2(function(n, r) {
        return C(r) / C(n);
    }), ot = ct(A2(it, 2, et)), ft = A4(ut, 0, ot, at, at), st = w, bt = function(n) {
        return {
            $: 1,
            a: n
        };
    }, vt = F2(function(n, r) {
        return n(r);
    }), dt = u, lt = E, $t = function(n) {
        return n.length;
    }, ht = F2(function(n, r) {
        return c(n, r) > 0 ? n : r;
    }), gt = function(n) {
        return {
            $: 0,
            a: n
        };
    }, pt = y, mt = F2(function(n, r) {
        for(;;){
            var t = A2(pt, et, n), e = t.b, u = A2(Yr, gt(t.a), r);
            if (!e.b) return tt(u);
            n = e, r = u;
        }
    }), wt = F2(function(n, r) {
        for(;;){
            var t = ct(r / et);
            if (1 === t) return A2(pt, et, n).a;
            n = A2(mt, n, d), r = t;
        }
    }), yt = F2(function(n, r) {
        if (r.m) {
            var t = r.m * et, e = lt(A2(it, et, t - 1)), u = n ? tt(r.q) : r.q, a = A2(wt, u, r.m);
            return A4(ut, $t(r.o) + t, A2(ht, 5, e * ot), a, r.o);
        }
        return A4(ut, $t(r.o), ot, at, r.o);
    }), kt = F5(function(n, r, t, e, u) {
        for(;;){
            if (0 > r) return A2(yt, !1, {
                q: e,
                m: t / et | 0,
                o: u
            });
            var a = bt(A3(st, et, r, n));
            r -= et, e = A2(Yr, a, e);
        }
    }), xt = F2(function(n, r) {
        if (n > 0) {
            var t = n % et;
            return A5(kt, r, n - t - et, n, d, A3(st, t, n - t, r));
        }
        return ft;
    }), It = function(n) {
        return !n.$;
    }, At = F, jt = U, Et = function(n) {
        return {
            $: 0,
            a: n
        };
    }, Ct = function(n) {
        switch(n.$){
            case 0:
                return 0;
            case 1:
                return 1;
            case 2:
                return 2;
            default:
                return 3;
        }
    }, Yt = function(n) {
        return n;
    }, _t = N, St = function(n) {
        return n.length;
    }, qt = T, Tt = F2(function(n, r) {
        return 1 > n ? r : A3(qt, n, St(r), r);
    }), Nt = function(n) {
        return "" === n;
    }, Ot = F2(function(n, r) {
        return 1 > n ? "" : A3(qt, 0, n, r);
    }), zt = function(n) {
        for(var r = 0, t = n.charCodeAt(0), e = 43 == t || 45 == t ? 1 : 0, u = e; n.length > u; ++u){
            var a = n.charCodeAt(u);
            if (48 > a || a > 57) return Dr;
            r = 10 * r + a - 48;
        }
        return u == e ? Dr : Br(45 == t ? -r : r);
    }, Mt = O, Zt = tn, Lt = Zt(0), Rt = F4(function(n, r, t, e) {
        if (e.b) {
            var u = e.a, a = e.b;
            if (a.b) {
                var c = a.a, i = a.b;
                if (i.b) {
                    var o = i.a, f = i.b;
                    if (f.b) {
                        var s = f.b;
                        return A2(n, u, A2(n, c, A2(n, o, A2(n, f.a, t > 500 ? A3(Pr, n, r, tt(s)) : A4(Rt, n, r, t + 1, s)))));
                    }
                    return A2(n, u, A2(n, c, A2(n, o, r)));
                }
                return A2(n, u, A2(n, c, r));
            }
            return A2(n, u, r);
        }
        return r;
    }), Bt = F3(function(n, r, t) {
        return A4(Rt, n, r, 0, t);
    }), Dt = F2(function(n, r) {
        return A3(Bt, F2(function(r, t) {
            return A2(Yr, n(r), t);
        }), d, r);
    }), Ft = un, Ut = F2(function(n, r) {
        return A2(Ft, function(r) {
            return Zt(n(r));
        }, r);
    }), Pt = F3(function(n, r, t) {
        return A2(Ft, function(r) {
            return A2(Ft, function(t) {
                return Zt(A2(n, r, t));
            }, t);
        }, r);
    }), Qt = function(n) {
        return A3(Bt, Pt(Yr), Zt(d), n);
    }, Wt = mn, Ht = F2(function(n, r) {
        var t = r;
        return on(A2(Ft, Wt(n), t));
    });
    hn.Task = gn(Lt, F3(function(n, r) {
        return A2(Ut, function() {
            return 0;
        }, Qt(A2(Dt, Ht(n), r)));
    }), F3(function() {
        return Zt(0);
    }), F2(function(n, r) {
        return A2(Ut, n, r);
    }));
    var Gt = yn("Task"), Vt = F2(function(n, r) {
        return Gt(A2(Ut, n, r));
    }), Xt = vr, Jt = function(n) {
        return {
            $: 11,
            a: n
        };
    }, Kt = function(n) {
        return {
            $: 12,
            a: n
        };
    }, ne = function(n) {
        return {
            $: 10,
            a: n
        };
    }, re = {
        $: 2
    }, te = kn, ee = F2(function(n, r) {
        return {
            $: 3,
            a: n,
            b: r
        };
    }), ue = function(n) {
        return {
            $: 0,
            a: n
        };
    }, ae = F2(function(n, r) {
        return {
            $: 4,
            a: n,
            b: r
        };
    }), ce = {
        $: 2
    }, ie = function(n) {
        return {
            $: 1,
            a: n
        };
    }, oe = function(n) {
        return {
            $: 0,
            a: n
        };
    }, fe = {
        $: 1
    }, se = {
        $: -2
    }, be = se, ve = function(n) {
        return !n.$;
    }, de = wn, le = i, $e = F2(function(n, r) {
        n: for(;;){
            if (-2 === r.$) return Dr;
            var t = r.c, e = r.d, u = r.e;
            switch(A2(le, n, r.b)){
                case 0:
                    r = e;
                    continue n;
                case 1:
                    return Br(t);
                default:
                    r = u;
                    continue n;
            }
        }
    }), he = F5(function(n, r, t, e, u) {
        return {
            $: -1,
            a: n,
            b: r,
            c: t,
            d: e,
            e: u
        };
    }), ge = F5(function(n, r, t, e, u) {
        if (-1 !== u.$ || u.a) {
            if (-1 !== e.$ || e.a || -1 !== e.d.$ || e.d.a) return A5(he, n, r, t, e, u);
            var a = e.d;
            return c = e.e, A5(he, 0, e.b, e.c, A5(he, 1, a.b, a.c, a.d, a.e), A5(he, 1, r, t, c, u));
        }
        var c, i = u.b, o = u.c, f = u.d, s = u.e;
        return -1 !== e.$ || e.a ? A5(he, n, i, o, A5(he, 0, r, t, e, f), s) : A5(he, 0, r, t, A5(he, 1, e.b, e.c, e.d, c = e.e), A5(he, 1, i, o, f, s));
    }), pe = F3(function(n, r, t) {
        if (-2 === t.$) return A5(he, 0, n, r, se, se);
        var e = t.a, u = t.b, a = t.c, c = t.d, i = t.e;
        switch(A2(le, n, u)){
            case 0:
                return A5(ge, e, u, a, A3(pe, n, r, c), i);
            case 1:
                return A5(he, e, u, r, c, i);
            default:
                return A5(ge, e, u, a, c, A3(pe, n, r, i));
        }
    }), me = F3(function(n, r, t) {
        var e = A3(pe, n, r, t);
        return -1 !== e.$ || e.a ? e : A5(he, 1, e.b, e.c, e.d, e.e);
    }), we = function(n) {
        if (-1 === n.$ && -1 === n.d.$ && -1 === n.e.$) {
            if (-1 !== n.e.d.$ || n.e.d.a) {
                var r = n.d, t = n.e;
                return c = t.b, i = t.c, e = t.d, s = t.e, A5(he, 1, n.b, n.c, A5(he, 0, r.b, r.c, r.d, r.e), A5(he, 0, c, i, e, s));
            }
            var e, u = n.d, a = n.e, c = a.b, i = a.c, o = (e = a.d).d, f = e.e, s = a.e;
            return A5(he, 0, e.b, e.c, A5(he, 1, n.b, n.c, A5(he, 0, u.b, u.c, u.d, u.e), o), A5(he, 1, c, i, f, s));
        }
        return n;
    }, ye = function(n) {
        if (-1 === n.$ && -1 === n.d.$ && -1 === n.e.$) {
            if (-1 !== n.d.d.$ || n.d.d.a) {
                var r = n.d, t = n.e;
                return f = t.b, s = t.c, b = t.d, v = t.e, A5(he, 1, e = n.b, u = n.c, A5(he, 0, r.b, r.c, r.d, i = r.e), A5(he, 0, f, s, b, v));
            }
            var e = n.b, u = n.c, a = n.d, c = a.d, i = a.e, o = n.e, f = o.b, s = o.c, b = o.d, v = o.e;
            return A5(he, 0, a.b, a.c, A5(he, 1, c.b, c.c, c.d, c.e), A5(he, 1, e, u, i, A5(he, 0, f, s, b, v)));
        }
        return n;
    }, ke = F7(function(n, r, t, e, u, a, c) {
        if (-1 !== a.$ || a.a) {
            n: for(;;){
                if (-1 === c.$ && 1 === c.a) {
                    if (-1 === c.d.$) {
                        if (1 === c.d.a) return ye(r);
                        break n;
                    }
                    return ye(r);
                }
                break n;
            }
            return r;
        }
        return A5(he, t, a.b, a.c, a.d, A5(he, 0, e, u, a.e, c));
    }), xe = function(n) {
        if (-1 === n.$ && -1 === n.d.$) {
            var r = n.a, t = n.b, e = n.c, u = n.d, a = u.d, c = n.e;
            if (1 === u.a) {
                if (-1 !== a.$ || a.a) {
                    var i = we(n);
                    if (-1 === i.$) {
                        var o = i.e;
                        return A5(ge, i.a, i.b, i.c, xe(i.d), o);
                    }
                    return se;
                }
                return A5(he, r, t, e, xe(u), c);
            }
            return A5(he, r, t, e, xe(u), c);
        }
        return se;
    }, Ie = F2(function(n, r) {
        if (-2 === r.$) return se;
        var t = r.a, e = r.b, u = r.c, a = r.d, i = r.e;
        if (0 > c(n, e)) {
            if (-1 === a.$ && 1 === a.a) {
                var o = a.d;
                if (-1 !== o.$ || o.a) {
                    var f = we(r);
                    if (-1 === f.$) {
                        var s = f.e;
                        return A5(ge, f.a, f.b, f.c, A2(Ie, n, f.d), s);
                    }
                    return se;
                }
                return A5(he, t, e, u, A2(Ie, n, a), i);
            }
            return A5(he, t, e, u, A2(Ie, n, a), i);
        }
        return A2(Ae, n, A7(ke, n, r, t, e, u, a, i));
    }), Ae = F2(function(n, r) {
        if (-1 === r.$) {
            var e = r.a, u = r.b, a = r.c, c = r.d, i = r.e;
            if (t(n, u)) {
                var o = function(n) {
                    for(;;){
                        if (-1 !== n.$ || -1 !== n.d.$) return n;
                        n = n.d;
                    }
                }(i);
                return -1 === o.$ ? A5(ge, e, o.b, o.c, c, xe(i)) : se;
            }
            return A5(ge, e, u, a, c, A2(Ie, n, i));
        }
        return se;
    }), je = F2(function(n, r) {
        var t = A2(Ie, n, r);
        return -1 !== t.$ || t.a ? t : A5(he, 1, t.b, t.c, t.d, t.e);
    }), Ee = F3(function(n, r, t) {
        var e = r(A2($e, n, t));
        return e.$ ? A2(je, n, t) : A3(me, n, e.a, t);
    }), Ce = F3(function(n, r, t) {
        return r(n(t));
    }), Ye = F2(function(n, r) {
        return A3(hr, "", Yt, A2(Ce, r, n));
    }), _e = function(n) {
        return {
            $: 4,
            a: n
        };
    }, Se = {
        $: 2
    }, qe = {
        $: 1
    }, Te = F2(function(n, r) {
        return r.$ ? Or(n(r.a)) : Lr(r.a);
    }), Ne = F2(function(n, r) {
        switch(r.$){
            case 0:
                return Or({
                    $: 0,
                    a: r.a
                });
            case 1:
                return Or(qe);
            case 2:
                return Or(Se);
            case 3:
                return Or({
                    $: 3,
                    a: r.a.cw
                });
            default:
                return A2(Te, _e, n(r.b));
        }
    }), Oe = function(n) {
        return A2(Ye, n, Ne(Lr));
    }, ze = F3(function(n, r, t) {
        return 0 > c(t, n) ? n : c(t, r) > 0 ? r : t;
    }), Me = A, Ze = a, Le = function(n) {
        return !A2(Me, 4, n) && !!A2(Me, 100, n) || !A2(Me, 400, n);
    }, Re = F2(function(n, r) {
        var t = Le(n) ? 1 : 0;
        switch(r){
            case 0:
                return 0;
            case 1:
                return 31;
            case 2:
                return 59 + t;
            case 3:
                return 90 + t;
            case 4:
                return 120 + t;
            case 5:
                return 151 + t;
            case 6:
                return 181 + t;
            case 7:
                return 212 + t;
            case 8:
                return 243 + t;
            case 9:
                return 273 + t;
            case 10:
                return 304 + t;
            default:
                return 334 + t;
        }
    }), Be = F2(function(n, r) {
        return lt(n / r);
    }), De = function(n) {
        var r = n - 1;
        return 365 * r + (A2(Be, r, 4) - A2(Be, r, 100) + A2(Be, r, 400));
    }, Fe = F2(function(n, r) {
        switch(r){
            case 0:
            case 2:
            case 4:
            case 6:
            case 7:
            case 9:
            default:
                return 31;
            case 1:
                return Le(n) ? 29 : 28;
            case 3:
            case 5:
            case 8:
            case 10:
                return 30;
        }
    }), Ue = F3(function(n, r, t) {
        return De(n) + A2(Re, n, r) + A3(ze, 1, A2(Fe, n, r), t);
    }), Pe = F2(function(n, r) {
        return lt(n / r);
    }), Qe = F3(function(n, r, t) {
        for(;;){
            if (!t.b) return r + n;
            var e = t.a, u = t.b;
            if (0 > c(e.i, r)) return r + e.d;
            t = u;
        }
    }), We = F2(function(n, r) {
        var t = n.b;
        return A3(Qe, n.a, A2(Pe, r, 6e4), t);
    }), He = function(n) {
        return -n;
    }, Ge = function(n) {
        var r = A2(Pe, n, 1440) + 719468, t = (0 > r ? r - 146096 : r) / 146097 | 0, e = r - 146097 * t, u = (e - (e / 1460 | 0) + (e / 36524 | 0) - (e / 146096 | 0)) / 365 | 0, a = e - (365 * u + (u / 4 | 0) - (u / 100 | 0)), c = (5 * a + 2) / 153 | 0, i = c + (10 > c ? 3 : -9);
        return {
            a7: a - ((153 * c + 2) / 5 | 0) + 1,
            bo: i,
            bV: u + 400 * t + (i > 2 ? 0 : 1)
        };
    }, Ve = F2(function(n, r) {
        return Ge(A2(We, n, r)).a7;
    }), Xe = F2(function(n, r) {
        switch(Ge(A2(We, n, r)).bo){
            case 1:
                return 0;
            case 2:
                return 1;
            case 3:
                return 2;
            case 4:
                return 3;
            case 5:
                return 4;
            case 6:
                return 5;
            case 7:
                return 6;
            case 8:
                return 7;
            case 9:
                return 8;
            case 10:
                return 9;
            case 11:
                return 10;
            default:
                return 11;
        }
    }), Je = F2(function(n, r) {
        return Ge(A2(We, n, r)).bV;
    }), Ke = F2(function(n, r) {
        return A3(Ue, A2(Je, n, r), A2(Xe, n, r), A2(Ve, n, r));
    }), nu = {
        $: 0
    }, ru = function(n) {
        return {
            $: 1,
            a: n
        };
    }, tu = F2(function(n, r) {
        return {
            bC: n,
            bK: r
        };
    }), eu = Zt(A2(tu, be, d)), uu = function(n) {
        return en(function(r) {
            var t = n.f;
            2 === t.$ && t.c && t.c(), n.f = null, r(tn(0));
        });
    }, au = on, cu = F3(function(n, r, t) {
        n: for(;;){
            if (r.b) {
                var e = r.a, u = r.b;
                if (e.$) {
                    var a = e.a;
                    return A2(Ft, function(r) {
                        var e = a.bM;
                        return A3(cu, n, u, 1 === e.$ ? t : A3(me, e.a, r, t));
                    }, au(A3(lr, n, Wt(n), a)));
                }
                var c = e.a, i = A2($e, c, t);
                if (1 === i.$) {
                    r = u;
                    continue n;
                }
                return A2(Ft, function() {
                    return A3(cu, n, u, A2(je, c, t));
                }, uu(i.a));
            }
            return Zt(t);
        }
    }), iu = F4(function(n, r, t, e) {
        return A2(Ft, function(n) {
            return Zt(A2(tu, n, t));
        }, A3(cu, n, r, e.bC));
    }), ou = F3(function(n, r, t) {
        var e = n(r);
        return e.$ ? t : A2(Yr, e.a, t);
    }), fu = F2(function(n, r) {
        return A3(Bt, ou(n), d, r);
    }), su = F4(function(n, r, e, u) {
        var a = u.b;
        return t(r, u.a) ? Br(A2(Wt, n, a(e))) : Dr;
    }), bu = F3(function(n, r, t) {
        return A2(Ft, function() {
            return Zt(t);
        }, Qt(A2(fu, A3(su, n, r.a, r.b), t.bK)));
    }), vu = F2(function(n, r) {
        if (r.$) {
            var t = r.a;
            return ru({
                bW: t.bW,
                bY: t.bY,
                bc: A2(gr, n, t.bc),
                bg: t.bg,
                cj: t.cj,
                cB: t.cB,
                bM: t.bM,
                bQ: t.bQ
            });
        }
        return {
            $: 0,
            a: r.a
        };
    }), du = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    });
    hn.Http = gn(eu, iu, bu, vu, F2(function(n, r) {
        return A2(du, r.a, A2(Ce, r.b, n));
    }));
    var lu, $u = yn("Http"), hu = (yn("Http"), function(n) {
        return function(n) {
            return $u(ru({
                bW: !1,
                bY: n.bY,
                bc: n.bc,
                bg: n.bg,
                cj: n.cj,
                cB: n.cB,
                bM: n.bM,
                bQ: n.bQ
            }));
        }({
            bY: nu,
            bc: n.bc,
            bg: d,
            cj: "GET",
            cB: Dr,
            bM: Dr,
            bQ: n.bQ
        });
    }), gu = jn("init_tooltips", function() {
        return null;
    }), pu = Yt, mu = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), wu = mu, yu = en(function(n) {
        n(tn(A2(wu, -(new Date).getTimezoneOffset(), d)));
    }), ku = (lu = pu, en(function(n) {
        n(tn(lu(Date.now())));
    })), xu = A3(Pt, Ke, yu, ku), Iu = A2(mu, 0, d), Au = function(n) {
        return {
            $: 8,
            a: n
        };
    }, ju = function(n) {
        return {
            $: 7,
            a: n
        };
    }, Eu = function(n) {
        return {
            $: 6,
            a: n
        };
    }, Cu = kn, Yu = Z, _u = Yn("receive_db_ready", Yu), Su = L, qu = Yn("receive_readcode", Su), Tu = Yn("receive_snomed", Su), Nu = function(n) {
        return {
            $: 1,
            a: n
        };
    }, Ou = function(n) {
        return {
            $: 0,
            a: n
        };
    }, zu = F2(function(n) {
        return n;
    }), Mu = Q, Zu = F2(function(n, r) {
        return {
            $: 1,
            a: n,
            b: r
        };
    }), Lu = F3(function(n, r, t) {
        return {
            $: 0,
            a: n,
            b: r,
            c: t
        };
    }), Ru = F2(function(n, r) {
        var t = r;
        return function(r) {
            var e = t(r);
            if (1 === e.$) return A2(Zu, e.a, e.b);
            var u = e.a, a = e.c, c = n(e.b)(a);
            if (1 === c.$) {
                var i = c.a;
                return A2(Zu, u || i, c.b);
            }
            return i = c.a, A3(Lu, u || i, c.b, c.c);
        };
    }), Bu = Ru, Du = {
        $: 11
    }, Fu = F2(function(n, r) {
        return {
            $: 1,
            a: n,
            b: r
        };
    }), Uu = F4(function(n, r, t, e) {
        return {
            a5: r,
            b0: e,
            cq: t,
            cu: n
        };
    }), Pu = {
        $: 0
    }, Qu = F2(function(n, r) {
        return A2(Fu, Pu, A4(Uu, n.cu, n.a5, r, n.f));
    }), Wu = mr, Hu = F2(function(n, r) {
        return function(e) {
            var u = A3(Wu, n, e.d, e.aS);
            return t(u, -1) ? A2(Zu, !1, A2(Qu, e, r)) : t(u, -2) ? A3(Lu, !0, 0, {
                a5: 1,
                f: e.f,
                h: e.h,
                d: e.d + 1,
                cu: e.cu + 1,
                aS: e.aS
            }) : A3(Lu, !0, 0, {
                a5: e.a5 + 1,
                f: e.f,
                h: e.h,
                d: u,
                cu: e.cu,
                aS: e.aS
            });
        };
    }), Gu = function(n) {
        return A2(Hu, n, Du);
    }, Vu = {
        $: 10
    }, Xu = function(n) {
        return function(r) {
            return t(St(r.aS), r.d) ? A3(Lu, !1, 0, r) : A2(Zu, !1, A2(Qu, r, n));
        };
    }, Ju = Xu(Vu), Ku = function(n) {
        return n.b ? Br(n.a) : Dr;
    }, na = F3(function(n, r, t) {
        var e = r, u = t;
        return function(r) {
            var t = e(r);
            if (1 === t.$) return A2(Zu, t.a, t.b);
            var a = t.a, c = t.b, i = u(t.c);
            if (1 === i.$) {
                var o = i.a;
                return A2(Zu, a || o, i.b);
            }
            o = i.a;
            var f = i.c;
            return A3(Lu, a || o, A2(n, c, i.b), f);
        };
    }), ra = F2(function(n, r) {
        return A3(na, zu, n, r);
    }), ta = ra, ea = F2(function(n, r) {
        return A3(na, vt, n, r);
    }), ua = ea, aa = F2(function(n, r) {
        return r.$ ? Dr : Br(n(r.a));
    }), ca = F2(function(n, r) {
        var t = r;
        return function(r) {
            var e = t(r);
            if (e.$) return A2(Zu, e.a, e.b);
            var u = e.c;
            return A3(Lu, e.a, n(e.b), u);
        };
    }), ia = ca, oa = F2(function(n, r) {
        return {
            $: 2,
            a: n,
            b: r
        };
    }), fa = F3(function(n, r, t) {
        n: for(;;){
            if (t.b) {
                var e = t.b, u = (0, t.a)(n);
                if (u.$) {
                    var a;
                    if ((a = u).a) return a;
                    r = A2(oa, r, a.b), t = e;
                    continue n;
                }
                return u;
            }
            return A2(Zu, !1, r);
        }
    }), sa = function(n) {
        return function(r) {
            return A3(fa, r, Pu, n);
        };
    }, ba = sa, va = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), da = function(n) {
        return {
            $: 2,
            a: n
        };
    }, la = F2(function(n, r) {
        return {
            $: 1,
            a: n,
            b: r
        };
    }), $a = function(n) {
        var r = n;
        return function(n) {
            var t = r(n);
            return 1 === t.$ ? A2(Zu, !1, t.b) : A3(Lu, !1, t.b, t.c);
        };
    }, ha = $a, ga = function(n) {
        return function(r) {
            return A3(Lu, !0, n, r);
        };
    }, pa = F2(function(n, r) {
        var t = r;
        return function(r) {
            var e = t(r);
            if (1 === e.$) return A2(Zu, e.a, e.b);
            var u = e.b, a = e.c;
            return A3(Lu, e.a, A2(n, A3(qt, r.d, a.d, r.aS), u), a);
        };
    }), ma = pa, wa = F2(function(n, r) {
        return r.$ ? n : r.a;
    }), ya = A2(ma, F2(function(n) {
        return A2(wa, 0, zt(n));
    }), Gu(rt)), ka = function(n) {
        return function(r) {
            return A3(Lu, !1, n, r);
        };
    }, xa = ka, Ia = A2(ma, F2(function(n) {
        return A2(wa, 0, zt(n));
    }), A2(ta, A2(ta, xa(0), Gu(rt)), Gu(rt))), Aa = A2(ma, F2(function(n) {
        return A2(wa, 0, zt(n));
    }), A2(ta, A2(ta, A2(ta, xa(0), Gu(rt)), Gu(rt)), Gu(rt))), ja = function(n) {
        return {
            $: 0,
            a: n
        };
    }, Ea = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), Ca = pr, Ya = function(n) {
        return !n;
    }, _a = function(n) {
        var r = n.a, e = n.b, u = !Nt(r);
        return function(n) {
            var a = A5(Ca, r, n.d, n.cu, n.a5, n.aS), c = a.a, i = a.b, o = a.c;
            return t(c, -1) ? A2(Zu, !1, A2(Qu, n, e)) : A3(Lu, u, 0, {
                a5: o,
                f: n.f,
                h: n.h,
                d: c,
                cu: i,
                aS: n.aS
            });
        };
    }, Sa = function(n) {
        return _a(function(n) {
            return A2(Ea, n, ja(n));
        }(n));
    }, qa = ba(h([
        A2(ua, A2(ta, xa(Yt), Sa("-")), ba(h([
            ha(A2(Bu, ga, A2(ia, da, Aa))),
            A2(ua, A2(ua, xa(va), Ia), ba(h([
                A2(ua, A2(ta, xa(Yt), Sa("-")), Ia),
                xa(1)
            ]))),
            A2(ua, A2(ua, A2(ta, xa(la), Sa("W")), Ia), ba(h([
                A2(ua, A2(ta, xa(Yt), Sa("-")), ya),
                xa(1)
            ])))
        ]))),
        ha(A2(Bu, ga, A2(ua, A2(ua, xa(va), Ia), ba(h([
            Ia,
            xa(1)
        ]))))),
        A2(ia, da, Aa),
        A2(ua, A2(ua, A2(ta, xa(la), Sa("W")), Ia), ba(h([
            ya,
            xa(1)
        ]))),
        xa(da(1))
    ])), Ta = F3(function(n, r, t) {
        return 1 > c(n, t) && 1 > c(t, r);
    }), Na = function(n) {
        switch(n){
            case 0:
                return "January";
            case 1:
                return "February";
            case 2:
                return "March";
            case 3:
                return "April";
            case 4:
                return "May";
            case 5:
                return "June";
            case 6:
                return "July";
            case 7:
                return "August";
            case 8:
                return "September";
            case 9:
                return "October";
            case 10:
                return "November";
            default:
                return "December";
        }
    }, Oa = function(n) {
        switch(A2(ht, 1, n)){
            case 1:
                return 0;
            case 2:
                return 1;
            case 3:
                return 2;
            case 4:
                return 3;
            case 5:
                return 4;
            case 6:
                return 5;
            case 7:
                return 6;
            case 8:
                return 7;
            case 9:
                return 8;
            case 10:
                return 9;
            case 11:
                return 10;
            default:
                return 11;
        }
    }, za = F3(function(n, r, t) {
        return A3(Ta, 1, 12, r) ? A3(Ta, 1, A2(Fe, n, Oa(r)), t) ? Lr(De(n) + A2(Re, n, Oa(r)) + t) : Or("Invalid date: day " + Fr(t) + " is out of range (1 to " + Fr(A2(Fe, n, Oa(r))) + ") for " + Na(Oa(r)) + (2 === r && 29 === t ? " (" + Fr(n) + " is not a leap year)" : "") + "; received (year " + Fr(n) + ", month " + Fr(r) + ", day " + Fr(t) + ")") : Or("Invalid date: month " + Fr(r) + " is out of range (1 to 12); received (year " + Fr(n) + ", month " + Fr(r) + ", day " + Fr(t) + ")");
    }), Ma = F2(function(n, r) {
        var t = Le(n) ? 366 : 365;
        return A3(Ta, 1, t, r) ? Lr(De(n) + r) : Or("Invalid ordinal date: ordinal-day " + Fr(r) + " is out of range (1 to " + Fr(t) + ") for " + Fr(n) + "; received (year " + Fr(n) + ", ordinal-day " + Fr(r) + ")");
    }), Za = function(n) {
        return A2(Me, 7, n) || 7;
    }, La = function(n) {
        var r = De(n) + 4;
        return r - Za(r);
    }, Ra = F3(function(n, r, t) {
        var e, u, a = 4 === (u = Za(function(n) {
            return De(n) + 1;
        }(e = n))) || 3 === u && Le(e) ? 53 : 52;
        return A3(Ta, 1, a, r) ? A3(Ta, 1, 7, t) ? Lr(La(n) + 7 * (r - 1) + t) : Or("Invalid week date: weekday " + Fr(t) + " is out of range (1 to 7); received (year " + Fr(n) + ", week " + Fr(r) + ", weekday " + Fr(t) + ")") : Or("Invalid week date: week " + Fr(r) + " is out of range (1 to " + Fr(a) + ") for " + Fr(n) + "; received (year " + Fr(n) + ", week " + Fr(r) + ", weekday " + Fr(t) + ")");
    }), Ba = function(n) {
        var r = n.a, t = n.b;
        switch(t.$){
            case 0:
                return A3(za, r, t.a, t.b);
            case 1:
                return A3(Ra, r, t.a, t.b);
            default:
                return A2(Ma, r, t.a);
        }
    }, Da = A2(ma, F2(function(n) {
        return A2(wa, 0, zt(n));
    }), A2(ta, A2(ta, A2(ta, A2(ta, A2(ta, xa(0), ba(h([
        Gu(function(n) {
            return "-" === n;
        }),
        xa(0)
    ]))), Gu(rt)), Gu(rt)), Gu(rt)), Gu(rt))), Fa = F2(function(n, r) {
        return o(n, r);
    }), Ua = function(n) {
        return {
            $: 12,
            a: n
        };
    }, Pa = function(n) {
        return function(r) {
            return A2(Zu, !1, A2(Qu, r, n));
        };
    }, Qa = function(n) {
        return Pa(Ua(n));
    }, Wa = function(n) {
        return n.$ ? Qa(n.a) : xa(n.a);
    }, Ha = A2(Bu, A2(Ce, Ba, Wa), A2(ua, A2(ua, xa(Fa), Da), qa)), Ga = F3(function(n, r, t) {
        return {
            a5: r,
            cq: t,
            cu: n
        };
    }), Va = function(n) {
        return A3(Ga, n.cu, n.a5, n.cq);
    }, Xa = F2(function(n, r) {
        n: for(;;)switch(n.$){
            case 0:
                return r;
            case 1:
                var t = n.b;
                n = n.a, r = A2(Yr, t, r);
                continue n;
            default:
                var e = n.b;
                n = n.a, r = A2(Xa, e, r);
                continue n;
        }
    }), Ja = F2(function(n, r) {
        var t = n({
            a5: 1,
            f: d,
            h: 1,
            d: 0,
            cu: 1,
            aS: r
        });
        return t.$ ? Or(A2(Xa, t.b, d)) : Lr(t.b);
    }), Ka = F2(function(n, r) {
        var t = A2(Ja, n, r);
        return t.$ ? Or(A2(Dt, Va, t.a)) : Lr(t.a);
    }), nc = A2(Ce, Ka(A2(ua, xa(Yt), A2(ta, Ha, A2(Bu, Wa, ba(h([
        A2(ia, Lr, Ju),
        A2(ia, zu(Or("Expected a date only, not a date and time")), Gu(dt("T"))),
        xa(Or("Expected a date only"))
    ])))))), Te(A2(Ce, Ku, A2(Ce, aa(function(n) {
        var r = n.cq;
        return 12 === r.$ ? r.a : "Expected a date in ISO 8601 format";
    }), wa(""))))), rc = te(d), tc = function(n) {
        return {
            $: 4,
            b: n
        };
    }, ec = B, uc = R, ac = tc(A3(jt, F2(function(n, r) {
        return {
            N: r,
            aQ: n
        };
    }), A2(ec, "Description", uc), A2(ec, "ReadCode", uc))), cc = nn, ic = jn("send_readcode_query", cc), oc = jn("send_snomed_query", cc), fc = $n, sc = tc(A5(P, F4(function(n, r, t, e) {
        return {
            a6: n,
            bw: r,
            N: e,
            aQ: t
        };
    }), A2(ec, "ConceptSCTID", uc), A2(ec, "PreferredTerm", uc), A2(ec, "ReadTerm", uc), A2(ec, "ReadCode", uc))), bc = F2(function(n, r) {
        return r.$ ? n : r.a;
    }), vc = F2(function(n, r) {
        switch(n.$){
            case 10:
                var e = n.a;
                return o(b(r, {
                    X: e,
                    ag: e
                }), rc);
            case 0:
                var u = n.a, a = A2(Vt, zu({
                    $: 1,
                    a: u
                }), fc(500));
                return o(b(r, {
                    G: u,
                    aa: ft,
                    B: ft
                }), te(h([
                    a
                ])));
            case 1:
                return t(r.G, n.a) && St(r.G) >= 3 ? o(b(r, {
                    ab: !0,
                    ad: !0
                }), te(h([
                    oc(r.G),
                    ic(r.G)
                ]))) : o(r, rc);
            case 2:
                return o(b(r, {
                    U: n.a,
                    P: c = n.b
                }), rc);
            case 3:
                return o(b(r, {
                    U: n.a
                }), rc);
            case 4:
                var c;
                return o(b(r, (c = zt(n.a)).$ ? {
                    P: 0
                } : {
                    P: c.a
                }), rc);
            case 5:
                return o(b(r, {
                    X: A2(bc, r.ag, nc(n.a))
                }), rc);
            case 8:
                return o(b(r, {
                    an: n.a
                }), rc);
            case 7:
                return o((i = A2(Mu, ac, n.a)).$ ? r : b(r, {
                    aa: i.a,
                    ab: !1
                }), rc);
            case 6:
                return o((i = A2(Mu, sc, n.a)).$ ? r : b(r, {
                    B: i.a,
                    ad: !1
                }), rc);
            case 9:
                return o(b(r, {
                    ac: n.a
                }), rc);
            case 11:
                return o(b(r, (i = n.a).$ ? {
                    V: Nu(i.a)
                } : {
                    V: Ou(i.a)
                }), rc);
            default:
                var i;
                return o(b(r, (i = n.a).$ ? {
                    W: Nu(i.a)
                } : {
                    W: Ou(i.a)
                }), rc);
        }
    }), dc = F2(function(n, r) {
        return A2(Ln, n, cc(r));
    }), lc = dc("className"), $c = On("div"), hc = F2(function(n, r) {
        return A2(Rn, function(n) {
            return /^(on|formAction$)/i.test(n) ? "data-" + n : n;
        }(n), Bn(r));
    }), gc = On("button"), pc = On("h4"), mc = dc("id"), wc = function(n) {
        return A2(hc, "role", n);
    }, yc = Nn, kc = F2(function(n, r) {
        return r.$ ? Or(r.a) : n(r.a);
    }), xc = function(n) {
        return "Problem at row " + Fr(n.cu) + "\n" + function(n) {
            switch(n.$){
                case 0:
                    return "Expecting " + n.a;
                case 1:
                    return "Expecting int";
                case 2:
                    return "Expecting hex";
                case 3:
                    return "Expecting octal";
                case 4:
                    return "Expecting binary";
                case 5:
                    return "Expecting float";
                case 6:
                    return "Expecting number";
                case 7:
                    return "Expecting variable";
                case 8:
                    return "Expecting symbol " + n.a;
                case 9:
                    return "Expecting keyword " + n.a;
                case 10:
                    return "Expecting keyword end";
                case 11:
                    return "Unexpected char";
                case 12:
                    return n.a;
                default:
                    return "Bad repeat";
            }
        }(n.cq);
    }, Ic = function(n) {
        return A2(Ur, "\n", A2(Dt, xc, n));
    }, Ac = {
        $: 10
    }, jc = function(n) {
        return {
            $: 11,
            a: n
        };
    }, Ec = function(n) {
        return {
            $: 4,
            a: n
        };
    }, Cc = function(n) {
        return {
            $: 7,
            a: n
        };
    }, Yc = function(n) {
        return {
            $: 5,
            a: n
        };
    }, _c = function(n) {
        return {
            $: 1,
            a: n
        };
    }, Sc = function(n) {
        return {
            $: 3,
            a: n
        };
    }, qc = F2(function(n, r) {
        return {
            $: 6,
            a: n,
            b: r
        };
    }), Tc = {
        $: 0
    }, Nc = function(n) {
        return {
            $: 8,
            a: n
        };
    }, Oc = {
        $: 8
    }, zc = F2(function(n, r) {
        return {
            $: 4,
            a: n,
            b: r
        };
    }), Mc = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), Zc = function(n) {
        return {
            $: 2,
            a: n
        };
    }, Lc = function(n) {
        return {
            $: 0,
            a: n
        };
    }, Rc = function(n) {
        return {
            $: 1,
            a: n
        };
    }, Bc = F2(function(n, r) {
        return {
            $: 3,
            a: n,
            b: r
        };
    }), Dc = F3(function(n, r, t) {
        return {
            $: 0,
            a: n,
            b: r,
            c: t
        };
    }), Fc = F3(function(n, r, t) {
        return {
            $: 2,
            a: n,
            b: r,
            c: t
        };
    }), Uc = function(n) {
        return {
            $: 6,
            a: n
        };
    }, Pc = function(n) {
        return {
            $: 2,
            a: n
        };
    }, Qc = F3(function(n, r, t) {
        return {
            $: 1,
            a: n,
            b: r,
            c: t
        };
    }), Wc = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), Hc = function(n) {
        return {
            $: 0,
            a: n
        };
    }, Gc = function(n) {
        return {
            $: 1,
            a: n
        };
    }, Vc = F3(function(n, r, t) {
        return {
            $: 2,
            a: n,
            b: r,
            c: t
        };
    }), Xc = F6(function(n, r, t, e, u, a) {
        return {
            $: 4,
            a: n,
            b: r,
            c: t,
            d: e,
            e: u,
            f: a
        };
    }), Jc = function(n) {
        return {
            $: 5,
            a: n
        };
    }, Kc = function(n) {
        return {
            $: 1,
            a: n
        };
    }, ni = function(n) {
        return {
            $: 12,
            a: n
        };
    }, ri = function(n) {
        return {
            $: 2,
            a: n
        };
    }, ti = function(n) {
        return {
            $: 4,
            a: n
        };
    }, ei = F2(function(n, r) {
        return {
            $: 6,
            a: n,
            b: r
        };
    }), ui = function(n) {
        return {
            $: 8,
            a: n
        };
    }, ai = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), ci = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), ii = {
        $: 8
    }, oi = {
        $: 7
    }, fi = F2(function(n, r) {
        return {
            $: 1,
            a: n,
            b: r
        };
    }), si = F4(function(n, r, t, e) {
        return {
            $: 3,
            a: n,
            b: r,
            c: t,
            d: e
        };
    }), bi = F2(function(n, r) {
        return {
            a: A2(Yr, r, n.a),
            b: n.b
        };
    }), vi = F5(function(n, r, e, u, a) {
        for(;;){
            var i = A3(Wu, n, r, a.aS);
            if (t(i, -1)) return A3(Lu, 0 > c(a.d, r), 0, {
                a5: u,
                f: a.f,
                h: a.h,
                d: r,
                cu: e,
                aS: a.aS
            });
            t(i, -2) ? (r += 1, e += 1, u = 1) : (r = i, u += 1);
        }
    }), di = function(n) {
        return function(r) {
            return A5(vi, n, r.d, r.cu, r.a5, r);
        };
    }, li = function(n) {
        switch(n){
            case " ":
            case "\t":
                return !0;
            default:
                return !1;
        }
    }, $i = A2(Ea, "\r", ja("a carriage return")), hi = A2(Ea, "\n", ja("a newline")), gi = sa(h([
        _a(hi),
        A2(ra, _a($i), sa(h([
            _a(hi),
            ka(0)
        ])))
    ])), pi = A2(ca, function() {
        return Ac;
    }, A2(ra, $a(di(li)), gi)), mi = A2(Ea, " ", ja("a space")), wi = _a, yi = h([
        wi(A2(Ea, ">", ja(">"))),
        A2(ra, $a(wi(mi)), sa(h([
            wi(A2(Ea, ">", ja(" >"))),
            wi(A2(Ea, " >", ja("  >"))),
            wi(A2(Ea, "  >", ja("   >")))
        ])))
    ]), ki = F3(function(n, r, t) {
        return n(r(t));
    }), xi = function(n) {
        switch(n){
            case "\n":
            case "\r":
                return !0;
            default:
                return !1;
        }
    }, Ii = di(A2(ki, Ya, xi)), Ai = function(n) {
        return A2(pa, zu, n);
    }, ji = Xu(ja("the end of the input")), Ei = sa(h([
        gi,
        ji
    ])), Ci = A2(ea, A2(ra, A2(ra, ka(jc), sa(yi)), sa(h([
        wi(mi),
        ka(0)
    ]))), A2(ra, Ai(Ii), Ei)), Yi = F2(function(n, r) {
        return r.b ? A3(Bt, Yr, r, n) : n;
    }), _i = function(n) {
        return A3(Bt, Yi, d, n);
    }, Si = F2(function(n, r) {
        return _i(A2(Dt, n, r));
    }), qi = function(n) {
        return A2(Ur, "\n", A2(Dt, xc, n));
    }, Ti = z, Ni = function(n) {
        n: for(;;)switch(n.$){
            case 1:
                return !A2(Ti, n.a, "\n");
            case 12:
                if ((t = n.a).b) {
                    n = t.a;
                    continue n;
                }
                return !1;
            case 4:
                var r = n.e;
                if (r.b) {
                    var t;
                    if ((t = r.a).b) {
                        n = t.a;
                        continue n;
                    }
                    return !1;
                }
                return !1;
            case 0:
                return !0;
            default:
                return !1;
        }
    }, Oi = F2(function(n, r) {
        return A3(Bt, F2(function(r, t) {
            return n(r) ? A2(Yr, r, t) : t;
        }), d, r);
    }), zi = function(n) {
        return A3(Pr, F2(function(n, r) {
            return A3(me, n.a, n.b, r);
        }), be, n);
    }, Mi = function(n) {
        return {
            $: 3,
            a: n
        };
    }, Zi = F3(function(n, r, t) {
        return {
            $: 0,
            a: n,
            b: r,
            c: t
        };
    }), Li = ja("at least 1 tag name character"), Ri = function(n) {
        switch(n){
            case " ":
            case "\r":
            case "\n":
            case "\t":
            case "/":
            case "<":
            case ">":
            case '"':
            case "'":
            case "=":
                return !1;
            default:
                return !0;
        }
    }, Bi = function(n) {
        return n.toLowerCase();
    }, Di = A2(pa, F2(function(n) {
        return Bi(n);
    }), A2(ra, A2(Hu, Ri, Li), di(Ri))), Fi = Di, Ui = function(n) {
        return _a(A2(Ea, n, Nc(n)));
    }, Pi = F4(function(n, r, t, e) {
        for(;;){
            var u = t(r)(e);
            if (u.$) return a = u.a, A2(Zu, n || a, u.b);
            var a = u.a, c = u.b, i = u.c;
            if (c.$) return A3(Lu, n || a, c.a, i);
            n = n || a, r = c.a, e = i;
        }
    }), Qi = F2(function(n, r) {
        return function(t) {
            return A4(Pi, !1, n, r, t);
        };
    }), Wi = zi(h([
        o("amp", "&"),
        o("lt", "<"),
        o("gt", ">"),
        o("apos", "'"),
        o("quot", '"')
    ])), Hi = function(n) {
        return 0 > n || n > 1114111 ? "\uFFFD" : n > 65535 ? String.fromCharCode(Math.floor((n -= 65536) / 1024) + 55296, n % 1024 + 56320) : String.fromCharCode(n);
    }, Gi = F2(function(n, r) {
        return r.$ ? Or(n) : Lr(r.a);
    }), Vi = Y, Xi = function(n) {
        return A2(Vi, n, "");
    }, Ji = I, Ki = F3(function(n, r, t) {
        n: for(;;){
            if (!r.b) return Lr(t);
            var e = r.a, u = r.b;
            switch(e){
                case "0":
                    n = a = n - 1, r = c = u, t = i = t;
                    continue n;
                case "1":
                    var a = n - 1, c = u, i = t + A2(Ji, 16, n);
                    n = a, r = c, t = i;
                    continue n;
                case "2":
                    a = n - 1, c = u, i = t + 2 * A2(Ji, 16, n), n = a, r = c, t = i;
                    continue n;
                case "3":
                    a = n - 1, c = u, i = t + 3 * A2(Ji, 16, n), n = a, r = c, t = i;
                    continue n;
                case "4":
                    a = n - 1, c = u, i = t + 4 * A2(Ji, 16, n), n = a, r = c, t = i;
                    continue n;
                case "5":
                    a = n - 1, c = u, i = t + 5 * A2(Ji, 16, n), n = a, r = c, t = i;
                    continue n;
                case "6":
                    a = n - 1, c = u, i = t + 6 * A2(Ji, 16, n), n = a, r = c, t = i;
                    continue n;
                case "7":
                    a = n - 1, c = u, i = t + 7 * A2(Ji, 16, n), n = a, r = c, t = i;
                    continue n;
                case "8":
                    a = n - 1, c = u, i = t + 8 * A2(Ji, 16, n), n = a, r = c, t = i;
                    continue n;
                case "9":
                    a = n - 1, c = u, i = t + 9 * A2(Ji, 16, n), n = a, r = c, t = i;
                    continue n;
                case "a":
                    a = n - 1, c = u, i = t + 10 * A2(Ji, 16, n), n = a, r = c, t = i;
                    continue n;
                case "b":
                    a = n - 1, c = u, i = t + 11 * A2(Ji, 16, n), n = a, r = c, t = i;
                    continue n;
                case "c":
                    a = n - 1, c = u, i = t + 12 * A2(Ji, 16, n), n = a, r = c, t = i;
                    continue n;
                case "d":
                    a = n - 1, c = u, i = t + 13 * A2(Ji, 16, n), n = a, r = c, t = i;
                    continue n;
                case "e":
                    a = n - 1, c = u, i = t + 14 * A2(Ji, 16, n), n = a, r = c, t = i;
                    continue n;
                case "f":
                    a = n - 1, c = u, i = t + 15 * A2(Ji, 16, n), n = a, r = c, t = i;
                    continue n;
                default:
                    return Or(Xi(e) + " is not a valid hexadecimal character.");
            }
        }
    }), no = F2(function(n, r) {
        return r.$ ? Or(r.a) : Lr(n(r.a));
    }), ro = S, to = function(n) {
        return A3(ro, Yr, d, n);
    }, eo = function(n) {
        var r = function(n) {
            var r, t = A2(Mt, "#x", r = n) ? A2(Te, Ua, A2(no, Hi, function(n) {
                if (Nt(n)) return Or("Empty strings are not valid hexadecimal strings.");
                var r = function() {
                    if (A2(Mt, "-", n)) {
                        var r = A2(wa, d, function(n) {
                            return n.b ? Br(n.b) : Dr;
                        }(to(n)));
                        return A2(no, He, A3(Ki, Qr(r) - 1, r, 0));
                    }
                    return A3(Ki, St(n) - 1, to(n), 0);
                }();
                return A2(Te, function(r) {
                    return A2(Ur, " ", h([
                        '"' + n + '"',
                        "is not a valid hexadecimal string because",
                        r
                    ]));
                }, r);
            }(A2(Tt, 2, r)))) : A2(Mt, "#", r) ? A2(Gi, Ua("Invalid escaped character: " + r), A2(aa, Hi, zt(A2(Tt, 1, r)))) : A2(Gi, Ua('No entity named "&' + r + ';" found.'), A2($e, r, Wi));
            return t.$ ? Pa(t.a) : ka(t.a);
        }, e = function(r) {
            return !t(r, n) && ";" !== r;
        };
        return A2(ea, A2(ra, ka(Yt), Ui("&")), A2(ra, A2(Ru, r, Ai(A2(ra, A2(Hu, e, ja("an entity character")), di(e)))), Ui(";")));
    }, uo = F3(function(n, r, t) {
        return A2(Ru, function(r) {
            return sa(h([
                A2(ca, function(n) {
                    return Hc(v(t, v(r, Xi(n))));
                }, eo(n)),
                ka(_c(v(t, r)))
            ]));
        }, Ai(di(r)));
    }), ao = function(n) {
        return A2(Qi, "", A2(uo, n, function(r) {
            return !t(r, n) && "&" !== r;
        }));
    }, co = sa(h([
        A2(ea, A2(ra, ka(Yt), Ui('"')), A2(ra, ao('"'), Ui('"'))),
        A2(ea, A2(ra, ka(Yt), Ui("'")), A2(ra, ao("'"), Ui("'")))
    ])), io = F2(function(n, r) {
        return Br(r.$ ? n : r.a);
    }), oo = function(n) {
        switch(n){
            case " ":
            case "\r":
            case "\n":
            case "\t":
                return !0;
            default:
                return !1;
        }
    }, fo = di(oo), so = function(n) {
        return sa(h([
            A2(ea, A2(ea, ka(F2(function(r, t) {
                return Hc(A3(Ee, Bi(r), io(t), n));
            })), A2(ra, A2(ra, A2(ra, Fi, fo), Ui("=")), fo)), A2(ra, co, fo)),
            ka(_c(n))
        ]));
    }, bo = F3(function(n, r, t) {
        for(;;){
            if (-2 === t.$) return r;
            var e = t.e, u = n, a = A3(n, t.b, t.c, A3(bo, n, r, t.d));
            n = u, r = a, t = e;
        }
    }), vo = A2(ca, A2(bo, F3(function(n, r, t) {
        return A2(Yr, {
            br: n,
            bR: r
        }, t);
    }), d), A2(Qi, be, so)), lo = function(n) {
        return function(r) {
            var t = A5(wr, n, r.d, r.cu, r.a5, r.aS), e = t.a, u = t.b, a = t.c, i = 0 > e ? St(r.aS) : e;
            return A3(Lu, 0 > c(r.d, i), 0, {
                a5: a,
                f: r.f,
                h: r.h,
                d: i,
                cu: u,
                aS: r.aS
            });
        };
    }, $o = A2(ea, A2(ra, ka(Yt), Ui("<![CDATA[")), A2(ra, Ai(lo("]]>")), Ui("]]>"))), ho = F2(function(n, r) {
        return A2(ca, function(n) {
            return n(r);
        }, sa(n));
    }), go = function(n) {
        var r = A2(Ru, function(r) {
            return t(n, r) ? ka(0) : Pa(Ua("tag name mismatch: " + n + " and " + r));
        }, Di);
        return A2(ra, A2(ra, A2(ra, A2(ra, Ui("</"), fo), r), fo), Ui(">"));
    }, po = function(n) {
        return A2(Ea, n, ja(n));
    }, mo = A2(ea, A2(ra, ka(function(n) {
        return {
            $: 2,
            a: n
        };
    }), _a(po("\x3c!--"))), A2(ra, Ai(lo("--\x3e")), _a(po("--\x3e")))), wo = F2(function(n, r) {
        return {
            $: 5,
            a: n,
            b: r
        };
    }), yo = ja("at least 1 uppercase character"), ko = Ai(A2(ra, A2(Hu, Kr, yo), di(Kr))), xo = A2(ra, A2(Hu, oo, ja("at least one whitespace")), di(oo)), Io = A2(ea, A2(ea, A2(ra, ka(wo), Ui("<!")), A2(ra, ko, xo)), A2(ra, Ai(lo(">")), Ui(">"))), Ao = A2(ea, A2(ra, ka(function(n) {
        return {
            $: 4,
            a: n
        };
    }), Ui("<?")), A2(ra, Ai(lo("?>")), Ui("?>"))), jo = function(n) {
        switch(n){
            case "<":
            case "&":
                return !1;
            default:
                return !0;
        }
    }, Eo = h([
        A2(ca, function() {
            return Hc(0);
        }, A2(ra, A2(Hu, jo, ja("is not & or <")), di(jo))),
        A2(ca, function() {
            return Hc(0);
        }, eo("<")),
        ka(_c(0))
    ]), Co = Ai(A2(Qi, 0, function() {
        return sa(Eo);
    })), Yo = function(n) {
        return A2(Qi, d, ho(_o(n)));
    }, _o = function(n) {
        return h([
            A2(ca, F2(function(n, r) {
                return _c(tt(r));
            }), go(n)),
            A2(Ru, function(r) {
                return Nt(r) ? A2(ca, F2(function(n, r) {
                    return _c(tt(r));
                }), go(n)) : ka(function(n) {
                    return Hc(A2(Yr, {
                        $: 1,
                        a: r
                    }, n));
                });
            }, Co),
            A2(ca, F2(function(n, r) {
                return Hc(A2(Yr, n, r));
            }), qo())
        ]);
    }, So = function(n) {
        return A2(ea, A2(ea, A2(ra, ka(Zi(n)), fo), A2(ra, vo, fo)), sa(h([
            A2(ca, function() {
                return d;
            }, Ui("/>")),
            A2(ea, A2(ra, ka(Yt), Ui(">")), Yo(n))
        ])));
    };
    function qo() {
        return sa(h([
            A2(ca, Mi, $o),
            Ao,
            mo,
            Io,
            To()
        ]));
    }
    function To() {
        return A2(ea, A2(ra, ka(Yt), Ui("<")), A2(Ru, So, Di));
    }
    var No = qo();
    qo = function() {
        return No;
    };
    var Oo = To();
    To = function() {
        return Oo;
    };
    var zo, Mo, Zo, Lo = A2(Ea, "\t", ja("a tab")), Ro = sa(h([
        wi(Lo),
        A2(ra, $a(wi(mi)), sa(h([
            wi(A2(Ea, "   ", Nc("Indentation"))),
            wi(A2(Ea, " \t", Nc("Indentation"))),
            wi(A2(Ea, "  \t", Nc("Indentation")))
        ])))
    ])), Bo = A2(ea, A2(ra, ka(Uc), Ro), A2(ra, Ai(Ii), Ei)), Do = function(n) {
        return !A2(Me, 2, n);
    }, Fo = function(n) {
        return n ? 1 : 0;
    }, Uo = F3(function(n, r, t) {
        var e = o(r, t);
        return "" === e.a ? t : "" === e.b ? r : v(r, v(n, t));
    }), Po = F2(function(n, r) {
        return n + "\n" + r;
    }), Qo = F2(function(n, r) {
        return o(r.a, n(r.b));
    }), Wo = F2(function(n, r) {
        for(;;){
            if (!r.b) return !1;
            var t = r.b;
            if (n(r.a)) return !0;
            r = t;
        }
    }), Ho = F2(function(n, r) {
        return A2(Wo, function(r) {
            return t(r, n);
        }, r);
    }), Go = A2(pa, F2(function(n) {
        return Gc(n);
    }), Ii), Vo = A2(ra, Go, Ei), Xo = F4(function(n, r, t, e) {
        return {
            bY: e,
            cc: r,
            ci: t,
            cp: n
        };
    }), Jo = function(n) {
        return A3(Lu, !1, n.a5, n);
    }, Ko = A2(ea, ka(function(n) {
        return o(n, "");
    }), A2(ra, Jo, Ei)), nf = function(n) {
        return A2(ra, A2(Hu, n, Ua("Expected one or more character")), di(n));
    }, rf = A2(ea, A2(ea, A2(ra, ka(F2(function(n, r) {
        return o(n, r);
    })), nf(li)), Jo), A2(ra, Ai(Ii), Ei)), tf = A2(Ea, ")", ja("a `)`")), ef = A2(Ea, ".", ja("a `.`")), uf = sa(h([
        A2(ra, ka(0), wi(ef)),
        A2(ra, ka(1), wi(tf))
    ])), af = A2(pa, F2(function(n) {
        return A2(wa, 0, zt(n));
    }), nf(rt)), cf = A2(Ru, function(n) {
        return n > 999999999 ? Pa(Ua("Starting numbers must be nine digits or less.")) : ka(n);
    }, af), of = _a(mi), ff = F3(function(n, r, t) {
        for(;;){
            if (0 >= r) return n;
            n = A2(Yr, t, n), r -= 1;
        }
    }), sf = F2(function(n, r) {
        return A3(ff, d, n, r);
    }), bf = F2(function(n, r) {
        var t = A2(sf, n, r);
        if (t.b) {
            var e = t.a, u = t.b;
            return A3(Pr, F2(function(n, r) {
                return sa(h([
                    A2(ra, n, r),
                    ka(0)
                ]));
            }), sa(h([
                e,
                ka(0)
            ])), u);
        }
        return ka(0);
    }), vf = function(n) {
        return 1 === n ? ka(n) : Pa(Ua("Lists inside a paragraph or after a paragraph without a blank line must start with 1"));
    }, df = F3(function(n, r, t) {
        return n > 0 ? A3(df, n >> 1, v(r, r), 1 & n ? v(t, r) : t) : t;
    }), lf = F2(function(n, r) {
        return A3(df, n, r, "");
    }), $f = function(n) {
        return A2(ca, function(n) {
            return A6(Xc, !0, n.cc, n.ci, n.cp, d, n.bY);
        }, function(n) {
            return A2(ea, A2(ea, A2(ea, A2(ea, A2(ea, ka(F5(function(n, r, t, e, u) {
                var a = u.a, c = u.b;
                return a - e > 4 ? A4(Xo, r, e - n + 1, t, v(A2(lf, a - e - 1, " "), c)) : A4(Xo, r, a - n, t, c);
            })), Jo), $a(function(n) {
                return n ? A2(Ru, vf, A2(ea, A2(ra, ka(Yt), A2(bf, 3, of)), cf)) : A2(ea, A2(ra, ka(Yt), A2(bf, 3, of)), cf);
            }(n))), $a(uf)), Jo), n ? rf : sa(h([
                Ko,
                rf
            ])));
        }(n));
    }, hf = {
        $: 1
    }, gf = F3(function(n, r, t) {
        return {
            $: 4,
            a: n,
            b: r,
            c: t
        };
    }), pf = F3(function(n, r, t) {
        return {
            $: 3,
            a: n,
            b: r,
            c: t
        };
    }), mf = function(n) {
        return {
            $: 0,
            a: n
        };
    }, wf = function(n) {
        var r = n, t = r.k;
        switch(t.$){
            case 0:
                return mf(r.j);
            case 1:
                return hf;
            case 2:
                return {
                    $: 2,
                    a: r.j
                };
            case 3:
                var e = t.a;
                return A3(pf, e.b, Dr, h([
                    mf(e.a)
                ]));
            case 4:
                var u = t.a;
                return A3(pf, u.a, u.b, yf(r.p));
            case 5:
                var a = t.a;
                return A3(gf, a.a, a.b, yf(r.p));
            case 6:
                return {
                    $: 5,
                    a: t.a
                };
            case 7:
                return A2(qc, t.a, yf(r.p));
            default:
                return function(n) {
                    return {
                        $: 7,
                        a: n
                    };
                }(yf(r.p));
        }
    }, yf = function(n) {
        return A2(Dt, wf, n);
    }, kf = F2(function(n, r) {
        return {
            g: r.g - n.r,
            p: r.p,
            i: r.i - n.r,
            j: r.j,
            t: r.t - n.r,
            r: r.r - n.r,
            k: r.k
        };
    }), xf = F2(function(n, r) {
        return {
            g: n.g,
            p: A2(Yr, A2(kf, n, r), n.p),
            i: n.i,
            j: n.j,
            t: n.t,
            r: n.r,
            k: n.k
        };
    }), If = m, Af = function(n) {
        var r = n;
        return {
            g: r.g,
            p: jf(r.p),
            i: r.i,
            j: r.j,
            t: r.t,
            r: r.r,
            k: r.k
        };
    }, jf = function(n) {
        var r = A2(If, function(n) {
            return n.i;
        }, n);
        return r.b ? A3(Ef, r.b, r.a, d) : d;
    }, Ef = F3(function(n, r, t) {
        for(;;){
            var e = r;
            if (!n.b) return A2(Yr, Af(e), t);
            var u = n.a, a = n.b;
            1 > c(e.g, u.i) ? (n = a, r = u, t = A2(Yr, Af(e), t)) : 0 > c(e.i, u.i) && c(e.g, u.g) > 0 ? (n = a, r = A2(xf, e, u)) : (n = a, r = e);
        }
    }), Cf = {
        $: 0
    }, Yf = F4(function(n, r, t, e) {
        return {
            c: r,
            Z: n,
            cl: t,
            cy: e
        };
    }), _f = yr, Sf = function(n) {
        return A2(_f, {
            bZ: !1,
            ck: !1
        }, n);
    }, qf = /.^/, Tf = A2(wa, qf, Sf("&#([0-9]{1,8});")), Nf = Ir(Ar), Of = function(n) {
        return function(n) {
            return 9 === n || 10 === n || 13 === n || 133 === n || n >= 32 && 126 >= n || n >= 160 && 55295 >= n || n >= 57344 && 64975 >= n || n >= 65008 && 65533 >= n || n >= 65536 && 1114109 >= n;
        }(n) && !function(n) {
            var r = A2(Me, 16, n), t = A2(Me, 131070, n);
            return !(131070 > n || (0 > t || t > 15) && (65536 > t || t > 65551) || 14 !== r && 15 !== r);
        }(n) ? Xi(Hi(n)) : Xi(Hi(65533));
    }, zf = A2(Nf, Tf, function(n) {
        var r = n.cy;
        if (r.b && !r.a.$) {
            var t = zt(r.a.a);
            return t.$ ? n.Z : Of(t.a);
        }
        return n.Z;
    }), Mf = A2(wa, qf, Sf("&([0-9a-zA-Z]+);")), Zf = zi(h([
        o("quot", 34),
        o("amp", 38),
        o("apos", 39),
        o("lt", 60),
        o("gt", 62),
        o("nbsp", 160),
        o("iexcl", 161),
        o("cent", 162),
        o("pound", 163),
        o("curren", 164),
        o("yen", 165),
        o("brvbar", 166),
        o("sect", 167),
        o("uml", 168),
        o("copy", 169),
        o("ordf", 170),
        o("laquo", 171),
        o("not", 172),
        o("shy", 173),
        o("reg", 174),
        o("macr", 175),
        o("deg", 176),
        o("plusmn", 177),
        o("sup2", 178),
        o("sup3", 179),
        o("acute", 180),
        o("micro", 181),
        o("para", 182),
        o("middot", 183),
        o("cedil", 184),
        o("sup1", 185),
        o("ordm", 186),
        o("raquo", 187),
        o("frac14", 188),
        o("frac12", 189),
        o("frac34", 190),
        o("iquest", 191),
        o("Agrave", 192),
        o("Aacute", 193),
        o("Acirc", 194),
        o("Atilde", 195),
        o("Auml", 196),
        o("Aring", 197),
        o("AElig", 198),
        o("Ccedil", 199),
        o("Egrave", 200),
        o("Eacute", 201),
        o("Ecirc", 202),
        o("Euml", 203),
        o("Igrave", 204),
        o("Iacute", 205),
        o("Icirc", 206),
        o("Iuml", 207),
        o("ETH", 208),
        o("Ntilde", 209),
        o("Ograve", 210),
        o("Oacute", 211),
        o("Ocirc", 212),
        o("Otilde", 213),
        o("Ouml", 214),
        o("times", 215),
        o("Oslash", 216),
        o("Ugrave", 217),
        o("Uacute", 218),
        o("Ucirc", 219),
        o("Uuml", 220),
        o("Yacute", 221),
        o("THORN", 222),
        o("szlig", 223),
        o("agrave", 224),
        o("aacute", 225),
        o("acirc", 226),
        o("atilde", 227),
        o("auml", 228),
        o("aring", 229),
        o("aelig", 230),
        o("ccedil", 231),
        o("egrave", 232),
        o("eacute", 233),
        o("ecirc", 234),
        o("euml", 235),
        o("igrave", 236),
        o("iacute", 237),
        o("icirc", 238),
        o("iuml", 239),
        o("eth", 240),
        o("ntilde", 241),
        o("ograve", 242),
        o("oacute", 243),
        o("ocirc", 244),
        o("otilde", 245),
        o("ouml", 246),
        o("divide", 247),
        o("oslash", 248),
        o("ugrave", 249),
        o("uacute", 250),
        o("ucirc", 251),
        o("uuml", 252),
        o("yacute", 253),
        o("thorn", 254),
        o("yuml", 255),
        o("OElig", 338),
        o("oelig", 339),
        o("Scaron", 352),
        o("scaron", 353),
        o("Yuml", 376),
        o("fnof", 402),
        o("circ", 710),
        o("tilde", 732),
        o("Alpha", 913),
        o("Beta", 914),
        o("Gamma", 915),
        o("Delta", 916),
        o("Epsilon", 917),
        o("Zeta", 918),
        o("Eta", 919),
        o("Theta", 920),
        o("Iota", 921),
        o("Kappa", 922),
        o("Lambda", 923),
        o("Mu", 924),
        o("Nu", 925),
        o("Xi", 926),
        o("Omicron", 927),
        o("Pi", 928),
        o("Rho", 929),
        o("Sigma", 931),
        o("Tau", 932),
        o("Upsilon", 933),
        o("Phi", 934),
        o("Chi", 935),
        o("Psi", 936),
        o("Omega", 937),
        o("alpha", 945),
        o("beta", 946),
        o("gamma", 947),
        o("delta", 948),
        o("epsilon", 949),
        o("zeta", 950),
        o("eta", 951),
        o("theta", 952),
        o("iota", 953),
        o("kappa", 954),
        o("lambda", 955),
        o("mu", 956),
        o("nu", 957),
        o("xi", 958),
        o("omicron", 959),
        o("pi", 960),
        o("rho", 961),
        o("sigmaf", 962),
        o("sigma", 963),
        o("tau", 964),
        o("upsilon", 965),
        o("phi", 966),
        o("chi", 967),
        o("psi", 968),
        o("omega", 969),
        o("thetasym", 977),
        o("upsih", 978),
        o("piv", 982),
        o("ensp", 8194),
        o("emsp", 8195),
        o("thinsp", 8201),
        o("zwnj", 8204),
        o("zwj", 8205),
        o("lrm", 8206),
        o("rlm", 8207),
        o("ndash", 8211),
        o("mdash", 8212),
        o("lsquo", 8216),
        o("rsquo", 8217),
        o("sbquo", 8218),
        o("ldquo", 8220),
        o("rdquo", 8221),
        o("bdquo", 8222),
        o("dagger", 8224),
        o("Dagger", 8225),
        o("bull", 8226),
        o("hellip", 8230),
        o("permil", 8240),
        o("prime", 8242),
        o("Prime", 8243),
        o("lsaquo", 8249),
        o("rsaquo", 8250),
        o("oline", 8254),
        o("frasl", 8260),
        o("euro", 8364),
        o("image", 8465),
        o("weierp", 8472),
        o("real", 8476),
        o("trade", 8482),
        o("alefsym", 8501),
        o("larr", 8592),
        o("uarr", 8593),
        o("rarr", 8594),
        o("darr", 8595),
        o("harr", 8596),
        o("crarr", 8629),
        o("lArr", 8656),
        o("uArr", 8657),
        o("rArr", 8658),
        o("dArr", 8659),
        o("hArr", 8660),
        o("forall", 8704),
        o("part", 8706),
        o("exist", 8707),
        o("empty", 8709),
        o("nabla", 8711),
        o("isin", 8712),
        o("notin", 8713),
        o("ni", 8715),
        o("prod", 8719),
        o("sum", 8721),
        o("minus", 8722),
        o("lowast", 8727),
        o("radic", 8730),
        o("prop", 8733),
        o("infin", 8734),
        o("ang", 8736),
        o("and", 8743),
        o("or", 8744),
        o("cap", 8745),
        o("cup", 8746),
        o("int", 8747),
        o("there4", 8756),
        o("sim", 8764),
        o("cong", 8773),
        o("asymp", 8776),
        o("ne", 8800),
        o("equiv", 8801),
        o("le", 8804),
        o("ge", 8805),
        o("sub", 8834),
        o("sup", 8835),
        o("nsub", 8836),
        o("sube", 8838),
        o("supe", 8839),
        o("oplus", 8853),
        o("otimes", 8855),
        o("perp", 8869),
        o("sdot", 8901),
        o("lceil", 8968),
        o("rceil", 8969),
        o("lfloor", 8970),
        o("rfloor", 8971),
        o("lang", 9001),
        o("rang", 9002),
        o("loz", 9674),
        o("spades", 9824),
        o("clubs", 9827),
        o("hearts", 9829),
        o("diams", 9830)
    ])), Lf = A2(Nf, Mf, function(n) {
        var r = n.cy;
        if (r.b && !r.a.$) {
            var t = A2($e, r.a.a, Zf);
            return t.$ ? n.Z : Xi(Hi(t.a));
        }
        return n.Z;
    }), Rf = A2(Nf, A2(wa, qf, Sf("(\\\\+)([!\"#$%&\\'()*+,./:;<=>?@[\\\\\\]^_`{|}~-])")), function(n) {
        var r = n.cy;
        if (r.b && !r.a.$ && r.b.b && !r.b.a.$) {
            var t = r.b.a.a;
            return v(A2(lf, St(r.a.a) / 2 | 0, "\\"), t);
        }
        return n.Z;
    }), Bf = A2(wa, qf, Sf("&#[Xx]([0-9a-fA-F]{1,8});")), Df = _, Ff = A2(Nf, Bf, function(n) {
        var r, t = n.cy;
        return t.b && !t.a.$ ? Of((r = t.a.a, A3(Df, F2(function(n, r) {
            return 16 * r + A2(Me, 39, Xr(n)) - 9;
        }), 0, Bi(r)))) : n.Z;
    }), Uf = function(n) {
        var r = Rf(n);
        return A2(_t, "&", r) ? Ff(zf(Lf(r))) : r;
    }, Pf = function(n) {
        return {
            g: 0,
            p: d,
            i: 0,
            j: Uf(n),
            t: 0,
            r: 0,
            k: Cf
        };
    }, Qf = F3(function(n, r, e) {
        var u = r, a = {
            g: u.g,
            p: A3(Wf, u.j, d, u.p),
            i: u.i,
            j: u.j,
            t: u.t,
            r: u.r,
            k: u.k
        };
        if (e.b) {
            var i = e.a;
            return i.k.$ ? t(u.g, i.i) ? A2(Yr, a, e) : 0 > c(u.g, i.i) ? A2(Yr, a, A2(Yr, Pf(A3(qt, u.g, i.i, n)), e)) : e : A2(Yr, a, e);
        }
        var o = A2(Tt, u.g, n);
        return Nt(o) ? h([
            a
        ]) : h([
            a,
            Pf(o)
        ]);
    }), Wf = F3(function(n, r, t) {
        for(;;){
            if (!t.b) {
                if (r.b) {
                    var e = r.a;
                    return e.i > 0 ? A2(Yr, Pf(A2(Ot, e.i, n)), r) : r;
                }
                return Nt(n) ? d : h([
                    Pf(n)
                ]);
            }
            var u = t.b, a = n, c = A3(Qf, n, t.a, r);
            n = a, r = c, t = u;
        }
    }), Hf = F3(function(n, r, t) {
        n: for(;;){
            if (!r.b) return d;
            var e = r.a, u = r.b;
            if (n.b) {
                var a = n.a, i = n.b;
                if (0 > c(a.c, e.c)) {
                    if (t) {
                        n = i, t += 1;
                        continue n;
                    }
                    return A2(Yr, a, A3(Hf, i, r, t + 1));
                }
                if (t > 1) {
                    r = u, t -= 1;
                    continue n;
                }
                if (1 === t) return A2(Yr, e, A3(Hf, n, u, t - 1));
                r = u, t = 0;
            } else if (t > 1) r = u, t -= 1;
            else {
                if (1 === t) return A2(Yr, e, A3(Hf, n, u, t - 1));
                r = u, t = 0;
            }
        }
    }), Gf = A2(wa, qf, Sf("(\\\\*)(\\<)")), Vf = xr(Ar), Xf = {
        $: 4
    }, Jf = function(n) {
        var r = n.cy;
        if (r.b && r.b.b && !r.b.a.$) {
            var t = A2(wa, 0, A2(aa, St, r.a));
            return Do(t) ? Br({
                c: n.c + t,
                aI: 1,
                e: Xf
            }) : Dr;
        }
        return Dr;
    }, Kf = A2(wa, qf, Sf("(\\\\*)(\\>)")), ns = function(n) {
        return {
            $: 5,
            a: n
        };
    }, rs = function(n) {
        var r = n.cy;
        if (r.b && r.b.b && !r.b.a.$) {
            var t = A2(wa, 0, A2(aa, St, r.a));
            return Br({
                c: n.c + t,
                aI: 1,
                e: Do(t) ? ns(1) : ns(0)
            });
        }
        return Dr;
    }, ts = A2(wa, qf, Sf("(\\\\*)([^*])?(\\*+)([^*])?")), es = F2(function(n, r) {
        return {
            $: 7,
            a: n,
            b: r
        };
    }), us = A2(Df, F2(function(n, r) {
        return r || function(n) {
            switch(n){
                case "!":
                case '"':
                case "#":
                case "%":
                case "&":
                case "'":
                case "(":
                case ")":
                case "*":
                case ",":
                case "-":
                case ".":
                case "/":
                case ":":
                case ";":
                case "?":
                case "@":
                case "[":
                case "]":
                case "_":
                case "{":
                case "}":
                case "~":
                    return !0;
                default:
                    return !1;
            }
        }(n);
    }), !1), as = A2(Df, F2(function(n, r) {
        return r || function(n) {
            switch(n){
                case " ":
                case "\f":
                case "\n":
                case "\r":
                case "\t":
                case "\v":
                case "\xa0":
                case "\u2028":
                case "\u2029":
                    return !0;
                default:
                    return !1;
            }
        }(n);
    }), !1), cs = function(n) {
        if (n.$) return 0;
        var r = n.a;
        return Nt(r) || as(r) ? 0 : us(r) ? 1 : 2;
    }, is = F3(function(n, r, t) {
        var e = t.cy;
        if (e.b && e.b.b && e.b.b.b && !e.b.b.a.$ && e.b.b.b.b) {
            var u = e.a, a = e.b, c = a.a, i = a.b, o = i.a.a, f = cs(i.b.a), s = c.$ ? 0 : St(c.a), b = t.c && !s ? Br(A3(qt, t.c - 1, t.c, r)) : c, v = u.$ ? 0 : St(u.a), d = !Do(v) && !s || !b.$ && "\\" === b.a, l = d ? St(o) - 1 : St(o), $ = d ? 1 : cs(b);
            return 0 >= l || "_" === n && 2 === $ && 2 === f ? Dr : Br({
                c: t.c + v + s + (d ? 1 : 0),
                aI: l,
                e: A2(es, n, {
                    ap: $,
                    as: f
                })
            });
        }
        return Dr;
    }), os = A2(wa, qf, Sf("(\\\\*)(\\`+)")), fs = function(n) {
        return {
            $: 0,
            a: n
        };
    }, ss = function(n) {
        var r = n.cy;
        if (r.b && r.b.b && !r.b.a.$) {
            var t = r.b.a.a, e = A2(wa, 0, A2(aa, St, r.a));
            return Br({
                c: n.c + e,
                aI: St(t),
                e: Do(e) ? fs(1) : fs(0)
            });
        }
        return Dr;
    }, bs = A2(wa, qf, Sf("(?:(\\\\+)|( {2,}))\\n")), vs = {
        $: 8
    }, ds = function(n) {
        var r = n.cy;
        n: for(;;){
            if (r.b) {
                if (r.a.$) {
                    if (r.b.b && !r.b.a.$) return Br({
                        c: n.c,
                        aI: St(n.Z),
                        e: vs
                    });
                    break n;
                }
                var t = St(r.a.a);
                return Do(t) ? Dr : Br({
                    c: n.c + t - 1,
                    aI: 2,
                    e: vs
                });
            }
            break n;
        }
        return Dr;
    }, ls = (Sf("(?:(\\\\+)|( *))\\n"), A2(wa, qf, Sf("(\\\\*)(\\])"))), $s = {
        $: 3
    }, hs = function(n) {
        var r = n.cy;
        if (r.b && r.b.b && !r.b.a.$) {
            var t = A2(wa, 0, A2(aa, St, r.a));
            return Do(t) ? Br({
                c: n.c + t,
                aI: 1,
                e: $s
            }) : Dr;
        }
        return Dr;
    }, gs = A2(wa, qf, Sf("(\\\\*)(\\!)?(\\[)")), ps = {
        $: 2
    }, ms = function(n) {
        return {
            $: 1,
            a: n
        };
    }, ws = function(n) {
        var r = n.cy;
        if (r.b && r.b.b && r.b.b.b && !r.b.b.a.$) {
            var t = r.b.a, e = A2(wa, 0, A2(aa, St, r.a)), u = !Do(e), a = u ? n.c + e + 1 : n.c + e;
            return u ? t.$ ? Dr : Br({
                c: a,
                aI: 1,
                e: ms(0)
            }) : Br(t.$ ? {
                c: a,
                aI: 1,
                e: ms(0)
            } : {
                c: a,
                aI: 2,
                e: ps
            });
        }
        return Dr;
    }, ys = function(n) {
        return {
            $: 9,
            a: n
        };
    }, ks = function(n) {
        var r = n.cy;
        if (r.b && r.b.b && !r.b.a.$) {
            var t = r.b.a.a, e = A2(wa, 0, A2(aa, St, r.a)), u = Do(e) ? o(St(t), ys(1)) : o(St(t), ys(0));
            return Br({
                c: n.c + e,
                aI: u.a,
                e: u.b
            });
        }
        return Dr;
    }, xs = A2(wa, qf, Sf("(\\\\*)(~{2,})([^~])?")), Is = A2(wa, qf, Sf("(\\\\*)([^_])?(\\_+)([^_])?")), As = F2(function(n, r) {
        if (n.b) {
            var t = n.a, e = n.b;
            if (r.b) {
                var u = r.a, a = r.b;
                return 0 > c(t.c, u.c) ? A2(Yr, t, A2(As, e, r)) : A2(Yr, u, A2(As, n, a));
            }
            return n;
        }
        return r;
    }), js = {
        $: 2
    }, Es = function(n) {
        return {
            $: 6,
            a: n
        };
    }, Cs = function(n) {
        return {
            $: 5,
            a: n
        };
    }, Ys = function(n) {
        return {
            $: 4,
            a: n
        };
    }, _s = {
        $: 8
    }, Ss = function(n) {
        return {
            $: 3,
            a: n
        };
    }, qs = kr, Ts = A2(wa, qf, Sf("%(?:3B|2C|2F|3F|3A|40|26|3D|2B|24|23|25)")), Ns = function(n) {
        return encodeURIComponent(n);
    }, Os = A2(Ce, Ns, A2(Nf, Ts, function(n) {
        return A2(wa, n.Z, function(n) {
            try {
                return Br(decodeURIComponent(n));
            } catch (n) {
                return Dr;
            }
        }(n.Z));
    })), zs = A2(wa, qf, Sf("^([A-Za-z][A-Za-z0-9.+\\-]{1,31}:[^<>\\x00-\\x20]*)$")), Ms = xr, Zs = A2(wa, qf, Sf("^\\[\\s*([^\\[\\]\\\\]*(?:\\\\.[^\\[\\]\\\\]*)*)\\s*\\]")), Ls = F2(function(n, r) {
        return r.$ ? Dr : n(r.a);
    }), Rs = function(n) {
        return n;
    }, Bs = A2(Ce, Rs, Bi), Ds = F2(function(n, r) {
        return o(Os(Uf(n)), A2(aa, Uf, r));
    }), Fs = F3(function(n, r, t) {
        var e, u = Nt(e = A2(wa, n.j, A2(wa, Dr, A2(Ls, A2(Ce, function(n) {
            return n.cy;
        }, Ku), t)))) ? n.j : e, a = A2($e, Bs(u), r);
        if (1 === a.$) return Dr;
        var c = a.a, i = c.a, o = c.b, f = 5 === n.k.$ ? Cs(A2(Ds, i, o)) : Ys(A2(Ds, i, o)), s = t.$ ? 0 : St(t.a.Z);
        return Br(b(n, {
            g: n.g + s,
            k: f
        }));
    }), Us = F3(function(n, r, t) {
        return A3(Fs, r, t, Ku(A3(Ms, 1, Zs, n)));
    }), Ps = " \\t\\f\\v\\r\\n", Qs = A2(wa, qf, Sf("^\\(\\s*(?:<([^<>\\f\\v\\r\\n]*)>|([^" + Ps + "\\(\\)\\\\]*(?:\\\\.[^" + Ps + "\\(\\)\\\\]*)*))(?:[" + Ps + "]+(?:'([^'\\\\]*(?:\\\\.[^'\\\\]*)*)'|\"([^\"\\\\]*(?:\\\\.[^\"\\\\]*)*)\"|\\(([^\\)\\\\]*(?:\\\\.[^\\)\\\\]*)*)\\)))?\\s*\\)")), Ws = function(n) {
        return A3(Pr, F2(function(n, r) {
            return r.$ ? n : Br(r.a);
        }), Dr, n);
    }, Hs = F2(function(n, r) {
        var t, e = r.cy;
        if (e.b && e.b.b && e.b.b.b && e.b.b.b.b && e.b.b.b.b.b) {
            var u = e.a, a = e.b, c = a.a, i = a.b, o = i.b, f = Ws(h([
                i.a,
                o.a,
                o.b.a
            ])), s = Ws(h([
                u,
                c
            ]));
            return Br((t = A2(wa, "", s), b(n, {
                g: n.g + St(r.Z),
                k: (5 === n.k.$ ? Cs : Ys)(A2(Ds, t, f))
            })));
        }
        return Dr;
    }), Gs = F3(function(n, r, t) {
        var e = r, u = A3(Ms, 1, Qs, n);
        if (u.b) {
            var a = A2(Hs, e, u.a);
            return a.$ ? A3(Us, n, e, t) : Br(a.a);
        }
        return A3(Us, n, e, t);
    }), Vs = function(n) {
        return !n.b;
    }, Xs = F2(function(n, r) {
        var t = n, e = Oi(function(n) {
            var r = n;
            return c(t.g, r.i) > 0 && 0 > c(t.g, r.g);
        });
        return Vs(r) || Vs(e(r)) ? Br(A2(Yr, t, r)) : Dr;
    }), Js = A2(wa, qf, Sf("^([a-zA-Z0-9.!#$%&'*+\\/=?^_`{|}~\\-]+@[a-zA-Z0-9](?:[a-zA-Z0-9\\-]{0,61}[a-zA-Z0-9])?(?:\\.[a-zA-Z0-9](?:[a-zA-Z0-9\\-]{0,61}[a-zA-Z0-9])?)*)$")), Ks = function(n) {
        var r = n;
        return A2(qs, Js, r.j) ? Lr(b(r, {
            k: Ss(o(r.j, "mailto:" + Os(r.j)))
        })) : Or(r);
    }, nb = F3(function(n, r, t) {
        for(;;){
            if (!t.b) return Dr;
            var e = t.a, u = t.b;
            if (r(e)) return Br(f(e, tt(n), u));
            n = A2(Yr, e, n), t = u;
        }
    }), rb = F2(function(n, r) {
        return A3(nb, d, n, r);
    }), tb = F2(function(n, r) {
        return {
            $: 6,
            a: n,
            b: r
        };
    }), eb = function(n) {
        return A3(Lu, !1, n.d, n);
    }, ub = F2(function(n, r) {
        var t = r, e = A2(ea, A2(ea, A2(ea, ka(F3(function(n, r, t) {
            return {
                bj: r,
                aI: t - n
            };
        })), eb), No), eb), u = A2(Ja, e, A2(Tt, t.i, n));
        return u.$ ? Dr : Br({
            c: t.i,
            aI: u.a.aI,
            e: A2(tb, 0, u.a.bj)
        });
    }), ab = F2(function(n, r) {
        return r.$ ? n(r.a) : r;
    }), cb = F2(function(n, r) {
        var e = r.e;
        return !e.$ && t(e.a ? r.aI : r.aI - 1, n.aI);
    }), ib = function(n) {
        switch(n.e.$){
            case 1:
            case 2:
                return !0;
            default:
                return !1;
        }
    }, ob = F2(function(n, r) {
        var e = r.e;
        if (7 === e.$) {
            var u = e.b, a = n.e;
            if (7 === a.$) {
                var c = a.b;
                return !(!t(e.a, a.a) || (t(u.ap, u.as) || t(c.ap, c.as)) && !A2(Me, 3, n.aI + r.aI) && (A2(Me, 3, n.aI) || A2(Me, 3, r.aI)));
            }
            return !1;
        }
        return !1;
    }), fb = F2(function(n, r) {
        var e, u, a = 9 === (u = r.e).$ ? o(!0, u.a ? r.aI : r.aI - 1) : o(!1, 0), c = a.a, i = a.b, f = 9 === (e = n.e).$ ? o(!0, e.a ? n.aI : n.aI - 1) : o(!1, 0);
        return f.a && c && t(f.b, i);
    }), sb = {
        $: 1
    }, bb = F2(function(n, r) {
        return {
            g: n.c + n.aI,
            p: d,
            i: n.c,
            j: "",
            t: 0,
            r: 0,
            k: r
        };
    }), vb = F2(function(n, r) {
        for(;;){
            if (!n.b) return r;
            var t = n.a, e = n.b;
            8 !== t.e.$ ? n = e : (n = e, r = A2(Yr, A2(bb, t, sb), r));
        }
    }), db = F2(function(n, r) {
        var t = n;
        return A2(Oi, function(n) {
            return c(n.c, t.g) > -1;
        }, r);
    }), lb = F6(function(n, r, t, e, u, a) {
        var c, i = a.c, f = A2(ab, Ks, A2(qs, zs, (c = A7(Ib, e, u, function(n) {
            return n;
        }, js, a.a, n, d)).j) ? Lr(b(c, {
            k: Ss(o(c.j, Os(c.j)))
        })) : Or(c));
        if (1 === f.$) {
            if (1 === r) {
                var s = A2(ub, u, f.a);
                return s.$ ? Dr : Br(o(A2(Yr, s.a, i), t));
            }
            return Dr;
        }
        return Br(o(i, A2(Yr, f.a, t)));
    }), $b = F5(function(n, r, t, e, u) {
        n: for(;;){
            if (!n.b) return A5(mb, tt(r), d, t, e, u);
            var a = n.a, c = n.b, i = a.e;
            switch(i.$){
                case 0:
                    var o = A2(rb, cb(a), r);
                    if (o.$) {
                        n = c, r = A2(Yr, a, r);
                        continue n;
                    }
                    var f = A5(hb, a, t, e, u, o.a);
                    n = c, r = h = f.a, t = g = f.b;
                    continue n;
                case 5:
                    var s = i.a, b = function(n) {
                        return 4 === n.e.$;
                    }, v = A2(rb, b, r);
                    if (v.$) {
                        n = c, r = A2(Oi, A2(ki, Ya, b), r);
                        continue n;
                    }
                    var l = A6(lb, a, s, t, e, u, v.a);
                    if (l.$) {
                        n = c, r = A2(Oi, A2(ki, Ya, b), r);
                        continue n;
                    }
                    var $ = l.a, h = $.a, g = $.b;
                    n = c, r = A2(Oi, A2(ki, Ya, b), h), t = g;
                    continue n;
                default:
                    n = c, r = A2(Yr, a, r);
                    continue n;
            }
        }
    }), hb = F5(function(n, r, t, e, u) {
        var a, c = u.a, i = u.c, f = (a = c.e).$ || a.a ? c : b(c, {
            c: c.c + 1,
            aI: c.aI - 1
        });
        return o(i, A2(Yr, A7(Ib, t, e, Rs, js, f, n, d), r));
    }), gb = F5(function(n, r, e, u, a) {
        n: for(;;){
            if (!n.b) return A5(kb, tt(r), d, e, u, a);
            var i = n.a, o = n.b, f = i.e;
            if (7 !== f.$) n = o, r = A2(Yr, i, r);
            else {
                var s = f.a, b = f.b.ap, v = f.b.as;
                if (t(b, v)) {
                    if (!v || "_" === s && 1 !== v) {
                        n = o;
                        continue n;
                    }
                    var l = A2(rb, ob(i), r);
                    if (l.$) {
                        n = o, r = A2(Yr, i, r);
                        continue n;
                    }
                    var $ = A5(pb, u, a, i, o, l.a);
                    n = $.a, r = $.c, e = A2(Yr, $.b, e);
                    continue n;
                }
                if (0 > c(b, v)) {
                    n = o, r = A2(Yr, i, r);
                    continue n;
                }
                var h = A2(rb, ob(i), r);
                if (h.$) {
                    n = o;
                    continue n;
                }
                var g = A5(pb, u, a, i, o, h.a);
                n = g.a, r = g.c, e = A2(Yr, g.b, e);
            }
        }
    }), pb = F5(function(n, r, t, e, u) {
        var a = u.a, c = u.b, i = u.c, o = a.aI - t.aI, s = o ? o > 0 ? {
            am: t,
            _: b(a, {
                c: a.c + o,
                aI: t.aI
            }),
            ar: A2(Yr, b(a, {
                aI: o
            }), i),
            av: e
        } : {
            am: b(t, {
                aI: a.aI
            }),
            _: a,
            ar: i,
            av: A2(Yr, b(t, {
                c: t.c + a.aI,
                aI: -o
            }), e)
        } : {
            am: t,
            _: a,
            ar: i,
            av: e
        }, v = A7(Ib, n, r, function(n) {
            return n;
        }, {
            $: 7,
            a: s._.aI
        }, s._, s.am, tt(c));
        return f(s.av, v, s.ar);
    }), mb = F5(function(n, r, t, e, u) {
        for(;;){
            if (!n.b) return A5(wb, tt(r), d, t, e, u);
            var a = n.a, c = n.b, i = a.e;
            6 !== i.$ ? (n = c, r = A2(Yr, a, r)) : (n = c, t = A2(Yr, A2(bb, a, Es(i.b)), t));
        }
    }), wb = F5(function(n, r, t, e, u) {
        n: for(;;){
            if (!n.b) return A5(gb, tt(r), d, t, e, u);
            var a = n.a, c = n.b;
            if (3 !== a.e.$) n = c, r = A2(Yr, a, r);
            else {
                var i = A2(rb, ib, r);
                if (i.$) {
                    n = c;
                    continue n;
                }
                var o = A6(yb, a, c, t, e, u, i.a);
                if (o.$) {
                    n = c;
                    continue n;
                }
                var f = o.a;
                n = f.a, r = f.c, t = f.b;
            }
        }
    }), yb = F6(function(n, r, t, e, u, a) {
        var c = a.a, i = a.b, s = a.c, d = f(r, t, v(i, s)), l = A2(Tt, n.c + 1, u), $ = function(n) {
            return 1 === n.e.$ ? b(n, {
                e: ms(1)
            }) : n;
        }, h = function(r) {
            return A7(Ib, e, u, function(n) {
                return n;
            }, r ? Ys(o("", Dr)) : Cs(o("", Dr)), c, n, tt(i));
        }, g = c.e;
        switch(g.$){
            case 2:
                var p = h(!1), m = A3(Gs, l, p, e);
                if (1 === m.$) return Br(d);
                var w = A2(Xs, x = m.a, t);
                if (w.$) return Br(d);
                var y = w.a;
                return Br(f(A2(db, x, r), y, s));
            case 1:
                if (g.a) return Br(d);
                p = h(!0);
                var k = A3(Gs, l, p, e);
                if (1 === k.$) return Br(d);
                var x, I = A2(Xs, x = k.a, t);
                return I.$ ? Br(d) : (y = I.a, Br(f(A2(db, x, r), y, A2(Dt, $, s))));
            default:
                return Dr;
        }
    }), kb = F5(function(n, r, t, e, u) {
        n: for(;;){
            if (!n.b) return A2(vb, tt(r), t);
            var a = n.a, c = n.b;
            if (9 !== a.e.$) n = c, r = A2(Yr, a, r);
            else {
                var i = A2(rb, fb(a), r);
                if (i.$) {
                    n = c, r = A2(Yr, a, r);
                    continue n;
                }
                var o = A5(xb, a, t, e, u, i.a);
                n = c, r = o.a, t = o.b;
            }
        }
    }), xb = F5(function(n, r, t, e, u) {
        var a, c = u.a, i = u.c, f = 9 !== (a = c.e).$ || a.a ? c : b(c, {
            c: c.c + 1,
            aI: c.aI - 1
        });
        return o(i, A2(Yr, A7(Ib, t, e, Rs, _s, f, n, d), r));
    }), Ib = F7(function(n, r, t, e, u, a, c) {
        var i = u.c + u.aI, o = a.c, f = t(A3(qt, i, o, r)), s = u.c, b = a.c + a.aI, v = {
            g: b,
            p: d,
            i: s,
            j: f,
            t: o,
            r: i,
            k: e
        };
        return {
            g: b,
            p: A2(Dt, function(n) {
                return A2(kf, v, n);
            }, A4(Ab, c, d, n, r)),
            i: s,
            j: f,
            t: o,
            r: i,
            k: e
        };
    }), Ab = F4(function(n, r, t, e) {
        return A5($b, n, d, r, t, e);
    }), jb = function(n) {
        return n.trim();
    }, Eb = F2(function(n, r) {
        var t = jb(r), e = function(n) {
            var r;
            return A2(As, A3(Hf, A2(If, function(n) {
                return n.c;
            }, A2(fu, Jf, A2(Vf, Gf, n))), A2(If, function(n) {
                return n.c;
            }, A2(fu, rs, A2(Vf, Kf, n))), 0), A2(As, (r = n, A2(fu, ds, A2(Vf, bs, r))), A2(As, function(n) {
                return A2(fu, hs, A2(Vf, ls, n));
            }(n), A2(As, function(n) {
                return A2(fu, ws, A2(Vf, gs, n));
            }(n), A2(As, function(n) {
                return A2(fu, ks, A2(Vf, xs, n));
            }(n), A2(As, function(n) {
                return A2(fu, A2(is, "_", n), A2(Vf, Is, n));
            }(n), A2(As, function(n) {
                return A2(fu, A2(is, "*", n), A2(Vf, ts, n));
            }(n), function(n) {
                return A2(fu, ss, A2(Vf, os, n));
            }(n))))))));
        }(t);
        return yf(A3(Wf, t, d, jf(A4(Ab, e, d, n, t))));
    }), Cb = sa(h([
        _a(A2(Ea, " ", ja(" "))),
        _a(A2(Ea, ">", ja(">"))),
        A2(ra, A2(ra, A2(Hu, nt, ja("Alpha")), di(function(n) {
            var r;
            return Jr(r = n) || Kr(r) || rt(r) || "-" === n;
        })), sa(h([
            _a(A2(Ea, ":", ja(":"))),
            _a(A2(Ea, "@", ja("@"))),
            _a(A2(Ea, "\\", ja("\\"))),
            _a(A2(Ea, "+", ja("+"))),
            _a(A2(Ea, ".", ja(".")))
        ])))
    ])), Yb = $a(A2(pa, F2(function(n) {
        return Gc(n);
    }), A2(ra, A2(ra, A2(ra, _a(A2(Ea, "<", ja("<"))), Cb), Ii), Ei))), _b = function(n) {
        return _a(A2(Ea, n, ja(n)));
    }, Sb = function(n) {
        var r = n.a, t = n.b, e = A2(wa, _c(t), A2(aa, function(n) {
            return _c(A2(Yr, n, t));
        }, r)), u = A2(wa, Hc(o(Dr, t)), A2(aa, function(n) {
            return Hc(o(Dr, A2(Yr, n, t)));
        }, r)), a = function(n) {
            return Hc(o(Br(function(n) {
                return v(A2(wa, "", r), n);
            }(n)), t));
        };
        return sa(h([
            A2(ca, function() {
                return e;
            }, _b("|\n")),
            A2(ca, function() {
                return e;
            }, _b("\n")),
            A2(ca, function() {
                return e;
            }, Xu(ja("end"))),
            A2(ra, $a(ka(a("|"))), _b("\\\\|")),
            A2(ra, $a(ka(a("\\"))), _b("\\\\")),
            A2(ra, $a(ka(a("|"))), _b("\\|")),
            A2(ra, $a(ka(u)), _b("|")),
            A2(pa, F2(function(n) {
                return a(n);
            }), A2(Hu, zu(!0), Ua("No character found")))
        ]));
    }, qb = A2(ca, A2(Pr, F2(function(n, r) {
        return A2(Yr, jb(n), r);
    }), d), A2(Qi, o(Dr, d), Sb)), Tb = A2(ea, A2(ra, ka(Yt), sa(h([
        _b("|"),
        ka(0)
    ]))), qb), Nb = F2(function(n, r) {
        var e, u = n.b, a = A2(Ja, Tb, r);
        return a.$ ? Or("Unable to parse previous line as a table header") : t(Qr(e = a.a), Qr(u)) ? Lr(function(n) {
            return A3(Wr, F2(function(n, r) {
                return {
                    aj: r,
                    L: n
                };
            }), n, u);
        }(e)) : Or("Tables must have the same number of header columns (" + Fr(Qr(e)) + ") as delimiter columns (" + Fr(Qr(u)) + ")");
    }), Ob = F2(function(n, r) {
        return {
            bY: r,
            ce: n
        };
    }), zb = {
        ak: "`",
        ao: 0,
        au: A2(Ea, "`", ja("a '`'"))
    }, Mb = function(n) {
        switch(n){
            case 1:
                return ka(0);
            case 2:
                return ka(1);
            case 3:
                return ka(2);
            case 4:
                return ka(3);
            default:
                return Pa(ja("Fenced code blocks should be indented no more than 3 spaces"));
        }
    }, Zb = F2(function(n, r) {
        var t = A3(Pr, F2(function(n, r) {
            return A2(ra, r, n);
        }), ka(0), A2(sf, n, _a(r.au)));
        return A2(pa, F2(function(n) {
            return o(r, St(n));
        }), A2(ra, t, di(dt(r.ak))));
    }), Lb = {
        ak: "~",
        ao: 1,
        au: A2(Ea, "~", ja("a `~`"))
    }, Rb = sa(h([
        A2(ra, A2(ra, of, sa(h([
            of,
            ka(0)
        ]))), sa(h([
            of,
            ka(0)
        ]))),
        ka(0)
    ])), Bb = A2(ea, A2(ea, A2(ra, ka(F2(function(n, r) {
        return {
            al: r.a,
            aH: n,
            aI: r.b
        };
    })), Rb), A2(Ru, Mb, Jo)), sa(h([
        A2(Zb, 3, zb),
        A2(Zb, 3, Lb)
    ]))), Db = dt(" "), Fb = F2(function(n, r) {
        return A2(ra, A2(ra, A2(ra, A2(ra, ka(0), Rb), A2(Zb, n, r)), di(Db)), Ei);
    }), Ub = function(n) {
        return A3(Lu, !1, n.aS, n);
    }, Pb = function(n) {
        var r, t = n.a, e = n.b;
        return sa(h([
            A2(ra, ka(_c(e)), Xu(Vu)),
            A2(pa, F2(function(n) {
                return Hc(o(t, v(e, n)));
            }), gi),
            $a(A2(ra, ka(_c(e)), A2(Fb, t.aI, t.al))),
            A2(ea, A2(ea, A2(ea, ka(F3(function(n, r, u) {
                return Hc(o(t, v(e, A3(qt, n, r, u))));
            })), (r = t.aH, A2(ea, A2(ra, ka(Yt), A2(bf, r, of)), A2(ra, A2(ra, eb, Ii), Ei)))), eb), Ub)
        ]));
    }, Qb = A2(Ru, function(n) {
        var r;
        return A2(ea, A2(ea, ka(Ob), A2(ra, (r = n.al, A2(pa, F2(function(n) {
            var r = jb(n);
            return "" === r ? Dr : Br(r);
        }), di(r.ao ? A2(ki, Ya, xi) : function(n) {
            return "`" !== n && !xi(n);
        }))), Ei)), function(n) {
            return A2(Qi, o(n, ""), Pb);
        }(n));
    }, Bb), Wb = F2(function(n, r) {
        return 1 > n ? r : A3(qt, 0, -n, r);
    }), Hb = A2(Ea, "#", ja("a `#`")), Gb = di(function(n) {
        return " " === n || "\n" === n || "\r" === n;
    }), Vb = A2(ea, A2(ea, A2(ra, A2(ra, ka(Mc), A2(Ru, function(n) {
        var r = St(n);
        return 4 > r ? ka(r) : Pa(ja("heading with < 4 spaces in front"));
    }, Ai(Gb))), wi(Hb)), A2(Ru, function(n) {
        var r = St(n) + 1;
        return 7 > r ? ka(r) : Pa(ja("heading with < 7 #'s"));
    }, Ai(di(function(n) {
        return "#" === n;
    })))), sa(h([
        A2(ra, ka(""), wi(hi)),
        A2(ea, A2(ra, ka(Yt), sa(h([
            wi(mi),
            wi(Lo)
        ]))), A2(pa, F2(function(n) {
            var r, t;
            return r = jb(n), t = function(n) {
                for(;;){
                    if (!A2(Ti, "#", n)) return n;
                    n = A2(Wb, 1, n);
                }
            }(r), A2(Ti, " ", t) || Nt(t) ? t.replace(/\s+$/, "") : r;
        }), Ii))
    ]))), Xb = wr, Jb = F4(function(n, r, t, e) {
        return A2(Fu, Pu, A4(Uu, n, r, t, e));
    }), Kb = function(n) {
        var r = n.a, e = n.b;
        return function(n) {
            var u = A5(Xb, r, n.d, n.cu, n.a5, n.aS), a = u.a, i = u.b, o = u.c;
            return t(a, -1) ? A2(Zu, !1, A4(Jb, i, o, e, n.f)) : A3(Lu, 0 > c(n.d, a), 0, {
                a5: o,
                f: n.f,
                h: n.h,
                d: a,
                cu: i,
                aS: n.aS
            });
        };
    }, nv = A2(Ea, ">", ja("a `>`")), rv = F3(function(n, r, t) {
        return {
            a5: r,
            f: t,
            cu: n
        };
    }), tv = F2(function(n, r) {
        return {
            a5: r.a5,
            f: n,
            h: r.h,
            d: r.d,
            cu: r.cu,
            aS: r.aS
        };
    }), ev = F2(function(n, r) {
        var t = r;
        return function(r) {
            var e = t(A2(tv, A2(Yr, A3(rv, r.cu, r.a5, n), r.f), r));
            return e.$ ? e : A3(Lu, e.a, e.b, A2(tv, r.f, e.c));
        };
    }), uv = function(n) {
        switch(n){
            case " ":
            case "\n":
            case "\t":
            case "\v":
            case "\f":
            case "\r":
                return !0;
            default:
                return !1;
        }
    }, av = A2(Ea, "<", ja("a `<`")), cv = A2(ev, "link destination", sa(h([
        A2(ea, A2(ra, ka(Ns), wi(av)), A2(ra, Ai(Kb(nv)), wi(nv))),
        Ai(nf(A2(ki, Ya, uv)))
    ]))), iv = A2(Ea, "]", ja("a `]`")), ov = A2(Ea, "[", ja("a `[`")), fv = A2(ea, A2(ra, ka(Bs), wi(ov)), A2(ra, Ai(Kb(iv)), wi(A2(Ea, "]:", ja("]:"))))), sv = A2(Ea, '"', ja("a double quote")), bv = function(n) {
        return A2(_t, "\n\n", n) ? Pa(ja("no blank line")) : ka(n);
    }, vv = A2(ra, di(function(n) {
        return !xi(n) && uv(n);
    }), Ei), dv = A2(ra, A2(Hu, uv, ja("Required whitespace")), di(uv)), lv = A2(Ea, "'", ja("a single quote")), $v = (zo = A2(ea, A2(ra, ka(Br), wi(lv)), A2(ra, A2(ra, A2(Ru, bv, Ai(Kb(lv))), wi(lv)), vv)), Mo = A2(ea, A2(ra, ka(Br), wi(sv)), A2(ra, A2(ra, A2(Ru, bv, Ai(Kb(sv))), wi(sv)), vv)), A2(ev, "title", sa(h([
        $a(A2(ea, A2(ra, ka(Yt), dv), sa(h([
            Mo,
            zo,
            ka(Dr)
        ])))),
        A2(ra, ka(Dr), vv)
    ])))), hv = A2(ev, "link reference definition", A2(ea, A2(ea, A2(ea, A2(ra, ka(F3(function(n, r, t) {
        return o(n, {
            b3: r,
            cC: t
        });
    })), Rb), A2(ra, A2(ra, A2(ra, fv, di(li)), sa(h([
        gi,
        ka(0)
    ]))), di(li))), cv), $v)), gv = di(li), pv = function(n) {
        var r = _b(Xi(n));
        return A2(ra, A2(ra, A2(ra, A2(ra, A2(ra, A2(ra, A2(ra, ka(0), r), gv), r), gv), r), di(function(r) {
            return t(r, n) || li(r);
        })), Ei);
    }, mv = sa(h([
        pv("-"),
        pv("*"),
        pv("_")
    ])), wv = sa(h([
        A2(ea, A2(ra, A2(ra, A2(ra, ka(Yt), of), sa(h([
            of,
            ka(0)
        ]))), sa(h([
            of,
            ka(0)
        ]))), mv),
        mv
    ])), yv = F2(function(n, r) {
        return {
            $: 13,
            a: n,
            b: r
        };
    }), kv = A2(Ea, "=", ja("a `=`")), xv = A2(Ea, "-", ja("a `-`")), Iv = (Zo = F3(function(n, r, t) {
        return A2(ra, A2(ra, ka(n), _a(r)), di(dt(t)));
    }), A2(pa, F2(function(n, r) {
        return A2(yv, r, n);
    }), A2(ea, A2(ra, ka(Yt), Rb), A2(ra, A2(ra, sa(h([
        A3(Zo, 0, kv, "="),
        A3(Zo, 1, xv, "-")
    ])), di(li)), Ei)))), Av = function(n) {
        return {
            $: 9,
            a: n
        };
    }, jv = di(li), Ev = function(n) {
        return sa(h([
            A2(Hu, n, Ua("Character not found")),
            ka(0)
        ]));
    }, Cv = function(n) {
        var r;
        return sa(h([
            $a(A2(ca, function() {
                return _c(n);
            }, _b("|\n"))),
            A2(ca, function() {
                return _c(n);
            }, _b("\n")),
            A2(ca, function() {
                return _c(n);
            }, Xu(ja("end"))),
            $a(A2(ra, A2(ra, ka(_c(n)), _b("|")), Xu(ja("end")))),
            A2(ea, A2(ra, A2(ra, ka(function(r) {
                return Hc(A2(Yr, r, n));
            }), (r = n, Vs(r) ? sa(h([
                _b("|"),
                ka(0)
            ])) : _b("|"))), jv), A2(ra, Ai(A2(ra, A2(ra, A2(ra, ka(0), Ev(function(n) {
                return ":" === n;
            })), nf(function(n) {
                return "-" === n;
            })), Ev(function(n) {
                return ":" === n;
            }))), jv))
        ]));
    }, Yv = function(n) {
        var r = o(A2(Mt, ":", n), A2(Ti, ":", n));
        return r.a ? Br(r.b ? 2 : 0) : r.b ? Br(1) : Dr;
    }, _v = A2(ca, Av, A2(Ru, function(n) {
        var r = n.a.bO, t = n.b;
        return Vs(t) ? Pa(ja("Must have at least one column in delimiter row.")) : 1 !== Qr(t) || A2(Mt, "|", r) && A2(Ti, "|", r) ? ka(n) : Pa(Ua("Tables with a single column must have pipes at the start and end of the delimiter row to avoid ambiguity."));
    }, A2(pa, F2(function(n, r) {
        return A2(ci, {
            bA: n,
            bO: jb(n)
        }, A2(Dt, Yv, tt(r)));
    }), A2(Qi, d, Cv)))), Sv = F2(function(n, r) {
        return !A2(Wo, A2(ki, Ya, n), r);
    }), qv = F3(function(n, r, t) {
        n: for(;;){
            if (n > 0) {
                if (r.b) {
                    var e = r.a;
                    n -= 1, r = r.b, t = A2(Yr, e, t);
                    continue n;
                }
                return t;
            }
            return t;
        }
    }), Tv = F2(function(n, r) {
        return tt(A3(qv, n, r, d));
    }), Nv = F3(function(n, r, t) {
        if (r > 0) {
            var e = o(r, t);
            n: for(;;){
                r: for(;;){
                    if (!e.b.b) return t;
                    if (!e.b.b.b) {
                        if (1 === e.a) break n;
                        break r;
                    }
                    switch(e.a){
                        case 1:
                            break n;
                        case 2:
                            var u = e.b;
                            return h([
                                u.a,
                                u.b.a
                            ]);
                        case 3:
                            if (e.b.b.b.b) {
                                var a = e.b, c = a.b;
                                return h([
                                    a.a,
                                    c.a,
                                    c.b.a
                                ]);
                            }
                            break r;
                        default:
                            if (e.b.b.b.b && e.b.b.b.b.b) {
                                var i = e.b, f = i.b, s = f.b, b = s.b, v = b.b;
                                return A2(Yr, i.a, A2(Yr, f.a, A2(Yr, s.a, A2(Yr, b.a, n > 1e3 ? A2(Tv, r - 4, v) : A3(Nv, n + 1, r - 4, v)))));
                            }
                            break r;
                    }
                }
                return t;
            }
            return h([
                e.b.a
            ]);
        }
        return d;
    }), Ov = F2(function(n, r) {
        return A3(Nv, 0, n, r);
    }), zv = F2(function(n, r) {
        var t = Qr(r);
        switch(A2(le, n, t)){
            case 0:
                return A2(Ov, n, r);
            case 1:
                return r;
            default:
                return v(r, A2(sf, n - t, ""));
        }
    }), Mv = function(n) {
        var r, t = n.a, e = n.b;
        return A2(ca, function(n) {
            return ui(A2(ai, t, v(e, h([
                n
            ]))));
        }, (r = Qr(t), A2(Ru, function(n) {
            return Vs(n) || A2(Sv, Nt, n) ? Pa(Ua("A line must have at least one column")) : ka(A2(zv, r, n));
        }, Tb)));
    }, Zv = {
        $: 2
    }, Lv = function(n) {
        return {
            $: 1,
            a: n
        };
    }, Rv = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), Bv = F4(function(n, r, t, e) {
        var u = e.a, a = e.b, c = u - t;
        return c > 4 ? f(r, t - n + 1, function() {
            switch(a.$){
                case 0:
                    var n = a.b;
                    return A2(Rv, a.a, v(A2(lf, c - 1, " "), n));
                case 1:
                    return n = a.a, Lv(v(A2(lf, c - 1, " "), n));
                default:
                    return Zv;
            }
        }()) : f(r, u - n, a);
    }), Dv = A2(ea, ka(function(n) {
        return o(n, Zv);
    }), A2(ra, Jo, Ei)), Fv = sa(h([
        A2(ra, ka(1), wi(A2(Ea, "[x] ", Nc("[x] ")))),
        A2(ra, ka(1), wi(A2(Ea, "[X] ", Nc("[X] ")))),
        A2(ra, ka(0), wi(A2(Ea, "[ ] ", Nc("[ ] "))))
    ])), Uv = A2(ea, sa(h([
        A2(ea, ka(Rv), A2(ra, Fv, di(li))),
        ka(Lv)
    ])), A2(ra, Ai(Ii), Ei)), Pv = A2(ea, A2(ea, A2(ra, ka(F2(function(n, r) {
        return o(n, r);
    })), nf(li)), Jo), Uv), Qv = sa(h([
        A2(ra, A2(ra, ka(0), A2(bf, 3, of)), wi(A2(Ea, "-", Nc("-")))),
        A2(ra, ka(1), wi(A2(Ea, "+", Nc("+")))),
        A2(ra, ka(2), wi(A2(Ea, "*", Nc("*"))))
    ])), Wv = function(n) {
        var r = F2(function(n, r) {
            switch(r.$){
                case 0:
                    return {
                        bY: r.b,
                        ci: n,
                        l: Br(1 === r.a)
                    };
                case 1:
                    return {
                        bY: r.a,
                        ci: n,
                        l: Dr
                    };
                default:
                    return {
                        bY: "",
                        ci: n,
                        l: Dr
                    };
            }
        });
        return A2(ca, function(n) {
            return A4(si, !0, n.b, d, A2(r, n.a, n.c));
        }, function(n) {
            return A2(ea, A2(ea, A2(ea, A2(ea, ka(Bv), Jo), $a(Qv)), Jo), n ? Pv : sa(h([
                Dv,
                Pv
            ])));
        }(n));
    }, Hv = F2(function(n, r) {
        switch(n.$){
            case 0:
                var t = n.a, e = n.b, u = nd(n.c);
                if (u.$) return Or(u.a);
                var a = Lc(A3(Dc, t, e, u.a));
                return Lr(A2(Yr, a, r));
            case 1:
                var c = td(n.a);
                return c.$ ? Or(ja(A2(Ur, "\n", A2(Dt, xc, c.a)))) : Lr(v(tt(c.a), r));
            case 2:
                return Lr(A2(Yr, Lc(Rc(n.a)), r));
            case 3:
                return Lr(A2(Yr, Lc(Ec(n.a)), r));
            case 4:
                return Lr(A2(Yr, Lc(ri(n.a)), r));
            default:
                return Lr(A2(Yr, Lc(A2(Bc, n.a, n.b)), r));
        }
    }), Gv = function(n) {
        var r = n.b;
        n: for(; r.b;)switch(r.a.$){
            case 11:
                var t = r.a.a, e = r.b, u = A2(Ja, vd(), t);
                return u.$ ? Pa(Ua(qi(u.a))) : ka({
                    a: v(n.a, (w = u.a).a),
                    b: A2(Yr, ni(w.b), e)
                });
            case 3:
                var a = r.a, c = a.a, i = a.b, o = a.c, f = a.d, s = (e = r.b, A2(Ja, vd(), f.bY));
                if (s.$) return Pa(Ua(qi(s.a)));
                var b = !A2(Ho, Ac, (w = s.a).b) && c;
                return ka({
                    a: v(n.a, w.a),
                    b: A2(Yr, A4(si, b, i, A2(Yr, {
                        bY: w.b,
                        l: f.l
                    }, o), f), e)
                });
            case 4:
                var d = r.a, l = (c = d.a, i = d.b, d.c), $ = d.d, h = (o = d.e, f = d.f, e = r.b, A2(Ja, vd(), f));
                return h.$ ? Pa(Ua(qi(h.a))) : (b = !A2(Ho, Ac, (w = h.a).b) && c, ka({
                    a: v(n.a, w.a),
                    b: A2(Yr, A6(Xc, b, i, l, $, A2(Yr, w.b, o), f), e)
                }));
            case 10:
                if (!r.b.b) break n;
                switch(r.b.a.$){
                    case 3:
                        var g = r.b, p = g.a, m = (c = p.a, i = p.b, o = p.c, f = p.d, e = g.b, A2(Ja, vd(), f.bY));
                        return m.$ ? Pa(Ua(qi(m.a))) : (b = !A2(Ho, Ac, (w = m.a).b) && c, ka({
                            a: v(n.a, w.a),
                            b: A2(Yr, A4(si, b, i, A2(Yr, {
                                bY: w.b,
                                l: f.l
                            }, o), f), e)
                        }));
                    case 4:
                        var w, y = r.b, k = y.a, x = (c = k.a, i = k.b, l = k.c, $ = k.d, o = k.e, f = k.f, e = y.b, A2(Ja, vd(), f));
                        return x.$ ? Pa(Ua(qi(x.a))) : (b = !A2(Ho, Ac, (w = x.a).b) && c, ka({
                            a: v(n.a, w.a),
                            b: A2(Yr, A6(Xc, b, i, l, $, A2(Yr, w.b, o), f), e)
                        }));
                    default:
                        break n;
                }
            default:
                break n;
        }
        return ka(n);
    }, Vv = F2(function(n, r) {
        var e = o(r, n.b);
        n: for(; e.b.b;)switch(e.b.a.$){
            case 5:
                if (5 === e.a.$) {
                    var u = e.b, a = u.b;
                    return ka({
                        a: n.a,
                        b: A2(Yr, Yc({
                            bY: A2(Po, u.a.a.bY, e.a.a.bY),
                            ce: Dr
                        }), a)
                    });
                }
                break n;
            case 6:
                switch(e.a.$){
                    case 6:
                        var c = e.b;
                        return a = c.b, ka({
                            a: n.a,
                            b: A2(Yr, Uc(A2(Po, c.a.a, e.a.a)), a)
                        });
                    case 10:
                        var i = e.b;
                        return a = i.b, ka({
                            a: n.a,
                            b: A2(Yr, Uc(A2(Po, i.a.a, "\n")), a)
                        });
                    default:
                        break n;
                }
            case 11:
                var f = e.b, s = f.a.a;
                switch(a = f.b, r.$){
                    case 11:
                        return ka({
                            a: n.a,
                            b: A2(Yr, jc(A2(Po, s, l = r.a)), a)
                        });
                    case 1:
                        var l = r.a, $ = A2(Ja, vd(), s);
                        if ($.$) return Pa(Ua(qi($.a)));
                        var h = (nn = $.a).b;
                        if (h.b) {
                            if (Ni(h.a) && !A2(Ti, "\n", s)) return ka({
                                a: n.a,
                                b: A2(Yr, jc(A2(Po, s, l)), a)
                            });
                            var g = A2(Ja, vd(), s);
                            if (g.$) return Pa(Ua(qi(g.a)));
                            var p = g.a;
                            return ka({
                                a: v(n.a, nn.a),
                                b: A2(Yr, r, A2(Yr, ni(p.b), a))
                            });
                        }
                        var m = A2(Ja, vd(), s);
                        return m.$ ? Pa(Ua(qi(m.a))) : (p = m.a, ka({
                            a: v(n.a, nn.a),
                            b: A2(Yr, r, A2(Yr, ni(p.b), a))
                        }));
                    case 6:
                        l = r.a;
                        var w = A2(Ja, vd(), s);
                        if (w.$) return Pa(Ua(qi(w.a)));
                        var y = (nn = w.a).b;
                        if (y.b && 1 === y.a.$) return ka({
                            a: n.a,
                            b: A2(Yr, jc(A3(Uo, " ", s, l)), a)
                        });
                        var k = A2(Ja, vd(), s);
                        return k.$ ? Pa(Ua(qi(k.a))) : (p = k.a, ka({
                            a: v(n.a, nn.a),
                            b: A2(Yr, r, A2(Yr, ni(p.b), a))
                        }));
                    default:
                        var x = A2(Ja, vd(), s);
                        return x.$ ? Pa(Ua(qi(x.a))) : ka({
                            a: v(n.a, (nn = x.a).a),
                            b: A2(Yr, r, A2(Yr, ni(nn.b), a))
                        });
                }
            case 3:
                var I = e.b, A = I.a, j = A.a, E = A.b, C = A.c, Y = A.d;
                switch(a = I.b, r.$){
                    case 3:
                        var _ = r.b;
                        if (t(Y.ci, (L = r.d).ci)) {
                            var S = A2(Ja, vd(), Y.bY);
                            return S.$ ? Pa(Ua(qi(S.a))) : ka(A2(Ho, Ac, (nn = S.a).b) ? {
                                a: v(n.a, nn.a),
                                b: A2(Yr, A4(si, !1, _, A2(Yr, {
                                    bY: nn.b,
                                    l: Y.l
                                }, C), L), a)
                            } : {
                                a: v(n.a, nn.a),
                                b: A2(Yr, A4(si, j, _, A2(Yr, {
                                    bY: nn.b,
                                    l: Y.l
                                }, C), L), a)
                            });
                        }
                        var q = A2(Ja, vd(), Y.bY);
                        if (q.$) return Pa(Ua(qi(q.a)));
                        var T = !A2(Ho, Ac, (nn = q.a).b) && j;
                        return ka({
                            a: v(n.a, nn.a),
                            b: A2(Yr, r, A2(Yr, A4(si, T, E, A2(Yr, {
                                bY: nn.b,
                                l: Y.l
                            }, C), L), a))
                        });
                    case 1:
                        return ka({
                            a: n.a,
                            b: A2(Yr, A4(si, j, E, C, b(Y, {
                                bY: A3(Uo, "\n", Y.bY, l = r.a)
                            })), a)
                        });
                    default:
                        var N = A2(Ja, vd(), Y.bY);
                        return N.$ ? Pa(Ua(qi(N.a))) : (T = !A2(Ho, Ac, (nn = N.a).b) && j, ka({
                            a: v(n.a, nn.a),
                            b: A2(Yr, r, A2(Yr, A4(si, T, E, A2(Yr, {
                                bY: nn.b,
                                l: Y.l
                            }, C), Y), a))
                        }));
                }
            case 4:
                var O = e.b, z = O.a, M = (j = z.a, E = z.b, z.c), Z = z.d;
                switch(C = z.e, Y = z.f, a = O.b, r.$){
                    case 4:
                        _ = r.b;
                        var L = r.f;
                        if (t(M, r.c)) {
                            var R = A2(Ja, vd(), Y);
                            return R.$ ? Pa(Ua(qi(R.a))) : (T = !A2(Ho, Ac, (nn = R.a).b) && j, ka({
                                a: v(n.a, nn.a),
                                b: A2(Yr, A6(Xc, T, _, M, Z, A2(Yr, nn.b, C), L), a)
                            }));
                        }
                        var B = A2(Ja, vd(), Y);
                        return B.$ ? Pa(Ua(qi(B.a))) : (T = !A2(Ho, Ac, (nn = B.a).b) && j, ka({
                            a: v(n.a, nn.a),
                            b: A2(Yr, r, A2(Yr, A6(Xc, T, E, M, Z, A2(Yr, nn.b, C), Y), a))
                        }));
                    case 1:
                        return ka({
                            a: n.a,
                            b: A2(Yr, A6(Xc, j, E, M, Z, C, Y + "\n" + (l = r.a)), a)
                        });
                    default:
                        var D = A2(Ja, vd(), Y);
                        return D.$ ? Pa(Ua(qi(D.a))) : (T = !A2(Ho, Ac, (nn = D.a).b) && j, ka({
                            a: v(n.a, nn.a),
                            b: A2(Yr, r, A2(Yr, A6(Xc, T, E, M, Z, A2(Yr, nn.b, C), Y), a))
                        }));
                }
            case 1:
                switch(e.a.$){
                    case 1:
                        var F = e.b;
                        return a = F.b, ka({
                            a: n.a,
                            b: A2(Yr, Gc(A3(Uo, "\n", s = F.a.a, l = e.a.a)), a)
                        });
                    case 13:
                        if (e.a.a) {
                            var U = e.b;
                            return a = U.b, ka({
                                a: n.a,
                                b: A2(Yr, A2(Mc, 2, U.a.a), a)
                            });
                        }
                        var P = e.b;
                        a = P.b;
                        return ka({
                            a: n.a,
                            b: A2(Yr, A2(Mc, 1, P.a.a), a)
                        });
                    case 9:
                        var Q = e.a.a, W = Q.a, H = e.b, G = H.a.a, V = (a = H.b, A2(Nb, A2(ci, W, Q.b), G));
                        return ka(V.$ ? {
                            a: n.a,
                            b: A2(Yr, Gc(A3(Uo, "\n", G, W.bA)), a)
                        } : {
                            a: n.a,
                            b: A2(Yr, ui(A2(ai, V.a, d)), a)
                        });
                    default:
                        break n;
                }
            case 8:
                if (8 === e.a.$) return a = e.b.b, ka({
                    a: n.a,
                    b: A2(Yr, ui(e.a.a), a)
                });
                break n;
            case 10:
                if (!e.b.b.b) break n;
                switch(e.b.b.a.$){
                    case 4:
                        var X = e.b.b, J = X.a, K = (j = J.a, E = J.b, M = J.c, Z = J.d, C = J.e, Y = J.f, a = X.b, A2(Ja, vd(), Y));
                        if (K.$) return Pa(Ua(qi(K.a)));
                        var nn = K.a;
                        if (4 === r.$) {
                            _ = r.b;
                            var rn = r.f;
                            return ka({
                                a: v(n.a, nn.a),
                                b: A2(Yr, A6(Xc, !1, _, M, Z, A2(Yr, nn.b, C), rn), a)
                            });
                        }
                        return ka({
                            a: v(n.a, nn.a),
                            b: A2(Yr, r, A2(Yr, Ac, A2(Yr, A6(Xc, j, E, M, Z, A2(Yr, nn.b, C), Y), a)))
                        });
                    case 3:
                        var tn = e.b.b, en = tn.a, un = (j = en.a, E = en.b, C = en.c, Y = en.d, a = tn.b, A2(Ja, vd(), Y.bY));
                        return un.$ ? Pa(Ua(qi(un.a))) : (nn = un.a, 3 === r.$ ? (rn = r.d, ka({
                            a: v(n.a, nn.a),
                            b: A2(Yr, A4(si, !1, E, A2(Yr, {
                                bY: nn.b,
                                l: Y.l
                            }, C), rn), a)
                        })) : ka({
                            a: v(n.a, nn.a),
                            b: A2(Yr, r, A2(Yr, Ac, A2(Yr, A4(si, j, E, A2(Yr, {
                                bY: nn.b,
                                l: Y.l
                            }, C), Y), a)))
                        }));
                    default:
                        break n;
                }
            default:
                break n;
        }
        return ka({
            a: n.a,
            b: A2(Yr, r, n.b)
        });
    }), Xv = F2(function(n, r) {
        var t = r, e = zi(A2(Dt, Qo(function(n) {
            return o(n.b3, n.cC);
        }), n));
        return A2(Dt, Jv, A2(Eb, e, t));
    }), Jv = function(n) {
        switch(n.$){
            case 0:
                return {
                    $: 7,
                    a: n.a
                };
            case 1:
                return Oc;
            case 2:
                return {
                    $: 6,
                    a: n.a
                };
            case 3:
                return A3(Qc, n.a, n.b, A2(Dt, Jv, t = n.c));
            case 4:
                return A3(Fc, n.a, n.b, A2(Dt, Jv, t = n.c));
            case 5:
                return function(n) {
                    return {
                        $: 0,
                        a: n
                    };
                }(Kv(n.a));
            case 6:
                var r = n.a, t = n.b;
                switch(r){
                    case 1:
                        return Sc(A2(Dt, Jv, t));
                    case 2:
                        return ti(A2(Dt, Jv, t));
                    default:
                        return Do(r) ? ti(h([
                            Jv(A2(qc, r - 2, t))
                        ])) : Sc(h([
                            Jv(A2(qc, r - 1, t))
                        ]));
                }
            default:
                return function(n) {
                    return {
                        $: 5,
                        a: n
                    };
                }(A2(Dt, Jv, t = n.a));
        }
    }, Kv = function(n) {
        switch(n.$){
            case 1:
                return Rc("TODO this never happens, but use types to drop this case.");
            case 0:
                return A3(Dc, n.a, n.b, A2(Si, function(n) {
                    return 1 === n.$ ? sd(n.a) : h([
                        Lc(Kv(n))
                    ]);
                }, n.c));
            case 2:
                return Rc(n.a);
            case 3:
                return Ec(n.a);
            case 4:
                return ri(n.a);
            default:
                return A2(Bc, n.a, n.b);
        }
    }, nd = function(n) {
        return A2(rd, n, d);
    }, rd = F2(function(n, r) {
        for(;;){
            if (!n.b) return Lr(tt(r));
            var t = n.b, e = A2(Hv, n.a, r);
            if (e.$) return Or(e.a);
            n = t, r = e.a;
        }
    }), td = function(n) {
        var r = A2(Ja, A2(ra, vd(), ji), n);
        if (1 === r.$) return Or(r.a);
        var t = ed(r.a);
        return 1 === t.$ ? A2(Ja, Pa(t.a), "") : Lr(A2(Oi, function(n) {
            return !(5 === n.$ && !n.a.b);
        }, t.a));
    }, ed = function(n) {
        return A3(ud, n, n.b, d);
    }, ud = F3(function(n, r, t) {
        n: for(;;){
            if (!r.b) return Lr(t);
            var e = r.b, u = A2(cd, n.a, r.a);
            switch(u.$){
                case 1:
                    r = e, t = A2(Yr, u.a, t);
                    continue n;
                case 0:
                    r = e;
                    continue n;
                default:
                    return Or(u.a);
            }
        }
    }), ad = F2(function(n, r) {
        return A2(Dt, function(r) {
            var t = r.aj;
            return A3(id, n, function(n) {
                return {
                    aj: t,
                    L: n
                };
            }, r.L);
        }, r);
    }), cd = F2(function(n, r) {
        switch(r.$){
            case 0:
                var t = r.b, e = function(n) {
                    switch(n){
                        case 1:
                            return Lr(0);
                        case 2:
                            return Lr(1);
                        case 3:
                            return Lr(2);
                        case 4:
                            return Lr(3);
                        case 5:
                            return Lr(4);
                        case 6:
                            return Lr(5);
                        default:
                            return Or(ja("A heading with 1 to 6 #'s, but found " + Fr(n)));
                    }
                }(r.a);
                return e.$ ? Pc(e.a) : Kc(A2(zc, e.a, A2(Xv, n, t)));
            case 1:
                return Kc(Jc(A2(Xv, n, t = r.a)));
            case 2:
                return Kc(Lc(r.a));
            case 3:
                var u = r.a, a = r.c, c = F2(function(r, t) {
                    var e, u = r.$ ? 0 : r.a ? 2 : 1, a = (e = ed({
                        a: n,
                        b: t
                    })).$ ? d : e.a;
                    return A2(Wc, u, a);
                });
                return Kc(A2(fi, Fo(u), tt(A2(Dt, function(n) {
                    return A2(c, n.l, n.bY);
                }, a))));
            case 4:
                var i = r.d;
                return a = r.e, c = function(r) {
                    var t = ed({
                        a: n,
                        b: r
                    });
                    return t.$ ? d : t.a;
                }, Kc(A3(Vc, Fo(u = r.a), i, tt(A2(Dt, c, a))));
            case 5:
                return Kc(Cc(r.a));
            case 7:
                return Kc(ii);
            case 10:
            case 11:
                return Tc;
            case 12:
                var o = ed({
                    a: n,
                    b: r.a
                });
                return o.$ ? Pc(o.a) : Kc({
                    $: 3,
                    a: o.a
                });
            case 6:
                return Kc(Cc({
                    bY: r.a,
                    ce: Dr
                }));
            case 8:
                var f = r.a, s = f.b;
                return Kc(A2(ei, A2(ad, n, f.a), A2(od, n, s)));
            case 9:
                return Kc(Jc(A2(Xv, n, r.a.a.bA)));
            default:
                return Kc(Jc(A2(Xv, n, r.b)));
        }
    }), id = F3(function(n, r, t) {
        return r(A2(Xv, n, t));
    }), od = F2(function(n, r) {
        return A2(Dt, function(r) {
            return A2(Dt, function(r) {
                return A3(id, n, Yt, r);
            }, r);
        }, r);
    }), fd = function(n) {
        return sa(h([
            A2(ca, function() {
                return _c(n);
            }, ji),
            A2(ca, function(r) {
                return Hc(A2(bi, n, r));
            }, $a(hv)),
            function() {
                var r = n.b;
                n: for(; r.b;)switch(r.a.$){
                    case 1:
                        return A2(ca, function(n) {
                            return Hc(n);
                        }, A2(Ru, Vv(n), ld()));
                    case 8:
                        var t = r.a.a;
                        return A2(ca, function(n) {
                            return Hc(n);
                        }, A2(Ru, Vv(n), sa(h([
                            dd(),
                            Mv(t)
                        ]))));
                    case 3:
                        var e = r.a, u = e.a, a = e.b, c = e.c, i = e.d, o = r.b, f = F2(function(n, r) {
                            return b(n, {
                                b: A2(Yr, Ac, A2(Yr, A4(si, u, a, c, b(i, {
                                    bY: A3(Uo, "", i.bY, r)
                                })), o))
                            });
                        }), s = F2(function(n, r) {
                            return b(n, {
                                b: A2(Yr, A4(si, u, a, c, b(i, {
                                    bY: A3(Uo, "\n", i.bY, r)
                                })), o)
                            });
                        });
                        return sa(h([
                            A2(ca, function(n) {
                                return Hc(n);
                            }, A2(ca, function() {
                                return A2(f, n, "\n");
                            }, pi)),
                            A2(ca, function(n) {
                                return Hc(n);
                            }, A2(ca, s(n), A2(ea, A2(ra, ka(Yt), wi(A2(Ea, A2(lf, a, " "), Nc("Indentation")))), A2(ra, Ai(Ii), Ei)))),
                            A2(ca, function(n) {
                                return Hc(n);
                            }, A2(Ru, Vv(n), $d()))
                        ]));
                    case 4:
                        var v = r.a, d = (u = v.a, a = v.b, v.c), l = v.d;
                        return c = v.e, i = v.f, o = r.b, f = F2(function(n, r) {
                            return b(n, {
                                b: A2(Yr, Ac, A2(Yr, A6(Xc, u, a, d, l, c, i + "\n" + r), o))
                            });
                        }), s = F2(function(n, r) {
                            return b(n, {
                                b: A2(Yr, A6(Xc, u, a, d, l, c, i + "\n" + r), o)
                            });
                        }), sa(h([
                            A2(ca, function(n) {
                                return Hc(n);
                            }, A2(ca, function() {
                                return A2(f, n, "\n");
                            }, pi)),
                            A2(ca, function(n) {
                                return Hc(n);
                            }, A2(ca, s(n), A2(ea, A2(ra, ka(Yt), wi(A2(Ea, A2(lf, a, " "), Nc("Indentation")))), A2(ra, Ai(Ii), Ei)))),
                            A2(ca, function(n) {
                                return Hc(n);
                            }, A2(Ru, Vv(n), $d()))
                        ]));
                    case 10:
                        if (!r.b.b) break n;
                        switch(r.b.a.$){
                            case 3:
                                var $ = r.b, g = $.a;
                                return u = g.a, a = g.b, c = g.c, i = g.d, o = $.b, f = F2(function(n, r) {
                                    return b(n, {
                                        b: A2(Yr, Ac, A2(Yr, A4(si, u, a, c, b(i, {
                                            bY: A3(Uo, "", i.bY, r)
                                        })), o))
                                    });
                                }), s = F2(function(n, r) {
                                    return b(n, {
                                        b: A2(Yr, A4(si, u, a, c, b(i, {
                                            bY: A3(Uo, "\n", i.bY, r)
                                        })), o)
                                    });
                                }), "" === jb(i.bY) ? A2(ca, function(n) {
                                    return Hc(n);
                                }, A2(Ru, Vv(n), dd())) : sa(h([
                                    A2(ca, function(n) {
                                        return Hc(n);
                                    }, A2(ca, function() {
                                        return A2(f, n, "\n");
                                    }, pi)),
                                    A2(ca, function(n) {
                                        return Hc(n);
                                    }, A2(ca, s(n), A2(ea, A2(ra, ka(Yt), wi(A2(Ea, A2(lf, a, " "), Nc("Indentation")))), A2(ra, Ai(Ii), Ei)))),
                                    A2(ca, function(n) {
                                        return Hc(n);
                                    }, A2(Ru, Vv(n), dd()))
                                ]));
                            case 4:
                                var p = r.b, m = p.a;
                                return u = m.a, a = m.b, d = m.c, l = m.d, c = m.e, i = m.f, o = p.b, f = F2(function(n, r) {
                                    return b(n, {
                                        b: A2(Yr, Ac, A2(Yr, A6(Xc, u, a, d, l, c, i + "\n" + r), o))
                                    });
                                }), s = F2(function(n, r) {
                                    return b(n, {
                                        b: A2(Yr, A6(Xc, u, a, d, l, c, i + "\n" + r), o)
                                    });
                                }), "" === jb(i) ? A2(ca, function(n) {
                                    return Hc(n);
                                }, A2(Ru, Vv(n), dd())) : sa(h([
                                    A2(ca, function(n) {
                                        return Hc(n);
                                    }, A2(ca, function() {
                                        return A2(f, n, "\n");
                                    }, pi)),
                                    A2(ca, function(n) {
                                        return Hc(n);
                                    }, A2(ca, s(n), A2(ea, A2(ra, ka(Yt), wi(A2(Ea, A2(lf, a, " "), Nc("Indentation")))), A2(ra, Ai(Ii), Ei)))),
                                    A2(ca, function(n) {
                                        return Hc(n);
                                    }, A2(Ru, Vv(n), dd()))
                                ]));
                            default:
                                break n;
                        }
                    default:
                        break n;
                }
                return A2(ca, function(n) {
                    return Hc(n);
                }, A2(Ru, Vv(n), dd()));
            }(),
            A2(ca, function(n) {
                return Hc(n);
            }, A2(Ru, Vv(n), Vo))
        ]));
    }, sd = function(n) {
        return A2(bc, d, td(n));
    }, bd = function(n) {
        switch(n.$){
            case 1:
                return ka(Gc(n.a));
            case 0:
                var r = n.a, t = n.b, e = nd(n.c);
                return e.$ ? Pa(e.a) : ka(Zc(A3(Dc, r, t, e.a)));
            case 2:
                return ka(Zc(Rc(n.a)));
            case 3:
                return ka(Zc(Ec(n.a)));
            case 4:
                return ka(Zc(ri(n.a)));
            default:
                return ka(Zc(A2(Bc, n.a, n.b)));
        }
    };
    function vd() {
        return A2(Ru, Gv, A2(Qi, {
            a: d,
            b: d
        }, fd));
    }
    function dd() {
        return sa(h([
            Yb,
            pi,
            Ci,
            A2(ca, Yc, $a(Qb)),
            Bo,
            A2(ca, function() {
                return oi;
            }, $a(wv)),
            Wv(!1),
            $f(!1),
            $a(Vb),
            hd()
        ]));
    }
    function ld() {
        return sa(h([
            Yb,
            pi,
            Ci,
            A2(ca, Yc, $a(Qb)),
            $a(Iv),
            A2(ca, function() {
                return oi;
            }, $a(wv)),
            Wv(!0),
            $f(!0),
            $a(Vb),
            hd(),
            $a(_v)
        ]));
    }
    function $d() {
        return sa(h([
            Yb,
            pi,
            Ci,
            A2(ca, Yc, $a(Qb)),
            A2(ca, function() {
                return oi;
            }, $a(wv)),
            Wv(!1),
            $f(!1),
            $a(Vb),
            hd()
        ]));
    }
    function hd() {
        return A2(Ru, bd, No);
    }
    var gd = vd();
    vd = function() {
        return gd;
    };
    var pd = dd();
    dd = function() {
        return pd;
    };
    var md = ld();
    ld = function() {
        return md;
    };
    var wd = $d();
    $d = function() {
        return wd;
    };
    var yd = hd();
    hd = function() {
        return yd;
    };
    var kd, xd, Id, Ad, jd = F3(function(n, r, t) {
        if (1 === r.$) return Or(r.a);
        var e = r.a;
        return 1 === t.$ ? Or(t.a) : Lr(A2(n, e, t.a));
    }), Ed = A2(Bt, jd(Yr), Lr(d)), Cd = F2(function(n, r) {
        n: for(;;){
            if (n > 0) {
                if (r.b) {
                    n -= 1, r = r.b;
                    continue n;
                }
                return r;
            }
            return r;
        }
    }), Yd = F3(function(n, r, t) {
        n: for(;;){
            if (!t.b) return r;
            var e = t.a, u = t.b;
            switch(e.$){
                case 0:
                    var a = e.a;
                    if (a.$) {
                        i = n, o = A2(n, e, r), n = i, r = o, t = u;
                        continue n;
                    }
                    var c = a.c, i = n, o = A2(n, e, r);
                    n = i, r = o, t = v(c, u);
                    continue n;
                case 1:
                    var f = A2(Si, function(n) {
                        return n.b;
                    }, s = e.b);
                    i = n, o = A2(n, e, r), n = i, r = o, t = v(f, u);
                    continue n;
                case 2:
                    var s = e.c;
                    i = n, o = A2(n, e, r), n = i, r = o, t = v(_i(s), u);
                    continue n;
                case 3:
                    s = e.a, i = n, o = A2(n, e, r), n = i, r = o, t = v(s, u);
                    continue n;
                default:
                    i = n, o = A2(n, e, r), n = i, r = o, t = u;
                    continue n;
            }
        }
    }), _d = function(n) {
        switch(n.$){
            case 5:
                return Sd(n.a);
            case 0:
                var r = n.a;
                if (r.$) return "";
                var t = r.c;
                return A3(Yd, F2(function(n, r) {
                    return v(r, _d(n));
                }), "", t);
            case 1:
                return A2(Ur, "\n", A2(Dt, function(n) {
                    return A2(Ur, "\n", A2(Dt, _d, n.b));
                }, n.b));
            case 2:
                return A2(Ur, "\n", A2(Dt, function(n) {
                    return A2(Ur, "\n", A2(Dt, _d, n));
                }, n.c));
            case 3:
                return A2(Ur, "\n", A2(Dt, _d, t = n.a));
            case 4:
                return Sd(n.b);
            case 6:
                var e = n.b;
                return A2(Ur, "\n", _i(h([
                    A2(Dt, Sd, A2(Dt, function(n) {
                        return n.L;
                    }, n.a)),
                    _i(A2(Dt, Dt(Sd), e))
                ])));
            case 7:
                return n.a.bY;
            default:
                return "";
        }
    }, Sd = function(n) {
        return A3(Pr, qd, "", n);
    }, qd = F2(function(n, r) {
        switch(n.$){
            case 7:
            case 6:
                return v(r, n.a);
            case 8:
                return r + " ";
            case 1:
            case 2:
                return v(r, Sd(n.c));
            case 0:
                var t = n.a;
                if (t.$) return r;
                var e = t.c;
                return A3(Yd, F2(function(n, r) {
                    return v(r, _d(n));
                }), r, e);
            default:
                return v(r, Sd(n.a));
        }
    }), Td = F5(function(n, r, t, e, u) {
        var a = e;
        return A2(kc, function(e) {
            return A2(no, function(n) {
                return n(e);
            }, A3(a, n, r, t));
        }, Ed(u));
    }), Nd = function(n) {
        return h([
            n
        ]);
    }, Od = F3(function(n, r, t) {
        var e = A2(Ld, n, r);
        return e.$ ? t : A2(Yr, e.a, t);
    }), zd = F2(function(n, r) {
        return A2(fu, Md(n), r);
    }), Md = function(n) {
        return function(r) {
            switch(r.$){
                case 4:
                    var t = r.a;
                    return Br(A2(no, function(r) {
                        return n.b8({
                            b$: r,
                            cf: t,
                            cr: Sd(e)
                        });
                    }, A2(Rd, n, e = r.b)));
                case 5:
                    var e;
                    return Br(A2(no, n.aO, A2(Rd, n, e = r.a)));
                case 0:
                    var u = r.a;
                    return u.$ ? Dr : Br(A4(Zd, n, u.a, u.b, u.c));
                case 1:
                    var a = r.a;
                    return Br(A2(no, function(r) {
                        return n.a0(A2(Dt, function(n) {
                            return A2(Wc, n.a, _i(n.b));
                        }, r));
                    }, Ed(A2(Dt, function(r) {
                        var t = r.b;
                        return A2(no, Wc(r.a), Ed(A2(fu, function(r) {
                            var t = o(a, r);
                            return 1 === t.a && 5 === t.b.$ ? Br(A2(Rd, n, t.b.a)) : A2(aa, no(Nd), A2(Md, n, r));
                        }, t)));
                    }, r.b))));
                case 2:
                    a = r.a;
                    var c = r.b;
                    return Br(A2(no, function(r) {
                        return A2(n.aM, c, A2(Dt, function(n) {
                            return _i(n);
                        }, r));
                    }, Ed(A2(Dt, function(r) {
                        return Ed(A2(fu, function(r) {
                            var t = o(a, r);
                            return 1 === t.a && 5 === t.b.$ ? Br(A2(Rd, n, t.b.a)) : A2(aa, no(Nd), A2(Md, n, r));
                        }, r));
                    }, r.c))));
                case 7:
                    return Br(Lr(n.aA(r.a)));
                case 8:
                    return Br(Lr(n.a$));
                case 3:
                    return Br(A2(no, n.az, Ed(A2(zd, n, r.a))));
                default:
                    var i = r.a, f = r.b, s = Ed(A2(Dt, function(r) {
                        var t = r.L;
                        return A2(no, Fa(r.aj), A2(Rd, n, t));
                    }, i)), b = A2(no, function(r) {
                        return n.aZ(Nd(n.at(A2(Dt, function(r) {
                            return A2(n.a_, r.a, r.b);
                        }, r))));
                    }, s), v = function(r) {
                        return A2(no, n.at, A2(no, Vr(F2(function(r, t) {
                            return A2(n.aY, A2(Ls, function(n) {
                                return n.aj;
                            }, Ku(A2(Cd, r, i))), t);
                        })), Ed(A2(Dt, Rd(n), r))));
                    }, l = Ed(A2(Dt, v, f));
                    return Br(A3(jd, F2(function(r, t) {
                        return n.aW(A2(Yr, r, function(r) {
                            return Vs(r) ? d : h([
                                n.aX(r)
                            ]);
                        }(t)));
                    }), b, l));
            }
        };
    }, Zd = F4(function(n, r, t, e) {
        return A5(Td, r, t, e, n.aF, A2(zd, n, e));
    }), Ld = F2(function(n, r) {
        switch(r.$){
            case 4:
                return Br(A2(no, n.aV, A2(Rd, n, r.a)));
            case 3:
                return Br(A2(no, n.aD, A2(Rd, n, r.a)));
            case 5:
                return Br(A2(no, n.aU, A2(Rd, n, r.a)));
            case 2:
                var t = r.a, e = r.b;
                return Br(Lr(n.aG({
                    ay: Sd(r.c),
                    aS: t,
                    cC: e
                })));
            case 7:
                return Br(Lr(n.j(r.a)));
            case 6:
                return Br(Lr(n.aB(r.a)));
            case 1:
                var u = r.a;
                return e = r.b, Br(A2(kc, function(r) {
                    return Lr(A2(n.aJ, {
                        b3: u,
                        cC: e
                    }, r));
                }, A2(Rd, n, r.c)));
            case 8:
                return Br(Lr(n.aE));
            default:
                var a = r.a;
                return a.$ ? Dr : Br(A4(Zd, n, a.a, a.b, a.c));
        }
    }), Rd = F2(function(n, r) {
        return Ed(A3(Bt, Od(n), d, r));
    }), Bd = F2(function(n, r) {
        return Ed(A2(zd, n, r));
    }), Dd = On("a"), Fd = dc("align"), Ud = dc("alt"), Pd = On("blockquote"), Qd = On("br"), Wd = nn, Hd = F2(function(n, r) {
        return A2(Ln, n, Wd(r));
    }), Gd = Hd("checked"), Vd = On("code"), Xd = On("del"), Jd = Hd("disabled"), Kd = On("em"), nl = On("h1"), rl = On("h2"), tl = On("h3"), el = On("h5"), ul = On("h6"), al = On("hr"), cl = function(n) {
        var r;
        return A2(dc, "href", /^javascript:/i.test((r = n).replace(/\s/g, "")) ? "" : r);
    }, il = On("img"), ol = On("input"), fl = On("li"), sl = On("ol"), bl = F2(function(n, r) {
        return 1 === n.$ ? r.$ ? Or(A2(Yr, n.a, r.a)) : Lr(r.a) : Lr(n.a);
    }), vl = F2(function(n, r) {
        return Vs(r) ? "<" + n + ">" : "<" + n + " " + function(n) {
            return A2(Ur, " ", A2(Dt, function(n) {
                return n.br + '="' + n.bR + '"';
            }, n));
        }(r) + ">";
    }), dl = On("p"), ll = On("pre"), $l = function(n) {
        return A2(dc, "src", Bn(n));
    }, hl = On("strong"), gl = On("table"), pl = On("tbody"), ml = On("td"), wl = On("th"), yl = On("thead"), kl = dc("title"), xl = On("tr"), Il = dc("type"), Al = On("ul"), jl = function(n) {
        return h(n.trim().split(/\s+/g));
    }, El = b({
        az: Pd(d),
        aA: function(n) {
            var r, t = n.bY, e = !(r = A2(aa, jl, n.ce)).$ && r.a.b ? h([
                lc("language-" + r.a.a)
            ]) : d;
            return A2(ll, d, h([
                A2(Vd, e, h([
                    yc(t)
                ]))
            ]));
        },
        aB: function(n) {
            return A2(Vd, d, h([
                yc(n)
            ]));
        },
        aD: function(n) {
            return A2(Kd, d, n);
        },
        aE: A2(Qd, d, d),
        b8: function(n) {
            var r = n.b$;
            switch(n.cf){
                case 0:
                    return A2(nl, d, r);
                case 1:
                    return A2(rl, d, r);
                case 2:
                    return A2(tl, d, r);
                case 3:
                    return A2(pc, d, r);
                case 4:
                    return A2(el, d, r);
                default:
                    return A2(ul, d, r);
            }
        },
        aF: (kd = d, Id = A2(Dt, function(n) {
            return n;
        }, kd), xd = A3(Pr, F2(function(n, r) {
            return F3(function(t, e, u) {
                return A2(bl, A3(n, t, e, u), A3(r, t, e, u));
            });
        }), F3(function() {
            return Or(d);
        }), Id), F3(function(n, r, t) {
            return A2(Te, function(t) {
                if (t.b) {
                    if (t.b.b) return "oneOf failed parsing this value:\n    " + A2(vl, n, r) + "\n\nParsing failed in the following 2 ways:\n\n\n" + A2(Ur, "\n\n", A2(Vr, F2(function(n, r) {
                        return "(" + Fr(n + 1) + ") " + r;
                    }), t)) + "\n";
                    var e = t.a;
                    return "Problem with the given value:\n\n" + A2(vl, n, r) + "\n\n" + e + "\n";
                }
                return "Ran into a oneOf with no possibilities!";
            }, A3(xd, n, r, t));
        })),
        aG: function(n) {
            var r = n.cC;
            if (r.$) return A2(il, h([
                $l(n.aS),
                Ud(n.ay)
            ]), d);
            var t = r.a;
            return A2(il, h([
                $l(n.aS),
                Ud(n.ay),
                kl(t)
            ]), d);
        },
        aJ: F2(function(n, r) {
            var t = n.cC;
            if (t.$) return A2(Dd, h([
                cl(n.b3)
            ]), r);
            var e = t.a;
            return A2(Dd, h([
                cl(n.b3),
                kl(e)
            ]), r);
        }),
        aM: F2(function(n, r) {
            var t;
            return A2(sl, 1 === n ? h([
                (t = n, A2(dc, "start", Fr(t)))
            ]) : d, A2(Dt, function(n) {
                return A2(fl, d, n);
            }, r));
        }),
        aO: dl(d),
        aU: function(n) {
            return A2(Xd, d, n);
        },
        aV: function(n) {
            return A2(hl, d, n);
        },
        aW: gl(d),
        aX: pl(d),
        aY: function(n) {
            return ml(A2(wa, d, A2(aa, Nd, A2(aa, Fd, A2(aa, function(n) {
                switch(n){
                    case 0:
                        return "left";
                    case 2:
                        return "center";
                    default:
                        return "right";
                }
            }, n)))));
        },
        aZ: yl(d),
        a_: function(n) {
            return wl(A2(wa, d, A2(aa, Nd, A2(aa, Fd, A2(aa, function(n) {
                switch(n){
                    case 0:
                        return "left";
                    case 2:
                        return "center";
                    default:
                        return "right";
                }
            }, n)))));
        },
        at: xl(d),
        j: yc,
        a$: A2(al, d, d),
        a0: function(n) {
            return A2(Al, d, A2(Dt, function(n) {
                var r = n.a, t = n.b, e = function() {
                    switch(r){
                        case 0:
                            return yc("");
                        case 1:
                            return A2(ol, h([
                                Jd(!0),
                                Gd(!1),
                                Il("checkbox")
                            ]), d);
                        default:
                            return A2(ol, h([
                                Jd(!0),
                                Gd(!0),
                                Il("checkbox")
                            ]), d);
                    }
                }();
                return A2(fl, d, A2(Yr, e, t));
            }, n));
        }
    }, {
        b8: function(n) {
            var r = n.b$;
            switch(n.cf){
                case 0:
                case 1:
                    return A2(rl, d, r);
                case 2:
                    return A2(tl, d, r);
                case 3:
                    return A2(pc, d, r);
                case 4:
                    return A2(el, d, r);
                default:
                    return A2(ul, d, r);
            }
        }
    }), Cl = function(n) {
        switch(n.$){
            case 2:
                return yc("");
            case 0:
                return (r = A2(kc, function(n) {
                    return A2(Bd, El, n);
                }, A2(Te, Ic, td(n.a)))).$ ? yc(r.a) : A2($c, d, r.a);
            default:
                return yc("Failed to load content.");
        }
        var r;
    }, Yl = On("span"), _l = A2($c, h([
        lc("footer")
    ]), h([
        A2($c, h([
            lc("row")
        ]), h([
            A2($c, h([
                lc("col-xs-4 text-left")
            ]), h([
                A2(Dd, h([
                    cl("#changelog"),
                    A2(hc, "data-toggle", "modal"),
                    A2(hc, "data-target", "#changelog")
                ]), h([
                    yc("What's New?")
                ]))
            ])),
            A2($c, h([
                lc("col-xs-4")
            ]), h([
                A2(dl, h([
                    lc("text-muted text-center")
                ]), h([
                    yc("Built with"),
                    A2(Yl, h([
                        A2(hc, "aria-hidden", "true"),
                        lc("glyphicon glyphicon-heart"),
                        A2(hc, "data-placement", "top"),
                        A2(hc, "data-toggle", "tooltip"),
                        A2(hc, "style", "color:red; margin-right: 4px")
                    ]), d),
                    yc("by Tubo Shi"),
                    A2(dl, d, h([
                        A2(Dd, h([
                            cl("mailto:tubo@tubo.nz?subject=Easy Read Code User")
                        ]), h([
                            yc("Comments and feedback")
                        ]))
                    ]))
                ]))
            ])),
            A2($c, h([
                lc("col-xs-4 text-right")
            ]), h([
                A2(Dd, h([
                    cl("#disclaimer"),
                    lc("text-right"),
                    A2(hc, "data-toggle", "modal"),
                    A2(hc, "data-target", "#disclaimer")
                ]), h([
                    yc("Disclaimer and copyright")
                ]))
            ]))
        ]))
    ])), Sl = On("small"), ql = F2(function(n, r) {
        return {
            $: 2,
            a: n,
            b: r
        };
    }), Tl = function(n) {
        return {
            $: 5,
            a: n
        };
    }, Nl = function(n) {
        return {
            $: 4,
            a: n
        };
    }, Ol = function(n) {
        return {
            $: 3,
            a: n
        };
    }, zl = F2(function(n, r) {
        return 0 > c(n, r) ? n : r;
    }), Ml = function(n) {
        switch(n){
            case 0:
                return 1;
            case 1:
                return 2;
            case 2:
                return 3;
            case 3:
                return 4;
            case 4:
                return 5;
            case 5:
                return 6;
            case 6:
                return 7;
            case 7:
                return 8;
            case 8:
                return 9;
            case 9:
                return 10;
            case 10:
                return 11;
            default:
                return 12;
        }
    }, Zl = F3(function(n, r, t) {
        for(;;){
            var e = A2(Fe, n, r), u = Ml(r);
            if (u >= 12 || 0 >= c(t, e)) return {
                a7: t,
                bo: r,
                bV: n
            };
            r = Oa(u + 1), t -= e;
        }
    }), Ll = F2(function(n, r) {
        return o(A2(Be, n, r), A2(Me, r, n));
    }), Rl = function(n) {
        var r = A2(Ll, n, 146097), t = r.a, e = A2(Ll, r.b, 36524), u = e.a, a = A2(Ll, e.b, 1461), c = a.a, i = A2(Ll, a.b, 365);
        return 400 * t + 100 * u + 4 * c + i.a + (i.b ? 1 : 0);
    }, Bl = function(n) {
        var r = n, t = Rl(r);
        return {
            aN: r - De(t),
            bV: t
        };
    }, Dl = function(n) {
        var r = Bl(n);
        return A3(Zl, r.bV, 0, r.aN);
    }, Fl = F3(function(n, r, t) {
        var e = t;
        switch(n){
            case 0:
                return A3(Fl, 1, 12 * r, e);
            case 1:
                var u = Dl(e), a = 12 * (u.bV - 1) + (Ml(u.bo) - 1) + r, c = Oa(A2(Me, 12, a) + 1), i = A2(Be, a, 12) + 1;
                return De(i) + A2(Re, i, c) + A2(zl, u.a7, A2(Fe, i, c));
            case 2:
                return e + 7 * r;
            default:
                return e + r;
        }
    }), Ul = A2(Ce, Dl, function(n) {
        return n.a7;
    }), Pl = A2(Ce, Dl, function(n) {
        return n.bo;
    }), Ql = A2(Ce, Pl, Ml), Wl = A2(Ce, Bl, function(n) {
        return n.aN;
    }), Hl = F3(function(n, r, t) {
        return v(A2(lf, n - St(t), Xi(r)), t);
    }), Gl = F2(function(n, r) {
        var t;
        return v(0 > r ? "-" : "", A3(Hl, n, "0", Fr(0 > (t = r) ? -t : t)));
    }), Vl = A2(Ce, Pl, function(n) {
        return (Ml(n) + 2) / 3 | 0;
    }), Xl = F2(function(n, r) {
        return 1 > n ? "" : A3(qt, -n, St(r), r);
    }), Jl = function(n) {
        switch(A2(ht, 1, n)){
            case 1:
                return 0;
            case 2:
                return 1;
            case 3:
                return 2;
            case 4:
                return 3;
            case 5:
                return 4;
            case 6:
                return 5;
            default:
                return 6;
        }
    }, Kl = function(n) {
        var r = n, t = Za(r), e = Rl(r + (4 - t));
        return {
            bT: 1 + ((r - (La(e) + 1)) / 7 | 0),
            bU: e,
            cF: Jl(t)
        };
    }, n$ = A2(Ce, Kl, function(n) {
        return n.bT;
    }), r$ = A2(Ce, Kl, function(n) {
        return n.bU;
    }), t$ = A2(Ce, Za, Jl), e$ = function(n) {
        return v(Fr(n), function(n) {
            var r = A2(Me, 100, n);
            switch(A2(zl, 20 > r ? r : A2(Me, 10, r), 4)){
                case 1:
                    return "st";
                case 2:
                    return "nd";
                case 3:
                    return "rd";
                default:
                    return "th";
            }
        }(n));
    }, u$ = F4(function(n, r, t, e) {
        switch(r){
            case "y":
                return 2 === t ? A2(Xl, 2, A3(Hl, 2, "0", Fr(Rl(e)))) : A2(Gl, t, Rl(e));
            case "Y":
                return 2 === t ? A2(Xl, 2, A3(Hl, 2, "0", Fr(r$(e)))) : A2(Gl, t, r$(e));
            case "Q":
                switch(t){
                    case 1:
                    case 2:
                    case 5:
                        return Fr(Vl(e));
                    case 3:
                        return "Q" + Fr(Vl(e));
                    case 4:
                        return e$(Vl(e));
                    default:
                        return "";
                }
            case "M":
                switch(t){
                    case 1:
                        return Fr(Ql(e));
                    case 2:
                        return A3(Hl, 2, "0", Fr(Ql(e)));
                    case 3:
                        return n.aq(Pl(e));
                    case 4:
                        return n.bp(Pl(e));
                    case 5:
                        return A2(Ot, 1, n.aq(Pl(e)));
                    default:
                        return "";
                }
            case "w":
                switch(t){
                    case 1:
                        return Fr(n$(e));
                    case 2:
                        return A3(Hl, 2, "0", Fr(n$(e)));
                    default:
                        return "";
                }
            case "d":
                switch(t){
                    case 1:
                        return Fr(Ul(e));
                    case 2:
                        return A3(Hl, 2, "0", Fr(Ul(e)));
                    case 3:
                        return n.aC(Ul(e));
                    default:
                        return "";
                }
            case "D":
                switch(t){
                    case 1:
                        return Fr(Wl(e));
                    case 2:
                        return A3(Hl, 2, "0", Fr(Wl(e)));
                    case 3:
                        return A3(Hl, 3, "0", Fr(Wl(e)));
                    default:
                        return "";
                }
            case "E":
                switch(t){
                    case 1:
                    case 2:
                    case 3:
                        return n.I(t$(e));
                    case 4:
                        return n.a1(t$(e));
                    case 5:
                        return A2(Ot, 1, n.I(t$(e)));
                    case 6:
                        return A2(Ot, 2, n.I(t$(e)));
                    default:
                        return "";
                }
            case "e":
                switch(t){
                    case 1:
                    case 2:
                        return Fr(Za(e));
                    default:
                        return A4(u$, n, "E", t, e);
                }
            default:
                return "";
        }
    }), a$ = F3(function(n, r, t) {
        return A3(Pr, F2(function(r, e) {
            return v(r.$ ? r.a : A4(u$, n, r.a, r.b, t), e);
        }), "", r);
    }), c$ = function(n) {
        return {
            $: 1,
            a: n
        };
    }, i$ = A2(ta, xa(c$("'")), Sa("''")), o$ = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), f$ = di, s$ = eb, b$ = Ai, v$ = A2(Bu, function(n) {
        var r = to(n);
        if (r.b && !r.b.b) {
            var t = r.a;
            return A2(ua, A2(ua, xa(F2(function(n, r) {
                return A2(o$, t, r - n + 1);
            })), A2(ta, s$, f$(dt(t)))), s$);
        }
        return Qa("expected exactly one char");
    }, b$(Gu(nt))), d$ = A2(Pr, F2(function(n, r) {
        var t = o(n, r);
        if (1 === t.a.$ && t.b.b && 1 === t.b.a.$) {
            var e = t.b, u = e.b;
            return A2(Yr, c$(v(t.a.a, e.a.a)), u);
        }
        return A2(Yr, n, r);
    }), d), l$ = function(n) {
        return "'" !== n && !nt(n);
    }, $$ = A2(ia, c$, b$(A2(ta, A2(ta, xa(0), Gu(l$)), f$(l$)))), h$ = function(n) {
        return ba(h([
            A2(Bu, function(r) {
                return h$(v(n, r));
            }, b$(A2(ta, A2(ta, xa(0), Gu(Ze("'"))), f$(Ze("'"))))),
            A2(Bu, function() {
                return h$(n + "'");
            }, Sa("''")),
            xa(n)
        ]));
    }, g$ = A2(ua, A2(ta, xa(c$), Gu(dt("'"))), A2(ta, h$(""), ba(h([
        Gu(dt("'")),
        Ju
    ])))), p$ = function(n) {
        var r;
        return ba(h([
            A2(Bu, function(r) {
                return p$(A2(Yr, r, n));
            }, ba(h([
                v$,
                $$,
                i$,
                g$
            ]))),
            (r = function() {
                return xa(d$(n));
            }, function(n) {
                return r(0)(n);
            })
        ]));
    }, m$ = F2(function(n, r) {
        var t, e = tt(A2(bc, h([
            c$(t = r)
        ]), A2(Ka, p$(d), t)));
        return A2(a$, n, e);
    }), w$ = function(n) {
        switch(n){
            case 0:
                return "Monday";
            case 1:
                return "Tuesday";
            case 2:
                return "Wednesday";
            case 3:
                return "Thursday";
            case 4:
                return "Friday";
            case 5:
                return "Saturday";
            default:
                return "Sunday";
        }
    }, y$ = {
        aC: e$,
        bp: Na,
        aq: A2(Ce, Na, Ot(3)),
        a1: w$,
        I: A2(Ce, w$, Ot(3))
    }, k$ = function(n) {
        return A2(m$, y$, n);
    }, x$ = F3(function(n, r, t) {
        var e = function() {
            switch(t){
                case 3:
                case 2:
                case 1:
                    return A3(Fl, t, r, n);
                default:
                    return n;
            }
        }();
        return A2(k$, "EEEE d/MM/y", A3(Fl, 3, -1, e));
    }), I$ = function(n) {
        switch(n){
            case 3:
                return "day(s)";
            case 2:
                return "week(s)";
            case 1:
                return "month(s)";
            default:
                return "";
        }
    }, A$ = Mn, j$ = F2(function(n, r) {
        return A2(A$, n, {
            $: 0,
            a: r
        });
    }), E$ = A2(F2(function(n, r) {
        return A3(Bt, ec, r, n);
    }), h([
        "target",
        "value"
    ]), uc), C$ = function(n) {
        return A2(j$, "click", Et(n));
    }, Y$ = function(n) {
        return o(n, !0);
    }, _$ = F2(function(n, r) {
        return A2(A$, n, {
            $: 1,
            a: r
        });
    }), S$ = function(n) {
        return A2(_$, "input", A2(At, Y$, A2(At, n, E$)));
    }, q$ = dc("placeholder"), T$ = k$("yyyy-MM-dd"), N$ = dc("value"), O$ = F4(function(n, r, t, e) {
        var u;
        return A2($c, h([
            lc("row date-group")
        ]), h([
            A2($c, h([
                lc("col-xs-8 col-xs-offset-2 col-sm-6 col-sm-offset-0 col-md-6 col-lg-4")
            ]), h([
                A2(el, h([
                    lc("text-center")
                ]), h([
                    yc("Injury date")
                ])),
                A2(ol, h([
                    A2(hc, "type", "date"),
                    lc("form-control text-center date-polyfill"),
                    (u = Tl, A2(j$, "change", A2(At, u, E$))),
                    mc("starting-date-input"),
                    N$(T$(e))
                ]), d)
            ])),
            A2($c, h([
                lc("col-xs-12 col-sm-6 col-md-6 col-lg-4 text-center")
            ]), h([
                A2(el, h([
                    lc("text-center")
                ]), h([
                    yc("unfit for work for " + Fr(r) + " " + I$(n))
                ])),
                A2($c, h([
                    lc("row")
                ]), h([
                    A2($c, h([
                        lc("input-group-btn "),
                        A2(hc, "role", "group")
                    ]), h([
                        A2(gc, h([
                            Il("button"),
                            lc("btn btn-default"),
                            C$(A2(ql, 3, 3))
                        ]), h([
                            yc("3 days")
                        ])),
                        A2(gc, h([
                            Il("button"),
                            lc("btn btn-default"),
                            C$(A2(ql, 3, 7))
                        ]), h([
                            yc("7 days")
                        ])),
                        A2(gc, h([
                            Il("button"),
                            lc("btn btn-default"),
                            C$(A2(ql, 3, 10))
                        ]), h([
                            yc("10 days")
                        ])),
                        A2(gc, h([
                            Il("button"),
                            lc("btn btn-default"),
                            C$(A2(ql, 3, 14))
                        ]), h([
                            yc("14 days")
                        ]))
                    ])),
                    A2($c, h([
                        lc("input-group input-group-sm input-date-length")
                    ]), h([
                        A2(ol, h([
                            Il("number"),
                            lc("form-control"),
                            q$(""),
                            S$(Nl)
                        ]), d),
                        A2($c, h([
                            lc("input-group-btn")
                        ]), h([
                            A2(gc, h([
                                Il("button"),
                                lc("btn btn-default dropdown-toggle"),
                                A2(hc, "data-toggle", "dropdown")
                            ]), h([
                                yc(I$(n)),
                                A2(Yl, h([
                                    lc("caret")
                                ]), d)
                            ])),
                            A2(Al, h([
                                lc("dropdown-menu dropdown-menu-right")
                            ]), h([
                                A2(fl, d, h([
                                    A2(Dd, h([
                                        cl("#"),
                                        C$(Ol(3))
                                    ]), h([
                                        yc("days(s)")
                                    ]))
                                ])),
                                A2(fl, d, h([
                                    A2(Dd, h([
                                        cl("#"),
                                        C$(Ol(2))
                                    ]), h([
                                        yc("week(s)")
                                    ]))
                                ])),
                                A2(fl, d, h([
                                    A2(Dd, h([
                                        cl("#"),
                                        C$(Ol(1))
                                    ]), h([
                                        yc("month(s)")
                                    ]))
                                ]))
                            ]))
                        ]))
                    ]))
                ]))
            ])),
            A2($c, h([
                lc("col-xs-8 col-xs-offset-2 col-lg-offset-0 col-lg-4")
            ]), h([
                A2(el, h([
                    lc("text-center")
                ]), h([
                    yc(" until (inclusive of injury date):")
                ])),
                A2($c, h([
                    lc("well well-sm text-center")
                ]), h([
                    A2(hl, d, h([
                        yc(A3(x$, e, r, n))
                    ]))
                ]))
            ]))
        ]));
    }), z$ = Hd("autofocus"), M$ = A2(ol, h([
        Il("text"),
        z$(!0),
        lc("search form-control input-lg"),
        q$("Enter a diagnosis, e.g. hand laceration"),
        S$(function(n) {
            return {
                $: 0,
                a: n
            };
        })
    ]), d), Z$ = Zn, L$ = function(n) {
        var r = n.an;
        return A2(el, h([
            lc("text-right")
        ]), h([
            yc("Database Status: "),
            A2(Yl, h([
                lc("glyphicon " + (r ? "glyphicon-ok-sign" : "glyphicon-refresh spinning")),
                A2(Z$, "color", r ? "green" : "orange"),
                A2(hc, "data-toggle", "tooltip"),
                A2(hc, "data-placement", "top"),
                A2(hc, "data-original-title", r ? "Database fully loaded" : "Database loading...")
            ]), d)
        ]));
    }, R$ = function(n) {
        return A2($c, h([
            lc("jumbotron")
        ]), h([
            A2(nl, h([
                lc("text-center")
            ]), h([
                yc("Easy Read Code"),
                A2(Sl, d, h([
                    yc(" 2025")
                ]))
            ])),
            L$(n),
            M$,
            A4(O$, n.U, n.P, n.ag, n.X)
        ]));
    }, B$ = function(n) {
        return On(function(n) {
            return "script" == n ? "p" : n;
        }(n));
    }, D$ = A2($c, h([
        lc("row promotion")
    ]), h([
        A3(B$, "picture", d, h([
            A3(B$, "source", h([
                A2(hc, "media", "(max-width: 992px)"),
                A2(hc, "srcset", "/stonz-banner-tablet-600x200.png, /stonz-banner-tablet-1200x400.png 2x")
            ]), d),
            A2(il, h([
                A2(hc, "srcset", "/stonz-banner-desktop-970x250.png, /stonz-banner-desktop-1940x500.png 2x"),
                A2(hc, "sizes", "85vw"),
                lc("img-responsive center-block"),
                Ud("Proudly sponsored by STONZ")
            ]), d)
        ]))
    ])), F$ = F3(function(n, r, t) {
        for(;;){
            var e = A2(pt, et, n), u = e.a, a = e.b;
            if (0 > c($t(u), et)) return A2(yt, !0, {
                q: r,
                m: t,
                o: u
            });
            n = a, r = A2(Yr, bt(u), r), t += 1;
        }
    }), U$ = F2(function(n, r) {
        var t;
        return (t = A3(Tr, F2(function(r, t) {
            return n(r) ? A2(Yr, r, t) : t;
        }), d, r)).b ? A3(F$, t, d, 0) : ft;
    }), P$ = function(n) {
        return n.a;
    }, Q$ = be, W$ = F2(function(n, r) {
        return A3(me, n, 0, r);
    }), H$ = F2(function(n, r) {
        return !A2($e, n, r).$;
    }), G$ = F2(function(n, r) {
        return A2(H$, n, r);
    }), V$ = F4(function(n, r, t, e) {
        for(;;){
            if (!t.b) return tt(e);
            var u = t.a, a = t.b, c = n(u);
            A2(G$, c, r) ? t = a : (r = A2(W$, c, r), t = a, e = A2(Yr, u, e));
        }
    }), X$ = F2(function(n, r) {
        return A4(V$, n, Q$, r, d);
    }), J$ = function(n) {
        return A2(xl, d, h([
            A2(ml, d, h([
                yc(n.aQ)
            ])),
            A2(ml, d, h([
                yc("")
            ])),
            A2(ml, d, h([
                yc(n.N)
            ]))
        ]));
    }, K$ = function(n) {
        return A2(xl, d, h([
            A2(ml, d, h([
                A2(hl, d, h([
                    yc(n.bw)
                ]))
            ])),
            A2(ml, d, h([
                yc(n.a6)
            ])),
            A2(ml, d, h([
                yc(n.N)
            ]))
        ]));
    }, nh = function(n) {
        var r, t, e, u = n.ad || n.ab, a = (r = A2(X$, Yt, A2(Dt, function(n) {
            return n.N;
        }, Nr(n.B))), A2(U$, function(n) {
            return !A2(Ho, n.N, r);
        }, n.aa)), c = P$(n.B) > 0 ? v(A2(Dt, K$, Nr(n.B)), n.ac ? A2(Dt, J$, Nr(a)) : d) : A2(Dt, J$, Nr(a)), i = u ? d : c, o = !u && P$(n.B) > 0 && P$(a) > 0;
        return A2($c, h([
            lc("results col-xs-12 col-md-10 col-md-offset-1 col-lg-8 col-lg-offset-2")
        ]), h([
            A2(gl, h([
                lc("table table-bordered table-hover table-striped")
            ]), h([
                A2(yl, d, h([
                    A2(xl, d, h([
                        A2(wl, h([
                            lc("col-sm-6")
                        ]), h([
                            yc("Diagnosis")
                        ])),
                        A2(wl, h([
                            lc("col-sm-3")
                        ]), h([
                            yc("SNOMED-CT "),
                            A2(Yl, h([
                                lc("glyphicon glyphicon-question-sign"),
                                A2(hc, "data-toggle", "tooltip"),
                                A2(hc, "data-placement", "top"),
                                A2(hc, "data-original-title", "SNOMED Clinical Terms (CT) is a new clinical terminology system, which has been endorsed by the New Zealand Ministry of Health for use in the health and disability sector. It will replace the UK Read clinical codes, which are no longer supported.")
                            ]), d)
                        ])),
                        A2(wl, h([
                            lc("col-sm-3")
                        ]), h([
                            yc("Read Code")
                        ]))
                    ]))
                ])),
                A2(pl, d, i)
            ])),
            u ? A2($c, h([
                lc("text-center")
            ]), h([
                yc("Loading... "),
                A2(Yl, h([
                    lc("glyphicon glyphicon-refresh spinning")
                ]), d)
            ])) : A2($c, d, d),
            o ? (t = n.ac, A2(gc, h([
                lc("btn btn-default col-xs-6 col-xs-offset-3 col-md-4 col-md-offset-4"),
                C$((e = !t, {
                    $: 9,
                    a: e
                }))
            ]), h([
                yc(t ? "Hide" : "Show"),
                yc(" less commonly used codes "),
                A2(Yl, h([
                    lc("glyphicon" + (t ? " glyphicon-triangle-top" : " glyphicon-triangle-bottom"))
                ]), d)
            ]))) : A2($c, d, d)
        ]));
    };
    Ad = {
        Main: {
            init: Xt({
                cb: function() {
                    return o({
                        U: 3,
                        V: re,
                        an: !1,
                        W: re,
                        X: A2(Ke, Iu, pu(0)),
                        G: "",
                        aa: ft,
                        ab: !1,
                        ac: !1,
                        P: 3,
                        B: ft,
                        ad: !1,
                        ag: A2(Ke, Iu, pu(0))
                    }, te(h([
                        A2(Vt, ne, xu),
                        gu(0),
                        hu({
                            bc: Oe(Jt),
                            bQ: "/changelog.md"
                        }),
                        hu({
                            bc: Oe(Kt),
                            bQ: "/disclaimer.md"
                        })
                    ])));
                },
                cz: function() {
                    return Cu(h([
                        Tu(Eu),
                        qu(ju),
                        _u(Au)
                    ]));
                },
                cD: vc,
                cE: function(n) {
                    var r, t;
                    return A2($c, h([
                        lc("container")
                    ]), h([
                        A2($c, h([
                            lc("content")
                        ]), h([
                            R$(n),
                            nh(n)
                        ])),
                        D$,
                        _l,
                        (t = n.W, A2($c, h([
                            mc("disclaimer"),
                            lc("modal fade"),
                            wc("dialog")
                        ]), h([
                            A2($c, h([
                                lc("modal-dialog")
                            ]), h([
                                A2($c, h([
                                    lc("modal-content")
                                ]), h([
                                    A2($c, h([
                                        lc("modal-header")
                                    ]), h([
                                        A2(gc, h([
                                            lc("close"),
                                            A2(hc, "data-dismiss", "modal")
                                        ]), h([
                                            yc("\xd7")
                                        ])),
                                        A2(pc, h([
                                            lc("modal-title text-center")
                                        ]), h([
                                            yc("Disclaimer and Copyright")
                                        ]))
                                    ])),
                                    A2($c, h([
                                        lc("modal-body")
                                    ]), h([
                                        A2($c, h([
                                            lc("disclaimer")
                                        ]), h([
                                            Cl(t)
                                        ]))
                                    ]))
                                ]))
                            ]))
                        ]))),
                        (r = n.V, A2($c, h([
                            mc("changelog"),
                            lc("modal fade"),
                            wc("dialog")
                        ]), h([
                            A2($c, h([
                                lc("modal-dialog")
                            ]), h([
                                A2($c, h([
                                    lc("modal-content")
                                ]), h([
                                    A2($c, h([
                                        lc("modal-header")
                                    ]), h([
                                        A2(gc, h([
                                            lc("close"),
                                            A2(hc, "data-dismiss", "modal")
                                        ]), h([
                                            yc("\xd7")
                                        ])),
                                        A2(pc, h([
                                            lc("modal-title")
                                        ]), h([
                                            yc("What's New?")
                                        ]))
                                    ])),
                                    A2($c, h([
                                        lc("modal-body")
                                    ]), h([
                                        A2($c, h([
                                            lc("changelog")
                                        ]), h([
                                            Cl(r)
                                        ]))
                                    ]))
                                ]))
                            ]))
                        ])))
                    ]));
                }
            })(Et(0))(0)
        }
    }, n.Elm ? function n(r, t) {
        for(var e in t)e in r ? "init" == e ? x(6) : n(r[e], t[e]) : r[e] = t[e];
    }(n.Elm, Ad) : n.Elm = Ad;
}($cd2a3739fedbc9f0$exports);


!function() {
    "use strict";
    var t = {
        815: function(t, e, r) {
            var a = r(81), n = r.n(a), o = r(645), i = r.n(o)()(n());
            i.push([
                t.id,
                'date-input-polyfill{width:auto;min-width:260px;height:auto;background-color:#fff;-webkit-box-shadow:0 0 5px 2px rgba(128,128,128,.81);-moz-box-shadow:0 0 5px 2px rgba(128,128,128,.81);box-shadow:0 0 5px 2px rgba(128,128,128,.81);position:absolute;font-family:Arial,sans-serif;font-size:16px;color:#000}date-input-polyfill .date-select-header{position:relative;width:100%;height:40px;background-color:#fff;text-align:center;line-height:40px}date-input-polyfill .date-select-header .date-header-button{padding:5px 25px 5px 5px;border:solid 1px #a8a3a3;background-color:#fff;min-width:150px;width:auto;max-width:180px;height:28px;border-radius:5px;cursor:pointer;position:relative;line-height:15px;font-size:13px;color:#000}date-input-polyfill .date-select-header .date-header-button.active:after{content:"<";display:inline-block;position:absolute;right:10px;-webkit-transform:rotate(90deg);-moz-transform:rotate(90deg);-o-transform:rotate(90deg);-ms-transform:rotate(90deg);transform:rotate(90deg);font-size:18px;top:6px}date-input-polyfill .date-select-header .date-header-button.inactive:after{content:"<";display:inline-block;position:absolute;right:10px;-webkit-transform:rotate(-90deg);-moz-transform:rotate(-90deg);-o-transform:rotate(-90deg);-ms-transform:rotate(-90deg);transform:rotate(-90deg);font-size:18px;top:6px}date-input-polyfill .day-matrix-wrapper{position:relative;background-color:#fff;width:100%;height:auto;padding:0 10px 10px 10px;box-sizing:border-box}date-input-polyfill .day-matrix-wrapper table{width:100%;text-align:center;font-size:18px;padding:0;line-height:24px;border-collapse:separate}date-input-polyfill .day-matrix-wrapper table thead{color:#b4b4b4;pointer-events:none}date-input-polyfill .day-matrix-wrapper table thead th{border:none;padding:0;text-align:center;font-size:18px}date-input-polyfill .day-matrix-wrapper table tbody td{border:solid 1px #fff;padding:0;text-align:center;font-size:18px;width:30px}date-input-polyfill .day-matrix-wrapper table tbody td.current-day{border:solid 1px #cce5f3;background-color:#cce5f3}date-input-polyfill .day-matrix-wrapper table tbody td.current-day.disabled{border:solid 1px #fff}date-input-polyfill .day-matrix-wrapper table tbody td[data-selected]{font-weight:bold;border:solid 1px #a2d8f6;background-color:#a2d8f6}date-input-polyfill .day-matrix-wrapper table tbody td[data-selected]:hover{border:solid 1px #a2d8f6;background-color:#a2d8f6}date-input-polyfill .day-matrix-wrapper table tbody td.prev-month,date-input-polyfill .day-matrix-wrapper table tbody td.next-month{color:#d3d3d3}date-input-polyfill .day-matrix-wrapper table tbody td.prev-month:hover,date-input-polyfill .day-matrix-wrapper table tbody td.next-month:hover{color:#fff}date-input-polyfill .day-matrix-wrapper table tbody td.disabled{background-color:gray;color:#d3d3d3}date-input-polyfill .day-matrix-wrapper table tbody td.disabled:hover{background-color:gray;border:solid 1px #fff;color:#d3d3d3}date-input-polyfill .day-matrix-wrapper table tbody td:hover{cursor:pointer;background-color:#d3d3d3;border:solid 1px #d3d3d3}date-input-polyfill .date-select-dropdown{position:absolute;width:100%;height:auto;top:40px;background-color:#fff;display:none}date-input-polyfill .date-select-dropdown .select-container{position:relative;float:left;width:100%;height:auto;padding:5px 60px 5px 60px}date-input-polyfill .date-select-dropdown .select-container .up,date-input-polyfill .date-select-dropdown .select-container .down{width:100%;height:25px;text-align:center;background-color:rgba(0,0,0,0);cursor:pointer;line-height:22px;float:left;border:none;outline:none;color:#7d7d7d;position:relative}date-input-polyfill .date-select-dropdown .select-container .up:after,date-input-polyfill .date-select-dropdown .select-container .down:after{content:"<";position:absolute;top:0;left:19px;font-size:20px;display:inline-block;-webkit-transform:rotate(90deg);-moz-transform:rotate(90deg);-o-transform:rotate(90deg);-ms-transform:rotate(90deg);transform:rotate(90deg)}date-input-polyfill .date-select-dropdown .select-container .down:after{-webkit-transform:rotate(-90deg);-moz-transform:rotate(-90deg);-o-transform:rotate(-90deg);-ms-transform:rotate(-90deg);transform:rotate(-90deg)}date-input-polyfill .date-select-dropdown .select-container .select-wrapper{float:left;width:50px;height:175px;position:relative;margin:10px}date-input-polyfill .date-select-dropdown .select-container .select-wrapper .option-wrapper{float:left;width:100%;height:auto}date-input-polyfill .date-select-dropdown .select-container .select-wrapper .option-wrapper .option{height:25px;border-radius:5px;text-align:center;float:left;width:100%;line-height:25px}date-input-polyfill .date-select-dropdown .select-container .select-wrapper .option-wrapper .option:nth-child(3){background-color:#d3d3d3}date-input-polyfill[data-open=false]{visibility:hidden;z-index:-100 !important;top:0}date-input-polyfill[data-open=true]{visibility:visible}',
                ""
            ]), e.Z = i;
        },
        645: function(t) {
            t.exports = function(t) {
                var e = [];
                return e.toString = function() {
                    return this.map(function(e) {
                        var r = "", a = void 0 !== e[5];
                        return e[4] && (r += "@supports (".concat(e[4], ") {")), e[2] && (r += "@media ".concat(e[2], " {")), a && (r += "@layer".concat(e[5].length > 0 ? " ".concat(e[5]) : "", " {")), r += t(e), a && (r += "}"), e[2] && (r += "}"), e[4] && (r += "}"), r;
                    }).join("");
                }, e.i = function(t, r, a, n, o) {
                    "string" == typeof t && (t = [
                        [
                            null,
                            t,
                            void 0
                        ]
                    ]);
                    var i = {};
                    if (a) for(var l = 0; l < this.length; l++){
                        var s = this[l][0];
                        null != s && (i[s] = !0);
                    }
                    for(var u = 0; u < t.length; u++){
                        var d = [].concat(t[u]);
                        a && i[d[0]] || (void 0 !== o && (void 0 === d[5] || (d[1] = "@layer".concat(d[5].length > 0 ? " ".concat(d[5]) : "", " {").concat(d[1], "}")), d[5] = o), r && (d[2] ? (d[1] = "@media ".concat(d[2], " {").concat(d[1], "}"), d[2] = r) : d[2] = r), n && (d[4] ? (d[1] = "@supports (".concat(d[4], ") {").concat(d[1], "}"), d[4] = n) : d[4] = "".concat(n)), e.push(d));
                    }
                }, e;
            };
        },
        81: function(t) {
            t.exports = function(t) {
                return t[1];
            };
        },
        379: function(t) {
            var e = [];
            function r(t) {
                for(var r = -1, a = 0; a < e.length; a++)if (e[a].identifier === t) {
                    r = a;
                    break;
                }
                return r;
            }
            function a(t, a) {
                for(var o = {}, i = [], l = 0; l < t.length; l++){
                    var s = t[l], u = a.base ? s[0] + a.base : s[0], d = o[u] || 0, c = "".concat(u, " ").concat(d);
                    o[u] = d + 1;
                    var p = r(c), h = {
                        css: s[1],
                        media: s[2],
                        sourceMap: s[3],
                        supports: s[4],
                        layer: s[5]
                    };
                    if (-1 !== p) e[p].references++, e[p].updater(h);
                    else {
                        var m = n(h, a);
                        a.byIndex = l, e.splice(l, 0, {
                            identifier: c,
                            updater: m,
                            references: 1
                        });
                    }
                    i.push(c);
                }
                return i;
            }
            function n(t, e) {
                var r = e.domAPI(e);
                return r.update(t), function(e) {
                    if (e) {
                        if (e.css === t.css && e.media === t.media && e.sourceMap === t.sourceMap && e.supports === t.supports && e.layer === t.layer) return;
                        r.update(t = e);
                    } else r.remove();
                };
            }
            t.exports = function(t, n) {
                var o = a(t = t || [], n = n || {});
                return function(t) {
                    t = t || [];
                    for(var i = 0; i < o.length; i++){
                        var l = r(o[i]);
                        e[l].references--;
                    }
                    for(var s = a(t, n), u = 0; u < o.length; u++){
                        var d = r(o[u]);
                        0 === e[d].references && (e[d].updater(), e.splice(d, 1));
                    }
                    o = s;
                };
            };
        },
        569: function(t) {
            var e = {};
            t.exports = function(t, r) {
                var a = function(t) {
                    if (void 0 === e[t]) {
                        var r = document.querySelector(t);
                        if (window.HTMLIFrameElement && r instanceof window.HTMLIFrameElement) try {
                            r = r.contentDocument.head;
                        } catch (t) {
                            r = null;
                        }
                        e[t] = r;
                    }
                    return e[t];
                }(t);
                if (!a) throw new Error("Couldn't find a style target. This probably means that the value for the 'insert' parameter is invalid.");
                a.appendChild(r);
            };
        },
        216: function(t) {
            t.exports = function(t) {
                var e = document.createElement("style");
                return t.setAttributes(e, t.attributes), t.insert(e, t.options), e;
            };
        },
        565: function(t, e, r) {
            t.exports = function(t) {
                var e = r.nc;
                e && t.setAttribute("nonce", e);
            };
        },
        795: function(t) {
            t.exports = function(t) {
                var e = t.insertStyleElement(t);
                return {
                    update: function(r) {
                        !function(t, e, r) {
                            var a = "";
                            r.supports && (a += "@supports (".concat(r.supports, ") {")), r.media && (a += "@media ".concat(r.media, " {"));
                            var n = void 0 !== r.layer;
                            n && (a += "@layer".concat(r.layer.length > 0 ? " ".concat(r.layer) : "", " {")), a += r.css, n && (a += "}"), r.media && (a += "}"), r.supports && (a += "}");
                            var o = r.sourceMap;
                            o && "undefined" != typeof btoa && (a += "\n/*# sourceMappingURL=data:application/json;base64,".concat(btoa(unescape(encodeURIComponent(JSON.stringify(o)))), " */")), e.styleTagTransform(a, t, e.options);
                        }(e, t, r);
                    },
                    remove: function() {
                        !function(t) {
                            if (null === t.parentNode) return !1;
                            t.parentNode.removeChild(t);
                        }(e);
                    }
                };
            };
        },
        589: function(t) {
            t.exports = function(t, e) {
                if (e.styleSheet) e.styleSheet.cssText = t;
                else {
                    for(; e.firstChild;)e.removeChild(e.firstChild);
                    e.appendChild(document.createTextNode(t));
                }
            };
        }
    }, e = {};
    function r(a) {
        var n = e[a];
        if (void 0 !== n) return n.exports;
        var o = e[a] = {
            id: a,
            exports: {}
        };
        return t[a](o, o.exports, r), o.exports;
    }
    r.n = function(t) {
        var e = t && t.__esModule ? function() {
            return t.default;
        } : function() {
            return t;
        };
        return r.d(e, {
            a: e
        }), e;
    }, r.d = function(t, e) {
        for(var a in e)r.o(e, a) && !r.o(t, a) && Object.defineProperty(t, a, {
            enumerable: !0,
            get: e[a]
        });
    }, r.o = function(t, e) {
        return Object.prototype.hasOwnProperty.call(t, e);
    }, r.nc = void 0, function() {
        var t = r(379), e = r.n(t), a = r(795), n = r.n(a), o = r(569), i = r.n(o), l = r(565), s = r.n(l), u = r(216), d = r.n(u), c = r(589), p = r.n(c), h = r(815), m = {};
        function f(t) {
            return f = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(t) {
                return typeof t;
            } : function(t) {
                return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
            }, f(t);
        }
        function y(t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
            t.prototype = Object.create(e && e.prototype, {
                constructor: {
                    value: t,
                    writable: !0,
                    configurable: !0
                }
            }), Object.defineProperty(t, "prototype", {
                writable: !1
            }), e && b(t, e);
        }
        function b(t, e) {
            return b = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
                return t.__proto__ = e, t;
            }, b(t, e);
        }
        function g(t) {
            var e = function() {
                if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                if (Reflect.construct.sham) return !1;
                if ("function" == typeof Proxy) return !0;
                try {
                    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                } catch (t) {
                    return !1;
                }
            }();
            return function() {
                var r, a = v(t);
                if (e) {
                    var n = v(this).constructor;
                    r = Reflect.construct(a, arguments, n);
                } else r = a.apply(this, arguments);
                return function(t, e) {
                    if (e && ("object" === f(e) || "function" == typeof e)) return e;
                    if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
                    return function(t) {
                        if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                        return t;
                    }(t);
                }(this, r);
            };
        }
        function v(t) {
            return v = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
                return t.__proto__ || Object.getPrototypeOf(t);
            }, v(t);
        }
        function S(t, e) {
            if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
        }
        function D(t, e) {
            for(var r = 0; r < e.length; r++){
                var a = e[r];
                a.enumerable = a.enumerable || !1, a.configurable = !0, "value" in a && (a.writable = !0), Object.defineProperty(t, (n = function(t, e) {
                    if ("object" !== f(t) || null === t) return t;
                    var r = t[Symbol.toPrimitive];
                    if (void 0 !== r) {
                        var a = r.call(t, "string");
                        if ("object" !== f(a)) return a;
                        throw new TypeError("@@toPrimitive must return a primitive value.");
                    }
                    return String(t);
                }(a.key), "symbol" === f(n) ? n : String(n)), a);
            }
            var n;
        }
        function w(t, e, r) {
            return e && D(t.prototype, e), r && D(t, r), Object.defineProperty(t, "prototype", {
                writable: !1
            }), t;
        }
        m.styleTagTransform = p(), m.setAttributes = s(), m.insert = i().bind(null, "head"), m.domAPI = n(), m.insertStyleElement = d(), e()(h.Z, m), h.Z && h.Z.locals && h.Z.locals;
        var A = function() {
            function t() {
                S(this, t), this.date = new Date, this.toggleUp = document.createElement("button"), this.toggleDown = document.createElement("button"), this.optionWrapper = document.createElement("div"), this.dateSelectWrapper = document.createElement("div"), this.toggleUp.className = "control up", this.toggleDown.className = "control down", this.optionWrapper.className = "option-wrapper", this.dateSelectWrapper.className = "select-wrapper", this.dateSelectWrapper.appendChild(this.toggleUp), this.dateSelectWrapper.appendChild(this.optionWrapper), this.dateSelectWrapper.appendChild(this.toggleDown);
            }
            return w(t, [
                {
                    key: "returnDateSelectWrapper",
                    value: function() {
                        return this.dateSelectWrapper;
                    }
                }
            ]), t;
        }(), M = function(t) {
            y(r, t);
            var e = g(r);
            function r() {
                var t;
                S(this, r), (t = e.call(this)).yearArray = [], t.dateSelectWrapper.className = "select-wrapper year-select";
                for(var a = 0; a < 5; a += 1){
                    var n = document.createElement("div");
                    n.className = "option", t.optionWrapper.appendChild(n);
                }
                return t.toggleDown.addEventListener("click", function() {
                    t.yearArray.shift(), t.yearArray.push(Number(t.yearArray[t.yearArray.length - 1]) + 1), t.redrawYearSelect();
                }), t.toggleUp.addEventListener("click", function() {
                    1 !== t.yearArray[2] && (t.yearArray.pop(), t.yearArray.unshift(Number(t.yearArray[0]) - 1), t.yearArray[0] < 1 && (t.yearArray[0] = ""), t.redrawYearSelect());
                }), t;
            }
            return w(r, [
                {
                    key: "redrawYearSelect",
                    value: function() {
                        for(var t = 0; t < 5; t += 1)this.optionWrapper.getElementsByClassName("option")[t].innerHTML = String(this.yearArray[t]);
                    }
                },
                {
                    key: "toggleByInput",
                    value: function(t) {
                        var e = t;
                        this.yearArray.length = 0, e -= 2;
                        for(var r = 0; r < 5; r += 1)e < 1 ? this.yearArray.push("") : this.yearArray.push(e), e += 1;
                        this.redrawYearSelect();
                    }
                },
                {
                    key: "returnSelectedYear",
                    value: function() {
                        return Number(this.yearArray[2]);
                    }
                }
            ]), r;
        }(A), x = function(t) {
            y(r, t);
            var e = g(r);
            function r() {
                var t;
                S(this, r), (t = e.call(this)).selectedLocaleArray = [], t.monthArray = [
                    0,
                    1,
                    2,
                    3,
                    4,
                    5,
                    6,
                    7,
                    8,
                    9,
                    10,
                    11
                ], t.dateSelectWrapper.className = "select-wrapper month-select";
                for(var a = 0; a < 5; a += 1){
                    var n = document.createElement("div");
                    n.className = "option", n.innerHTML = "s", t.optionWrapper.appendChild(n);
                }
                return t.toggleDown.addEventListener("click", function() {
                    t.monthArray.push(Number(t.monthArray.shift())), t.redrawMonthSelect();
                }), t.toggleUp.addEventListener("click", function() {
                    t.monthArray.unshift(Number(t.monthArray.pop())), t.redrawMonthSelect();
                }), t;
            }
            return w(r, [
                {
                    key: "setLocalLabels",
                    value: function(t) {
                        this.selectedLocaleArray = t;
                    }
                },
                {
                    key: "redrawMonthSelect",
                    value: function() {
                        for(var t = this.returnMonthStringArray(), e = 0; e < 5; e += 1)this.optionWrapper.getElementsByClassName("option")[e].innerHTML = t[e];
                    }
                },
                {
                    key: "returnMonthStringArray",
                    value: function() {
                        var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : null, e = [], r = this.selectedLocaleArray;
                        return t || 0 === t ? this.selectedLocaleArray[t] : (this.monthArray.forEach(function(t) {
                            e.push(r[t].substring(0, 3));
                        }), e);
                    }
                },
                {
                    key: "toggleByInput",
                    value: function(t) {
                        t !== this.monthArray[2] && (this.monthArray = this.rotate(this.monthArray, this.calculateDateOffset(t)), this.redrawMonthSelect());
                    }
                },
                {
                    key: "calculateDateOffset",
                    value: function(t) {
                        var e = this.monthArray.length, r = 0;
                        switch(!0){
                            case t < this.monthArray[2]:
                                r = e - this.monthArray[2] + t;
                                break;
                            case t === this.monthArray[2]:
                                break;
                            case t > this.monthArray[2]:
                                r = t - this.monthArray[2];
                        }
                        return r;
                    }
                },
                {
                    key: "rotate",
                    value: function(t, e) {
                        for(var r = e; r > 0;){
                            var a = t.shift();
                            t.push(a), r -= 1;
                        }
                        return t;
                    }
                },
                {
                    key: "toggleByMatrix",
                    value: function(t) {
                        switch(t){
                            case "next":
                                this.monthArray = this.rotate(this.monthArray, 1);
                                break;
                            case "prev":
                                this.monthArray = this.rotate(this.monthArray, 11);
                        }
                        this.redrawMonthSelect();
                    }
                },
                {
                    key: "returnSelectedMonthAsLabel",
                    value: function() {
                        return this.returnMonthStringArray(this.monthArray[2]);
                    }
                },
                {
                    key: "returnSelectedMonth",
                    value: function() {
                        return this.monthArray[2];
                    }
                }
            ]), r;
        }(A);
        function E(t) {
            return E = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(t) {
                return typeof t;
            } : function(t) {
                return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
            }, E(t);
        }
        function k(t, e) {
            for(var r = 0; r < e.length; r++){
                var a = e[r];
                a.enumerable = a.enumerable || !1, a.configurable = !0, "value" in a && (a.writable = !0), Object.defineProperty(t, (n = function(t, e) {
                    if ("object" !== E(t) || null === t) return t;
                    var r = t[Symbol.toPrimitive];
                    if (void 0 !== r) {
                        var a = r.call(t, "string");
                        if ("object" !== E(a)) return a;
                        throw new TypeError("@@toPrimitive must return a primitive value.");
                    }
                    return String(t);
                }(a.key), "symbol" === E(n) ? n : String(n)), a);
            }
            var n;
        }
        var T = new (function() {
            function t() {
                var e = this;
                !function(t, e) {
                    if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
                }(this, t), this.date = new Date, this.isOpen = !1, this.yearSelect = new M, this.monthSelect = new x, this.localeLabels = [], this.firstDayOfWeek = "", this.targetInputElement = null, this.daysHead = document.createElement("thead"), this.daysWrapper = document.createElement("tbody"), this.dateSelectWrapper = document.createElement("div"), this.dateSelectWrapper.className = "date-select-dropdown", this.selectWrapper = document.createElement("div"), this.selectWrapper.className = "select-container", this.selectWrapper.appendChild(this.monthSelect.returnDateSelectWrapper()), this.selectWrapper.appendChild(this.yearSelect.returnDateSelectWrapper()), this.dateSelectWrapper.appendChild(this.selectWrapper), this.pickerElement = document.createElement("date-input-polyfill"), this.pickerElement.className = "date-input-polyfill";
                var r = document.createElement("div");
                r.className = "date-select-header", this.dateHeaderButton = document.createElement("button"), this.dateHeaderButton.className = "date-header-button inactive", this.dateHeaderButton.addEventListener("click", function() {
                    return e.toggleDateHeader();
                }), r.appendChild(this.dateHeaderButton);
                var a = document.createElement("div");
                a.className = "day-matrix-wrapper", this.pickerElement.appendChild(r), this.pickerElement.appendChild(a), this.pickerElement.appendChild(this.dateSelectWrapper), this.daysWrapper.addEventListener("click", function(t) {
                    return e.clickDayElement(t.target);
                });
                var n = document.createElement("table");
                n.appendChild(this.daysHead), n.appendChild(this.daysWrapper), a.appendChild(n), this.hide(), document.body.appendChild(this.pickerElement);
            }
            var e, r;
            return e = t, r = [
                {
                    key: "removeClickOut",
                    value: function(t) {
                        if (this.isOpen) {
                            for(var e = t.target, r = e === this.pickerElement || e === this.targetInputElement; !r && null !== e;)r = (e = e.parentNode) === this.pickerElement;
                            r || this.hide();
                        }
                    }
                },
                {
                    key: "toggleDateHeader",
                    value: function() {
                        this.dateHeaderButton.classList.contains("inactive") ? (this.dateHeaderButton.className = "date-header-button active", this.dateSelectWrapper.style.display = "block") : this.dateHeaderButton.classList.contains("active") && (this.dateHeaderButton.className = "date-header-button inactive", this.dateSelectWrapper.style.display = "none", this.date.setMonth(this.monthSelect.returnSelectedMonth()), this.date.setFullYear(this.yearSelect.returnSelectedYear()), this.refreshDaysMatrix());
                    }
                },
                {
                    key: "clickDayElement",
                    value: function(t) {
                        if (!(t.textContent.length > 2 || t.classList.contains("disabled"))) {
                            var e = this.daysWrapper.querySelector("[data-selected]");
                            e && e.removeAttribute("data-selected"), t.setAttribute("data-selected", "");
                            var r = !1;
                            t.classList.contains("next-month") ? (11 === this.monthSelect.returnSelectedMonth() && this.yearSelect.toggleByInput(this.yearSelect.returnSelectedYear() + 1), this.monthSelect.toggleByMatrix("next"), r = !0) : t.classList.contains("prev-month") && (0 === this.monthSelect.returnSelectedMonth() && this.yearSelect.toggleByInput(this.yearSelect.returnSelectedYear() - 1), this.monthSelect.toggleByMatrix("prev"), r = !0), r && (this.date = new Date, this.date.setMonth(this.monthSelect.returnSelectedMonth()), this.date.setFullYear(this.yearSelect.returnSelectedYear()), this.dateHeaderButton.innerHTML = "".concat(this.monthSelect.returnSelectedMonthAsLabel(), " ").concat(this.yearSelect.returnSelectedYear())), this.date.setDate(parseInt(t.textContent)), this.setInput();
                        }
                    }
                },
                {
                    key: "positionPicker",
                    value: function(t) {
                        var e = t.getBoundingClientRect();
                        this.pickerElement.style.top = "".concat(e.top + e.height + (document.documentElement.scrollTop || document.body.scrollTop) + 3, "px");
                        var r = this.pickerElement.getBoundingClientRect(), a = r.width ? r.width : 280, n = e.right - a;
                        this.pickerElement.className = "polyfill-right-aligned", e.right < a && (n = e.left, this.pickerElement.className = "polyfill-left-aligned"), this.pickerElement.style.left = "".concat(n + (document.documentElement.scrollLeft || document.body.scrollLeft), "px"), this.show();
                    }
                },
                {
                    key: "attachTo",
                    value: function(t) {
                        var e;
                        return !(t.htmlElement === (null === (e = this.targetInputElement) || void 0 === e ? void 0 : e.htmlElement) && this.isOpen || (this.targetInputElement = t, this.syncPickerWithInput(), this.positionPicker(this.targetInputElement.htmlElement), 0));
                    }
                },
                {
                    key: "hide",
                    value: function() {
                        this.isOpen = !1, this.pickerElement.setAttribute("data-open", String(this.isOpen)), this.dateHeaderButton.className = "date-header-button inactive", this.targetInputElement && (this.dateSelectWrapper.style.display = "none", this.targetInputElement.htmlElement.blur());
                    }
                },
                {
                    key: "show",
                    value: function() {
                        var t = this;
                        this.isOpen = !0, this.pickerElement.setAttribute("data-open", String(this.isOpen)), setTimeout(function() {
                            document.addEventListener("mousedown", function(e) {
                                return t.removeClickOut(e);
                            }), document.addEventListener("touchstart", function(e) {
                                return t.removeClickOut(e);
                            });
                        }, 500), window.onpopstate = function() {
                            t.hide();
                        };
                    }
                },
                {
                    key: "syncPickerWithInput",
                    value: function() {
                        var t = this;
                        null != this.targetInputElement.htmlElement.valueAsDate ? this.date = this.targetInputElement.htmlElement.valueAsDate : this.date = new Date, this.createMatrixHeader(), this.monthSelect.setLocalLabels(this.localeLabels.months), this.monthSelect.redrawMonthSelect();
                        var e = new Date(this.targetInputElement.dateRange[0].getTime()), r = new Date(this.targetInputElement.dateRange[1].getTime());
                        if (this.date <= r && this.date >= e) this.monthSelect.toggleByInput(this.date.getMonth()), this.yearSelect.toggleByInput(this.date.getFullYear());
                        else {
                            var a = new Date;
                            this.date = a <= r && a >= e ? a : e, this.monthSelect.toggleByInput(this.date.getMonth()), this.yearSelect.toggleByInput(this.date.getFullYear());
                        }
                        this.dateHeaderButton.innerHTML = "".concat(this.monthSelect.returnSelectedMonthAsLabel(), " ").concat(this.yearSelect.returnSelectedYear());
                        for(var n = this.selectWrapper.getElementsByClassName("control"), o = 0; o < n.length; o += 1)n[o].addEventListener("click", function() {
                            t.dateHeaderButton.innerHTML = "".concat(t.monthSelect.returnSelectedMonthAsLabel(), " ").concat(t.yearSelect.returnSelectedYear());
                        });
                        this.refreshDaysMatrix();
                    }
                },
                {
                    key: "setInput",
                    value: function() {
                        var t = this;
                        this.targetInputElement.htmlElement.valueAsDate = this.date, this.targetInputElement.htmlElement.focus(), setTimeout(function() {
                            t.hide();
                        }, 100);
                    }
                },
                {
                    key: "createMatrixHeader",
                    value: function() {
                        if (this.localeLabels === this.targetInputElement.localeLabels && this.firstDayOfWeek === this.targetInputElement.firstDayOfWeek) return !1;
                        this.localeLabels = this.targetInputElement.localeLabels, this.firstDayOfWeek = this.targetInputElement.firstDayOfWeek;
                        for(var t = [], e = 0, r = this.localeLabels.days.length; e < r; e += 1)t.push('<th scope="col">'.concat(this.localeLabels.days[e], "</th>"));
                        return "mo" === this.targetInputElement.firstDayOfWeek && t.push(t.shift()), "sa" === this.targetInputElement.firstDayOfWeek && t.unshift(t.pop()), this.daysHead.innerHTML = "<tr> ".concat(t.join(""), " </tr>"), !0;
                    }
                },
                {
                    key: "refreshDaysMatrix",
                    value: function() {
                        var t, e = this.date.getFullYear(), r = this.date.getMonth(), a = [], n = this.returnAbsoluteDate(e, r, 1).getDay(), o = this.returnAbsoluteDate(e, r + 1, 0).getDate();
                        if ("mo" === this.targetInputElement.firstDayOfWeek && (0 === n ? n = 6 : n -= 1), "sa" === this.targetInputElement.firstDayOfWeek && (6 === n ? n = 0 : n += 1), n > 0) for(var i = this.returnAbsoluteDate(e, r, 0).getDate(), l = n, s = l - 1, u = 0; u < l; u += 1)a.push(i - s), s -= 1;
                        var d = (null === (t = this.targetInputElement) || void 0 === t ? void 0 : t.htmlElement.valueAsDate) || !1, c = d && e === d.getFullYear() && r === d.getMonth(), p = [], h = new Date, m = !1;
                        this.date.getFullYear() === h.getFullYear() && this.date.getMonth() === h.getMonth() && (m = !0);
                        for(var f = this.targetInputElement.dateRange[0], y = this.targetInputElement.dateRange[1], b = 0; b < o + n; b += 1)if (b % 7 == 0 && p.push("".concat(0 !== b ? "</tr>" : "", "<tr>")), b + 1 <= n) {
                            var g = this.returnAbsoluteDate(e, r - 1, a[b]);
                            p.push('<td class="prev-month \n                    '.concat(g < f || g > y ? "disabled" : "", '">').concat(a[b], "</td>"));
                        } else {
                            var v = b + 1 - n, S = c && d.getDate() === v, D = this.returnAbsoluteDate(e, r, v);
                            if (m && h.getDate() === v) p.push("<td data-day ".concat(S ? "data-selected" : "", " class='current-day\n                        ").concat(D < f || D > y ? "disabled" : "", "'>").concat(v, "</td>"));
                            else {
                                var w = "<td data-day ".concat(S ? "data-selected" : "", " \n                        class='").concat(D < f || D > y ? "disabled" : "", "'>").concat(v, "</td>");
                                p.push(w);
                            }
                        }
                        var A = n + o;
                        if (A < 42) for(var M = this.returnAbsoluteDate(e, r + 2, 0), x = 1; A < 42;)M.setDate(x), A % 7 == 0 && p.push("".concat(0 !== x ? "</tr>" : "", "<tr>")), p.push('<td class="next-month\n                    '.concat(M < f || M > y ? "disabled" : "", '\n                    ">').concat(x, "</td>")), x += 1, A += 1;
                        this.daysWrapper.innerHTML = p.join("");
                    }
                },
                {
                    key: "returnCurrentDate",
                    value: function() {
                        return this.date;
                    }
                },
                {
                    key: "returnAbsoluteDate",
                    value: function(t, e, r) {
                        var a = new Date;
                        return a.setFullYear(t, e, r), a.setHours(0, 0, 0, 0), a;
                    }
                }
            ], k(e.prototype, r), Object.defineProperty(e, "prototype", {
                writable: !1
            }), t;
        }());
        function N(t) {
            return N = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(t) {
                return typeof t;
            } : function(t) {
                return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
            }, N(t);
        }
        var O, L, H, W = (O = /d{1,4}|m{1,4}|yy(?:yy)?|([HhMsTt])\1?|[LloSZWN]|'[^']*'/g, L = /\b(?:[PMCEA][SDP]T|(?:Pacific|Mountain|Central|Eastern|Atlantic) (?:Standard|Daylight|Prevailing) Time|(?:GMT|UTC)(?:[-+]\d{4})?)\b/g, H = /[^-+\dA-Z]/g, function(t, e, r, a) {
            if (1 !== arguments.length || "string" !== (null === (n = t) ? "null" : void 0 === n ? "undefined" : "object" !== N(n) ? N(n) : Array.isArray(n) ? "array" : ({}).toString.call(n).slice(8, -1).toLowerCase()) || /\d/.test(t) || (e = t, t = void 0), (t = t || new Date) instanceof Date || (t = new Date(t)), isNaN(t)) throw TypeError("Invalid date");
            var n, o = (e = String(W.masks[e] || e || W.masks.default)).slice(0, 4);
            "UTC:" !== o && "GMT:" !== o || (e = e.slice(4), r = !0, "GMT:" === o && (a = !0));
            var i = r ? "getUTC" : "get", l = t[i + "Date"](), s = t[i + "Day"](), u = t[i + "Month"](), d = t[i + "FullYear"](), c = t[i + "Hours"](), p = t[i + "Minutes"](), h = t[i + "Seconds"](), m = t[i + "Milliseconds"](), f = r ? 0 : t.getTimezoneOffset(), y = function(t) {
                var e = new Date(t.getFullYear(), t.getMonth(), t.getDate());
                e.setDate(e.getDate() - (e.getDay() + 6) % 7 + 3);
                var r = new Date(e.getFullYear(), 0, 4);
                r.setDate(r.getDate() - (r.getDay() + 6) % 7 + 3);
                var a = e.getTimezoneOffset() - r.getTimezoneOffset();
                e.setHours(e.getHours() - a);
                var n = (e - r) / 6048e5;
                return 1 + Math.floor(n);
            }(t), b = function(t) {
                var e = t.getDay();
                return 0 === e && (e = 7), e;
            }(t), g = {
                d: l,
                dd: C(l),
                ddd: W.i18n.dayNames[s],
                dddd: W.i18n.dayNames[s + 7],
                m: u + 1,
                mm: C(u + 1),
                mmm: W.i18n.monthNames[u],
                mmmm: W.i18n.monthNames[u + 12],
                yy: String(d).length < 3 ? d : String(d).slice(String(d).length - 2),
                yyyy: C(d, 4),
                h: c % 12 || 12,
                hh: C(c % 12 || 12),
                H: c,
                HH: C(c),
                M: p,
                MM: C(p),
                s: h,
                ss: C(h),
                l: C(m, 3),
                L: C(Math.round(m / 10)),
                t: c < 12 ? "a" : "p",
                tt: c < 12 ? "am" : "pm",
                T: c < 12 ? "A" : "P",
                TT: c < 12 ? "AM" : "PM",
                Z: a ? "GMT" : r ? "UTC" : (String(t).match(L) || [
                    ""
                ]).pop().replace(H, ""),
                o: (f > 0 ? "-" : "+") + C(100 * Math.floor(Math.abs(f) / 60) + Math.abs(f) % 60, 4),
                S: [
                    "th",
                    "st",
                    "nd",
                    "rd"
                ][l % 10 > 3 ? 0 : (l % 100 - l % 10 != 10) * l % 10],
                W: y,
                N: b
            };
            return e.replace(O, function(t) {
                return t in g ? g[t] : t.slice(1, t.length - 1);
            });
        });
        function C(t, e) {
            for(t = String(t), e = e || 2; t.length < e;)t = "0".concat(t);
            return t;
        }
        W.masks = {
            default: "ddd mmm dd yyyy HH:MM:ss",
            shortDate: "m/d/yy",
            mediumDate: "mmm d, yyyy",
            longDate: "mmmm d, yyyy",
            fullDate: "dddd, mmmm d, yyyy",
            shortTime: "h:MM TT",
            mediumTime: "h:MM:ss TT",
            longTime: "h:MM:ss TT Z",
            isoDate: "yyyy-mm-dd",
            isoTime: "HH:MM:ss",
            isoDateTime: "yyyy-mm-dd'T'HH:MM:sso",
            isoUtcDateTime: "UTC:yyyy-mm-dd'T'HH:MM:ss'Z'",
            expiresHeaderFormat: "ddd, dd mmm yyyy HH:MM:ss Z"
        }, W.i18n = {
            dayNames: [
                "Sun",
                "Mon",
                "Tue",
                "Wed",
                "Thu",
                "Fri",
                "Sat",
                "Sunday",
                "Monday",
                "Tuesday",
                "Wednesday",
                "Thursday",
                "Friday",
                "Saturday"
            ],
            monthNames: [
                "Jan",
                "Feb",
                "Mar",
                "Apr",
                "May",
                "Jun",
                "Jul",
                "Aug",
                "Sep",
                "Oct",
                "Nov",
                "Dec",
                "January",
                "February",
                "March",
                "April",
                "May",
                "June",
                "July",
                "August",
                "September",
                "October",
                "November",
                "December"
            ]
        };
        var I = W, Y = {
            "en_en-US_en-UK": {
                days: [
                    "Su",
                    "Mo",
                    "Tu",
                    "We",
                    "Th",
                    "Fr",
                    "Sa"
                ],
                months: [
                    "January",
                    "February",
                    "March",
                    "April",
                    "May",
                    "June",
                    "July",
                    "August",
                    "September",
                    "October",
                    "November",
                    "December"
                ]
            },
            "zh_zh-CN": {
                days: [
                    "\u661F\u671F\u5929",
                    "\u661F\u671F\u4E00",
                    "\u661F\u671F\u4E8C",
                    "\u661F\u671F\u4E09",
                    "\u661F\u671F\u56DB",
                    "\u661F\u671F\u4E94",
                    "\u661F\u671F\u516D"
                ],
                months: [
                    "\u4E00\u6708",
                    "\u4E8C\u6708",
                    "\u4E09\u6708",
                    "\u56DB\u6708",
                    "\u4E94\u6708",
                    "\u516D\u6708",
                    "\u4E03\u6708",
                    "\u516B\u6708",
                    "\u4E5D\u6708",
                    "\u5341\u6708",
                    "\u5341\u4E00\u6708",
                    "\u5341\u4E8C\u6708"
                ]
            },
            "zh-Hans_zh-Hans-CN": {
                days: [
                    "\u5468\u65E5",
                    "\u5468\u4E00",
                    "\u5468\u4E8C",
                    "\u5468\u4E09",
                    "\u5468\u56DB",
                    "\u5468\u4E94",
                    "\u5468\u516D"
                ],
                months: [
                    "\u4E00\u6708",
                    "\u4E8C\u6708",
                    "\u4E09\u6708",
                    "\u56DB\u6708",
                    "\u4E94\u6708",
                    "\u516D\u6708",
                    "\u4E03\u6708",
                    "\u516B\u6708",
                    "\u4E5D\u6708",
                    "\u5341\u6708",
                    "\u5341\u4E00\u6708",
                    "\u5341\u4E8C\u6708"
                ]
            },
            "zh-Hant_zh-Hant-TW": {
                days: [
                    "\u9031\u65E5",
                    "\u9031\u4E00",
                    "\u9031\u4E8C",
                    "\u9031\u4E09",
                    "\u9031\u56DB",
                    "\u9031\u4E94",
                    "\u9031\u516D"
                ],
                months: [
                    "\u4E00\u6708",
                    "\u4E8C\u6708",
                    "\u4E09\u6708",
                    "\u56DB\u6708",
                    "\u4E94\u6708",
                    "\u516D\u6708",
                    "\u4E03\u6708",
                    "\u516B\u6708",
                    "\u4E5D\u6708",
                    "\u5341\u6708",
                    "\u5341\u4E00\u6708",
                    "\u5341\u4E8C\u6708"
                ]
            },
            "de_de-DE": {
                days: [
                    "So",
                    "Mo",
                    "Di",
                    "Mi",
                    "Do",
                    "Fr",
                    "Sa"
                ],
                months: [
                    "Januar",
                    "Februar",
                    "M\xe4rz",
                    "April",
                    "Mai",
                    "Juni",
                    "Juli",
                    "August",
                    "September",
                    "Oktober",
                    "November",
                    "Dezember"
                ],
                today: "Heute",
                format: "D-M-Y"
            },
            "nl_nl-NL_nl-BE": {
                days: [
                    "Zo",
                    "Ma",
                    "Di",
                    "Wo",
                    "Do",
                    "Vr",
                    "Za"
                ],
                months: [
                    "Januari",
                    "Februari",
                    "Maart",
                    "April",
                    "Mei",
                    "Juni",
                    "Juli",
                    "Augustus",
                    "September",
                    "Oktober",
                    "November",
                    "December"
                ],
                today: "Vandaag",
                format: "D/M/Y"
            },
            "pt_pt-BR": {
                days: [
                    "Dom",
                    "Seg",
                    "Ter",
                    "Qua",
                    "Qui",
                    "Sex",
                    "S\xe1b"
                ],
                months: [
                    "Janeiro",
                    "Fevereiro",
                    "Mar\xe7o",
                    "Abril",
                    "Maio",
                    "Junho",
                    "Julho",
                    "Agosto",
                    "Setembro",
                    "Outubro",
                    "Novembro",
                    "Dezembro"
                ],
                today: "Hoje"
            },
            "fr_fr-FR_fr-BE": {
                days: [
                    "Di",
                    "Lu",
                    "Ma",
                    "Me",
                    "Je",
                    "Ve",
                    "Sa"
                ],
                months: [
                    "Janvier",
                    "F\xe9vrier",
                    "Mars",
                    "Avril",
                    "Mai",
                    "Juin",
                    "Juillet",
                    "Ao\xfbt",
                    "Septembre",
                    "Octobre",
                    "Novembre",
                    "D\xe9cembre"
                ],
                today: "Aujourd'hui",
                format: "D/M/Y"
            },
            "es_es-VE": {
                days: [
                    "Do",
                    "Lu",
                    "Ma",
                    "Mi",
                    "Ju",
                    "Vi",
                    "Sa"
                ],
                months: [
                    "Enero",
                    "Febrero",
                    "Marzo",
                    "Abril",
                    "Mayo",
                    "Junio",
                    "Julio",
                    "Agosto",
                    "Septiembre",
                    "Octubre",
                    "Noviembre",
                    "Diciembre"
                ],
                today: "Hoy",
                format: "D/M/Y"
            },
            "it_it-IT": {
                days: [
                    "Do",
                    "Lu",
                    "Ma",
                    "Me",
                    "Gi",
                    "Ve",
                    "Sa"
                ],
                months: [
                    "Gennaio",
                    "Febbraio",
                    "Marzo",
                    "Aprile",
                    "Maggio",
                    "Giugno",
                    "Luglio",
                    "Agosto",
                    "Settembre",
                    "Ottobre",
                    "Novembre",
                    "Dicembre"
                ],
                today: "Oggi",
                format: "D/M/Y"
            },
            "da_da-dk": {
                days: [
                    "S\xf8ndag",
                    "Mandag",
                    "Tirsdag",
                    "Onsdag",
                    "Torsdag",
                    "Fredag",
                    "L\xf8rdag"
                ],
                months: [
                    "Januar",
                    "Februar",
                    "Marts",
                    "April",
                    "Maj",
                    "Juni",
                    "Juli",
                    "August",
                    "September",
                    "Oktober",
                    "November",
                    "December"
                ],
                today: "I dag",
                format: "dd/MM-YYYY"
            },
            "ru_ru-RU_ru-UA_ru-KZ_ru-MD": {
                days: [
                    "\u0412\u0441",
                    "\u041F\u043D",
                    "\u0412\u0442",
                    "\u0421\u0440",
                    "\u0427\u0442",
                    "\u041F\u0442",
                    "\u0421\u0431"
                ],
                months: [
                    "\u042F\u043D\u0432\u0430\u0440\u044C",
                    "\u0424\u0435\u0432\u0440\u0430\u043B\u044C",
                    "\u041C\u0430\u0440\u0442",
                    "\u0410\u043F\u0440\u0435\u043B\u044C",
                    "\u041C\u0430\u0439",
                    "\u0418\u044E\u043D\u044C",
                    "\u0418\u044E\u043B\u044C",
                    "\u0410\u0432\u0433\u0443\u0441\u0442",
                    "\u0421\u0435\u043D\u0442\u044F\u0431\u0440\u044C",
                    "\u041E\u043A\u0442\u044F\u0431\u0440\u044C",
                    "\u041D\u043E\u044F\u0431\u0440\u044C",
                    "\u0414\u0435\u043A\u0430\u0431\u0440\u044C"
                ],
                today: "\u0421\u0435\u0433\u043E\u0434\u043D\u044F",
                format: "D.M.Y"
            },
            "uk_uk-UA": {
                days: [
                    "\u041D\u0434",
                    "\u041F\u043D",
                    "\u0412\u0442",
                    "\u0421\u0440",
                    "\u0427\u0442",
                    "\u041F\u0442",
                    "\u0421\u0431"
                ],
                months: [
                    "\u0421\u0456\u0447\u0435\u043D\u044C",
                    "\u041B\u044E\u0442\u0438\u0439",
                    "\u0411\u0435\u0440\u0435\u0437\u0435\u043D\u044C",
                    "\u041A\u0432\u0456\u0442\u0435\u043D\u044C",
                    "\u0422\u0440\u0430\u0432\u0435\u043D\u044C",
                    "\u0427\u0435\u0440\u0432\u0435\u043D\u044C",
                    "\u041B\u0438\u043F\u0435\u043D\u044C",
                    "\u0421\u0435\u0440\u043F\u0435\u043D\u044C",
                    "\u0412\u0435\u0440\u0435\u0441\u0435\u043D\u044C",
                    "\u0416\u043E\u0432\u0442\u0435\u043D\u044C",
                    "\u041B\u0438\u0441\u0442\u043E\u043F\u0430\u0434",
                    "\u0413\u0440\u0443\u0434\u0435\u043D\u044C"
                ],
                today: "C\u044C\u043E\u0433\u043E\u0434\u043D\u0456",
                format: "D.M.Y"
            },
            "sv_sv-SE": {
                days: [
                    "S\xf6ndag",
                    "M\xe5ndag",
                    "Tisdag",
                    "Onsdag",
                    "Torsdag",
                    "Fredag",
                    "L\xf6rdag"
                ],
                months: [
                    "Januari",
                    "Februari",
                    "Mars",
                    "April",
                    "Maj",
                    "Juni",
                    "Juli",
                    "Augusti",
                    "September",
                    "Oktober",
                    "November",
                    "December"
                ],
                today: "Idag",
                format: "YYYY-MM-dd"
            },
            "fi_fi-FI": {
                days: [
                    "Su",
                    "Ma",
                    "Ti",
                    "Ke",
                    "To",
                    "Pe",
                    "La"
                ],
                months: [
                    "Tammikuu",
                    "Helmikuu",
                    "Maaliskuu",
                    "Huhtikuu",
                    "Toukokuu",
                    "Kes\xe4kuu",
                    "Hein\xe4kuu",
                    "Elokuu",
                    "Syyskuu",
                    "Lokakuu",
                    "Marraskuu",
                    "Joulukuu"
                ],
                today: "T\xe4n\xe4\xe4n",
                format: "dd/MM/YYYY"
            }
        };
        function F(t) {
            T.attachTo(t);
        }
        function B(t) {
            return t.getAttribute("data-first-day") || document.body.getAttribute("data-first-day") || "su";
        }
        function J(t) {
            return t.getAttribute("lang") || document.body.getAttribute("lang") || "en";
        }
        function P(t) {
            return t.getAttribute("min") || t.getAttribute("data-min") || "";
        }
        function _(t) {
            return t.getAttribute("max") || t.getAttribute("data-max") || "";
        }
        function j(t, e) {
            var r = new Date("1800"), a = new Date("3000"), n = r, o = a;
            if (t && Date.parse(t)) {
                var i = new Date(t);
                i.setHours(0, 0, 0, 0), n = i;
            }
            if (e && Date.parse(e)) {
                var l = new Date(e);
                l.setHours(0, 0, 0, 0), o = l;
            }
            return n > o && (n = r, o = a), n < new Date("0001") && (n = new Date("0001")), [
                n,
                o
            ];
        }
        function z(t) {
            var e = [];
            return Object.keys(Y).forEach(function(r) {
                var a = r, n = a.split("_");
                ((n = n.map(function(t) {
                    return t.toLowerCase();
                })).indexOf(t) >= 0 || n.indexOf(t.slice(0, 2)) >= 0) && (e = Y[a]);
            }), e;
        }
        function R(t) {
            for(var e = function() {
                var e = t[r], a = J(e), n = function(t) {
                    return t.getAttribute("date-format") || document.body.getAttribute("date-format") || t.getAttribute("data-date-format") || document.body.getAttribute("data-date-format") || "yyyy-mm-dd";
                }(e), o = P(e), i = _(e), l = j(o, i), s = z(a), u = B(e), d = function(t) {
                    return !!t.getAttribute("data-force-polyfill");
                }(e);
                d && e.setAttribute("type", "text");
                var c, p, h, m, f, y = {
                    htmlElement: e,
                    firstDayOfWeek: u,
                    dateFormat: n,
                    dateRange: l,
                    locale: a,
                    localeLabels: s,
                    minDateAttribute: o,
                    maxDateAttribute: i
                };
                e.setAttribute("data-has-picker", ""), e.addEventListener("focus", function() {
                    return F(y);
                }), e.addEventListener("mouseup", function() {
                    return F(y);
                }), c = y, "MutationObserver" in window && new MutationObserver(function(t) {
                    t.forEach(function(t) {
                        if (-1 !== t.attributeName.indexOf("min") || -1 !== t.attributeName.indexOf("max")) c.minDateAttribute = P(c.htmlElement), c.maxDateAttribute = _(c.htmlElement), c.dateRange = j(c.minDateAttribute, c.maxDateAttribute);
                        else if ("lang" === t.attributeName) c.locale = J(c.htmlElement), c.localeLabels = z(c.locale);
                        else if ("data-first-day" === t.attributeName) c.firstDayOfWeek = B(c.htmlElement);
                        else if ("data-date-format" === t.attributeName || "date-format" === t.attributeName) {
                            var e = c.htmlElement.valueAsDate;
                            c.dateFormat = c.htmlElement.getAttribute(t.attributeName) || "yyyy-mm-dd", e && (c.htmlElement.valueAsDate = e);
                        }
                    });
                }).observe(c.htmlElement, {
                    attributes: !0
                }), function(t) {
                    var e = t;
                    Object.defineProperties(e.htmlElement, {
                        valueAsDate: {
                            get: function() {
                                if (!e.htmlElement.value) return null;
                                function t(t, e) {
                                    for(var r = t.length - 1; r >= 0; r -= 1)if (t[r].charAt(0) === e) return r;
                                    return null;
                                }
                                var r = (e.dateFormat || "yyyy-mm-dd").split(/(m+|d+|y+)/).filter(Boolean), a = e.htmlElement.value.split(/(\D+)/).filter(Boolean), n = Number(a[t(r, "y") || 0]), o = Number(a[t(r, "m") || 0]), i = Number(a[t(r, "d") || 0]), l = new Date(n, o - 1, i, 0, 0, 0, 0);
                                return isNaN(l.getDate()) ? null : l;
                            },
                            set: function(t) {
                                var r;
                                e.htmlElement.value = I(t, e.dateFormat), "function" == typeof Event ? r = new Event("change", {
                                    bubbles: !0
                                }) : (r = document.createEvent("Event")).initEvent("change", !0, !0), e.htmlElement.dispatchEvent(r);
                            }
                        },
                        valueAsNumber: {
                            get: function() {
                                return e.htmlElement.value ? e.htmlElement.valueAsDate.valueOf() : NaN;
                            },
                            set: function(t) {
                                e.htmlElement.valueAsDate = new Date(t);
                            }
                        }
                    });
                }(y), h = (p = y).dateRange[0], m = p.dateRange[1], (f = p.htmlElement).addEventListener("keydown", function(t) {
                    var e = new Date;
                    switch(t.keyCode){
                        case 9:
                        case 27:
                            T.hide();
                            break;
                        case 37:
                            f.valueAsDate && ((e = T.returnCurrentDate()).setDate(e.getDate() - 1), e >= h && (f.valueAsDate = e));
                            break;
                        case 38:
                            f.valueAsDate && ((e = T.returnCurrentDate()).setDate(e.getDate() - 7), e >= h && (f.valueAsDate = e));
                            break;
                        case 39:
                            f.valueAsDate && ((e = T.returnCurrentDate()).setDate(e.getDate() + 1), e <= m && (f.valueAsDate = e));
                            break;
                        case 40:
                            f.valueAsDate && ((e = T.returnCurrentDate()).setDate(e.getDate() + 7), e <= m && (f.valueAsDate = e));
                    }
                    T.syncPickerWithInput();
                }), f.addEventListener("keyup", function() {
                    T.syncPickerWithInput();
                });
            }, r = 0; r < t.length; r += 1)e();
        }
        function U() {
            R(document.querySelectorAll('input[type="text"].date-polyfill:not([data-has-picker])')), R(document.querySelectorAll('input[type="date"][data-force-polyfill]:not([data-has-picker])')), function() {
                var t = document.createElement("input");
                t.setAttribute("type", "date");
                var e = "not-a-date";
                return t.setAttribute("value", e), !(t.value === e);
            }() || R(document.querySelectorAll('input[type="date"]:not([data-has-picker])'));
        }
        document.addEventListener("DOMContentLoaded", function() {
            var t;
            U(), null === (t = document.querySelector("body")) || void 0 === t || t.addEventListener("mousedown", function() {
                return U();
            });
        });
    }();
}();


var $b88ce8cf286a26cd$exports = {};
/* @license
Papa Parse
v5.5.3
https://github.com/mholt/PapaParse
License: MIT
*/ ((e, t)=>{
    "function" == typeof define && define.amd ? define([], t) : $b88ce8cf286a26cd$exports = t();
})($b88ce8cf286a26cd$exports, function r() {
    var n = "undefined" != typeof self ? self : "undefined" != typeof window ? window : void 0 !== n ? n : {};
    var d, s = !n.document && !!n.postMessage, a = n.IS_PAPA_WORKER || !1, o = {}, h = 0, v = {};
    function u(e) {
        this._handle = null, this._finished = !1, this._completed = !1, this._halted = !1, this._input = null, this._baseIndex = 0, this._partialLine = "", this._rowCount = 0, this._start = 0, this._nextChunk = null, this.isFirstChunk = !0, this._completeResults = {
            data: [],
            errors: [],
            meta: {}
        }, (function(e) {
            var t = b(e);
            t.chunkSize = parseInt(t.chunkSize), e.step || e.chunk || (t.chunkSize = null);
            this._handle = new i(t), (this._handle.streamer = this)._config = t;
        }).call(this, e), this.parseChunk = function(t, e) {
            var i = parseInt(this._config.skipFirstNLines) || 0;
            if (this.isFirstChunk && 0 < i) {
                let e = this._config.newline;
                e || (r = this._config.quoteChar || '"', e = this._handle.guessLineEndings(t, r)), t = [
                    ...t.split(e).slice(i)
                ].join(e);
            }
            this.isFirstChunk && U(this._config.beforeFirstChunk) && void 0 !== (r = this._config.beforeFirstChunk(t)) && (t = r), this.isFirstChunk = !1, this._halted = !1;
            var i = this._partialLine + t, r = (this._partialLine = "", this._handle.parse(i, this._baseIndex, !this._finished));
            if (!this._handle.paused() && !this._handle.aborted()) {
                t = r.meta.cursor, i = (this._finished || (this._partialLine = i.substring(t - this._baseIndex), this._baseIndex = t), r && r.data && (this._rowCount += r.data.length), this._finished || this._config.preview && this._rowCount >= this._config.preview);
                if (a) n.postMessage({
                    results: r,
                    workerId: v.WORKER_ID,
                    finished: i
                });
                else if (U(this._config.chunk) && !e) {
                    if (this._config.chunk(r, this._handle), this._handle.paused() || this._handle.aborted()) return void (this._halted = !0);
                    this._completeResults = r = void 0;
                }
                return this._config.step || this._config.chunk || (this._completeResults.data = this._completeResults.data.concat(r.data), this._completeResults.errors = this._completeResults.errors.concat(r.errors), this._completeResults.meta = r.meta), this._completed || !i || !U(this._config.complete) || r && r.meta.aborted || (this._config.complete(this._completeResults, this._input), this._completed = !0), i || r && r.meta.paused || this._nextChunk(), r;
            }
            this._halted = !0;
        }, this._sendError = function(e) {
            U(this._config.error) ? this._config.error(e) : a && this._config.error && n.postMessage({
                workerId: v.WORKER_ID,
                error: e,
                finished: !1
            });
        };
    }
    function f(e) {
        var r;
        (e = e || {}).chunkSize || (e.chunkSize = v.RemoteChunkSize), u.call(this, e), this._nextChunk = s ? function() {
            this._readChunk(), this._chunkLoaded();
        } : function() {
            this._readChunk();
        }, this.stream = function(e) {
            this._input = e, this._nextChunk();
        }, this._readChunk = function() {
            if (this._finished) this._chunkLoaded();
            else {
                if (r = new XMLHttpRequest, this._config.withCredentials && (r.withCredentials = this._config.withCredentials), s || (r.onload = y(this._chunkLoaded, this), r.onerror = y(this._chunkError, this)), r.open(this._config.downloadRequestBody ? "POST" : "GET", this._input, !s), this._config.downloadRequestHeaders) {
                    var e, t = this._config.downloadRequestHeaders;
                    for(e in t)r.setRequestHeader(e, t[e]);
                }
                var i;
                this._config.chunkSize && (i = this._start + this._config.chunkSize - 1, r.setRequestHeader("Range", "bytes=" + this._start + "-" + i));
                try {
                    r.send(this._config.downloadRequestBody);
                } catch (e) {
                    this._chunkError(e.message);
                }
                s && 0 === r.status && this._chunkError();
            }
        }, this._chunkLoaded = function() {
            4 === r.readyState && (r.status < 200 || 400 <= r.status ? this._chunkError() : (this._start += this._config.chunkSize || r.responseText.length, this._finished = !this._config.chunkSize || this._start >= ((e)=>null !== (e = e.getResponseHeader("Content-Range")) ? parseInt(e.substring(e.lastIndexOf("/") + 1)) : -1)(r), this.parseChunk(r.responseText)));
        }, this._chunkError = function(e) {
            e = r.statusText || e;
            this._sendError(new Error(e));
        };
    }
    function l(e) {
        (e = e || {}).chunkSize || (e.chunkSize = v.LocalChunkSize), u.call(this, e);
        var i, r, n = "undefined" != typeof FileReader;
        this.stream = function(e) {
            this._input = e, r = e.slice || e.webkitSlice || e.mozSlice, n ? ((i = new FileReader).onload = y(this._chunkLoaded, this), i.onerror = y(this._chunkError, this)) : i = new FileReaderSync, this._nextChunk();
        }, this._nextChunk = function() {
            this._finished || this._config.preview && !(this._rowCount < this._config.preview) || this._readChunk();
        }, this._readChunk = function() {
            var e = this._input, t = (this._config.chunkSize && (t = Math.min(this._start + this._config.chunkSize, this._input.size), e = r.call(e, this._start, t)), i.readAsText(e, this._config.encoding));
            n || this._chunkLoaded({
                target: {
                    result: t
                }
            });
        }, this._chunkLoaded = function(e) {
            this._start += this._config.chunkSize, this._finished = !this._config.chunkSize || this._start >= this._input.size, this.parseChunk(e.target.result);
        }, this._chunkError = function() {
            this._sendError(i.error);
        };
    }
    function c(e) {
        var i;
        u.call(this, e = e || {}), this.stream = function(e) {
            return i = e, this._nextChunk();
        }, this._nextChunk = function() {
            var e, t;
            if (!this._finished) return e = this._config.chunkSize, i = e ? (t = i.substring(0, e), i.substring(e)) : (t = i, ""), this._finished = !i, this.parseChunk(t);
        };
    }
    function p(e) {
        u.call(this, e = e || {});
        var t = [], i = !0, r = !1;
        this.pause = function() {
            u.prototype.pause.apply(this, arguments), this._input.pause();
        }, this.resume = function() {
            u.prototype.resume.apply(this, arguments), this._input.resume();
        }, this.stream = function(e) {
            this._input = e, this._input.on("data", this._streamData), this._input.on("end", this._streamEnd), this._input.on("error", this._streamError);
        }, this._checkIsFinished = function() {
            r && 1 === t.length && (this._finished = !0);
        }, this._nextChunk = function() {
            this._checkIsFinished(), t.length ? this.parseChunk(t.shift()) : i = !0;
        }, this._streamData = y(function(e) {
            try {
                t.push("string" == typeof e ? e : e.toString(this._config.encoding)), i && (i = !1, this._checkIsFinished(), this.parseChunk(t.shift()));
            } catch (e) {
                this._streamError(e);
            }
        }, this), this._streamError = y(function(e) {
            this._streamCleanUp(), this._sendError(e);
        }, this), this._streamEnd = y(function() {
            this._streamCleanUp(), r = !0, this._streamData("");
        }, this), this._streamCleanUp = y(function() {
            this._input.removeListener("data", this._streamData), this._input.removeListener("end", this._streamEnd), this._input.removeListener("error", this._streamError);
        }, this);
    }
    function i(m) {
        var n, s, a, t, o = Math.pow(2, 53), h = -o, u = /^\s*-?(\d+\.?|\.\d+|\d+\.\d+)([eE][-+]?\d+)?\s*$/, d = /^((\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d\.\d+([+-][0-2]\d:[0-5]\d|Z))|(\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d([+-][0-2]\d:[0-5]\d|Z))|(\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d([+-][0-2]\d:[0-5]\d|Z)))$/, i = this, r = 0, f = 0, l = !1, e = !1, c = [], p = {
            data: [],
            errors: [],
            meta: {}
        };
        function y(e) {
            return "greedy" === m.skipEmptyLines ? "" === e.join("").trim() : 1 === e.length && 0 === e[0].length;
        }
        function g() {
            if (p && a && (k("Delimiter", "UndetectableDelimiter", "Unable to auto-detect delimiting character; defaulted to '" + v.DefaultDelimiter + "'"), a = !1), m.skipEmptyLines && (p.data = p.data.filter(function(e) {
                return !y(e);
            })), _()) {
                if (p) {
                    if (Array.isArray(p.data[0])) {
                        for(var e = 0; _() && e < p.data.length; e++)p.data[e].forEach(t);
                        p.data.splice(0, 1);
                    } else p.data.forEach(t);
                }
                function t(e, t) {
                    U(m.transformHeader) && (e = m.transformHeader(e, t)), c.push(e);
                }
            }
            function i(e, t) {
                for(var i = m.header ? {} : [], r = 0; r < e.length; r++){
                    var n = r, s = e[r], s = ((e, t)=>((e)=>(m.dynamicTypingFunction && void 0 === m.dynamicTyping[e] && (m.dynamicTyping[e] = m.dynamicTypingFunction(e)), !0 === (m.dynamicTyping[e] || m.dynamicTyping)))(e) ? "true" === t || "TRUE" === t || "false" !== t && "FALSE" !== t && (((e)=>{
                            if (u.test(e)) {
                                e = parseFloat(e);
                                if (h < e && e < o) return 1;
                            }
                        })(t) ? parseFloat(t) : d.test(t) ? new Date(t) : "" === t ? null : t) : t)(n = m.header ? r >= c.length ? "__parsed_extra" : c[r] : n, s = m.transform ? m.transform(s, n) : s);
                    "__parsed_extra" === n ? (i[n] = i[n] || [], i[n].push(s)) : i[n] = s;
                }
                return m.header && (r > c.length ? k("FieldMismatch", "TooManyFields", "Too many fields: expected " + c.length + " fields but parsed " + r, f + t) : r < c.length && k("FieldMismatch", "TooFewFields", "Too few fields: expected " + c.length + " fields but parsed " + r, f + t)), i;
            }
            var r;
            p && (m.header || m.dynamicTyping || m.transform) && (r = 1, !p.data.length || Array.isArray(p.data[0]) ? (p.data = p.data.map(i), r = p.data.length) : p.data = i(p.data, 0), m.header && p.meta && (p.meta.fields = c), f += r);
        }
        function _() {
            return m.header && 0 === c.length;
        }
        function k(e, t, i, r) {
            e = {
                type: e,
                code: t,
                message: i
            };
            void 0 !== r && (e.row = r), p.errors.push(e);
        }
        U(m.step) && (t = m.step, m.step = function(e) {
            p = e, _() ? g() : (g(), 0 !== p.data.length && (r += e.data.length, m.preview && r > m.preview ? s.abort() : (p.data = p.data[0], t(p, i))));
        }), this.parse = function(e, t, i) {
            var r = m.quoteChar || '"', r = (m.newline || (m.newline = this.guessLineEndings(e, r)), a = !1, m.delimiter ? U(m.delimiter) && (m.delimiter = m.delimiter(e), p.meta.delimiter = m.delimiter) : ((r = ((e, t, i, r, n)=>{
                var s, a, o, h;
                n = n || [
                    ",",
                    "\t",
                    "|",
                    ";",
                    v.RECORD_SEP,
                    v.UNIT_SEP
                ];
                for(var u = 0; u < n.length; u++){
                    for(var d, f = n[u], l = 0, c = 0, p = 0, g = (o = void 0, new E({
                        comments: r,
                        delimiter: f,
                        newline: t,
                        preview: 10
                    }).parse(e)), _ = 0; _ < g.data.length; _++)i && y(g.data[_]) ? p++ : (d = g.data[_].length, c += d, void 0 === o ? o = d : 0 < d && (l += Math.abs(d - o), o = d));
                    0 < g.data.length && (c /= g.data.length - p), (void 0 === a || l <= a) && (void 0 === h || h < c) && 1.99 < c && (a = l, s = f, h = c);
                }
                return {
                    successful: !!(m.delimiter = s),
                    bestDelimiter: s
                };
            })(e, m.newline, m.skipEmptyLines, m.comments, m.delimitersToGuess)).successful ? m.delimiter = r.bestDelimiter : (a = !0, m.delimiter = v.DefaultDelimiter), p.meta.delimiter = m.delimiter), b(m));
            return m.preview && m.header && r.preview++, n = e, s = new E(r), p = s.parse(n, t, i), g(), l ? {
                meta: {
                    paused: !0
                }
            } : p || {
                meta: {
                    paused: !1
                }
            };
        }, this.paused = function() {
            return l;
        }, this.pause = function() {
            l = !0, s.abort(), n = U(m.chunk) ? "" : n.substring(s.getCharIndex());
        }, this.resume = function() {
            i.streamer._halted ? (l = !1, i.streamer.parseChunk(n, !0)) : setTimeout(i.resume, 3);
        }, this.aborted = function() {
            return e;
        }, this.abort = function() {
            e = !0, s.abort(), p.meta.aborted = !0, U(m.complete) && m.complete(p), n = "";
        }, this.guessLineEndings = function(e, t) {
            e = e.substring(0, 1048576);
            var t = new RegExp(P(t) + "([^]*?)" + P(t), "gm"), i = (e = e.replace(t, "")).split("\r"), t = e.split("\n"), e = 1 < t.length && t[0].length < i[0].length;
            if (1 === i.length || e) return "\n";
            for(var r = 0, n = 0; n < i.length; n++)"\n" === i[n][0] && r++;
            return r >= i.length / 2 ? "\r\n" : "\r";
        };
    }
    function P(e) {
        return e.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
    }
    function E(C) {
        var S = (C = C || {}).delimiter, O = C.newline, x = C.comments, I = C.step, A = C.preview, T = C.fastMode, D = null, L = !1, F = null == C.quoteChar ? '"' : C.quoteChar, j = F;
        if (void 0 !== C.escapeChar && (j = C.escapeChar), ("string" != typeof S || -1 < v.BAD_DELIMITERS.indexOf(S)) && (S = ","), x === S) throw new Error("Comment character same as delimiter");
        !0 === x ? x = "#" : ("string" != typeof x || -1 < v.BAD_DELIMITERS.indexOf(x)) && (x = !1), "\n" !== O && "\r" !== O && "\r\n" !== O && (O = "\n");
        var z = 0, M = !1;
        this.parse = function(i, t, r) {
            if ("string" != typeof i) throw new Error("Input must be a string");
            var n = i.length, e = S.length, s = O.length, a = x.length, o = U(I), h = [], u = [], d = [], f = z = 0;
            if (!i) return w();
            if (T || !1 !== T && -1 === i.indexOf(F)) {
                for(var l = i.split(O), c = 0; c < l.length; c++){
                    if (d = l[c], z += d.length, c !== l.length - 1) z += O.length;
                    else if (r) return w();
                    if (!x || d.substring(0, a) !== x) {
                        if (o) {
                            if (h = [], k(d.split(S)), R(), M) return w();
                        } else k(d.split(S));
                        if (A && A <= c) return h = h.slice(0, A), w(!0);
                    }
                }
                return w();
            }
            for(var p = i.indexOf(S, z), g = i.indexOf(O, z), _ = new RegExp(P(j) + P(F), "g"), m = i.indexOf(F, z);;)if (i[z] === F) for(m = z, z++;;){
                if (-1 === (m = i.indexOf(F, m + 1))) return r || u.push({
                    type: "Quotes",
                    code: "MissingQuotes",
                    message: "Quoted field unterminated",
                    row: h.length,
                    index: z
                }), E();
                if (m === n - 1) return E(i.substring(z, m).replace(_, F));
                if (F === j && i[m + 1] === j) m++;
                else if (F === j || 0 === m || i[m - 1] !== j) {
                    -1 !== p && p < m + 1 && (p = i.indexOf(S, m + 1));
                    var y = v(-1 === (g = -1 !== g && g < m + 1 ? i.indexOf(O, m + 1) : g) ? p : Math.min(p, g));
                    if (i.substr(m + 1 + y, e) === S) {
                        d.push(i.substring(z, m).replace(_, F)), i[z = m + 1 + y + e] !== F && (m = i.indexOf(F, z)), p = i.indexOf(S, z), g = i.indexOf(O, z);
                        break;
                    }
                    y = v(g);
                    if (i.substring(m + 1 + y, m + 1 + y + s) === O) {
                        if (d.push(i.substring(z, m).replace(_, F)), b(m + 1 + y + s), p = i.indexOf(S, z), m = i.indexOf(F, z), o && (R(), M)) return w();
                        if (A && h.length >= A) return w(!0);
                        break;
                    }
                    u.push({
                        type: "Quotes",
                        code: "InvalidQuotes",
                        message: "Trailing quote on quoted field is malformed",
                        row: h.length,
                        index: z
                    }), m++;
                }
            }
            else if (x && 0 === d.length && i.substring(z, z + a) === x) {
                if (-1 === g) return w();
                z = g + s, g = i.indexOf(O, z), p = i.indexOf(S, z);
            } else if (-1 !== p && (p < g || -1 === g)) d.push(i.substring(z, p)), z = p + e, p = i.indexOf(S, z);
            else {
                if (-1 === g) break;
                if (d.push(i.substring(z, g)), b(g + s), o && (R(), M)) return w();
                if (A && h.length >= A) return w(!0);
            }
            return E();
            function k(e) {
                h.push(e), f = z;
            }
            function v(e) {
                var t = 0;
                return t = -1 !== e && (e = i.substring(m + 1, e)) && "" === e.trim() ? e.length : t;
            }
            function E(e) {
                return r || (void 0 === e && (e = i.substring(z)), d.push(e), z = n, k(d), o && R()), w();
            }
            function b(e) {
                z = e, k(d), d = [], g = i.indexOf(O, z);
            }
            function w(e) {
                if (C.header && !t && h.length && !L) {
                    var s = h[0], a = Object.create(null), o = new Set(s);
                    let n = !1;
                    for(let r = 0; r < s.length; r++){
                        let i = s[r];
                        if (a[i = U(C.transformHeader) ? C.transformHeader(i, r) : i]) {
                            let e, t = a[i];
                            for(; e = i + "_" + t, t++, o.has(e););
                            o.add(e), s[r] = e, a[i]++, n = !0, (D = null === D ? {} : D)[e] = i;
                        } else a[i] = 1, s[r] = i;
                        o.add(i);
                    }
                    n && console.warn("Duplicate headers found and renamed."), L = !0;
                }
                return {
                    data: h,
                    errors: u,
                    meta: {
                        delimiter: S,
                        linebreak: O,
                        aborted: M,
                        truncated: !!e,
                        cursor: f + (t || 0),
                        renamedHeaders: D
                    }
                };
            }
            function R() {
                I(w()), h = [], u = [];
            }
        }, this.abort = function() {
            M = !0;
        }, this.getCharIndex = function() {
            return z;
        };
    }
    function g(e) {
        var t = e.data, i = o[t.workerId], r = !1;
        if (t.error) i.userError(t.error, t.file);
        else if (t.results && t.results.data) {
            var n = {
                abort: function() {
                    r = !0, _(t.workerId, {
                        data: [],
                        errors: [],
                        meta: {
                            aborted: !0
                        }
                    });
                },
                pause: m,
                resume: m
            };
            if (U(i.userStep)) {
                for(var s = 0; s < t.results.data.length && (i.userStep({
                    data: t.results.data[s],
                    errors: t.results.errors,
                    meta: t.results.meta
                }, n), !r); s++);
                delete t.results;
            } else U(i.userChunk) && (i.userChunk(t.results, n, t.file), delete t.results);
        }
        t.finished && !r && _(t.workerId, t.results);
    }
    function _(e, t) {
        var i = o[e];
        U(i.userComplete) && i.userComplete(t), i.terminate(), delete o[e];
    }
    function m() {
        throw new Error("Not implemented.");
    }
    function b(e) {
        if ("object" != typeof e || null === e) return e;
        var t, i = Array.isArray(e) ? [] : {};
        for(t in e)i[t] = b(e[t]);
        return i;
    }
    function y(e, t) {
        return function() {
            e.apply(t, arguments);
        };
    }
    function U(e) {
        return "function" == typeof e;
    }
    return v.parse = function(e, t) {
        var i = (t = t || {}).dynamicTyping || !1;
        U(i) && (t.dynamicTypingFunction = i, i = {});
        if (t.dynamicTyping = i, t.transform = !!U(t.transform) && t.transform, !t.worker || !v.WORKERS_SUPPORTED) return i = null, v.NODE_STREAM_INPUT, "string" == typeof e ? (e = ((e)=>65279 !== e.charCodeAt(0) ? e : e.slice(1))(e), i = new (t.download ? f : c)(t)) : !0 === e.readable && U(e.read) && U(e.on) ? i = new p(t) : (n.File && e instanceof File || e instanceof Object) && (i = new l(t)), i.stream(e);
        (i = (()=>{
            var e;
            return !!v.WORKERS_SUPPORTED && (e = (()=>{
                var e = n.URL || n.webkitURL || null, t = r.toString();
                return v.BLOB_URL || (v.BLOB_URL = e.createObjectURL(new Blob([
                    "var global = (function() { if (typeof self !== 'undefined') { return self; } if (typeof window !== 'undefined') { return window; } if (typeof global !== 'undefined') { return global; } return {}; })(); global.IS_PAPA_WORKER=true; ",
                    "(",
                    t,
                    ")();"
                ], {
                    type: "text/javascript"
                })));
            })(), (e = new n.Worker(e)).onmessage = g, e.id = h++, o[e.id] = e);
        })()).userStep = t.step, i.userChunk = t.chunk, i.userComplete = t.complete, i.userError = t.error, t.step = U(t.step), t.chunk = U(t.chunk), t.complete = U(t.complete), t.error = U(t.error), delete t.worker, i.postMessage({
            input: e,
            config: t,
            workerId: i.id
        });
    }, v.unparse = function(e, t) {
        var n = !1, _ = !0, m = ",", y = "\r\n", s = '"', a = s + s, i = !1, r = null, o = !1, h = ((()=>{
            if ("object" == typeof t) {
                if ("string" != typeof t.delimiter || v.BAD_DELIMITERS.filter(function(e) {
                    return -1 !== t.delimiter.indexOf(e);
                }).length || (m = t.delimiter), "boolean" != typeof t.quotes && "function" != typeof t.quotes && !Array.isArray(t.quotes) || (n = t.quotes), "boolean" != typeof t.skipEmptyLines && "string" != typeof t.skipEmptyLines || (i = t.skipEmptyLines), "string" == typeof t.newline && (y = t.newline), "string" == typeof t.quoteChar && (s = t.quoteChar), "boolean" == typeof t.header && (_ = t.header), Array.isArray(t.columns)) {
                    if (0 === t.columns.length) throw new Error("Option columns is empty");
                    r = t.columns;
                }
                void 0 !== t.escapeChar && (a = t.escapeChar + s), t.escapeFormulae instanceof RegExp ? o = t.escapeFormulae : "boolean" == typeof t.escapeFormulae && t.escapeFormulae && (o = /^[=+\-@\t\r].*$/);
            }
        })(), new RegExp(P(s), "g"));
        "string" == typeof e && (e = JSON.parse(e));
        if (Array.isArray(e)) {
            if (!e.length || Array.isArray(e[0])) return u(null, e, i);
            if ("object" == typeof e[0]) return u(r || Object.keys(e[0]), e, i);
        } else if ("object" == typeof e) return "string" == typeof e.data && (e.data = JSON.parse(e.data)), Array.isArray(e.data) && (e.fields || (e.fields = e.meta && e.meta.fields || r), e.fields || (e.fields = Array.isArray(e.data[0]) ? e.fields : "object" == typeof e.data[0] ? Object.keys(e.data[0]) : []), Array.isArray(e.data[0]) || "object" == typeof e.data[0] || (e.data = [
            e.data
        ])), u(e.fields || [], e.data || [], i);
        throw new Error("Unable to serialize unrecognized input");
        function u(e, t, i) {
            var r = "", n = ("string" == typeof e && (e = JSON.parse(e)), "string" == typeof t && (t = JSON.parse(t)), Array.isArray(e) && 0 < e.length), s = !Array.isArray(t[0]);
            if (n && _) {
                for(var a = 0; a < e.length; a++)0 < a && (r += m), r += k(e[a], a);
                0 < t.length && (r += y);
            }
            for(var o = 0; o < t.length; o++){
                var h = (n ? e : t[o]).length, u = !1, d = n ? 0 === Object.keys(t[o]).length : 0 === t[o].length;
                if (i && !n && (u = "greedy" === i ? "" === t[o].join("").trim() : 1 === t[o].length && 0 === t[o][0].length), "greedy" === i && n) {
                    for(var f = [], l = 0; l < h; l++){
                        var c = s ? e[l] : l;
                        f.push(t[o][c]);
                    }
                    u = "" === f.join("").trim();
                }
                if (!u) {
                    for(var p = 0; p < h; p++){
                        0 < p && !d && (r += m);
                        var g = n && s ? e[p] : p;
                        r += k(t[o][g], p);
                    }
                    o < t.length - 1 && (!i || 0 < h && !d) && (r += y);
                }
            }
            return r;
        }
        function k(e, t) {
            var i, r;
            return null == e ? "" : e.constructor === Date ? JSON.stringify(e).slice(1, 25) : (r = !1, o && "string" == typeof e && o.test(e) && (e = "'" + e, r = !0), i = e.toString().replace(h, a), (r = r || !0 === n || "function" == typeof n && n(e, t) || Array.isArray(n) && n[t] || ((e, t)=>{
                for(var i = 0; i < t.length; i++)if (-1 < e.indexOf(t[i])) return !0;
                return !1;
            })(i, v.BAD_DELIMITERS) || -1 < i.indexOf(m) || " " === i.charAt(0) || " " === i.charAt(i.length - 1)) ? s + i + s : i);
        }
    }, v.RECORD_SEP = String.fromCharCode(30), v.UNIT_SEP = String.fromCharCode(31), v.BYTE_ORDER_MARK = "\ufeff", v.BAD_DELIMITERS = [
        "\r",
        "\n",
        '"',
        v.BYTE_ORDER_MARK
    ], v.WORKERS_SUPPORTED = !s && !!n.Worker, v.NODE_STREAM_INPUT = 1, v.LocalChunkSize = 10485760, v.RemoteChunkSize = 5242880, v.DefaultDelimiter = ",", v.Parser = E, v.ParserHandle = i, v.NetworkStreamer = f, v.FileStreamer = l, v.StringStreamer = c, v.ReadableStreamStreamer = p, n.jQuery && ((d = n.jQuery).fn.parse = function(o) {
        var i = o.config || {}, h = [];
        return this.each(function(e) {
            if (!("INPUT" === d(this).prop("tagName").toUpperCase() && "file" === d(this).attr("type").toLowerCase() && n.FileReader) || !this.files || 0 === this.files.length) return !0;
            for(var t = 0; t < this.files.length; t++)h.push({
                file: this.files[t],
                inputElem: this,
                instanceConfig: d.extend({}, i)
            });
        }), e(), this;
        function e() {
            if (0 === h.length) U(o.complete) && o.complete();
            else {
                var e, t, i, r, n = h[0];
                if (U(o.before)) {
                    var s = o.before(n.file, n.inputElem);
                    if ("object" == typeof s) {
                        if ("abort" === s.action) return e = "AbortError", t = n.file, i = n.inputElem, r = s.reason, void (U(o.error) && o.error({
                            name: e
                        }, t, i, r));
                        if ("skip" === s.action) return void u();
                        "object" == typeof s.config && (n.instanceConfig = d.extend(n.instanceConfig, s.config));
                    } else if ("skip" === s) return void u();
                }
                var a = n.instanceConfig.complete;
                n.instanceConfig.complete = function(e) {
                    U(a) && a(e, n.file, n.inputElem), u();
                }, v.parse(n.file, n.instanceConfig);
            }
        }
        function u() {
            h.splice(0, 1), e();
        }
    }), a && (n.onmessage = function(e) {
        e = e.data;
        void 0 === v.WORKER_ID && e && (v.WORKER_ID = e.workerId);
        "string" == typeof e.input ? n.postMessage({
            workerId: v.WORKER_ID,
            results: v.parse(e.input, e.config),
            finished: !0
        }) : (n.File && e.input instanceof File || e.input instanceof Object) && (e = v.parse(e.input, e.config)) && n.postMessage({
            workerId: v.WORKER_ID,
            results: e,
            finished: !0
        });
    }), (f.prototype = Object.create(u.prototype)).constructor = f, (l.prototype = Object.create(u.prototype)).constructor = l, (c.prototype = Object.create(c.prototype)).constructor = c, (p.prototype = Object.create(u.prototype)).constructor = p, v;
});


/*
 * Dexie.js - a minimalistic wrapper for IndexedDB
 * ===============================================
 *
 * By David Fahlander, david.fahlander@gmail.com
 *
 * Version 4.2.1, Sat Oct 04 2025
 *
 * https://dexie.org
 *
 * Apache License Version 2.0, January 2004, http://www.apache.org/licenses/
 */ /*! *****************************************************************************
Copyright (c) Microsoft Corporation.
Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.
THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ var $786a5f856536c5d4$var$extendStatics = function(d, b) {
    $786a5f856536c5d4$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $786a5f856536c5d4$var$extendStatics(d, b);
};
function $786a5f856536c5d4$var$__extends(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $786a5f856536c5d4$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $786a5f856536c5d4$var$__assign = function() {
    $786a5f856536c5d4$var$__assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $786a5f856536c5d4$var$__assign.apply(this, arguments);
};
function $786a5f856536c5d4$var$__spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
var $786a5f856536c5d4$var$_global = typeof globalThis !== 'undefined' ? globalThis : typeof self !== 'undefined' ? self : typeof window !== 'undefined' ? window : $parcel$global;
var $786a5f856536c5d4$var$keys = Object.keys;
var $786a5f856536c5d4$var$isArray = Array.isArray;
if (typeof Promise !== 'undefined' && !$786a5f856536c5d4$var$_global.Promise) $786a5f856536c5d4$var$_global.Promise = Promise;
function $786a5f856536c5d4$var$extend(obj, extension) {
    if (typeof extension !== 'object') return obj;
    $786a5f856536c5d4$var$keys(extension).forEach(function(key) {
        obj[key] = extension[key];
    });
    return obj;
}
var $786a5f856536c5d4$var$getProto = Object.getPrototypeOf;
var $786a5f856536c5d4$var$_hasOwn = {}.hasOwnProperty;
function $786a5f856536c5d4$var$hasOwn(obj, prop) {
    return $786a5f856536c5d4$var$_hasOwn.call(obj, prop);
}
function $786a5f856536c5d4$var$props(proto, extension) {
    if (typeof extension === 'function') extension = extension($786a5f856536c5d4$var$getProto(proto));
    (typeof Reflect === "undefined" ? $786a5f856536c5d4$var$keys : Reflect.ownKeys)(extension).forEach(function(key) {
        $786a5f856536c5d4$var$setProp(proto, key, extension[key]);
    });
}
var $786a5f856536c5d4$var$defineProperty = Object.defineProperty;
function $786a5f856536c5d4$var$setProp(obj, prop, functionOrGetSet, options) {
    $786a5f856536c5d4$var$defineProperty(obj, prop, $786a5f856536c5d4$var$extend(functionOrGetSet && $786a5f856536c5d4$var$hasOwn(functionOrGetSet, "get") && typeof functionOrGetSet.get === 'function' ? {
        get: functionOrGetSet.get,
        set: functionOrGetSet.set,
        configurable: true
    } : {
        value: functionOrGetSet,
        configurable: true,
        writable: true
    }, options));
}
function $786a5f856536c5d4$var$derive(Child) {
    return {
        from: function(Parent) {
            Child.prototype = Object.create(Parent.prototype);
            $786a5f856536c5d4$var$setProp(Child.prototype, "constructor", Child);
            return {
                extend: $786a5f856536c5d4$var$props.bind(null, Child.prototype)
            };
        }
    };
}
var $786a5f856536c5d4$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
function $786a5f856536c5d4$var$getPropertyDescriptor(obj, prop) {
    var pd = $786a5f856536c5d4$var$getOwnPropertyDescriptor(obj, prop);
    var proto;
    return pd || (proto = $786a5f856536c5d4$var$getProto(obj)) && $786a5f856536c5d4$var$getPropertyDescriptor(proto, prop);
}
var $786a5f856536c5d4$var$_slice = [].slice;
function $786a5f856536c5d4$var$slice(args, start, end) {
    return $786a5f856536c5d4$var$_slice.call(args, start, end);
}
function $786a5f856536c5d4$var$override(origFunc, overridedFactory) {
    return overridedFactory(origFunc);
}
function $786a5f856536c5d4$var$assert(b) {
    if (!b) throw new Error("Assertion Failed");
}
function $786a5f856536c5d4$var$asap$1(fn) {
    if ($786a5f856536c5d4$var$_global.setImmediate) setImmediate(fn);
    else setTimeout(fn, 0);
}
function $786a5f856536c5d4$var$arrayToObject(array, extractor) {
    return array.reduce(function(result, item, i) {
        var nameAndValue = extractor(item, i);
        if (nameAndValue) result[nameAndValue[0]] = nameAndValue[1];
        return result;
    }, {});
}
function $786a5f856536c5d4$var$getByKeyPath(obj, keyPath) {
    if (typeof keyPath === 'string' && $786a5f856536c5d4$var$hasOwn(obj, keyPath)) return obj[keyPath];
    if (!keyPath) return obj;
    if (typeof keyPath !== 'string') {
        var rv = [];
        for(var i = 0, l = keyPath.length; i < l; ++i){
            var val = $786a5f856536c5d4$var$getByKeyPath(obj, keyPath[i]);
            rv.push(val);
        }
        return rv;
    }
    var period = keyPath.indexOf('.');
    if (period !== -1) {
        var innerObj = obj[keyPath.substr(0, period)];
        return innerObj == null ? undefined : $786a5f856536c5d4$var$getByKeyPath(innerObj, keyPath.substr(period + 1));
    }
    return undefined;
}
function $786a5f856536c5d4$var$setByKeyPath(obj, keyPath, value) {
    if (!obj || keyPath === undefined) return;
    if ('isFrozen' in Object && Object.isFrozen(obj)) return;
    if (typeof keyPath !== 'string' && 'length' in keyPath) {
        $786a5f856536c5d4$var$assert(typeof value !== 'string' && 'length' in value);
        for(var i = 0, l = keyPath.length; i < l; ++i)$786a5f856536c5d4$var$setByKeyPath(obj, keyPath[i], value[i]);
    } else {
        var period = keyPath.indexOf('.');
        if (period !== -1) {
            var currentKeyPath = keyPath.substr(0, period);
            var remainingKeyPath = keyPath.substr(period + 1);
            if (remainingKeyPath === "") {
                if (value === undefined) {
                    if ($786a5f856536c5d4$var$isArray(obj) && !isNaN(parseInt(currentKeyPath))) obj.splice(currentKeyPath, 1);
                    else delete obj[currentKeyPath];
                } else obj[currentKeyPath] = value;
            } else {
                var innerObj = obj[currentKeyPath];
                if (!innerObj || !$786a5f856536c5d4$var$hasOwn(obj, currentKeyPath)) innerObj = obj[currentKeyPath] = {};
                $786a5f856536c5d4$var$setByKeyPath(innerObj, remainingKeyPath, value);
            }
        } else if (value === undefined) {
            if ($786a5f856536c5d4$var$isArray(obj) && !isNaN(parseInt(keyPath))) obj.splice(keyPath, 1);
            else delete obj[keyPath];
        } else obj[keyPath] = value;
    }
}
function $786a5f856536c5d4$var$delByKeyPath(obj, keyPath) {
    if (typeof keyPath === 'string') $786a5f856536c5d4$var$setByKeyPath(obj, keyPath, undefined);
    else if ('length' in keyPath) [].map.call(keyPath, function(kp) {
        $786a5f856536c5d4$var$setByKeyPath(obj, kp, undefined);
    });
}
function $786a5f856536c5d4$var$shallowClone(obj) {
    var rv = {};
    for(var m in obj)if ($786a5f856536c5d4$var$hasOwn(obj, m)) rv[m] = obj[m];
    return rv;
}
var $786a5f856536c5d4$var$concat = [].concat;
function $786a5f856536c5d4$var$flatten(a) {
    return $786a5f856536c5d4$var$concat.apply([], a);
}
var $786a5f856536c5d4$var$intrinsicTypeNames = "BigUint64Array,BigInt64Array,Array,Boolean,String,Date,RegExp,Blob,File,FileList,FileSystemFileHandle,FileSystemDirectoryHandle,ArrayBuffer,DataView,Uint8ClampedArray,ImageBitmap,ImageData,Map,Set,CryptoKey".split(',').concat($786a5f856536c5d4$var$flatten([
    8,
    16,
    32,
    64
].map(function(num) {
    return [
        "Int",
        "Uint",
        "Float"
    ].map(function(t) {
        return t + num + "Array";
    });
}))).filter(function(t) {
    return $786a5f856536c5d4$var$_global[t];
});
var $786a5f856536c5d4$var$intrinsicTypes = new Set($786a5f856536c5d4$var$intrinsicTypeNames.map(function(t) {
    return $786a5f856536c5d4$var$_global[t];
}));
function $786a5f856536c5d4$var$cloneSimpleObjectTree(o) {
    var rv = {};
    for(var k in o)if ($786a5f856536c5d4$var$hasOwn(o, k)) {
        var v = o[k];
        rv[k] = !v || typeof v !== 'object' || $786a5f856536c5d4$var$intrinsicTypes.has(v.constructor) ? v : $786a5f856536c5d4$var$cloneSimpleObjectTree(v);
    }
    return rv;
}
function $786a5f856536c5d4$var$objectIsEmpty(o) {
    for(var k in o)if ($786a5f856536c5d4$var$hasOwn(o, k)) return false;
    return true;
}
var $786a5f856536c5d4$var$circularRefs = null;
function $786a5f856536c5d4$var$deepClone(any) {
    $786a5f856536c5d4$var$circularRefs = new WeakMap();
    var rv = $786a5f856536c5d4$var$innerDeepClone(any);
    $786a5f856536c5d4$var$circularRefs = null;
    return rv;
}
function $786a5f856536c5d4$var$innerDeepClone(x) {
    if (!x || typeof x !== 'object') return x;
    var rv = $786a5f856536c5d4$var$circularRefs.get(x);
    if (rv) return rv;
    if ($786a5f856536c5d4$var$isArray(x)) {
        rv = [];
        $786a5f856536c5d4$var$circularRefs.set(x, rv);
        for(var i = 0, l = x.length; i < l; ++i)rv.push($786a5f856536c5d4$var$innerDeepClone(x[i]));
    } else if ($786a5f856536c5d4$var$intrinsicTypes.has(x.constructor)) rv = x;
    else {
        var proto = $786a5f856536c5d4$var$getProto(x);
        rv = proto === Object.prototype ? {} : Object.create(proto);
        $786a5f856536c5d4$var$circularRefs.set(x, rv);
        for(var prop in x)if ($786a5f856536c5d4$var$hasOwn(x, prop)) rv[prop] = $786a5f856536c5d4$var$innerDeepClone(x[prop]);
    }
    return rv;
}
var $786a5f856536c5d4$var$toString = {}.toString;
function $786a5f856536c5d4$var$toStringTag(o) {
    return $786a5f856536c5d4$var$toString.call(o).slice(8, -1);
}
var $786a5f856536c5d4$var$iteratorSymbol = typeof Symbol !== 'undefined' ? Symbol.iterator : '@@iterator';
var $786a5f856536c5d4$var$getIteratorOf = typeof $786a5f856536c5d4$var$iteratorSymbol === "symbol" ? function(x) {
    var i;
    return x != null && (i = x[$786a5f856536c5d4$var$iteratorSymbol]) && i.apply(x);
} : function() {
    return null;
};
function $786a5f856536c5d4$var$delArrayItem(a, x) {
    var i = a.indexOf(x);
    if (i >= 0) a.splice(i, 1);
    return i >= 0;
}
var $786a5f856536c5d4$var$NO_CHAR_ARRAY = {};
function $786a5f856536c5d4$var$getArrayOf(arrayLike) {
    var i, a, x, it;
    if (arguments.length === 1) {
        if ($786a5f856536c5d4$var$isArray(arrayLike)) return arrayLike.slice();
        if (this === $786a5f856536c5d4$var$NO_CHAR_ARRAY && typeof arrayLike === 'string') return [
            arrayLike
        ];
        if (it = $786a5f856536c5d4$var$getIteratorOf(arrayLike)) {
            a = [];
            while(x = it.next(), !x.done)a.push(x.value);
            return a;
        }
        if (arrayLike == null) return [
            arrayLike
        ];
        i = arrayLike.length;
        if (typeof i === 'number') {
            a = new Array(i);
            while(i--)a[i] = arrayLike[i];
            return a;
        }
        return [
            arrayLike
        ];
    }
    i = arguments.length;
    a = new Array(i);
    while(i--)a[i] = arguments[i];
    return a;
}
var $786a5f856536c5d4$var$isAsyncFunction = typeof Symbol !== 'undefined' ? function(fn) {
    return fn[Symbol.toStringTag] === 'AsyncFunction';
} : function() {
    return false;
};
var $786a5f856536c5d4$var$dexieErrorNames = [
    'Modify',
    'Bulk',
    'OpenFailed',
    'VersionChange',
    'Schema',
    'Upgrade',
    'InvalidTable',
    'MissingAPI',
    'NoSuchDatabase',
    'InvalidArgument',
    'SubTransaction',
    'Unsupported',
    'Internal',
    'DatabaseClosed',
    'PrematureCommit',
    'ForeignAwait'
];
var $786a5f856536c5d4$var$idbDomErrorNames = [
    'Unknown',
    'Constraint',
    'Data',
    'TransactionInactive',
    'ReadOnly',
    'Version',
    'NotFound',
    'InvalidState',
    'InvalidAccess',
    'Abort',
    'Timeout',
    'QuotaExceeded',
    'Syntax',
    'DataClone'
];
var $786a5f856536c5d4$var$errorList = $786a5f856536c5d4$var$dexieErrorNames.concat($786a5f856536c5d4$var$idbDomErrorNames);
var $786a5f856536c5d4$var$defaultTexts = {
    VersionChanged: "Database version changed by other database connection",
    DatabaseClosed: "Database has been closed",
    Abort: "Transaction aborted",
    TransactionInactive: "Transaction has already completed or failed",
    MissingAPI: "IndexedDB API missing. Please visit https://tinyurl.com/y2uuvskb"
};
function $786a5f856536c5d4$var$DexieError(name, msg) {
    this.name = name;
    this.message = msg;
}
$786a5f856536c5d4$var$derive($786a5f856536c5d4$var$DexieError).from(Error).extend({
    toString: function() {
        return this.name + ": " + this.message;
    }
});
function $786a5f856536c5d4$var$getMultiErrorMessage(msg, failures) {
    return msg + ". Errors: " + Object.keys(failures).map(function(key) {
        return failures[key].toString();
    }).filter(function(v, i, s) {
        return s.indexOf(v) === i;
    }).join('\n');
}
function $786a5f856536c5d4$var$ModifyError(msg, failures, successCount, failedKeys) {
    this.failures = failures;
    this.failedKeys = failedKeys;
    this.successCount = successCount;
    this.message = $786a5f856536c5d4$var$getMultiErrorMessage(msg, failures);
}
$786a5f856536c5d4$var$derive($786a5f856536c5d4$var$ModifyError).from($786a5f856536c5d4$var$DexieError);
function $786a5f856536c5d4$var$BulkError(msg, failures) {
    this.name = "BulkError";
    this.failures = Object.keys(failures).map(function(pos) {
        return failures[pos];
    });
    this.failuresByPos = failures;
    this.message = $786a5f856536c5d4$var$getMultiErrorMessage(msg, this.failures);
}
$786a5f856536c5d4$var$derive($786a5f856536c5d4$var$BulkError).from($786a5f856536c5d4$var$DexieError);
var $786a5f856536c5d4$var$errnames = $786a5f856536c5d4$var$errorList.reduce(function(obj, name) {
    return obj[name] = name + "Error", obj;
}, {});
var $786a5f856536c5d4$var$BaseException = $786a5f856536c5d4$var$DexieError;
var $786a5f856536c5d4$var$exceptions = $786a5f856536c5d4$var$errorList.reduce(function(obj, name) {
    var fullName = name + "Error";
    function DexieError(msgOrInner, inner) {
        this.name = fullName;
        if (!msgOrInner) {
            this.message = $786a5f856536c5d4$var$defaultTexts[name] || fullName;
            this.inner = null;
        } else if (typeof msgOrInner === 'string') {
            this.message = "".concat(msgOrInner).concat(!inner ? '' : '\n ' + inner);
            this.inner = inner || null;
        } else if (typeof msgOrInner === 'object') {
            this.message = "".concat(msgOrInner.name, " ").concat(msgOrInner.message);
            this.inner = msgOrInner;
        }
    }
    $786a5f856536c5d4$var$derive(DexieError).from($786a5f856536c5d4$var$BaseException);
    obj[name] = DexieError;
    return obj;
}, {});
$786a5f856536c5d4$var$exceptions.Syntax = SyntaxError;
$786a5f856536c5d4$var$exceptions.Type = TypeError;
$786a5f856536c5d4$var$exceptions.Range = RangeError;
var $786a5f856536c5d4$var$exceptionMap = $786a5f856536c5d4$var$idbDomErrorNames.reduce(function(obj, name) {
    obj[name + "Error"] = $786a5f856536c5d4$var$exceptions[name];
    return obj;
}, {});
function $786a5f856536c5d4$var$mapError(domError, message) {
    if (!domError || domError instanceof $786a5f856536c5d4$var$DexieError || domError instanceof TypeError || domError instanceof SyntaxError || !domError.name || !$786a5f856536c5d4$var$exceptionMap[domError.name]) return domError;
    var rv = new $786a5f856536c5d4$var$exceptionMap[domError.name](message || domError.message, domError);
    if ("stack" in domError) $786a5f856536c5d4$var$setProp(rv, "stack", {
        get: function() {
            return this.inner.stack;
        }
    });
    return rv;
}
var $786a5f856536c5d4$var$fullNameExceptions = $786a5f856536c5d4$var$errorList.reduce(function(obj, name) {
    if ([
        "Syntax",
        "Type",
        "Range"
    ].indexOf(name) === -1) obj[name + "Error"] = $786a5f856536c5d4$var$exceptions[name];
    return obj;
}, {});
$786a5f856536c5d4$var$fullNameExceptions.ModifyError = $786a5f856536c5d4$var$ModifyError;
$786a5f856536c5d4$var$fullNameExceptions.DexieError = $786a5f856536c5d4$var$DexieError;
$786a5f856536c5d4$var$fullNameExceptions.BulkError = $786a5f856536c5d4$var$BulkError;
function $786a5f856536c5d4$var$nop() {}
function $786a5f856536c5d4$var$mirror(val) {
    return val;
}
function $786a5f856536c5d4$var$pureFunctionChain(f1, f2) {
    if (f1 == null || f1 === $786a5f856536c5d4$var$mirror) return f2;
    return function(val) {
        return f2(f1(val));
    };
}
function $786a5f856536c5d4$var$callBoth(on1, on2) {
    return function() {
        on1.apply(this, arguments);
        on2.apply(this, arguments);
    };
}
function $786a5f856536c5d4$var$hookCreatingChain(f1, f2) {
    if (f1 === $786a5f856536c5d4$var$nop) return f2;
    return function() {
        var res = f1.apply(this, arguments);
        if (res !== undefined) arguments[0] = res;
        var onsuccess = this.onsuccess, onerror = this.onerror;
        this.onsuccess = null;
        this.onerror = null;
        var res2 = f2.apply(this, arguments);
        if (onsuccess) this.onsuccess = this.onsuccess ? $786a5f856536c5d4$var$callBoth(onsuccess, this.onsuccess) : onsuccess;
        if (onerror) this.onerror = this.onerror ? $786a5f856536c5d4$var$callBoth(onerror, this.onerror) : onerror;
        return res2 !== undefined ? res2 : res;
    };
}
function $786a5f856536c5d4$var$hookDeletingChain(f1, f2) {
    if (f1 === $786a5f856536c5d4$var$nop) return f2;
    return function() {
        f1.apply(this, arguments);
        var onsuccess = this.onsuccess, onerror = this.onerror;
        this.onsuccess = this.onerror = null;
        f2.apply(this, arguments);
        if (onsuccess) this.onsuccess = this.onsuccess ? $786a5f856536c5d4$var$callBoth(onsuccess, this.onsuccess) : onsuccess;
        if (onerror) this.onerror = this.onerror ? $786a5f856536c5d4$var$callBoth(onerror, this.onerror) : onerror;
    };
}
function $786a5f856536c5d4$var$hookUpdatingChain(f1, f2) {
    if (f1 === $786a5f856536c5d4$var$nop) return f2;
    return function(modifications) {
        var res = f1.apply(this, arguments);
        $786a5f856536c5d4$var$extend(modifications, res);
        var onsuccess = this.onsuccess, onerror = this.onerror;
        this.onsuccess = null;
        this.onerror = null;
        var res2 = f2.apply(this, arguments);
        if (onsuccess) this.onsuccess = this.onsuccess ? $786a5f856536c5d4$var$callBoth(onsuccess, this.onsuccess) : onsuccess;
        if (onerror) this.onerror = this.onerror ? $786a5f856536c5d4$var$callBoth(onerror, this.onerror) : onerror;
        return res === undefined ? res2 === undefined ? undefined : res2 : $786a5f856536c5d4$var$extend(res, res2);
    };
}
function $786a5f856536c5d4$var$reverseStoppableEventChain(f1, f2) {
    if (f1 === $786a5f856536c5d4$var$nop) return f2;
    return function() {
        if (f2.apply(this, arguments) === false) return false;
        return f1.apply(this, arguments);
    };
}
function $786a5f856536c5d4$var$promisableChain(f1, f2) {
    if (f1 === $786a5f856536c5d4$var$nop) return f2;
    return function() {
        var res = f1.apply(this, arguments);
        if (res && typeof res.then === 'function') {
            var thiz = this, i = arguments.length, args = new Array(i);
            while(i--)args[i] = arguments[i];
            return res.then(function() {
                return f2.apply(thiz, args);
            });
        }
        return f2.apply(this, arguments);
    };
}
var $786a5f856536c5d4$var$debug = typeof location !== 'undefined' && /^(http|https):\/\/(localhost|127\.0\.0\.1)/.test(location.href);
function $786a5f856536c5d4$var$setDebug(value, filter) {
    $786a5f856536c5d4$var$debug = value;
}
var $786a5f856536c5d4$var$INTERNAL = {};
var $786a5f856536c5d4$var$ZONE_ECHO_LIMIT = 100, $786a5f856536c5d4$var$_a$1 = typeof Promise === 'undefined' ? [] : function() {
    var globalP = Promise.resolve();
    if (typeof crypto === 'undefined' || !crypto.subtle) return [
        globalP,
        $786a5f856536c5d4$var$getProto(globalP),
        globalP
    ];
    var nativeP = crypto.subtle.digest("SHA-512", new Uint8Array([
        0
    ]));
    return [
        nativeP,
        $786a5f856536c5d4$var$getProto(nativeP),
        globalP
    ];
}(), $786a5f856536c5d4$var$resolvedNativePromise = $786a5f856536c5d4$var$_a$1[0], $786a5f856536c5d4$var$nativePromiseProto = $786a5f856536c5d4$var$_a$1[1], $786a5f856536c5d4$var$resolvedGlobalPromise = $786a5f856536c5d4$var$_a$1[2], $786a5f856536c5d4$var$nativePromiseThen = $786a5f856536c5d4$var$nativePromiseProto && $786a5f856536c5d4$var$nativePromiseProto.then;
var $786a5f856536c5d4$var$NativePromise = $786a5f856536c5d4$var$resolvedNativePromise && $786a5f856536c5d4$var$resolvedNativePromise.constructor;
var $786a5f856536c5d4$var$patchGlobalPromise = !!$786a5f856536c5d4$var$resolvedGlobalPromise;
function $786a5f856536c5d4$var$schedulePhysicalTick() {
    queueMicrotask($786a5f856536c5d4$var$physicalTick);
}
var $786a5f856536c5d4$var$asap = function(callback, args) {
    $786a5f856536c5d4$var$microtickQueue.push([
        callback,
        args
    ]);
    if ($786a5f856536c5d4$var$needsNewPhysicalTick) {
        $786a5f856536c5d4$var$schedulePhysicalTick();
        $786a5f856536c5d4$var$needsNewPhysicalTick = false;
    }
};
var $786a5f856536c5d4$var$isOutsideMicroTick = true, $786a5f856536c5d4$var$needsNewPhysicalTick = true, $786a5f856536c5d4$var$unhandledErrors = [], $786a5f856536c5d4$var$rejectingErrors = [], $786a5f856536c5d4$var$rejectionMapper = $786a5f856536c5d4$var$mirror;
var $786a5f856536c5d4$var$globalPSD = {
    id: 'global',
    global: true,
    ref: 0,
    unhandleds: [],
    onunhandled: $786a5f856536c5d4$var$nop,
    pgp: false,
    env: {},
    finalize: $786a5f856536c5d4$var$nop
};
var $786a5f856536c5d4$var$PSD = $786a5f856536c5d4$var$globalPSD;
var $786a5f856536c5d4$var$microtickQueue = [];
var $786a5f856536c5d4$var$numScheduledCalls = 0;
var $786a5f856536c5d4$var$tickFinalizers = [];
function $786a5f856536c5d4$var$DexiePromise(fn) {
    if (typeof this !== 'object') throw new TypeError('Promises must be constructed via new');
    this._listeners = [];
    this._lib = false;
    var psd = this._PSD = $786a5f856536c5d4$var$PSD;
    if (typeof fn !== 'function') {
        if (fn !== $786a5f856536c5d4$var$INTERNAL) throw new TypeError('Not a function');
        this._state = arguments[1];
        this._value = arguments[2];
        if (this._state === false) $786a5f856536c5d4$var$handleRejection(this, this._value);
        return;
    }
    this._state = null;
    this._value = null;
    ++psd.ref;
    $786a5f856536c5d4$var$executePromiseTask(this, fn);
}
var $786a5f856536c5d4$var$thenProp = {
    get: function() {
        var psd = $786a5f856536c5d4$var$PSD, microTaskId = $786a5f856536c5d4$var$totalEchoes;
        function then(onFulfilled, onRejected) {
            var _this = this;
            var possibleAwait = !psd.global && (psd !== $786a5f856536c5d4$var$PSD || microTaskId !== $786a5f856536c5d4$var$totalEchoes);
            var cleanup = possibleAwait && !$786a5f856536c5d4$var$decrementExpectedAwaits();
            var rv = new $786a5f856536c5d4$var$DexiePromise(function(resolve, reject) {
                $786a5f856536c5d4$var$propagateToListener(_this, new $786a5f856536c5d4$var$Listener($786a5f856536c5d4$var$nativeAwaitCompatibleWrap(onFulfilled, psd, possibleAwait, cleanup), $786a5f856536c5d4$var$nativeAwaitCompatibleWrap(onRejected, psd, possibleAwait, cleanup), resolve, reject, psd));
            });
            if (this._consoleTask) rv._consoleTask = this._consoleTask;
            return rv;
        }
        then.prototype = $786a5f856536c5d4$var$INTERNAL;
        return then;
    },
    set: function(value) {
        $786a5f856536c5d4$var$setProp(this, 'then', value && value.prototype === $786a5f856536c5d4$var$INTERNAL ? $786a5f856536c5d4$var$thenProp : {
            get: function() {
                return value;
            },
            set: $786a5f856536c5d4$var$thenProp.set
        });
    }
};
$786a5f856536c5d4$var$props($786a5f856536c5d4$var$DexiePromise.prototype, {
    then: $786a5f856536c5d4$var$thenProp,
    _then: function(onFulfilled, onRejected) {
        $786a5f856536c5d4$var$propagateToListener(this, new $786a5f856536c5d4$var$Listener(null, null, onFulfilled, onRejected, $786a5f856536c5d4$var$PSD));
    },
    catch: function(onRejected) {
        if (arguments.length === 1) return this.then(null, onRejected);
        var type = arguments[0], handler = arguments[1];
        return typeof type === 'function' ? this.then(null, function(err) {
            return err instanceof type ? handler(err) : $786a5f856536c5d4$var$PromiseReject(err);
        }) : this.then(null, function(err) {
            return err && err.name === type ? handler(err) : $786a5f856536c5d4$var$PromiseReject(err);
        });
    },
    finally: function(onFinally) {
        return this.then(function(value) {
            return $786a5f856536c5d4$var$DexiePromise.resolve(onFinally()).then(function() {
                return value;
            });
        }, function(err) {
            return $786a5f856536c5d4$var$DexiePromise.resolve(onFinally()).then(function() {
                return $786a5f856536c5d4$var$PromiseReject(err);
            });
        });
    },
    timeout: function(ms, msg) {
        var _this = this;
        return ms < Infinity ? new $786a5f856536c5d4$var$DexiePromise(function(resolve, reject) {
            var handle = setTimeout(function() {
                return reject(new $786a5f856536c5d4$var$exceptions.Timeout(msg));
            }, ms);
            _this.then(resolve, reject).finally(clearTimeout.bind(null, handle));
        }) : this;
    }
});
if (typeof Symbol !== 'undefined' && Symbol.toStringTag) $786a5f856536c5d4$var$setProp($786a5f856536c5d4$var$DexiePromise.prototype, Symbol.toStringTag, 'Dexie.Promise');
$786a5f856536c5d4$var$globalPSD.env = $786a5f856536c5d4$var$snapShot();
function $786a5f856536c5d4$var$Listener(onFulfilled, onRejected, resolve, reject, zone) {
    this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
    this.onRejected = typeof onRejected === 'function' ? onRejected : null;
    this.resolve = resolve;
    this.reject = reject;
    this.psd = zone;
}
$786a5f856536c5d4$var$props($786a5f856536c5d4$var$DexiePromise, {
    all: function() {
        var values = $786a5f856536c5d4$var$getArrayOf.apply(null, arguments).map($786a5f856536c5d4$var$onPossibleParallellAsync);
        return new $786a5f856536c5d4$var$DexiePromise(function(resolve, reject) {
            if (values.length === 0) resolve([]);
            var remaining = values.length;
            values.forEach(function(a, i) {
                return $786a5f856536c5d4$var$DexiePromise.resolve(a).then(function(x) {
                    values[i] = x;
                    if (!--remaining) resolve(values);
                }, reject);
            });
        });
    },
    resolve: function(value) {
        if (value instanceof $786a5f856536c5d4$var$DexiePromise) return value;
        if (value && typeof value.then === 'function') return new $786a5f856536c5d4$var$DexiePromise(function(resolve, reject) {
            value.then(resolve, reject);
        });
        var rv = new $786a5f856536c5d4$var$DexiePromise($786a5f856536c5d4$var$INTERNAL, true, value);
        return rv;
    },
    reject: $786a5f856536c5d4$var$PromiseReject,
    race: function() {
        var values = $786a5f856536c5d4$var$getArrayOf.apply(null, arguments).map($786a5f856536c5d4$var$onPossibleParallellAsync);
        return new $786a5f856536c5d4$var$DexiePromise(function(resolve, reject) {
            values.map(function(value) {
                return $786a5f856536c5d4$var$DexiePromise.resolve(value).then(resolve, reject);
            });
        });
    },
    PSD: {
        get: function() {
            return $786a5f856536c5d4$var$PSD;
        },
        set: function(value) {
            return $786a5f856536c5d4$var$PSD = value;
        }
    },
    totalEchoes: {
        get: function() {
            return $786a5f856536c5d4$var$totalEchoes;
        }
    },
    newPSD: $786a5f856536c5d4$var$newScope,
    usePSD: $786a5f856536c5d4$var$usePSD,
    scheduler: {
        get: function() {
            return $786a5f856536c5d4$var$asap;
        },
        set: function(value) {
            $786a5f856536c5d4$var$asap = value;
        }
    },
    rejectionMapper: {
        get: function() {
            return $786a5f856536c5d4$var$rejectionMapper;
        },
        set: function(value) {
            $786a5f856536c5d4$var$rejectionMapper = value;
        }
    },
    follow: function(fn, zoneProps) {
        return new $786a5f856536c5d4$var$DexiePromise(function(resolve, reject) {
            return $786a5f856536c5d4$var$newScope(function(resolve, reject) {
                var psd = $786a5f856536c5d4$var$PSD;
                psd.unhandleds = [];
                psd.onunhandled = reject;
                psd.finalize = $786a5f856536c5d4$var$callBoth(function() {
                    var _this = this;
                    $786a5f856536c5d4$var$run_at_end_of_this_or_next_physical_tick(function() {
                        _this.unhandleds.length === 0 ? resolve() : reject(_this.unhandleds[0]);
                    });
                }, psd.finalize);
                fn();
            }, zoneProps, resolve, reject);
        });
    }
});
if ($786a5f856536c5d4$var$NativePromise) {
    if ($786a5f856536c5d4$var$NativePromise.allSettled) $786a5f856536c5d4$var$setProp($786a5f856536c5d4$var$DexiePromise, "allSettled", function() {
        var possiblePromises = $786a5f856536c5d4$var$getArrayOf.apply(null, arguments).map($786a5f856536c5d4$var$onPossibleParallellAsync);
        return new $786a5f856536c5d4$var$DexiePromise(function(resolve) {
            if (possiblePromises.length === 0) resolve([]);
            var remaining = possiblePromises.length;
            var results = new Array(remaining);
            possiblePromises.forEach(function(p, i) {
                return $786a5f856536c5d4$var$DexiePromise.resolve(p).then(function(value) {
                    return results[i] = {
                        status: "fulfilled",
                        value: value
                    };
                }, function(reason) {
                    return results[i] = {
                        status: "rejected",
                        reason: reason
                    };
                }).then(function() {
                    return --remaining || resolve(results);
                });
            });
        });
    });
    if ($786a5f856536c5d4$var$NativePromise.any && typeof AggregateError !== 'undefined') $786a5f856536c5d4$var$setProp($786a5f856536c5d4$var$DexiePromise, "any", function() {
        var possiblePromises = $786a5f856536c5d4$var$getArrayOf.apply(null, arguments).map($786a5f856536c5d4$var$onPossibleParallellAsync);
        return new $786a5f856536c5d4$var$DexiePromise(function(resolve, reject) {
            if (possiblePromises.length === 0) reject(new AggregateError([]));
            var remaining = possiblePromises.length;
            var failures = new Array(remaining);
            possiblePromises.forEach(function(p, i) {
                return $786a5f856536c5d4$var$DexiePromise.resolve(p).then(function(value) {
                    return resolve(value);
                }, function(failure) {
                    failures[i] = failure;
                    if (!--remaining) reject(new AggregateError(failures));
                });
            });
        });
    });
    if ($786a5f856536c5d4$var$NativePromise.withResolvers) $786a5f856536c5d4$var$DexiePromise.withResolvers = $786a5f856536c5d4$var$NativePromise.withResolvers;
}
function $786a5f856536c5d4$var$executePromiseTask(promise, fn) {
    try {
        fn(function(value) {
            if (promise._state !== null) return;
            if (value === promise) throw new TypeError('A promise cannot be resolved with itself.');
            var shouldExecuteTick = promise._lib && $786a5f856536c5d4$var$beginMicroTickScope();
            if (value && typeof value.then === 'function') $786a5f856536c5d4$var$executePromiseTask(promise, function(resolve, reject) {
                value instanceof $786a5f856536c5d4$var$DexiePromise ? value._then(resolve, reject) : value.then(resolve, reject);
            });
            else {
                promise._state = true;
                promise._value = value;
                $786a5f856536c5d4$var$propagateAllListeners(promise);
            }
            if (shouldExecuteTick) $786a5f856536c5d4$var$endMicroTickScope();
        }, $786a5f856536c5d4$var$handleRejection.bind(null, promise));
    } catch (ex) {
        $786a5f856536c5d4$var$handleRejection(promise, ex);
    }
}
function $786a5f856536c5d4$var$handleRejection(promise, reason) {
    $786a5f856536c5d4$var$rejectingErrors.push(reason);
    if (promise._state !== null) return;
    var shouldExecuteTick = promise._lib && $786a5f856536c5d4$var$beginMicroTickScope();
    reason = $786a5f856536c5d4$var$rejectionMapper(reason);
    promise._state = false;
    promise._value = reason;
    $786a5f856536c5d4$var$addPossiblyUnhandledError(promise);
    $786a5f856536c5d4$var$propagateAllListeners(promise);
    if (shouldExecuteTick) $786a5f856536c5d4$var$endMicroTickScope();
}
function $786a5f856536c5d4$var$propagateAllListeners(promise) {
    var listeners = promise._listeners;
    promise._listeners = [];
    for(var i = 0, len = listeners.length; i < len; ++i)$786a5f856536c5d4$var$propagateToListener(promise, listeners[i]);
    var psd = promise._PSD;
    --psd.ref || psd.finalize();
    if ($786a5f856536c5d4$var$numScheduledCalls === 0) {
        ++$786a5f856536c5d4$var$numScheduledCalls;
        $786a5f856536c5d4$var$asap(function() {
            if (--$786a5f856536c5d4$var$numScheduledCalls === 0) $786a5f856536c5d4$var$finalizePhysicalTick();
        }, []);
    }
}
function $786a5f856536c5d4$var$propagateToListener(promise, listener) {
    if (promise._state === null) {
        promise._listeners.push(listener);
        return;
    }
    var cb = promise._state ? listener.onFulfilled : listener.onRejected;
    if (cb === null) return (promise._state ? listener.resolve : listener.reject)(promise._value);
    ++listener.psd.ref;
    ++$786a5f856536c5d4$var$numScheduledCalls;
    $786a5f856536c5d4$var$asap($786a5f856536c5d4$var$callListener, [
        cb,
        promise,
        listener
    ]);
}
function $786a5f856536c5d4$var$callListener(cb, promise, listener) {
    try {
        var ret, value = promise._value;
        if (!promise._state && $786a5f856536c5d4$var$rejectingErrors.length) $786a5f856536c5d4$var$rejectingErrors = [];
        ret = $786a5f856536c5d4$var$debug && promise._consoleTask ? promise._consoleTask.run(function() {
            return cb(value);
        }) : cb(value);
        if (!promise._state && $786a5f856536c5d4$var$rejectingErrors.indexOf(value) === -1) $786a5f856536c5d4$var$markErrorAsHandled(promise);
        listener.resolve(ret);
    } catch (e) {
        listener.reject(e);
    } finally{
        if (--$786a5f856536c5d4$var$numScheduledCalls === 0) $786a5f856536c5d4$var$finalizePhysicalTick();
        --listener.psd.ref || listener.psd.finalize();
    }
}
function $786a5f856536c5d4$var$physicalTick() {
    $786a5f856536c5d4$var$usePSD($786a5f856536c5d4$var$globalPSD, function() {
        $786a5f856536c5d4$var$beginMicroTickScope() && $786a5f856536c5d4$var$endMicroTickScope();
    });
}
function $786a5f856536c5d4$var$beginMicroTickScope() {
    var wasRootExec = $786a5f856536c5d4$var$isOutsideMicroTick;
    $786a5f856536c5d4$var$isOutsideMicroTick = false;
    $786a5f856536c5d4$var$needsNewPhysicalTick = false;
    return wasRootExec;
}
function $786a5f856536c5d4$var$endMicroTickScope() {
    var callbacks, i, l;
    do while($786a5f856536c5d4$var$microtickQueue.length > 0){
        callbacks = $786a5f856536c5d4$var$microtickQueue;
        $786a5f856536c5d4$var$microtickQueue = [];
        l = callbacks.length;
        for(i = 0; i < l; ++i){
            var item = callbacks[i];
            item[0].apply(null, item[1]);
        }
    }
    while ($786a5f856536c5d4$var$microtickQueue.length > 0);
    $786a5f856536c5d4$var$isOutsideMicroTick = true;
    $786a5f856536c5d4$var$needsNewPhysicalTick = true;
}
function $786a5f856536c5d4$var$finalizePhysicalTick() {
    var unhandledErrs = $786a5f856536c5d4$var$unhandledErrors;
    $786a5f856536c5d4$var$unhandledErrors = [];
    unhandledErrs.forEach(function(p) {
        p._PSD.onunhandled.call(null, p._value, p);
    });
    var finalizers = $786a5f856536c5d4$var$tickFinalizers.slice(0);
    var i = finalizers.length;
    while(i)finalizers[--i]();
}
function $786a5f856536c5d4$var$run_at_end_of_this_or_next_physical_tick(fn) {
    function finalizer() {
        fn();
        $786a5f856536c5d4$var$tickFinalizers.splice($786a5f856536c5d4$var$tickFinalizers.indexOf(finalizer), 1);
    }
    $786a5f856536c5d4$var$tickFinalizers.push(finalizer);
    ++$786a5f856536c5d4$var$numScheduledCalls;
    $786a5f856536c5d4$var$asap(function() {
        if (--$786a5f856536c5d4$var$numScheduledCalls === 0) $786a5f856536c5d4$var$finalizePhysicalTick();
    }, []);
}
function $786a5f856536c5d4$var$addPossiblyUnhandledError(promise) {
    if (!$786a5f856536c5d4$var$unhandledErrors.some(function(p) {
        return p._value === promise._value;
    })) $786a5f856536c5d4$var$unhandledErrors.push(promise);
}
function $786a5f856536c5d4$var$markErrorAsHandled(promise) {
    var i = $786a5f856536c5d4$var$unhandledErrors.length;
    while(i)if ($786a5f856536c5d4$var$unhandledErrors[--i]._value === promise._value) {
        $786a5f856536c5d4$var$unhandledErrors.splice(i, 1);
        return;
    }
}
function $786a5f856536c5d4$var$PromiseReject(reason) {
    return new $786a5f856536c5d4$var$DexiePromise($786a5f856536c5d4$var$INTERNAL, false, reason);
}
function $786a5f856536c5d4$var$wrap(fn, errorCatcher) {
    var psd = $786a5f856536c5d4$var$PSD;
    return function() {
        var wasRootExec = $786a5f856536c5d4$var$beginMicroTickScope(), outerScope = $786a5f856536c5d4$var$PSD;
        try {
            $786a5f856536c5d4$var$switchToZone(psd, true);
            return fn.apply(this, arguments);
        } catch (e) {
            errorCatcher && errorCatcher(e);
        } finally{
            $786a5f856536c5d4$var$switchToZone(outerScope, false);
            if (wasRootExec) $786a5f856536c5d4$var$endMicroTickScope();
        }
    };
}
var $786a5f856536c5d4$var$task = {
    awaits: 0,
    echoes: 0,
    id: 0
};
var $786a5f856536c5d4$var$taskCounter = 0;
var $786a5f856536c5d4$var$zoneStack = [];
var $786a5f856536c5d4$var$zoneEchoes = 0;
var $786a5f856536c5d4$var$totalEchoes = 0;
var $786a5f856536c5d4$var$zone_id_counter = 0;
function $786a5f856536c5d4$var$newScope(fn, props, a1, a2) {
    var parent = $786a5f856536c5d4$var$PSD, psd = Object.create(parent);
    psd.parent = parent;
    psd.ref = 0;
    psd.global = false;
    psd.id = ++$786a5f856536c5d4$var$zone_id_counter;
    $786a5f856536c5d4$var$globalPSD.env;
    psd.env = $786a5f856536c5d4$var$patchGlobalPromise ? {
        Promise: $786a5f856536c5d4$var$DexiePromise,
        PromiseProp: {
            value: $786a5f856536c5d4$var$DexiePromise,
            configurable: true,
            writable: true
        },
        all: $786a5f856536c5d4$var$DexiePromise.all,
        race: $786a5f856536c5d4$var$DexiePromise.race,
        allSettled: $786a5f856536c5d4$var$DexiePromise.allSettled,
        any: $786a5f856536c5d4$var$DexiePromise.any,
        resolve: $786a5f856536c5d4$var$DexiePromise.resolve,
        reject: $786a5f856536c5d4$var$DexiePromise.reject
    } : {};
    if (props) $786a5f856536c5d4$var$extend(psd, props);
    ++parent.ref;
    psd.finalize = function() {
        --this.parent.ref || this.parent.finalize();
    };
    var rv = $786a5f856536c5d4$var$usePSD(psd, fn, a1, a2);
    if (psd.ref === 0) psd.finalize();
    return rv;
}
function $786a5f856536c5d4$var$incrementExpectedAwaits() {
    if (!$786a5f856536c5d4$var$task.id) $786a5f856536c5d4$var$task.id = ++$786a5f856536c5d4$var$taskCounter;
    ++$786a5f856536c5d4$var$task.awaits;
    $786a5f856536c5d4$var$task.echoes += $786a5f856536c5d4$var$ZONE_ECHO_LIMIT;
    return $786a5f856536c5d4$var$task.id;
}
function $786a5f856536c5d4$var$decrementExpectedAwaits() {
    if (!$786a5f856536c5d4$var$task.awaits) return false;
    if (--$786a5f856536c5d4$var$task.awaits === 0) $786a5f856536c5d4$var$task.id = 0;
    $786a5f856536c5d4$var$task.echoes = $786a5f856536c5d4$var$task.awaits * $786a5f856536c5d4$var$ZONE_ECHO_LIMIT;
    return true;
}
if (('' + $786a5f856536c5d4$var$nativePromiseThen).indexOf('[native code]') === -1) $786a5f856536c5d4$var$incrementExpectedAwaits = $786a5f856536c5d4$var$decrementExpectedAwaits = $786a5f856536c5d4$var$nop;
function $786a5f856536c5d4$var$onPossibleParallellAsync(possiblePromise) {
    if ($786a5f856536c5d4$var$task.echoes && possiblePromise && possiblePromise.constructor === $786a5f856536c5d4$var$NativePromise) {
        $786a5f856536c5d4$var$incrementExpectedAwaits();
        return possiblePromise.then(function(x) {
            $786a5f856536c5d4$var$decrementExpectedAwaits();
            return x;
        }, function(e) {
            $786a5f856536c5d4$var$decrementExpectedAwaits();
            return $786a5f856536c5d4$var$rejection(e);
        });
    }
    return possiblePromise;
}
function $786a5f856536c5d4$var$zoneEnterEcho(targetZone) {
    ++$786a5f856536c5d4$var$totalEchoes;
    if (!$786a5f856536c5d4$var$task.echoes || --$786a5f856536c5d4$var$task.echoes === 0) $786a5f856536c5d4$var$task.echoes = $786a5f856536c5d4$var$task.awaits = $786a5f856536c5d4$var$task.id = 0;
    $786a5f856536c5d4$var$zoneStack.push($786a5f856536c5d4$var$PSD);
    $786a5f856536c5d4$var$switchToZone(targetZone, true);
}
function $786a5f856536c5d4$var$zoneLeaveEcho() {
    var zone = $786a5f856536c5d4$var$zoneStack[$786a5f856536c5d4$var$zoneStack.length - 1];
    $786a5f856536c5d4$var$zoneStack.pop();
    $786a5f856536c5d4$var$switchToZone(zone, false);
}
function $786a5f856536c5d4$var$switchToZone(targetZone, bEnteringZone) {
    var currentZone = $786a5f856536c5d4$var$PSD;
    if (bEnteringZone ? $786a5f856536c5d4$var$task.echoes && (!$786a5f856536c5d4$var$zoneEchoes++ || targetZone !== $786a5f856536c5d4$var$PSD) : $786a5f856536c5d4$var$zoneEchoes && (!--$786a5f856536c5d4$var$zoneEchoes || targetZone !== $786a5f856536c5d4$var$PSD)) queueMicrotask(bEnteringZone ? $786a5f856536c5d4$var$zoneEnterEcho.bind(null, targetZone) : $786a5f856536c5d4$var$zoneLeaveEcho);
    if (targetZone === $786a5f856536c5d4$var$PSD) return;
    $786a5f856536c5d4$var$PSD = targetZone;
    if (currentZone === $786a5f856536c5d4$var$globalPSD) $786a5f856536c5d4$var$globalPSD.env = $786a5f856536c5d4$var$snapShot();
    if ($786a5f856536c5d4$var$patchGlobalPromise) {
        var GlobalPromise = $786a5f856536c5d4$var$globalPSD.env.Promise;
        var targetEnv = targetZone.env;
        if (currentZone.global || targetZone.global) {
            Object.defineProperty($786a5f856536c5d4$var$_global, 'Promise', targetEnv.PromiseProp);
            GlobalPromise.all = targetEnv.all;
            GlobalPromise.race = targetEnv.race;
            GlobalPromise.resolve = targetEnv.resolve;
            GlobalPromise.reject = targetEnv.reject;
            if (targetEnv.allSettled) GlobalPromise.allSettled = targetEnv.allSettled;
            if (targetEnv.any) GlobalPromise.any = targetEnv.any;
        }
    }
}
function $786a5f856536c5d4$var$snapShot() {
    var GlobalPromise = $786a5f856536c5d4$var$_global.Promise;
    return $786a5f856536c5d4$var$patchGlobalPromise ? {
        Promise: GlobalPromise,
        PromiseProp: Object.getOwnPropertyDescriptor($786a5f856536c5d4$var$_global, "Promise"),
        all: GlobalPromise.all,
        race: GlobalPromise.race,
        allSettled: GlobalPromise.allSettled,
        any: GlobalPromise.any,
        resolve: GlobalPromise.resolve,
        reject: GlobalPromise.reject
    } : {};
}
function $786a5f856536c5d4$var$usePSD(psd, fn, a1, a2, a3) {
    var outerScope = $786a5f856536c5d4$var$PSD;
    try {
        $786a5f856536c5d4$var$switchToZone(psd, true);
        return fn(a1, a2, a3);
    } finally{
        $786a5f856536c5d4$var$switchToZone(outerScope, false);
    }
}
function $786a5f856536c5d4$var$nativeAwaitCompatibleWrap(fn, zone, possibleAwait, cleanup) {
    return typeof fn !== 'function' ? fn : function() {
        var outerZone = $786a5f856536c5d4$var$PSD;
        if (possibleAwait) $786a5f856536c5d4$var$incrementExpectedAwaits();
        $786a5f856536c5d4$var$switchToZone(zone, true);
        try {
            return fn.apply(this, arguments);
        } finally{
            $786a5f856536c5d4$var$switchToZone(outerZone, false);
            if (cleanup) queueMicrotask($786a5f856536c5d4$var$decrementExpectedAwaits);
        }
    };
}
function $786a5f856536c5d4$var$execInGlobalContext(cb) {
    if (Promise === $786a5f856536c5d4$var$NativePromise && $786a5f856536c5d4$var$task.echoes === 0) {
        if ($786a5f856536c5d4$var$zoneEchoes === 0) cb();
        else enqueueNativeMicroTask(cb);
    } else setTimeout(cb, 0);
}
var $786a5f856536c5d4$var$rejection = $786a5f856536c5d4$var$DexiePromise.reject;
function $786a5f856536c5d4$var$tempTransaction(db, mode, storeNames, fn) {
    if (!db.idbdb || !db._state.openComplete && !$786a5f856536c5d4$var$PSD.letThrough && !db._vip) {
        if (db._state.openComplete) return $786a5f856536c5d4$var$rejection(new $786a5f856536c5d4$var$exceptions.DatabaseClosed(db._state.dbOpenError));
        if (!db._state.isBeingOpened) {
            if (!db._state.autoOpen) return $786a5f856536c5d4$var$rejection(new $786a5f856536c5d4$var$exceptions.DatabaseClosed());
            db.open().catch($786a5f856536c5d4$var$nop);
        }
        return db._state.dbReadyPromise.then(function() {
            return $786a5f856536c5d4$var$tempTransaction(db, mode, storeNames, fn);
        });
    } else {
        var trans = db._createTransaction(mode, storeNames, db._dbSchema);
        try {
            trans.create();
            db._state.PR1398_maxLoop = 3;
        } catch (ex) {
            if (ex.name === $786a5f856536c5d4$var$errnames.InvalidState && db.isOpen() && --db._state.PR1398_maxLoop > 0) {
                console.warn('Dexie: Need to reopen db');
                db.close({
                    disableAutoOpen: false
                });
                return db.open().then(function() {
                    return $786a5f856536c5d4$var$tempTransaction(db, mode, storeNames, fn);
                });
            }
            return $786a5f856536c5d4$var$rejection(ex);
        }
        return trans._promise(mode, function(resolve, reject) {
            return $786a5f856536c5d4$var$newScope(function() {
                $786a5f856536c5d4$var$PSD.trans = trans;
                return fn(resolve, reject, trans);
            });
        }).then(function(result) {
            if (mode === 'readwrite') try {
                trans.idbtrans.commit();
            } catch (_a) {}
            return mode === 'readonly' ? result : trans._completion.then(function() {
                return result;
            });
        });
    }
}
var $786a5f856536c5d4$var$DEXIE_VERSION = '4.2.1';
var $786a5f856536c5d4$var$maxString = String.fromCharCode(65535);
var $786a5f856536c5d4$var$minKey = -Infinity;
var $786a5f856536c5d4$var$INVALID_KEY_ARGUMENT = "Invalid key provided. Keys must be of type string, number, Date or Array<string | number | Date>.";
var $786a5f856536c5d4$var$STRING_EXPECTED = "String expected.";
var $786a5f856536c5d4$var$connections = [];
var $786a5f856536c5d4$var$DBNAMES_DB = '__dbnames';
var $786a5f856536c5d4$var$READONLY = 'readonly';
var $786a5f856536c5d4$var$READWRITE = 'readwrite';
function $786a5f856536c5d4$var$combine(filter1, filter2) {
    return filter1 ? filter2 ? function() {
        return filter1.apply(this, arguments) && filter2.apply(this, arguments);
    } : filter1 : filter2;
}
var $786a5f856536c5d4$var$AnyRange = {
    type: 3,
    lower: -Infinity,
    lowerOpen: false,
    upper: [
        []
    ],
    upperOpen: false
};
function $786a5f856536c5d4$var$workaroundForUndefinedPrimKey(keyPath) {
    return typeof keyPath === "string" && !/\./.test(keyPath) ? function(obj) {
        if (obj[keyPath] === undefined && keyPath in obj) {
            obj = $786a5f856536c5d4$var$deepClone(obj);
            delete obj[keyPath];
        }
        return obj;
    } : function(obj) {
        return obj;
    };
}
function $786a5f856536c5d4$export$bc644a473284d944() {
    throw $786a5f856536c5d4$var$exceptions.Type("Entity instances must never be new:ed. Instances are generated by the framework bypassing the constructor.");
}
function $786a5f856536c5d4$export$6154dcdb7d23e37b(a, b) {
    try {
        var ta = $786a5f856536c5d4$var$type(a);
        var tb = $786a5f856536c5d4$var$type(b);
        if (ta !== tb) {
            if (ta === 'Array') return 1;
            if (tb === 'Array') return -1;
            if (ta === 'binary') return 1;
            if (tb === 'binary') return -1;
            if (ta === 'string') return 1;
            if (tb === 'string') return -1;
            if (ta === 'Date') return 1;
            if (tb !== 'Date') return NaN;
            return -1;
        }
        switch(ta){
            case 'number':
            case 'Date':
            case 'string':
                return a > b ? 1 : a < b ? -1 : 0;
            case 'binary':
                return $786a5f856536c5d4$var$compareUint8Arrays($786a5f856536c5d4$var$getUint8Array(a), $786a5f856536c5d4$var$getUint8Array(b));
            case 'Array':
                return $786a5f856536c5d4$var$compareArrays(a, b);
        }
    } catch (_a) {}
    return NaN;
}
function $786a5f856536c5d4$var$compareArrays(a, b) {
    var al = a.length;
    var bl = b.length;
    var l = al < bl ? al : bl;
    for(var i = 0; i < l; ++i){
        var res = $786a5f856536c5d4$export$6154dcdb7d23e37b(a[i], b[i]);
        if (res !== 0) return res;
    }
    return al === bl ? 0 : al < bl ? -1 : 1;
}
function $786a5f856536c5d4$var$compareUint8Arrays(a, b) {
    var al = a.length;
    var bl = b.length;
    var l = al < bl ? al : bl;
    for(var i = 0; i < l; ++i){
        if (a[i] !== b[i]) return a[i] < b[i] ? -1 : 1;
    }
    return al === bl ? 0 : al < bl ? -1 : 1;
}
function $786a5f856536c5d4$var$type(x) {
    var t = typeof x;
    if (t !== 'object') return t;
    if (ArrayBuffer.isView(x)) return 'binary';
    var tsTag = $786a5f856536c5d4$var$toStringTag(x);
    return tsTag === 'ArrayBuffer' ? 'binary' : tsTag;
}
function $786a5f856536c5d4$var$getUint8Array(a) {
    if (a instanceof Uint8Array) return a;
    if (ArrayBuffer.isView(a)) return new Uint8Array(a.buffer, a.byteOffset, a.byteLength);
    return new Uint8Array(a);
}
function $786a5f856536c5d4$var$builtInDeletionTrigger(table, keys, res) {
    var yProps = table.schema.yProps;
    if (!yProps) return res;
    if (keys && res.numFailures > 0) keys = keys.filter(function(_, i) {
        return !res.failures[i];
    });
    return Promise.all(yProps.map(function(_a) {
        var updatesTable = _a.updatesTable;
        return keys ? table.db.table(updatesTable).where('k').anyOf(keys).delete() : table.db.table(updatesTable).clear();
    })).then(function() {
        return res;
    });
}
var $786a5f856536c5d4$export$4118fdb20badc28d = function() {
    function PropModification(spec) {
        this["@@propmod"] = spec;
    }
    PropModification.prototype.execute = function(value) {
        var _a;
        var spec = this["@@propmod"];
        if (spec.add !== undefined) {
            var term = spec.add;
            if ($786a5f856536c5d4$var$isArray(term)) return $786a5f856536c5d4$var$__spreadArray($786a5f856536c5d4$var$__spreadArray([], $786a5f856536c5d4$var$isArray(value) ? value : [], true), term, true).sort();
            if (typeof term === 'number') return (Number(value) || 0) + term;
            if (typeof term === 'bigint') try {
                return BigInt(value) + term;
            } catch (_b) {
                return BigInt(0) + term;
            }
            throw new TypeError("Invalid term ".concat(term));
        }
        if (spec.remove !== undefined) {
            var subtrahend_1 = spec.remove;
            if ($786a5f856536c5d4$var$isArray(subtrahend_1)) return $786a5f856536c5d4$var$isArray(value) ? value.filter(function(item) {
                return !subtrahend_1.includes(item);
            }).sort() : [];
            if (typeof subtrahend_1 === 'number') return Number(value) - subtrahend_1;
            if (typeof subtrahend_1 === 'bigint') try {
                return BigInt(value) - subtrahend_1;
            } catch (_c) {
                return BigInt(0) - subtrahend_1;
            }
            throw new TypeError("Invalid subtrahend ".concat(subtrahend_1));
        }
        var prefixToReplace = (_a = spec.replacePrefix) === null || _a === void 0 ? void 0 : _a[0];
        if (prefixToReplace && typeof value === 'string' && value.startsWith(prefixToReplace)) return spec.replacePrefix[1] + value.substring(prefixToReplace.length);
        return value;
    };
    return PropModification;
}();
function $786a5f856536c5d4$var$applyUpdateSpec(obj, changes) {
    var keyPaths = $786a5f856536c5d4$var$keys(changes);
    var numKeys = keyPaths.length;
    var anythingModified = false;
    for(var i = 0; i < numKeys; ++i){
        var keyPath = keyPaths[i];
        var value = changes[keyPath];
        var origValue = $786a5f856536c5d4$var$getByKeyPath(obj, keyPath);
        if (value instanceof $786a5f856536c5d4$export$4118fdb20badc28d) {
            $786a5f856536c5d4$var$setByKeyPath(obj, keyPath, value.execute(origValue));
            anythingModified = true;
        } else if (origValue !== value) {
            $786a5f856536c5d4$var$setByKeyPath(obj, keyPath, value);
            anythingModified = true;
        }
    }
    return anythingModified;
}
var $786a5f856536c5d4$var$Table = function() {
    function Table() {}
    Table.prototype._trans = function(mode, fn, writeLocked) {
        var trans = this._tx || $786a5f856536c5d4$var$PSD.trans;
        var tableName = this.name;
        var task = $786a5f856536c5d4$var$debug && typeof console !== 'undefined' && console.createTask && console.createTask("Dexie: ".concat(mode === 'readonly' ? 'read' : 'write', " ").concat(this.name));
        function checkTableInTransaction(resolve, reject, trans) {
            if (!trans.schema[tableName]) throw new $786a5f856536c5d4$var$exceptions.NotFound("Table " + tableName + " not part of transaction");
            return fn(trans.idbtrans, trans);
        }
        var wasRootExec = $786a5f856536c5d4$var$beginMicroTickScope();
        try {
            var p = trans && trans.db._novip === this.db._novip ? trans === $786a5f856536c5d4$var$PSD.trans ? trans._promise(mode, checkTableInTransaction, writeLocked) : $786a5f856536c5d4$var$newScope(function() {
                return trans._promise(mode, checkTableInTransaction, writeLocked);
            }, {
                trans: trans,
                transless: $786a5f856536c5d4$var$PSD.transless || $786a5f856536c5d4$var$PSD
            }) : $786a5f856536c5d4$var$tempTransaction(this.db, mode, [
                this.name
            ], checkTableInTransaction);
            if (task) {
                p._consoleTask = task;
                p = p.catch(function(err) {
                    console.trace(err);
                    return $786a5f856536c5d4$var$rejection(err);
                });
            }
            return p;
        } finally{
            if (wasRootExec) $786a5f856536c5d4$var$endMicroTickScope();
        }
    };
    Table.prototype.get = function(keyOrCrit, cb) {
        var _this = this;
        if (keyOrCrit && keyOrCrit.constructor === Object) return this.where(keyOrCrit).first(cb);
        if (keyOrCrit == null) return $786a5f856536c5d4$var$rejection(new $786a5f856536c5d4$var$exceptions.Type("Invalid argument to Table.get()"));
        return this._trans('readonly', function(trans) {
            return _this.core.get({
                trans: trans,
                key: keyOrCrit
            }).then(function(res) {
                return _this.hook.reading.fire(res);
            });
        }).then(cb);
    };
    Table.prototype.where = function(indexOrCrit) {
        if (typeof indexOrCrit === 'string') return new this.db.WhereClause(this, indexOrCrit);
        if ($786a5f856536c5d4$var$isArray(indexOrCrit)) return new this.db.WhereClause(this, "[".concat(indexOrCrit.join('+'), "]"));
        var keyPaths = $786a5f856536c5d4$var$keys(indexOrCrit);
        if (keyPaths.length === 1) return this.where(keyPaths[0]).equals(indexOrCrit[keyPaths[0]]);
        var compoundIndex = this.schema.indexes.concat(this.schema.primKey).filter(function(ix) {
            if (ix.compound && keyPaths.every(function(keyPath) {
                return ix.keyPath.indexOf(keyPath) >= 0;
            })) {
                for(var i = 0; i < keyPaths.length; ++i){
                    if (keyPaths.indexOf(ix.keyPath[i]) === -1) return false;
                }
                return true;
            }
            return false;
        }).sort(function(a, b) {
            return a.keyPath.length - b.keyPath.length;
        })[0];
        if (compoundIndex && this.db._maxKey !== $786a5f856536c5d4$var$maxString) {
            var keyPathsInValidOrder = compoundIndex.keyPath.slice(0, keyPaths.length);
            return this.where(keyPathsInValidOrder).equals(keyPathsInValidOrder.map(function(kp) {
                return indexOrCrit[kp];
            }));
        }
        if (!compoundIndex && $786a5f856536c5d4$var$debug) console.warn("The query ".concat(JSON.stringify(indexOrCrit), " on ").concat(this.name, " would benefit from a ") + "compound index [".concat(keyPaths.join('+'), "]"));
        var idxByName = this.schema.idxByName;
        function equals(a, b) {
            return $786a5f856536c5d4$export$6154dcdb7d23e37b(a, b) === 0;
        }
        var _a = keyPaths.reduce(function(_a, keyPath) {
            var prevIndex = _a[0], prevFilterFn = _a[1];
            var index = idxByName[keyPath];
            var value = indexOrCrit[keyPath];
            return [
                prevIndex || index,
                prevIndex || !index ? $786a5f856536c5d4$var$combine(prevFilterFn, index && index.multi ? function(x) {
                    var prop = $786a5f856536c5d4$var$getByKeyPath(x, keyPath);
                    return $786a5f856536c5d4$var$isArray(prop) && prop.some(function(item) {
                        return equals(value, item);
                    });
                } : function(x) {
                    return equals(value, $786a5f856536c5d4$var$getByKeyPath(x, keyPath));
                }) : prevFilterFn
            ];
        }, [
            null,
            null
        ]), idx = _a[0], filterFunction = _a[1];
        return idx ? this.where(idx.name).equals(indexOrCrit[idx.keyPath]).filter(filterFunction) : compoundIndex ? this.filter(filterFunction) : this.where(keyPaths).equals('');
    };
    Table.prototype.filter = function(filterFunction) {
        return this.toCollection().and(filterFunction);
    };
    Table.prototype.count = function(thenShortcut) {
        return this.toCollection().count(thenShortcut);
    };
    Table.prototype.offset = function(offset) {
        return this.toCollection().offset(offset);
    };
    Table.prototype.limit = function(numRows) {
        return this.toCollection().limit(numRows);
    };
    Table.prototype.each = function(callback) {
        return this.toCollection().each(callback);
    };
    Table.prototype.toArray = function(thenShortcut) {
        return this.toCollection().toArray(thenShortcut);
    };
    Table.prototype.toCollection = function() {
        return new this.db.Collection(new this.db.WhereClause(this));
    };
    Table.prototype.orderBy = function(index) {
        return new this.db.Collection(new this.db.WhereClause(this, $786a5f856536c5d4$var$isArray(index) ? "[".concat(index.join('+'), "]") : index));
    };
    Table.prototype.reverse = function() {
        return this.toCollection().reverse();
    };
    Table.prototype.mapToClass = function(constructor) {
        var _a = this, db = _a.db, tableName = _a.name;
        this.schema.mappedClass = constructor;
        if (constructor.prototype instanceof $786a5f856536c5d4$export$bc644a473284d944) constructor = function(_super) {
            $786a5f856536c5d4$var$__extends(class_1, _super);
            function class_1() {
                return _super !== null && _super.apply(this, arguments) || this;
            }
            Object.defineProperty(class_1.prototype, "db", {
                get: function() {
                    return db;
                },
                enumerable: false,
                configurable: true
            });
            class_1.prototype.table = function() {
                return tableName;
            };
            return class_1;
        }(constructor);
        var inheritedProps = new Set();
        for(var proto = constructor.prototype; proto; proto = $786a5f856536c5d4$var$getProto(proto))Object.getOwnPropertyNames(proto).forEach(function(propName) {
            return inheritedProps.add(propName);
        });
        var readHook = function(obj) {
            if (!obj) return obj;
            var res = Object.create(constructor.prototype);
            for(var m in obj)if (!inheritedProps.has(m)) try {
                res[m] = obj[m];
            } catch (_) {}
            return res;
        };
        if (this.schema.readHook) this.hook.reading.unsubscribe(this.schema.readHook);
        this.schema.readHook = readHook;
        this.hook("reading", readHook);
        return constructor;
    };
    Table.prototype.defineClass = function() {
        function Class(content) {
            $786a5f856536c5d4$var$extend(this, content);
        }
        return this.mapToClass(Class);
    };
    Table.prototype.add = function(obj, key) {
        var _this = this;
        var _a = this.schema.primKey, auto = _a.auto, keyPath = _a.keyPath;
        var objToAdd = obj;
        if (keyPath && auto) objToAdd = $786a5f856536c5d4$var$workaroundForUndefinedPrimKey(keyPath)(obj);
        return this._trans('readwrite', function(trans) {
            return _this.core.mutate({
                trans: trans,
                type: 'add',
                keys: key != null ? [
                    key
                ] : null,
                values: [
                    objToAdd
                ]
            });
        }).then(function(res) {
            return res.numFailures ? $786a5f856536c5d4$var$DexiePromise.reject(res.failures[0]) : res.lastResult;
        }).then(function(lastResult) {
            if (keyPath) try {
                $786a5f856536c5d4$var$setByKeyPath(obj, keyPath, lastResult);
            } catch (_) {}
            return lastResult;
        });
    };
    Table.prototype.upsert = function(key, modifications) {
        var _this = this;
        var keyPath = this.schema.primKey.keyPath;
        return this._trans('readwrite', function(trans) {
            return _this.core.get({
                trans: trans,
                key: key
            }).then(function(existing) {
                var obj = existing !== null && existing !== void 0 ? existing : {};
                $786a5f856536c5d4$var$applyUpdateSpec(obj, modifications);
                if (keyPath) $786a5f856536c5d4$var$setByKeyPath(obj, keyPath, key);
                return _this.core.mutate({
                    trans: trans,
                    type: 'put',
                    values: [
                        obj
                    ],
                    keys: [
                        key
                    ],
                    upsert: true,
                    updates: {
                        keys: [
                            key
                        ],
                        changeSpecs: [
                            modifications
                        ]
                    }
                }).then(function(res) {
                    return res.numFailures ? $786a5f856536c5d4$var$DexiePromise.reject(res.failures[0]) : !!existing;
                });
            });
        });
    };
    Table.prototype.update = function(keyOrObject, modifications) {
        if (typeof keyOrObject === 'object' && !$786a5f856536c5d4$var$isArray(keyOrObject)) {
            var key = $786a5f856536c5d4$var$getByKeyPath(keyOrObject, this.schema.primKey.keyPath);
            if (key === undefined) return $786a5f856536c5d4$var$rejection(new $786a5f856536c5d4$var$exceptions.InvalidArgument("Given object does not contain its primary key"));
            return this.where(":id").equals(key).modify(modifications);
        } else return this.where(":id").equals(keyOrObject).modify(modifications);
    };
    Table.prototype.put = function(obj, key) {
        var _this = this;
        var _a = this.schema.primKey, auto = _a.auto, keyPath = _a.keyPath;
        var objToAdd = obj;
        if (keyPath && auto) objToAdd = $786a5f856536c5d4$var$workaroundForUndefinedPrimKey(keyPath)(obj);
        return this._trans('readwrite', function(trans) {
            return _this.core.mutate({
                trans: trans,
                type: 'put',
                values: [
                    objToAdd
                ],
                keys: key != null ? [
                    key
                ] : null
            });
        }).then(function(res) {
            return res.numFailures ? $786a5f856536c5d4$var$DexiePromise.reject(res.failures[0]) : res.lastResult;
        }).then(function(lastResult) {
            if (keyPath) try {
                $786a5f856536c5d4$var$setByKeyPath(obj, keyPath, lastResult);
            } catch (_) {}
            return lastResult;
        });
    };
    Table.prototype.delete = function(key) {
        var _this = this;
        return this._trans('readwrite', function(trans) {
            return _this.core.mutate({
                trans: trans,
                type: 'delete',
                keys: [
                    key
                ]
            }).then(function(res) {
                return $786a5f856536c5d4$var$builtInDeletionTrigger(_this, [
                    key
                ], res);
            }).then(function(res) {
                return res.numFailures ? $786a5f856536c5d4$var$DexiePromise.reject(res.failures[0]) : undefined;
            });
        });
    };
    Table.prototype.clear = function() {
        var _this = this;
        return this._trans('readwrite', function(trans) {
            return _this.core.mutate({
                trans: trans,
                type: 'deleteRange',
                range: $786a5f856536c5d4$var$AnyRange
            }).then(function(res) {
                return $786a5f856536c5d4$var$builtInDeletionTrigger(_this, null, res);
            });
        }).then(function(res) {
            return res.numFailures ? $786a5f856536c5d4$var$DexiePromise.reject(res.failures[0]) : undefined;
        });
    };
    Table.prototype.bulkGet = function(keys) {
        var _this = this;
        return this._trans('readonly', function(trans) {
            return _this.core.getMany({
                keys: keys,
                trans: trans
            }).then(function(result) {
                return result.map(function(res) {
                    return _this.hook.reading.fire(res);
                });
            });
        });
    };
    Table.prototype.bulkAdd = function(objects, keysOrOptions, options) {
        var _this = this;
        var keys = Array.isArray(keysOrOptions) ? keysOrOptions : undefined;
        options = options || (keys ? undefined : keysOrOptions);
        var wantResults = options ? options.allKeys : undefined;
        return this._trans('readwrite', function(trans) {
            var _a = _this.schema.primKey, auto = _a.auto, keyPath = _a.keyPath;
            if (keyPath && keys) throw new $786a5f856536c5d4$var$exceptions.InvalidArgument("bulkAdd(): keys argument invalid on tables with inbound keys");
            if (keys && keys.length !== objects.length) throw new $786a5f856536c5d4$var$exceptions.InvalidArgument("Arguments objects and keys must have the same length");
            var numObjects = objects.length;
            var objectsToAdd = keyPath && auto ? objects.map($786a5f856536c5d4$var$workaroundForUndefinedPrimKey(keyPath)) : objects;
            return _this.core.mutate({
                trans: trans,
                type: 'add',
                keys: keys,
                values: objectsToAdd,
                wantResults: wantResults
            }).then(function(_a) {
                var numFailures = _a.numFailures, results = _a.results, lastResult = _a.lastResult, failures = _a.failures;
                var result = wantResults ? results : lastResult;
                if (numFailures === 0) return result;
                throw new $786a5f856536c5d4$var$BulkError("".concat(_this.name, ".bulkAdd(): ").concat(numFailures, " of ").concat(numObjects, " operations failed"), failures);
            });
        });
    };
    Table.prototype.bulkPut = function(objects, keysOrOptions, options) {
        var _this = this;
        var keys = Array.isArray(keysOrOptions) ? keysOrOptions : undefined;
        options = options || (keys ? undefined : keysOrOptions);
        var wantResults = options ? options.allKeys : undefined;
        return this._trans('readwrite', function(trans) {
            var _a = _this.schema.primKey, auto = _a.auto, keyPath = _a.keyPath;
            if (keyPath && keys) throw new $786a5f856536c5d4$var$exceptions.InvalidArgument("bulkPut(): keys argument invalid on tables with inbound keys");
            if (keys && keys.length !== objects.length) throw new $786a5f856536c5d4$var$exceptions.InvalidArgument("Arguments objects and keys must have the same length");
            var numObjects = objects.length;
            var objectsToPut = keyPath && auto ? objects.map($786a5f856536c5d4$var$workaroundForUndefinedPrimKey(keyPath)) : objects;
            return _this.core.mutate({
                trans: trans,
                type: 'put',
                keys: keys,
                values: objectsToPut,
                wantResults: wantResults
            }).then(function(_a) {
                var numFailures = _a.numFailures, results = _a.results, lastResult = _a.lastResult, failures = _a.failures;
                var result = wantResults ? results : lastResult;
                if (numFailures === 0) return result;
                throw new $786a5f856536c5d4$var$BulkError("".concat(_this.name, ".bulkPut(): ").concat(numFailures, " of ").concat(numObjects, " operations failed"), failures);
            });
        });
    };
    Table.prototype.bulkUpdate = function(keysAndChanges) {
        var _this = this;
        var coreTable = this.core;
        var keys = keysAndChanges.map(function(entry) {
            return entry.key;
        });
        var changeSpecs = keysAndChanges.map(function(entry) {
            return entry.changes;
        });
        var offsetMap = [];
        return this._trans('readwrite', function(trans) {
            return coreTable.getMany({
                trans: trans,
                keys: keys,
                cache: 'clone'
            }).then(function(objs) {
                var resultKeys = [];
                var resultObjs = [];
                keysAndChanges.forEach(function(_a, idx) {
                    var key = _a.key, changes = _a.changes;
                    var obj = objs[idx];
                    if (obj) {
                        for(var _i = 0, _b = Object.keys(changes); _i < _b.length; _i++){
                            var keyPath = _b[_i];
                            var value = changes[keyPath];
                            if (keyPath === _this.schema.primKey.keyPath) {
                                if ($786a5f856536c5d4$export$6154dcdb7d23e37b(value, key) !== 0) throw new $786a5f856536c5d4$var$exceptions.Constraint("Cannot update primary key in bulkUpdate()");
                            } else $786a5f856536c5d4$var$setByKeyPath(obj, keyPath, value);
                        }
                        offsetMap.push(idx);
                        resultKeys.push(key);
                        resultObjs.push(obj);
                    }
                });
                var numEntries = resultKeys.length;
                return coreTable.mutate({
                    trans: trans,
                    type: 'put',
                    keys: resultKeys,
                    values: resultObjs,
                    updates: {
                        keys: keys,
                        changeSpecs: changeSpecs
                    }
                }).then(function(_a) {
                    var numFailures = _a.numFailures, failures = _a.failures;
                    if (numFailures === 0) return numEntries;
                    for(var _i = 0, _b = Object.keys(failures); _i < _b.length; _i++){
                        var offset = _b[_i];
                        var mappedOffset = offsetMap[Number(offset)];
                        if (mappedOffset != null) {
                            var failure = failures[offset];
                            delete failures[offset];
                            failures[mappedOffset] = failure;
                        }
                    }
                    throw new $786a5f856536c5d4$var$BulkError("".concat(_this.name, ".bulkUpdate(): ").concat(numFailures, " of ").concat(numEntries, " operations failed"), failures);
                });
            });
        });
    };
    Table.prototype.bulkDelete = function(keys) {
        var _this = this;
        var numKeys = keys.length;
        return this._trans('readwrite', function(trans) {
            return _this.core.mutate({
                trans: trans,
                type: 'delete',
                keys: keys
            }).then(function(res) {
                return $786a5f856536c5d4$var$builtInDeletionTrigger(_this, keys, res);
            });
        }).then(function(_a) {
            var numFailures = _a.numFailures, lastResult = _a.lastResult, failures = _a.failures;
            if (numFailures === 0) return lastResult;
            throw new $786a5f856536c5d4$var$BulkError("".concat(_this.name, ".bulkDelete(): ").concat(numFailures, " of ").concat(numKeys, " operations failed"), failures);
        });
    };
    return Table;
}();
function $786a5f856536c5d4$var$Events(ctx) {
    var evs = {};
    var rv = function(eventName, subscriber) {
        if (subscriber) {
            var i = arguments.length, args = new Array(i - 1);
            while(--i)args[i - 1] = arguments[i];
            evs[eventName].subscribe.apply(null, args);
            return ctx;
        } else if (typeof eventName === 'string') return evs[eventName];
    };
    rv.addEventType = add;
    for(var i = 1, l = arguments.length; i < l; ++i)add(arguments[i]);
    return rv;
    function add(eventName, chainFunction, defaultFunction) {
        if (typeof eventName === 'object') return addConfiguredEvents(eventName);
        if (!chainFunction) chainFunction = $786a5f856536c5d4$var$reverseStoppableEventChain;
        if (!defaultFunction) defaultFunction = $786a5f856536c5d4$var$nop;
        var context = {
            subscribers: [],
            fire: defaultFunction,
            subscribe: function(cb) {
                if (context.subscribers.indexOf(cb) === -1) {
                    context.subscribers.push(cb);
                    context.fire = chainFunction(context.fire, cb);
                }
            },
            unsubscribe: function(cb) {
                context.subscribers = context.subscribers.filter(function(fn) {
                    return fn !== cb;
                });
                context.fire = context.subscribers.reduce(chainFunction, defaultFunction);
            }
        };
        evs[eventName] = rv[eventName] = context;
        return context;
    }
    function addConfiguredEvents(cfg) {
        $786a5f856536c5d4$var$keys(cfg).forEach(function(eventName) {
            var args = cfg[eventName];
            if ($786a5f856536c5d4$var$isArray(args)) add(eventName, cfg[eventName][0], cfg[eventName][1]);
            else if (args === 'asap') var context = add(eventName, $786a5f856536c5d4$var$mirror, function fire() {
                var i = arguments.length, args = new Array(i);
                while(i--)args[i] = arguments[i];
                context.subscribers.forEach(function(fn) {
                    $786a5f856536c5d4$var$asap$1(function fireEvent() {
                        fn.apply(null, args);
                    });
                });
            });
            else throw new $786a5f856536c5d4$var$exceptions.InvalidArgument("Invalid event config");
        });
    }
}
function $786a5f856536c5d4$var$makeClassConstructor(prototype, constructor) {
    $786a5f856536c5d4$var$derive(constructor).from({
        prototype: prototype
    });
    return constructor;
}
function $786a5f856536c5d4$var$createTableConstructor(db) {
    return $786a5f856536c5d4$var$makeClassConstructor($786a5f856536c5d4$var$Table.prototype, function Table(name, tableSchema, trans) {
        this.db = db;
        this._tx = trans;
        this.name = name;
        this.schema = tableSchema;
        this.hook = db._allTables[name] ? db._allTables[name].hook : $786a5f856536c5d4$var$Events(null, {
            "creating": [
                $786a5f856536c5d4$var$hookCreatingChain,
                $786a5f856536c5d4$var$nop
            ],
            "reading": [
                $786a5f856536c5d4$var$pureFunctionChain,
                $786a5f856536c5d4$var$mirror
            ],
            "updating": [
                $786a5f856536c5d4$var$hookUpdatingChain,
                $786a5f856536c5d4$var$nop
            ],
            "deleting": [
                $786a5f856536c5d4$var$hookDeletingChain,
                $786a5f856536c5d4$var$nop
            ]
        });
    });
}
function $786a5f856536c5d4$var$isPlainKeyRange(ctx, ignoreLimitFilter) {
    return !(ctx.filter || ctx.algorithm || ctx.or) && (ignoreLimitFilter ? ctx.justLimit : !ctx.replayFilter);
}
function $786a5f856536c5d4$var$addFilter(ctx, fn) {
    ctx.filter = $786a5f856536c5d4$var$combine(ctx.filter, fn);
}
function $786a5f856536c5d4$var$addReplayFilter(ctx, factory, isLimitFilter) {
    var curr = ctx.replayFilter;
    ctx.replayFilter = curr ? function() {
        return $786a5f856536c5d4$var$combine(curr(), factory());
    } : factory;
    ctx.justLimit = isLimitFilter && !curr;
}
function $786a5f856536c5d4$var$addMatchFilter(ctx, fn) {
    ctx.isMatch = $786a5f856536c5d4$var$combine(ctx.isMatch, fn);
}
function $786a5f856536c5d4$var$getIndexOrStore(ctx, coreSchema) {
    if (ctx.isPrimKey) return coreSchema.primaryKey;
    var index = coreSchema.getIndexByKeyPath(ctx.index);
    if (!index) throw new $786a5f856536c5d4$var$exceptions.Schema("KeyPath " + ctx.index + " on object store " + coreSchema.name + " is not indexed");
    return index;
}
function $786a5f856536c5d4$var$openCursor(ctx, coreTable, trans) {
    var index = $786a5f856536c5d4$var$getIndexOrStore(ctx, coreTable.schema);
    return coreTable.openCursor({
        trans: trans,
        values: !ctx.keysOnly,
        reverse: ctx.dir === 'prev',
        unique: !!ctx.unique,
        query: {
            index: index,
            range: ctx.range
        }
    });
}
function $786a5f856536c5d4$var$iter(ctx, fn, coreTrans, coreTable) {
    var filter = ctx.replayFilter ? $786a5f856536c5d4$var$combine(ctx.filter, ctx.replayFilter()) : ctx.filter;
    if (!ctx.or) return $786a5f856536c5d4$var$iterate($786a5f856536c5d4$var$openCursor(ctx, coreTable, coreTrans), $786a5f856536c5d4$var$combine(ctx.algorithm, filter), fn, !ctx.keysOnly && ctx.valueMapper);
    else {
        var set_1 = {};
        var union = function(item, cursor, advance) {
            if (!filter || filter(cursor, advance, function(result) {
                return cursor.stop(result);
            }, function(err) {
                return cursor.fail(err);
            })) {
                var primaryKey = cursor.primaryKey;
                var key = '' + primaryKey;
                if (key === '[object ArrayBuffer]') key = '' + new Uint8Array(primaryKey);
                if (!$786a5f856536c5d4$var$hasOwn(set_1, key)) {
                    set_1[key] = true;
                    fn(item, cursor, advance);
                }
            }
        };
        return Promise.all([
            ctx.or._iterate(union, coreTrans),
            $786a5f856536c5d4$var$iterate($786a5f856536c5d4$var$openCursor(ctx, coreTable, coreTrans), ctx.algorithm, union, !ctx.keysOnly && ctx.valueMapper)
        ]);
    }
}
function $786a5f856536c5d4$var$iterate(cursorPromise, filter, fn, valueMapper) {
    var mappedFn = valueMapper ? function(x, c, a) {
        return fn(valueMapper(x), c, a);
    } : fn;
    var wrappedFn = $786a5f856536c5d4$var$wrap(mappedFn);
    return cursorPromise.then(function(cursor) {
        if (cursor) return cursor.start(function() {
            var c = function() {
                return cursor.continue();
            };
            if (!filter || filter(cursor, function(advancer) {
                return c = advancer;
            }, function(val) {
                cursor.stop(val);
                c = $786a5f856536c5d4$var$nop;
            }, function(e) {
                cursor.fail(e);
                c = $786a5f856536c5d4$var$nop;
            })) wrappedFn(cursor.value, cursor, function(advancer) {
                return c = advancer;
            });
            c();
        });
    });
}
var $786a5f856536c5d4$var$Collection = function() {
    function Collection() {}
    Collection.prototype._read = function(fn, cb) {
        var ctx = this._ctx;
        return ctx.error ? ctx.table._trans(null, $786a5f856536c5d4$var$rejection.bind(null, ctx.error)) : ctx.table._trans('readonly', fn).then(cb);
    };
    Collection.prototype._write = function(fn) {
        var ctx = this._ctx;
        return ctx.error ? ctx.table._trans(null, $786a5f856536c5d4$var$rejection.bind(null, ctx.error)) : ctx.table._trans('readwrite', fn, "locked");
    };
    Collection.prototype._addAlgorithm = function(fn) {
        var ctx = this._ctx;
        ctx.algorithm = $786a5f856536c5d4$var$combine(ctx.algorithm, fn);
    };
    Collection.prototype._iterate = function(fn, coreTrans) {
        return $786a5f856536c5d4$var$iter(this._ctx, fn, coreTrans, this._ctx.table.core);
    };
    Collection.prototype.clone = function(props) {
        var rv = Object.create(this.constructor.prototype), ctx = Object.create(this._ctx);
        if (props) $786a5f856536c5d4$var$extend(ctx, props);
        rv._ctx = ctx;
        return rv;
    };
    Collection.prototype.raw = function() {
        this._ctx.valueMapper = null;
        return this;
    };
    Collection.prototype.each = function(fn) {
        var ctx = this._ctx;
        return this._read(function(trans) {
            return $786a5f856536c5d4$var$iter(ctx, fn, trans, ctx.table.core);
        });
    };
    Collection.prototype.count = function(cb) {
        var _this = this;
        return this._read(function(trans) {
            var ctx = _this._ctx;
            var coreTable = ctx.table.core;
            if ($786a5f856536c5d4$var$isPlainKeyRange(ctx, true)) return coreTable.count({
                trans: trans,
                query: {
                    index: $786a5f856536c5d4$var$getIndexOrStore(ctx, coreTable.schema),
                    range: ctx.range
                }
            }).then(function(count) {
                return Math.min(count, ctx.limit);
            });
            else {
                var count = 0;
                return $786a5f856536c5d4$var$iter(ctx, function() {
                    ++count;
                    return false;
                }, trans, coreTable).then(function() {
                    return count;
                });
            }
        }).then(cb);
    };
    Collection.prototype.sortBy = function(keyPath, cb) {
        var parts = keyPath.split('.').reverse(), lastPart = parts[0], lastIndex = parts.length - 1;
        function getval(obj, i) {
            if (i) return getval(obj[parts[i]], i - 1);
            return obj[lastPart];
        }
        var order = this._ctx.dir === "next" ? 1 : -1;
        function sorter(a, b) {
            var aVal = getval(a, lastIndex), bVal = getval(b, lastIndex);
            return $786a5f856536c5d4$export$6154dcdb7d23e37b(aVal, bVal) * order;
        }
        return this.toArray(function(a) {
            return a.sort(sorter);
        }).then(cb);
    };
    Collection.prototype.toArray = function(cb) {
        var _this = this;
        return this._read(function(trans) {
            var ctx = _this._ctx;
            if (ctx.dir === 'next' && $786a5f856536c5d4$var$isPlainKeyRange(ctx, true) && ctx.limit > 0) {
                var valueMapper_1 = ctx.valueMapper;
                var index = $786a5f856536c5d4$var$getIndexOrStore(ctx, ctx.table.core.schema);
                return ctx.table.core.query({
                    trans: trans,
                    limit: ctx.limit,
                    values: true,
                    query: {
                        index: index,
                        range: ctx.range
                    }
                }).then(function(_a) {
                    var result = _a.result;
                    return valueMapper_1 ? result.map(valueMapper_1) : result;
                });
            } else {
                var a_1 = [];
                return $786a5f856536c5d4$var$iter(ctx, function(item) {
                    return a_1.push(item);
                }, trans, ctx.table.core).then(function() {
                    return a_1;
                });
            }
        }, cb);
    };
    Collection.prototype.offset = function(offset) {
        var ctx = this._ctx;
        if (offset <= 0) return this;
        ctx.offset += offset;
        if ($786a5f856536c5d4$var$isPlainKeyRange(ctx)) $786a5f856536c5d4$var$addReplayFilter(ctx, function() {
            var offsetLeft = offset;
            return function(cursor, advance) {
                if (offsetLeft === 0) return true;
                if (offsetLeft === 1) {
                    --offsetLeft;
                    return false;
                }
                advance(function() {
                    cursor.advance(offsetLeft);
                    offsetLeft = 0;
                });
                return false;
            };
        });
        else $786a5f856536c5d4$var$addReplayFilter(ctx, function() {
            var offsetLeft = offset;
            return function() {
                return --offsetLeft < 0;
            };
        });
        return this;
    };
    Collection.prototype.limit = function(numRows) {
        this._ctx.limit = Math.min(this._ctx.limit, numRows);
        $786a5f856536c5d4$var$addReplayFilter(this._ctx, function() {
            var rowsLeft = numRows;
            return function(cursor, advance, resolve) {
                if (--rowsLeft <= 0) advance(resolve);
                return rowsLeft >= 0;
            };
        }, true);
        return this;
    };
    Collection.prototype.until = function(filterFunction, bIncludeStopEntry) {
        $786a5f856536c5d4$var$addFilter(this._ctx, function(cursor, advance, resolve) {
            if (filterFunction(cursor.value)) {
                advance(resolve);
                return bIncludeStopEntry;
            } else return true;
        });
        return this;
    };
    Collection.prototype.first = function(cb) {
        return this.limit(1).toArray(function(a) {
            return a[0];
        }).then(cb);
    };
    Collection.prototype.last = function(cb) {
        return this.reverse().first(cb);
    };
    Collection.prototype.filter = function(filterFunction) {
        $786a5f856536c5d4$var$addFilter(this._ctx, function(cursor) {
            return filterFunction(cursor.value);
        });
        $786a5f856536c5d4$var$addMatchFilter(this._ctx, filterFunction);
        return this;
    };
    Collection.prototype.and = function(filter) {
        return this.filter(filter);
    };
    Collection.prototype.or = function(indexName) {
        return new this.db.WhereClause(this._ctx.table, indexName, this);
    };
    Collection.prototype.reverse = function() {
        this._ctx.dir = this._ctx.dir === "prev" ? "next" : "prev";
        if (this._ondirectionchange) this._ondirectionchange(this._ctx.dir);
        return this;
    };
    Collection.prototype.desc = function() {
        return this.reverse();
    };
    Collection.prototype.eachKey = function(cb) {
        var ctx = this._ctx;
        ctx.keysOnly = !ctx.isMatch;
        return this.each(function(val, cursor) {
            cb(cursor.key, cursor);
        });
    };
    Collection.prototype.eachUniqueKey = function(cb) {
        this._ctx.unique = "unique";
        return this.eachKey(cb);
    };
    Collection.prototype.eachPrimaryKey = function(cb) {
        var ctx = this._ctx;
        ctx.keysOnly = !ctx.isMatch;
        return this.each(function(val, cursor) {
            cb(cursor.primaryKey, cursor);
        });
    };
    Collection.prototype.keys = function(cb) {
        var ctx = this._ctx;
        ctx.keysOnly = !ctx.isMatch;
        var a = [];
        return this.each(function(item, cursor) {
            a.push(cursor.key);
        }).then(function() {
            return a;
        }).then(cb);
    };
    Collection.prototype.primaryKeys = function(cb) {
        var ctx = this._ctx;
        if (ctx.dir === 'next' && $786a5f856536c5d4$var$isPlainKeyRange(ctx, true) && ctx.limit > 0) return this._read(function(trans) {
            var index = $786a5f856536c5d4$var$getIndexOrStore(ctx, ctx.table.core.schema);
            return ctx.table.core.query({
                trans: trans,
                values: false,
                limit: ctx.limit,
                query: {
                    index: index,
                    range: ctx.range
                }
            });
        }).then(function(_a) {
            var result = _a.result;
            return result;
        }).then(cb);
        ctx.keysOnly = !ctx.isMatch;
        var a = [];
        return this.each(function(item, cursor) {
            a.push(cursor.primaryKey);
        }).then(function() {
            return a;
        }).then(cb);
    };
    Collection.prototype.uniqueKeys = function(cb) {
        this._ctx.unique = "unique";
        return this.keys(cb);
    };
    Collection.prototype.firstKey = function(cb) {
        return this.limit(1).keys(function(a) {
            return a[0];
        }).then(cb);
    };
    Collection.prototype.lastKey = function(cb) {
        return this.reverse().firstKey(cb);
    };
    Collection.prototype.distinct = function() {
        var ctx = this._ctx, idx = ctx.index && ctx.table.schema.idxByName[ctx.index];
        if (!idx || !idx.multi) return this;
        var set = {};
        $786a5f856536c5d4$var$addFilter(this._ctx, function(cursor) {
            var strKey = cursor.primaryKey.toString();
            var found = $786a5f856536c5d4$var$hasOwn(set, strKey);
            set[strKey] = true;
            return !found;
        });
        return this;
    };
    Collection.prototype.modify = function(changes) {
        var _this = this;
        var ctx = this._ctx;
        return this._write(function(trans) {
            var modifyer;
            if (typeof changes === 'function') modifyer = changes;
            else modifyer = function(item) {
                return $786a5f856536c5d4$var$applyUpdateSpec(item, changes);
            };
            var coreTable = ctx.table.core;
            var _a = coreTable.schema.primaryKey, outbound = _a.outbound, extractKey = _a.extractKey;
            var limit = 200;
            var modifyChunkSize = _this.db._options.modifyChunkSize;
            if (modifyChunkSize) {
                if (typeof modifyChunkSize == 'object') limit = modifyChunkSize[coreTable.name] || modifyChunkSize['*'] || 200;
                else limit = modifyChunkSize;
            }
            var totalFailures = [];
            var successCount = 0;
            var failedKeys = [];
            var applyMutateResult = function(expectedCount, res) {
                var failures = res.failures, numFailures = res.numFailures;
                successCount += expectedCount - numFailures;
                for(var _i = 0, _a = $786a5f856536c5d4$var$keys(failures); _i < _a.length; _i++){
                    var pos = _a[_i];
                    totalFailures.push(failures[pos]);
                }
            };
            var isUnconditionalDelete = changes === $786a5f856536c5d4$var$deleteCallback;
            return _this.clone().primaryKeys().then(function(keys) {
                var criteria = $786a5f856536c5d4$var$isPlainKeyRange(ctx) && ctx.limit === Infinity && (typeof changes !== 'function' || isUnconditionalDelete) && {
                    index: ctx.index,
                    range: ctx.range
                };
                var nextChunk = function(offset) {
                    var count = Math.min(limit, keys.length - offset);
                    var keysInChunk = keys.slice(offset, offset + count);
                    return (isUnconditionalDelete ? Promise.resolve([]) : coreTable.getMany({
                        trans: trans,
                        keys: keysInChunk,
                        cache: "immutable"
                    })).then(function(values) {
                        var addValues = [];
                        var putValues = [];
                        var putKeys = outbound ? [] : null;
                        var deleteKeys = isUnconditionalDelete ? keysInChunk : [];
                        if (!isUnconditionalDelete) for(var i = 0; i < count; ++i){
                            var origValue = values[i];
                            var ctx_1 = {
                                value: $786a5f856536c5d4$var$deepClone(origValue),
                                primKey: keys[offset + i]
                            };
                            if (modifyer.call(ctx_1, ctx_1.value, ctx_1) !== false) {
                                if (ctx_1.value == null) deleteKeys.push(keys[offset + i]);
                                else if (!outbound && $786a5f856536c5d4$export$6154dcdb7d23e37b(extractKey(origValue), extractKey(ctx_1.value)) !== 0) {
                                    deleteKeys.push(keys[offset + i]);
                                    addValues.push(ctx_1.value);
                                } else {
                                    putValues.push(ctx_1.value);
                                    if (outbound) putKeys.push(keys[offset + i]);
                                }
                            }
                        }
                        return Promise.resolve(addValues.length > 0 && coreTable.mutate({
                            trans: trans,
                            type: 'add',
                            values: addValues
                        }).then(function(res) {
                            for(var pos in res.failures)deleteKeys.splice(parseInt(pos), 1);
                            applyMutateResult(addValues.length, res);
                        })).then(function() {
                            return (putValues.length > 0 || criteria && typeof changes === 'object') && coreTable.mutate({
                                trans: trans,
                                type: 'put',
                                keys: putKeys,
                                values: putValues,
                                criteria: criteria,
                                changeSpec: typeof changes !== 'function' && changes,
                                isAdditionalChunk: offset > 0
                            }).then(function(res) {
                                return applyMutateResult(putValues.length, res);
                            });
                        }).then(function() {
                            return (deleteKeys.length > 0 || criteria && isUnconditionalDelete) && coreTable.mutate({
                                trans: trans,
                                type: 'delete',
                                keys: deleteKeys,
                                criteria: criteria,
                                isAdditionalChunk: offset > 0
                            }).then(function(res) {
                                return $786a5f856536c5d4$var$builtInDeletionTrigger(ctx.table, deleteKeys, res);
                            }).then(function(res) {
                                return applyMutateResult(deleteKeys.length, res);
                            });
                        }).then(function() {
                            return keys.length > offset + count && nextChunk(offset + limit);
                        });
                    });
                };
                return nextChunk(0).then(function() {
                    if (totalFailures.length > 0) throw new $786a5f856536c5d4$var$ModifyError("Error modifying one or more objects", totalFailures, successCount, failedKeys);
                    return keys.length;
                });
            });
        });
    };
    Collection.prototype.delete = function() {
        var ctx = this._ctx, range = ctx.range;
        if ($786a5f856536c5d4$var$isPlainKeyRange(ctx) && !ctx.table.schema.yProps && (ctx.isPrimKey || range.type === 3)) return this._write(function(trans) {
            var primaryKey = ctx.table.core.schema.primaryKey;
            var coreRange = range;
            return ctx.table.core.count({
                trans: trans,
                query: {
                    index: primaryKey,
                    range: coreRange
                }
            }).then(function(count) {
                return ctx.table.core.mutate({
                    trans: trans,
                    type: 'deleteRange',
                    range: coreRange
                }).then(function(_a) {
                    var failures = _a.failures, numFailures = _a.numFailures;
                    if (numFailures) throw new $786a5f856536c5d4$var$ModifyError("Could not delete some values", Object.keys(failures).map(function(pos) {
                        return failures[pos];
                    }), count - numFailures);
                    return count - numFailures;
                });
            });
        });
        return this.modify($786a5f856536c5d4$var$deleteCallback);
    };
    return Collection;
}();
var $786a5f856536c5d4$var$deleteCallback = function(value, ctx) {
    return ctx.value = null;
};
function $786a5f856536c5d4$var$createCollectionConstructor(db) {
    return $786a5f856536c5d4$var$makeClassConstructor($786a5f856536c5d4$var$Collection.prototype, function Collection(whereClause, keyRangeGenerator) {
        this.db = db;
        var keyRange = $786a5f856536c5d4$var$AnyRange, error = null;
        if (keyRangeGenerator) try {
            keyRange = keyRangeGenerator();
        } catch (ex) {
            error = ex;
        }
        var whereCtx = whereClause._ctx;
        var table = whereCtx.table;
        var readingHook = table.hook.reading.fire;
        this._ctx = {
            table: table,
            index: whereCtx.index,
            isPrimKey: !whereCtx.index || table.schema.primKey.keyPath && whereCtx.index === table.schema.primKey.name,
            range: keyRange,
            keysOnly: false,
            dir: "next",
            unique: "",
            algorithm: null,
            filter: null,
            replayFilter: null,
            justLimit: true,
            isMatch: null,
            offset: 0,
            limit: Infinity,
            error: error,
            or: whereCtx.or,
            valueMapper: readingHook !== $786a5f856536c5d4$var$mirror ? readingHook : null
        };
    });
}
function $786a5f856536c5d4$var$simpleCompare(a, b) {
    return a < b ? -1 : a === b ? 0 : 1;
}
function $786a5f856536c5d4$var$simpleCompareReverse(a, b) {
    return a > b ? -1 : a === b ? 0 : 1;
}
function $786a5f856536c5d4$var$fail(collectionOrWhereClause, err, T) {
    var collection = collectionOrWhereClause instanceof $786a5f856536c5d4$var$WhereClause ? new collectionOrWhereClause.Collection(collectionOrWhereClause) : collectionOrWhereClause;
    collection._ctx.error = T ? new T(err) : new TypeError(err);
    return collection;
}
function $786a5f856536c5d4$var$emptyCollection(whereClause) {
    return new whereClause.Collection(whereClause, function() {
        return $786a5f856536c5d4$var$rangeEqual("");
    }).limit(0);
}
function $786a5f856536c5d4$var$upperFactory(dir) {
    return dir === "next" ? function(s) {
        return s.toUpperCase();
    } : function(s) {
        return s.toLowerCase();
    };
}
function $786a5f856536c5d4$var$lowerFactory(dir) {
    return dir === "next" ? function(s) {
        return s.toLowerCase();
    } : function(s) {
        return s.toUpperCase();
    };
}
function $786a5f856536c5d4$var$nextCasing(key, lowerKey, upperNeedle, lowerNeedle, cmp, dir) {
    var length = Math.min(key.length, lowerNeedle.length);
    var llp = -1;
    for(var i = 0; i < length; ++i){
        var lwrKeyChar = lowerKey[i];
        if (lwrKeyChar !== lowerNeedle[i]) {
            if (cmp(key[i], upperNeedle[i]) < 0) return key.substr(0, i) + upperNeedle[i] + upperNeedle.substr(i + 1);
            if (cmp(key[i], lowerNeedle[i]) < 0) return key.substr(0, i) + lowerNeedle[i] + upperNeedle.substr(i + 1);
            if (llp >= 0) return key.substr(0, llp) + lowerKey[llp] + upperNeedle.substr(llp + 1);
            return null;
        }
        if (cmp(key[i], lwrKeyChar) < 0) llp = i;
    }
    if (length < lowerNeedle.length && dir === "next") return key + upperNeedle.substr(key.length);
    if (length < key.length && dir === "prev") return key.substr(0, upperNeedle.length);
    return llp < 0 ? null : key.substr(0, llp) + lowerNeedle[llp] + upperNeedle.substr(llp + 1);
}
function $786a5f856536c5d4$var$addIgnoreCaseAlgorithm(whereClause, match, needles, suffix) {
    var upper, lower, compare, upperNeedles, lowerNeedles, direction, nextKeySuffix, needlesLen = needles.length;
    if (!needles.every(function(s) {
        return typeof s === 'string';
    })) return $786a5f856536c5d4$var$fail(whereClause, $786a5f856536c5d4$var$STRING_EXPECTED);
    function initDirection(dir) {
        upper = $786a5f856536c5d4$var$upperFactory(dir);
        lower = $786a5f856536c5d4$var$lowerFactory(dir);
        compare = dir === "next" ? $786a5f856536c5d4$var$simpleCompare : $786a5f856536c5d4$var$simpleCompareReverse;
        var needleBounds = needles.map(function(needle) {
            return {
                lower: lower(needle),
                upper: upper(needle)
            };
        }).sort(function(a, b) {
            return compare(a.lower, b.lower);
        });
        upperNeedles = needleBounds.map(function(nb) {
            return nb.upper;
        });
        lowerNeedles = needleBounds.map(function(nb) {
            return nb.lower;
        });
        direction = dir;
        nextKeySuffix = dir === "next" ? "" : suffix;
    }
    initDirection("next");
    var c = new whereClause.Collection(whereClause, function() {
        return $786a5f856536c5d4$var$createRange(upperNeedles[0], lowerNeedles[needlesLen - 1] + suffix);
    });
    c._ondirectionchange = function(direction) {
        initDirection(direction);
    };
    var firstPossibleNeedle = 0;
    c._addAlgorithm(function(cursor, advance, resolve) {
        var key = cursor.key;
        if (typeof key !== 'string') return false;
        var lowerKey = lower(key);
        if (match(lowerKey, lowerNeedles, firstPossibleNeedle)) return true;
        else {
            var lowestPossibleCasing = null;
            for(var i = firstPossibleNeedle; i < needlesLen; ++i){
                var casing = $786a5f856536c5d4$var$nextCasing(key, lowerKey, upperNeedles[i], lowerNeedles[i], compare, direction);
                if (casing === null && lowestPossibleCasing === null) firstPossibleNeedle = i + 1;
                else if (lowestPossibleCasing === null || compare(lowestPossibleCasing, casing) > 0) lowestPossibleCasing = casing;
            }
            if (lowestPossibleCasing !== null) advance(function() {
                cursor.continue(lowestPossibleCasing + nextKeySuffix);
            });
            else advance(resolve);
            return false;
        }
    });
    return c;
}
function $786a5f856536c5d4$var$createRange(lower, upper, lowerOpen, upperOpen) {
    return {
        type: 2,
        lower: lower,
        upper: upper,
        lowerOpen: lowerOpen,
        upperOpen: upperOpen
    };
}
function $786a5f856536c5d4$var$rangeEqual(value) {
    return {
        type: 1,
        lower: value,
        upper: value
    };
}
var $786a5f856536c5d4$var$WhereClause = function() {
    function WhereClause() {}
    Object.defineProperty(WhereClause.prototype, "Collection", {
        get: function() {
            return this._ctx.table.db.Collection;
        },
        enumerable: false,
        configurable: true
    });
    WhereClause.prototype.between = function(lower, upper, includeLower, includeUpper) {
        includeLower = includeLower !== false;
        includeUpper = includeUpper === true;
        try {
            if (this._cmp(lower, upper) > 0 || this._cmp(lower, upper) === 0 && (includeLower || includeUpper) && !(includeLower && includeUpper)) return $786a5f856536c5d4$var$emptyCollection(this);
            return new this.Collection(this, function() {
                return $786a5f856536c5d4$var$createRange(lower, upper, !includeLower, !includeUpper);
            });
        } catch (e) {
            return $786a5f856536c5d4$var$fail(this, $786a5f856536c5d4$var$INVALID_KEY_ARGUMENT);
        }
    };
    WhereClause.prototype.equals = function(value) {
        if (value == null) return $786a5f856536c5d4$var$fail(this, $786a5f856536c5d4$var$INVALID_KEY_ARGUMENT);
        return new this.Collection(this, function() {
            return $786a5f856536c5d4$var$rangeEqual(value);
        });
    };
    WhereClause.prototype.above = function(value) {
        if (value == null) return $786a5f856536c5d4$var$fail(this, $786a5f856536c5d4$var$INVALID_KEY_ARGUMENT);
        return new this.Collection(this, function() {
            return $786a5f856536c5d4$var$createRange(value, undefined, true);
        });
    };
    WhereClause.prototype.aboveOrEqual = function(value) {
        if (value == null) return $786a5f856536c5d4$var$fail(this, $786a5f856536c5d4$var$INVALID_KEY_ARGUMENT);
        return new this.Collection(this, function() {
            return $786a5f856536c5d4$var$createRange(value, undefined, false);
        });
    };
    WhereClause.prototype.below = function(value) {
        if (value == null) return $786a5f856536c5d4$var$fail(this, $786a5f856536c5d4$var$INVALID_KEY_ARGUMENT);
        return new this.Collection(this, function() {
            return $786a5f856536c5d4$var$createRange(undefined, value, false, true);
        });
    };
    WhereClause.prototype.belowOrEqual = function(value) {
        if (value == null) return $786a5f856536c5d4$var$fail(this, $786a5f856536c5d4$var$INVALID_KEY_ARGUMENT);
        return new this.Collection(this, function() {
            return $786a5f856536c5d4$var$createRange(undefined, value);
        });
    };
    WhereClause.prototype.startsWith = function(str) {
        if (typeof str !== 'string') return $786a5f856536c5d4$var$fail(this, $786a5f856536c5d4$var$STRING_EXPECTED);
        return this.between(str, str + $786a5f856536c5d4$var$maxString, true, true);
    };
    WhereClause.prototype.startsWithIgnoreCase = function(str) {
        if (str === "") return this.startsWith(str);
        return $786a5f856536c5d4$var$addIgnoreCaseAlgorithm(this, function(x, a) {
            return x.indexOf(a[0]) === 0;
        }, [
            str
        ], $786a5f856536c5d4$var$maxString);
    };
    WhereClause.prototype.equalsIgnoreCase = function(str) {
        return $786a5f856536c5d4$var$addIgnoreCaseAlgorithm(this, function(x, a) {
            return x === a[0];
        }, [
            str
        ], "");
    };
    WhereClause.prototype.anyOfIgnoreCase = function() {
        var set = $786a5f856536c5d4$var$getArrayOf.apply($786a5f856536c5d4$var$NO_CHAR_ARRAY, arguments);
        if (set.length === 0) return $786a5f856536c5d4$var$emptyCollection(this);
        return $786a5f856536c5d4$var$addIgnoreCaseAlgorithm(this, function(x, a) {
            return a.indexOf(x) !== -1;
        }, set, "");
    };
    WhereClause.prototype.startsWithAnyOfIgnoreCase = function() {
        var set = $786a5f856536c5d4$var$getArrayOf.apply($786a5f856536c5d4$var$NO_CHAR_ARRAY, arguments);
        if (set.length === 0) return $786a5f856536c5d4$var$emptyCollection(this);
        return $786a5f856536c5d4$var$addIgnoreCaseAlgorithm(this, function(x, a) {
            return a.some(function(n) {
                return x.indexOf(n) === 0;
            });
        }, set, $786a5f856536c5d4$var$maxString);
    };
    WhereClause.prototype.anyOf = function() {
        var _this = this;
        var set = $786a5f856536c5d4$var$getArrayOf.apply($786a5f856536c5d4$var$NO_CHAR_ARRAY, arguments);
        var compare = this._cmp;
        try {
            set.sort(compare);
        } catch (e) {
            return $786a5f856536c5d4$var$fail(this, $786a5f856536c5d4$var$INVALID_KEY_ARGUMENT);
        }
        if (set.length === 0) return $786a5f856536c5d4$var$emptyCollection(this);
        var c = new this.Collection(this, function() {
            return $786a5f856536c5d4$var$createRange(set[0], set[set.length - 1]);
        });
        c._ondirectionchange = function(direction) {
            compare = direction === "next" ? _this._ascending : _this._descending;
            set.sort(compare);
        };
        var i = 0;
        c._addAlgorithm(function(cursor, advance, resolve) {
            var key = cursor.key;
            while(compare(key, set[i]) > 0){
                ++i;
                if (i === set.length) {
                    advance(resolve);
                    return false;
                }
            }
            if (compare(key, set[i]) === 0) return true;
            else {
                advance(function() {
                    cursor.continue(set[i]);
                });
                return false;
            }
        });
        return c;
    };
    WhereClause.prototype.notEqual = function(value) {
        return this.inAnyRange([
            [
                $786a5f856536c5d4$var$minKey,
                value
            ],
            [
                value,
                this.db._maxKey
            ]
        ], {
            includeLowers: false,
            includeUppers: false
        });
    };
    WhereClause.prototype.noneOf = function() {
        var set = $786a5f856536c5d4$var$getArrayOf.apply($786a5f856536c5d4$var$NO_CHAR_ARRAY, arguments);
        if (set.length === 0) return new this.Collection(this);
        try {
            set.sort(this._ascending);
        } catch (e) {
            return $786a5f856536c5d4$var$fail(this, $786a5f856536c5d4$var$INVALID_KEY_ARGUMENT);
        }
        var ranges = set.reduce(function(res, val) {
            return res ? res.concat([
                [
                    res[res.length - 1][1],
                    val
                ]
            ]) : [
                [
                    $786a5f856536c5d4$var$minKey,
                    val
                ]
            ];
        }, null);
        ranges.push([
            set[set.length - 1],
            this.db._maxKey
        ]);
        return this.inAnyRange(ranges, {
            includeLowers: false,
            includeUppers: false
        });
    };
    WhereClause.prototype.inAnyRange = function(ranges, options) {
        var _this = this;
        var cmp = this._cmp, ascending = this._ascending, descending = this._descending, min = this._min, max = this._max;
        if (ranges.length === 0) return $786a5f856536c5d4$var$emptyCollection(this);
        if (!ranges.every(function(range) {
            return range[0] !== undefined && range[1] !== undefined && ascending(range[0], range[1]) <= 0;
        })) return $786a5f856536c5d4$var$fail(this, "First argument to inAnyRange() must be an Array of two-value Arrays [lower,upper] where upper must not be lower than lower", $786a5f856536c5d4$var$exceptions.InvalidArgument);
        var includeLowers = !options || options.includeLowers !== false;
        var includeUppers = options && options.includeUppers === true;
        function addRange(ranges, newRange) {
            var i = 0, l = ranges.length;
            for(; i < l; ++i){
                var range = ranges[i];
                if (cmp(newRange[0], range[1]) < 0 && cmp(newRange[1], range[0]) > 0) {
                    range[0] = min(range[0], newRange[0]);
                    range[1] = max(range[1], newRange[1]);
                    break;
                }
            }
            if (i === l) ranges.push(newRange);
            return ranges;
        }
        var sortDirection = ascending;
        function rangeSorter(a, b) {
            return sortDirection(a[0], b[0]);
        }
        var set;
        try {
            set = ranges.reduce(addRange, []);
            set.sort(rangeSorter);
        } catch (ex) {
            return $786a5f856536c5d4$var$fail(this, $786a5f856536c5d4$var$INVALID_KEY_ARGUMENT);
        }
        var rangePos = 0;
        var keyIsBeyondCurrentEntry = includeUppers ? function(key) {
            return ascending(key, set[rangePos][1]) > 0;
        } : function(key) {
            return ascending(key, set[rangePos][1]) >= 0;
        };
        var keyIsBeforeCurrentEntry = includeLowers ? function(key) {
            return descending(key, set[rangePos][0]) > 0;
        } : function(key) {
            return descending(key, set[rangePos][0]) >= 0;
        };
        function keyWithinCurrentRange(key) {
            return !keyIsBeyondCurrentEntry(key) && !keyIsBeforeCurrentEntry(key);
        }
        var checkKey = keyIsBeyondCurrentEntry;
        var c = new this.Collection(this, function() {
            return $786a5f856536c5d4$var$createRange(set[0][0], set[set.length - 1][1], !includeLowers, !includeUppers);
        });
        c._ondirectionchange = function(direction) {
            if (direction === "next") {
                checkKey = keyIsBeyondCurrentEntry;
                sortDirection = ascending;
            } else {
                checkKey = keyIsBeforeCurrentEntry;
                sortDirection = descending;
            }
            set.sort(rangeSorter);
        };
        c._addAlgorithm(function(cursor, advance, resolve) {
            var key = cursor.key;
            while(checkKey(key)){
                ++rangePos;
                if (rangePos === set.length) {
                    advance(resolve);
                    return false;
                }
            }
            if (keyWithinCurrentRange(key)) return true;
            else if (_this._cmp(key, set[rangePos][1]) === 0 || _this._cmp(key, set[rangePos][0]) === 0) return false;
            else {
                advance(function() {
                    if (sortDirection === ascending) cursor.continue(set[rangePos][0]);
                    else cursor.continue(set[rangePos][1]);
                });
                return false;
            }
        });
        return c;
    };
    WhereClause.prototype.startsWithAnyOf = function() {
        var set = $786a5f856536c5d4$var$getArrayOf.apply($786a5f856536c5d4$var$NO_CHAR_ARRAY, arguments);
        if (!set.every(function(s) {
            return typeof s === 'string';
        })) return $786a5f856536c5d4$var$fail(this, "startsWithAnyOf() only works with strings");
        if (set.length === 0) return $786a5f856536c5d4$var$emptyCollection(this);
        return this.inAnyRange(set.map(function(str) {
            return [
                str,
                str + $786a5f856536c5d4$var$maxString
            ];
        }));
    };
    return WhereClause;
}();
function $786a5f856536c5d4$var$createWhereClauseConstructor(db) {
    return $786a5f856536c5d4$var$makeClassConstructor($786a5f856536c5d4$var$WhereClause.prototype, function WhereClause(table, index, orCollection) {
        this.db = db;
        this._ctx = {
            table: table,
            index: index === ":id" ? null : index,
            or: orCollection
        };
        this._cmp = this._ascending = $786a5f856536c5d4$export$6154dcdb7d23e37b;
        this._descending = function(a, b) {
            return $786a5f856536c5d4$export$6154dcdb7d23e37b(b, a);
        };
        this._max = function(a, b) {
            return $786a5f856536c5d4$export$6154dcdb7d23e37b(a, b) > 0 ? a : b;
        };
        this._min = function(a, b) {
            return $786a5f856536c5d4$export$6154dcdb7d23e37b(a, b) < 0 ? a : b;
        };
        this._IDBKeyRange = db._deps.IDBKeyRange;
        if (!this._IDBKeyRange) throw new $786a5f856536c5d4$var$exceptions.MissingAPI();
    });
}
function $786a5f856536c5d4$var$eventRejectHandler(reject) {
    return $786a5f856536c5d4$var$wrap(function(event) {
        $786a5f856536c5d4$var$preventDefault(event);
        reject(event.target.error);
        return false;
    });
}
function $786a5f856536c5d4$var$preventDefault(event) {
    if (event.stopPropagation) event.stopPropagation();
    if (event.preventDefault) event.preventDefault();
}
var $786a5f856536c5d4$var$DEXIE_STORAGE_MUTATED_EVENT_NAME = 'storagemutated';
var $786a5f856536c5d4$var$STORAGE_MUTATED_DOM_EVENT_NAME = 'x-storagemutated-1';
var $786a5f856536c5d4$var$globalEvents = $786a5f856536c5d4$var$Events(null, $786a5f856536c5d4$var$DEXIE_STORAGE_MUTATED_EVENT_NAME);
var $786a5f856536c5d4$var$Transaction = function() {
    function Transaction() {}
    Transaction.prototype._lock = function() {
        $786a5f856536c5d4$var$assert(!$786a5f856536c5d4$var$PSD.global);
        ++this._reculock;
        if (this._reculock === 1 && !$786a5f856536c5d4$var$PSD.global) $786a5f856536c5d4$var$PSD.lockOwnerFor = this;
        return this;
    };
    Transaction.prototype._unlock = function() {
        $786a5f856536c5d4$var$assert(!$786a5f856536c5d4$var$PSD.global);
        if (--this._reculock === 0) {
            if (!$786a5f856536c5d4$var$PSD.global) $786a5f856536c5d4$var$PSD.lockOwnerFor = null;
            while(this._blockedFuncs.length > 0 && !this._locked()){
                var fnAndPSD = this._blockedFuncs.shift();
                try {
                    $786a5f856536c5d4$var$usePSD(fnAndPSD[1], fnAndPSD[0]);
                } catch (e) {}
            }
        }
        return this;
    };
    Transaction.prototype._locked = function() {
        return this._reculock && $786a5f856536c5d4$var$PSD.lockOwnerFor !== this;
    };
    Transaction.prototype.create = function(idbtrans) {
        var _this = this;
        if (!this.mode) return this;
        var idbdb = this.db.idbdb;
        var dbOpenError = this.db._state.dbOpenError;
        $786a5f856536c5d4$var$assert(!this.idbtrans);
        if (!idbtrans && !idbdb) switch(dbOpenError && dbOpenError.name){
            case "DatabaseClosedError":
                throw new $786a5f856536c5d4$var$exceptions.DatabaseClosed(dbOpenError);
            case "MissingAPIError":
                throw new $786a5f856536c5d4$var$exceptions.MissingAPI(dbOpenError.message, dbOpenError);
            default:
                throw new $786a5f856536c5d4$var$exceptions.OpenFailed(dbOpenError);
        }
        if (!this.active) throw new $786a5f856536c5d4$var$exceptions.TransactionInactive();
        $786a5f856536c5d4$var$assert(this._completion._state === null);
        idbtrans = this.idbtrans = idbtrans || (this.db.core ? this.db.core.transaction(this.storeNames, this.mode, {
            durability: this.chromeTransactionDurability
        }) : idbdb.transaction(this.storeNames, this.mode, {
            durability: this.chromeTransactionDurability
        }));
        idbtrans.onerror = $786a5f856536c5d4$var$wrap(function(ev) {
            $786a5f856536c5d4$var$preventDefault(ev);
            _this._reject(idbtrans.error);
        });
        idbtrans.onabort = $786a5f856536c5d4$var$wrap(function(ev) {
            $786a5f856536c5d4$var$preventDefault(ev);
            _this.active && _this._reject(new $786a5f856536c5d4$var$exceptions.Abort(idbtrans.error));
            _this.active = false;
            _this.on("abort").fire(ev);
        });
        idbtrans.oncomplete = $786a5f856536c5d4$var$wrap(function() {
            _this.active = false;
            _this._resolve();
            if ('mutatedParts' in idbtrans) $786a5f856536c5d4$var$globalEvents.storagemutated.fire(idbtrans["mutatedParts"]);
        });
        return this;
    };
    Transaction.prototype._promise = function(mode, fn, bWriteLock) {
        var _this = this;
        if (mode === 'readwrite' && this.mode !== 'readwrite') return $786a5f856536c5d4$var$rejection(new $786a5f856536c5d4$var$exceptions.ReadOnly("Transaction is readonly"));
        if (!this.active) return $786a5f856536c5d4$var$rejection(new $786a5f856536c5d4$var$exceptions.TransactionInactive());
        if (this._locked()) return new $786a5f856536c5d4$var$DexiePromise(function(resolve, reject) {
            _this._blockedFuncs.push([
                function() {
                    _this._promise(mode, fn, bWriteLock).then(resolve, reject);
                },
                $786a5f856536c5d4$var$PSD
            ]);
        });
        else if (bWriteLock) return $786a5f856536c5d4$var$newScope(function() {
            var p = new $786a5f856536c5d4$var$DexiePromise(function(resolve, reject) {
                _this._lock();
                var rv = fn(resolve, reject, _this);
                if (rv && rv.then) rv.then(resolve, reject);
            });
            p.finally(function() {
                return _this._unlock();
            });
            p._lib = true;
            return p;
        });
        else {
            var p = new $786a5f856536c5d4$var$DexiePromise(function(resolve, reject) {
                var rv = fn(resolve, reject, _this);
                if (rv && rv.then) rv.then(resolve, reject);
            });
            p._lib = true;
            return p;
        }
    };
    Transaction.prototype._root = function() {
        return this.parent ? this.parent._root() : this;
    };
    Transaction.prototype.waitFor = function(promiseLike) {
        var root = this._root();
        var promise = $786a5f856536c5d4$var$DexiePromise.resolve(promiseLike);
        if (root._waitingFor) root._waitingFor = root._waitingFor.then(function() {
            return promise;
        });
        else {
            root._waitingFor = promise;
            root._waitingQueue = [];
            var store = root.idbtrans.objectStore(root.storeNames[0]);
            (function spin() {
                ++root._spinCount;
                while(root._waitingQueue.length)root._waitingQueue.shift()();
                if (root._waitingFor) store.get(-Infinity).onsuccess = spin;
            })();
        }
        var currentWaitPromise = root._waitingFor;
        return new $786a5f856536c5d4$var$DexiePromise(function(resolve, reject) {
            promise.then(function(res) {
                return root._waitingQueue.push($786a5f856536c5d4$var$wrap(resolve.bind(null, res)));
            }, function(err) {
                return root._waitingQueue.push($786a5f856536c5d4$var$wrap(reject.bind(null, err)));
            }).finally(function() {
                if (root._waitingFor === currentWaitPromise) root._waitingFor = null;
            });
        });
    };
    Transaction.prototype.abort = function() {
        if (this.active) {
            this.active = false;
            if (this.idbtrans) this.idbtrans.abort();
            this._reject(new $786a5f856536c5d4$var$exceptions.Abort());
        }
    };
    Transaction.prototype.table = function(tableName) {
        var memoizedTables = this._memoizedTables || (this._memoizedTables = {});
        if ($786a5f856536c5d4$var$hasOwn(memoizedTables, tableName)) return memoizedTables[tableName];
        var tableSchema = this.schema[tableName];
        if (!tableSchema) throw new $786a5f856536c5d4$var$exceptions.NotFound("Table " + tableName + " not part of transaction");
        var transactionBoundTable = new this.db.Table(tableName, tableSchema, this);
        transactionBoundTable.core = this.db.core.table(tableName);
        memoizedTables[tableName] = transactionBoundTable;
        return transactionBoundTable;
    };
    return Transaction;
}();
function $786a5f856536c5d4$var$createTransactionConstructor(db) {
    return $786a5f856536c5d4$var$makeClassConstructor($786a5f856536c5d4$var$Transaction.prototype, function Transaction(mode, storeNames, dbschema, chromeTransactionDurability, parent) {
        var _this = this;
        if (mode !== 'readonly') storeNames.forEach(function(storeName) {
            var _a;
            var yProps = (_a = dbschema[storeName]) === null || _a === void 0 ? void 0 : _a.yProps;
            if (yProps) storeNames = storeNames.concat(yProps.map(function(p) {
                return p.updatesTable;
            }));
        });
        this.db = db;
        this.mode = mode;
        this.storeNames = storeNames;
        this.schema = dbschema;
        this.chromeTransactionDurability = chromeTransactionDurability;
        this.idbtrans = null;
        this.on = $786a5f856536c5d4$var$Events(this, "complete", "error", "abort");
        this.parent = parent || null;
        this.active = true;
        this._reculock = 0;
        this._blockedFuncs = [];
        this._resolve = null;
        this._reject = null;
        this._waitingFor = null;
        this._waitingQueue = null;
        this._spinCount = 0;
        this._completion = new $786a5f856536c5d4$var$DexiePromise(function(resolve, reject) {
            _this._resolve = resolve;
            _this._reject = reject;
        });
        this._completion.then(function() {
            _this.active = false;
            _this.on.complete.fire();
        }, function(e) {
            var wasActive = _this.active;
            _this.active = false;
            _this.on.error.fire(e);
            _this.parent ? _this.parent._reject(e) : wasActive && _this.idbtrans && _this.idbtrans.abort();
            return $786a5f856536c5d4$var$rejection(e);
        });
    });
}
function $786a5f856536c5d4$var$createIndexSpec(name, keyPath, unique, multi, auto, compound, isPrimKey, type) {
    return {
        name: name,
        keyPath: keyPath,
        unique: unique,
        multi: multi,
        auto: auto,
        compound: compound,
        src: (unique && !isPrimKey ? '&' : '') + (multi ? '*' : '') + (auto ? "++" : "") + $786a5f856536c5d4$var$nameFromKeyPath(keyPath),
        type: type
    };
}
function $786a5f856536c5d4$var$nameFromKeyPath(keyPath) {
    return typeof keyPath === 'string' ? keyPath : keyPath ? '[' + [].join.call(keyPath, '+') + ']' : "";
}
function $786a5f856536c5d4$var$createTableSchema(name, primKey, indexes) {
    return {
        name: name,
        primKey: primKey,
        indexes: indexes,
        mappedClass: null,
        idxByName: $786a5f856536c5d4$var$arrayToObject(indexes, function(index) {
            return [
                index.name,
                index
            ];
        })
    };
}
function $786a5f856536c5d4$var$safariMultiStoreFix(storeNames) {
    return storeNames.length === 1 ? storeNames[0] : storeNames;
}
var $786a5f856536c5d4$var$getMaxKey = function(IdbKeyRange) {
    try {
        IdbKeyRange.only([
            []
        ]);
        $786a5f856536c5d4$var$getMaxKey = function() {
            return [
                []
            ];
        };
        return [
            []
        ];
    } catch (e) {
        $786a5f856536c5d4$var$getMaxKey = function() {
            return $786a5f856536c5d4$var$maxString;
        };
        return $786a5f856536c5d4$var$maxString;
    }
};
function $786a5f856536c5d4$var$getKeyExtractor(keyPath) {
    if (keyPath == null) return function() {
        return undefined;
    };
    else if (typeof keyPath === 'string') return $786a5f856536c5d4$var$getSinglePathKeyExtractor(keyPath);
    else return function(obj) {
        return $786a5f856536c5d4$var$getByKeyPath(obj, keyPath);
    };
}
function $786a5f856536c5d4$var$getSinglePathKeyExtractor(keyPath) {
    var split = keyPath.split('.');
    if (split.length === 1) return function(obj) {
        return obj[keyPath];
    };
    else return function(obj) {
        return $786a5f856536c5d4$var$getByKeyPath(obj, keyPath);
    };
}
function $786a5f856536c5d4$var$arrayify(arrayLike) {
    return [].slice.call(arrayLike);
}
var $786a5f856536c5d4$var$_id_counter = 0;
function $786a5f856536c5d4$var$getKeyPathAlias(keyPath) {
    return keyPath == null ? ":id" : typeof keyPath === 'string' ? keyPath : "[".concat(keyPath.join('+'), "]");
}
function $786a5f856536c5d4$var$createDBCore(db, IdbKeyRange, tmpTrans) {
    function extractSchema(db, trans) {
        var tables = $786a5f856536c5d4$var$arrayify(db.objectStoreNames);
        return {
            schema: {
                name: db.name,
                tables: tables.map(function(table) {
                    return trans.objectStore(table);
                }).map(function(store) {
                    var keyPath = store.keyPath, autoIncrement = store.autoIncrement;
                    var compound = $786a5f856536c5d4$var$isArray(keyPath);
                    var outbound = keyPath == null;
                    var indexByKeyPath = {};
                    var result = {
                        name: store.name,
                        primaryKey: {
                            name: null,
                            isPrimaryKey: true,
                            outbound: outbound,
                            compound: compound,
                            keyPath: keyPath,
                            autoIncrement: autoIncrement,
                            unique: true,
                            extractKey: $786a5f856536c5d4$var$getKeyExtractor(keyPath)
                        },
                        indexes: $786a5f856536c5d4$var$arrayify(store.indexNames).map(function(indexName) {
                            return store.index(indexName);
                        }).map(function(index) {
                            var name = index.name, unique = index.unique, multiEntry = index.multiEntry, keyPath = index.keyPath;
                            var compound = $786a5f856536c5d4$var$isArray(keyPath);
                            var result = {
                                name: name,
                                compound: compound,
                                keyPath: keyPath,
                                unique: unique,
                                multiEntry: multiEntry,
                                extractKey: $786a5f856536c5d4$var$getKeyExtractor(keyPath)
                            };
                            indexByKeyPath[$786a5f856536c5d4$var$getKeyPathAlias(keyPath)] = result;
                            return result;
                        }),
                        getIndexByKeyPath: function(keyPath) {
                            return indexByKeyPath[$786a5f856536c5d4$var$getKeyPathAlias(keyPath)];
                        }
                    };
                    indexByKeyPath[":id"] = result.primaryKey;
                    if (keyPath != null) indexByKeyPath[$786a5f856536c5d4$var$getKeyPathAlias(keyPath)] = result.primaryKey;
                    return result;
                })
            },
            hasGetAll: tables.length > 0 && 'getAll' in trans.objectStore(tables[0]) && !(typeof navigator !== 'undefined' && /Safari/.test(navigator.userAgent) && !/(Chrome\/|Edge\/)/.test(navigator.userAgent) && [].concat(navigator.userAgent.match(/Safari\/(\d*)/))[1] < 604)
        };
    }
    function makeIDBKeyRange(range) {
        if (range.type === 3) return null;
        if (range.type === 4) throw new Error("Cannot convert never type to IDBKeyRange");
        var lower = range.lower, upper = range.upper, lowerOpen = range.lowerOpen, upperOpen = range.upperOpen;
        var idbRange = lower === undefined ? upper === undefined ? null : IdbKeyRange.upperBound(upper, !!upperOpen) : upper === undefined ? IdbKeyRange.lowerBound(lower, !!lowerOpen) : IdbKeyRange.bound(lower, upper, !!lowerOpen, !!upperOpen);
        return idbRange;
    }
    function createDbCoreTable(tableSchema) {
        var tableName = tableSchema.name;
        function mutate(_a) {
            var trans = _a.trans, type = _a.type, keys = _a.keys, values = _a.values, range = _a.range;
            return new Promise(function(resolve, reject) {
                resolve = $786a5f856536c5d4$var$wrap(resolve);
                var store = trans.objectStore(tableName);
                var outbound = store.keyPath == null;
                var isAddOrPut = type === "put" || type === "add";
                if (!isAddOrPut && type !== 'delete' && type !== 'deleteRange') throw new Error("Invalid operation type: " + type);
                var length = (keys || values || {
                    length: 1
                }).length;
                if (keys && values && keys.length !== values.length) throw new Error("Given keys array must have same length as given values array.");
                if (length === 0) return resolve({
                    numFailures: 0,
                    failures: {},
                    results: [],
                    lastResult: undefined
                });
                var req;
                var reqs = [];
                var failures = [];
                var numFailures = 0;
                var errorHandler = function(event) {
                    ++numFailures;
                    $786a5f856536c5d4$var$preventDefault(event);
                };
                if (type === 'deleteRange') {
                    if (range.type === 4) return resolve({
                        numFailures: numFailures,
                        failures: failures,
                        results: [],
                        lastResult: undefined
                    });
                    if (range.type === 3) reqs.push(req = store.clear());
                    else reqs.push(req = store.delete(makeIDBKeyRange(range)));
                } else {
                    var _a = isAddOrPut ? outbound ? [
                        values,
                        keys
                    ] : [
                        values,
                        null
                    ] : [
                        keys,
                        null
                    ], args1 = _a[0], args2 = _a[1];
                    if (isAddOrPut) for(var i = 0; i < length; ++i){
                        reqs.push(req = args2 && args2[i] !== undefined ? store[type](args1[i], args2[i]) : store[type](args1[i]));
                        req.onerror = errorHandler;
                    }
                    else for(var i = 0; i < length; ++i){
                        reqs.push(req = store[type](args1[i]));
                        req.onerror = errorHandler;
                    }
                }
                var done = function(event) {
                    var lastResult = event.target.result;
                    reqs.forEach(function(req, i) {
                        return req.error != null && (failures[i] = req.error);
                    });
                    resolve({
                        numFailures: numFailures,
                        failures: failures,
                        results: type === "delete" ? keys : reqs.map(function(req) {
                            return req.result;
                        }),
                        lastResult: lastResult
                    });
                };
                req.onerror = function(event) {
                    errorHandler(event);
                    done(event);
                };
                req.onsuccess = done;
            });
        }
        function openCursor(_a) {
            var trans = _a.trans, values = _a.values, query = _a.query, reverse = _a.reverse, unique = _a.unique;
            return new Promise(function(resolve, reject) {
                resolve = $786a5f856536c5d4$var$wrap(resolve);
                var index = query.index, range = query.range;
                var store = trans.objectStore(tableName);
                var source = index.isPrimaryKey ? store : store.index(index.name);
                var direction = reverse ? unique ? "prevunique" : "prev" : unique ? "nextunique" : "next";
                var req = values || !('openKeyCursor' in source) ? source.openCursor(makeIDBKeyRange(range), direction) : source.openKeyCursor(makeIDBKeyRange(range), direction);
                req.onerror = $786a5f856536c5d4$var$eventRejectHandler(reject);
                req.onsuccess = $786a5f856536c5d4$var$wrap(function(ev) {
                    var cursor = req.result;
                    if (!cursor) {
                        resolve(null);
                        return;
                    }
                    cursor.___id = ++$786a5f856536c5d4$var$_id_counter;
                    cursor.done = false;
                    var _cursorContinue = cursor.continue.bind(cursor);
                    var _cursorContinuePrimaryKey = cursor.continuePrimaryKey;
                    if (_cursorContinuePrimaryKey) _cursorContinuePrimaryKey = _cursorContinuePrimaryKey.bind(cursor);
                    var _cursorAdvance = cursor.advance.bind(cursor);
                    var doThrowCursorIsNotStarted = function() {
                        throw new Error("Cursor not started");
                    };
                    var doThrowCursorIsStopped = function() {
                        throw new Error("Cursor not stopped");
                    };
                    cursor.trans = trans;
                    cursor.stop = cursor.continue = cursor.continuePrimaryKey = cursor.advance = doThrowCursorIsNotStarted;
                    cursor.fail = $786a5f856536c5d4$var$wrap(reject);
                    cursor.next = function() {
                        var _this = this;
                        var gotOne = 1;
                        return this.start(function() {
                            return gotOne-- ? _this.continue() : _this.stop();
                        }).then(function() {
                            return _this;
                        });
                    };
                    cursor.start = function(callback) {
                        var iterationPromise = new Promise(function(resolveIteration, rejectIteration) {
                            resolveIteration = $786a5f856536c5d4$var$wrap(resolveIteration);
                            req.onerror = $786a5f856536c5d4$var$eventRejectHandler(rejectIteration);
                            cursor.fail = rejectIteration;
                            cursor.stop = function(value) {
                                cursor.stop = cursor.continue = cursor.continuePrimaryKey = cursor.advance = doThrowCursorIsStopped;
                                resolveIteration(value);
                            };
                        });
                        var guardedCallback = function() {
                            if (req.result) try {
                                callback();
                            } catch (err) {
                                cursor.fail(err);
                            }
                            else {
                                cursor.done = true;
                                cursor.start = function() {
                                    throw new Error("Cursor behind last entry");
                                };
                                cursor.stop();
                            }
                        };
                        req.onsuccess = $786a5f856536c5d4$var$wrap(function(ev) {
                            req.onsuccess = guardedCallback;
                            guardedCallback();
                        });
                        cursor.continue = _cursorContinue;
                        cursor.continuePrimaryKey = _cursorContinuePrimaryKey;
                        cursor.advance = _cursorAdvance;
                        guardedCallback();
                        return iterationPromise;
                    };
                    resolve(cursor);
                }, reject);
            });
        }
        function query(hasGetAll) {
            return function(request) {
                return new Promise(function(resolve, reject) {
                    resolve = $786a5f856536c5d4$var$wrap(resolve);
                    var trans = request.trans, values = request.values, limit = request.limit, query = request.query;
                    var nonInfinitLimit = limit === Infinity ? undefined : limit;
                    var index = query.index, range = query.range;
                    var store = trans.objectStore(tableName);
                    var source = index.isPrimaryKey ? store : store.index(index.name);
                    var idbKeyRange = makeIDBKeyRange(range);
                    if (limit === 0) return resolve({
                        result: []
                    });
                    if (hasGetAll) {
                        var req = values ? source.getAll(idbKeyRange, nonInfinitLimit) : source.getAllKeys(idbKeyRange, nonInfinitLimit);
                        req.onsuccess = function(event) {
                            return resolve({
                                result: event.target.result
                            });
                        };
                        req.onerror = $786a5f856536c5d4$var$eventRejectHandler(reject);
                    } else {
                        var count_1 = 0;
                        var req_1 = values || !('openKeyCursor' in source) ? source.openCursor(idbKeyRange) : source.openKeyCursor(idbKeyRange);
                        var result_1 = [];
                        req_1.onsuccess = function(event) {
                            var cursor = req_1.result;
                            if (!cursor) return resolve({
                                result: result_1
                            });
                            result_1.push(values ? cursor.value : cursor.primaryKey);
                            if (++count_1 === limit) return resolve({
                                result: result_1
                            });
                            cursor.continue();
                        };
                        req_1.onerror = $786a5f856536c5d4$var$eventRejectHandler(reject);
                    }
                });
            };
        }
        return {
            name: tableName,
            schema: tableSchema,
            mutate: mutate,
            getMany: function(_a) {
                var trans = _a.trans, keys = _a.keys;
                return new Promise(function(resolve, reject) {
                    resolve = $786a5f856536c5d4$var$wrap(resolve);
                    var store = trans.objectStore(tableName);
                    var length = keys.length;
                    var result = new Array(length);
                    var keyCount = 0;
                    var callbackCount = 0;
                    var req;
                    var successHandler = function(event) {
                        var req = event.target;
                        result[req._pos] = req.result;
                        if (++callbackCount === keyCount) resolve(result);
                    };
                    var errorHandler = $786a5f856536c5d4$var$eventRejectHandler(reject);
                    for(var i = 0; i < length; ++i){
                        var key = keys[i];
                        if (key != null) {
                            req = store.get(keys[i]);
                            req._pos = i;
                            req.onsuccess = successHandler;
                            req.onerror = errorHandler;
                            ++keyCount;
                        }
                    }
                    if (keyCount === 0) resolve(result);
                });
            },
            get: function(_a) {
                var trans = _a.trans, key = _a.key;
                return new Promise(function(resolve, reject) {
                    resolve = $786a5f856536c5d4$var$wrap(resolve);
                    var store = trans.objectStore(tableName);
                    var req = store.get(key);
                    req.onsuccess = function(event) {
                        return resolve(event.target.result);
                    };
                    req.onerror = $786a5f856536c5d4$var$eventRejectHandler(reject);
                });
            },
            query: query(hasGetAll),
            openCursor: openCursor,
            count: function(_a) {
                var query = _a.query, trans = _a.trans;
                var index = query.index, range = query.range;
                return new Promise(function(resolve, reject) {
                    var store = trans.objectStore(tableName);
                    var source = index.isPrimaryKey ? store : store.index(index.name);
                    var idbKeyRange = makeIDBKeyRange(range);
                    var req = idbKeyRange ? source.count(idbKeyRange) : source.count();
                    req.onsuccess = $786a5f856536c5d4$var$wrap(function(ev) {
                        return resolve(ev.target.result);
                    });
                    req.onerror = $786a5f856536c5d4$var$eventRejectHandler(reject);
                });
            }
        };
    }
    var _a = extractSchema(db, tmpTrans), schema = _a.schema, hasGetAll = _a.hasGetAll;
    var tables = schema.tables.map(function(tableSchema) {
        return createDbCoreTable(tableSchema);
    });
    var tableMap = {};
    tables.forEach(function(table) {
        return tableMap[table.name] = table;
    });
    return {
        stack: "dbcore",
        transaction: db.transaction.bind(db),
        table: function(name) {
            var result = tableMap[name];
            if (!result) throw new Error("Table '".concat(name, "' not found"));
            return tableMap[name];
        },
        MIN_KEY: -Infinity,
        MAX_KEY: $786a5f856536c5d4$var$getMaxKey(IdbKeyRange),
        schema: schema
    };
}
function $786a5f856536c5d4$var$createMiddlewareStack(stackImpl, middlewares) {
    return middlewares.reduce(function(down, _a) {
        var create = _a.create;
        return $786a5f856536c5d4$var$__assign($786a5f856536c5d4$var$__assign({}, down), create(down));
    }, stackImpl);
}
function $786a5f856536c5d4$var$createMiddlewareStacks(middlewares, idbdb, _a, tmpTrans) {
    var IDBKeyRange = _a.IDBKeyRange;
    _a.indexedDB;
    var dbcore = $786a5f856536c5d4$var$createMiddlewareStack($786a5f856536c5d4$var$createDBCore(idbdb, IDBKeyRange, tmpTrans), middlewares.dbcore);
    return {
        dbcore: dbcore
    };
}
function $786a5f856536c5d4$var$generateMiddlewareStacks(db, tmpTrans) {
    var idbdb = tmpTrans.db;
    var stacks = $786a5f856536c5d4$var$createMiddlewareStacks(db._middlewares, idbdb, db._deps, tmpTrans);
    db.core = stacks.dbcore;
    db.tables.forEach(function(table) {
        var tableName = table.name;
        if (db.core.schema.tables.some(function(tbl) {
            return tbl.name === tableName;
        })) {
            table.core = db.core.table(tableName);
            if (db[tableName] instanceof db.Table) db[tableName].core = table.core;
        }
    });
}
function $786a5f856536c5d4$var$setApiOnPlace(db, objs, tableNames, dbschema) {
    tableNames.forEach(function(tableName) {
        var schema = dbschema[tableName];
        objs.forEach(function(obj) {
            var propDesc = $786a5f856536c5d4$var$getPropertyDescriptor(obj, tableName);
            if (!propDesc || "value" in propDesc && propDesc.value === undefined) {
                if (obj === db.Transaction.prototype || obj instanceof db.Transaction) $786a5f856536c5d4$var$setProp(obj, tableName, {
                    get: function() {
                        return this.table(tableName);
                    },
                    set: function(value) {
                        $786a5f856536c5d4$var$defineProperty(this, tableName, {
                            value: value,
                            writable: true,
                            configurable: true,
                            enumerable: true
                        });
                    }
                });
                else obj[tableName] = new db.Table(tableName, schema);
            }
        });
    });
}
function $786a5f856536c5d4$var$removeTablesApi(db, objs) {
    objs.forEach(function(obj) {
        for(var key in obj)if (obj[key] instanceof db.Table) delete obj[key];
    });
}
function $786a5f856536c5d4$var$lowerVersionFirst(a, b) {
    return a._cfg.version - b._cfg.version;
}
function $786a5f856536c5d4$var$runUpgraders(db, oldVersion, idbUpgradeTrans, reject) {
    var globalSchema = db._dbSchema;
    if (idbUpgradeTrans.objectStoreNames.contains('$meta') && !globalSchema.$meta) {
        globalSchema.$meta = $786a5f856536c5d4$var$createTableSchema("$meta", $786a5f856536c5d4$var$parseIndexSyntax("")[0], []);
        db._storeNames.push('$meta');
    }
    var trans = db._createTransaction('readwrite', db._storeNames, globalSchema);
    trans.create(idbUpgradeTrans);
    trans._completion.catch(reject);
    var rejectTransaction = trans._reject.bind(trans);
    var transless = $786a5f856536c5d4$var$PSD.transless || $786a5f856536c5d4$var$PSD;
    $786a5f856536c5d4$var$newScope(function() {
        $786a5f856536c5d4$var$PSD.trans = trans;
        $786a5f856536c5d4$var$PSD.transless = transless;
        if (oldVersion === 0) {
            $786a5f856536c5d4$var$keys(globalSchema).forEach(function(tableName) {
                $786a5f856536c5d4$var$createTable(idbUpgradeTrans, tableName, globalSchema[tableName].primKey, globalSchema[tableName].indexes);
            });
            $786a5f856536c5d4$var$generateMiddlewareStacks(db, idbUpgradeTrans);
            $786a5f856536c5d4$var$DexiePromise.follow(function() {
                return db.on.populate.fire(trans);
            }).catch(rejectTransaction);
        } else {
            $786a5f856536c5d4$var$generateMiddlewareStacks(db, idbUpgradeTrans);
            return $786a5f856536c5d4$var$getExistingVersion(db, trans, oldVersion).then(function(oldVersion) {
                return $786a5f856536c5d4$var$updateTablesAndIndexes(db, oldVersion, trans, idbUpgradeTrans);
            }).catch(rejectTransaction);
        }
    });
}
function $786a5f856536c5d4$var$patchCurrentVersion(db, idbUpgradeTrans) {
    $786a5f856536c5d4$var$createMissingTables(db._dbSchema, idbUpgradeTrans);
    if (idbUpgradeTrans.db.version % 10 === 0 && !idbUpgradeTrans.objectStoreNames.contains('$meta')) idbUpgradeTrans.db.createObjectStore('$meta').add(Math.ceil(idbUpgradeTrans.db.version / 10 - 1), 'version');
    var globalSchema = $786a5f856536c5d4$var$buildGlobalSchema(db, db.idbdb, idbUpgradeTrans);
    $786a5f856536c5d4$var$adjustToExistingIndexNames(db, db._dbSchema, idbUpgradeTrans);
    var diff = $786a5f856536c5d4$var$getSchemaDiff(globalSchema, db._dbSchema);
    var _loop_1 = function(tableChange) {
        if (tableChange.change.length || tableChange.recreate) {
            console.warn("Unable to patch indexes of table ".concat(tableChange.name, " because it has changes on the type of index or primary key."));
            return {
                value: void 0
            };
        }
        var store = idbUpgradeTrans.objectStore(tableChange.name);
        tableChange.add.forEach(function(idx) {
            if ($786a5f856536c5d4$var$debug) console.debug("Dexie upgrade patch: Creating missing index ".concat(tableChange.name, ".").concat(idx.src));
            $786a5f856536c5d4$var$addIndex(store, idx);
        });
    };
    for(var _i = 0, _a = diff.change; _i < _a.length; _i++){
        var tableChange = _a[_i];
        var state_1 = _loop_1(tableChange);
        if (typeof state_1 === "object") return state_1.value;
    }
}
function $786a5f856536c5d4$var$getExistingVersion(db, trans, oldVersion) {
    if (trans.storeNames.includes('$meta')) return trans.table('$meta').get('version').then(function(metaVersion) {
        return metaVersion != null ? metaVersion : oldVersion;
    });
    else return $786a5f856536c5d4$var$DexiePromise.resolve(oldVersion);
}
function $786a5f856536c5d4$var$updateTablesAndIndexes(db, oldVersion, trans, idbUpgradeTrans) {
    var queue = [];
    var versions = db._versions;
    var globalSchema = db._dbSchema = $786a5f856536c5d4$var$buildGlobalSchema(db, db.idbdb, idbUpgradeTrans);
    var versToRun = versions.filter(function(v) {
        return v._cfg.version >= oldVersion;
    });
    if (versToRun.length === 0) return $786a5f856536c5d4$var$DexiePromise.resolve();
    versToRun.forEach(function(version) {
        queue.push(function() {
            var oldSchema = globalSchema;
            var newSchema = version._cfg.dbschema;
            $786a5f856536c5d4$var$adjustToExistingIndexNames(db, oldSchema, idbUpgradeTrans);
            $786a5f856536c5d4$var$adjustToExistingIndexNames(db, newSchema, idbUpgradeTrans);
            globalSchema = db._dbSchema = newSchema;
            var diff = $786a5f856536c5d4$var$getSchemaDiff(oldSchema, newSchema);
            diff.add.forEach(function(tuple) {
                $786a5f856536c5d4$var$createTable(idbUpgradeTrans, tuple[0], tuple[1].primKey, tuple[1].indexes);
            });
            diff.change.forEach(function(change) {
                if (change.recreate) throw new $786a5f856536c5d4$var$exceptions.Upgrade("Not yet support for changing primary key");
                else {
                    var store_1 = idbUpgradeTrans.objectStore(change.name);
                    change.add.forEach(function(idx) {
                        return $786a5f856536c5d4$var$addIndex(store_1, idx);
                    });
                    change.change.forEach(function(idx) {
                        store_1.deleteIndex(idx.name);
                        $786a5f856536c5d4$var$addIndex(store_1, idx);
                    });
                    change.del.forEach(function(idxName) {
                        return store_1.deleteIndex(idxName);
                    });
                }
            });
            var contentUpgrade = version._cfg.contentUpgrade;
            if (contentUpgrade && version._cfg.version > oldVersion) {
                $786a5f856536c5d4$var$generateMiddlewareStacks(db, idbUpgradeTrans);
                trans._memoizedTables = {};
                var upgradeSchema_1 = $786a5f856536c5d4$var$shallowClone(newSchema);
                diff.del.forEach(function(table) {
                    upgradeSchema_1[table] = oldSchema[table];
                });
                $786a5f856536c5d4$var$removeTablesApi(db, [
                    db.Transaction.prototype
                ]);
                $786a5f856536c5d4$var$setApiOnPlace(db, [
                    db.Transaction.prototype
                ], $786a5f856536c5d4$var$keys(upgradeSchema_1), upgradeSchema_1);
                trans.schema = upgradeSchema_1;
                var contentUpgradeIsAsync_1 = $786a5f856536c5d4$var$isAsyncFunction(contentUpgrade);
                if (contentUpgradeIsAsync_1) $786a5f856536c5d4$var$incrementExpectedAwaits();
                var returnValue_1;
                var promiseFollowed = $786a5f856536c5d4$var$DexiePromise.follow(function() {
                    returnValue_1 = contentUpgrade(trans);
                    if (returnValue_1) {
                        if (contentUpgradeIsAsync_1) {
                            var decrementor = $786a5f856536c5d4$var$decrementExpectedAwaits.bind(null, null);
                            returnValue_1.then(decrementor, decrementor);
                        }
                    }
                });
                return returnValue_1 && typeof returnValue_1.then === 'function' ? $786a5f856536c5d4$var$DexiePromise.resolve(returnValue_1) : promiseFollowed.then(function() {
                    return returnValue_1;
                });
            }
        });
        queue.push(function(idbtrans) {
            var newSchema = version._cfg.dbschema;
            $786a5f856536c5d4$var$deleteRemovedTables(newSchema, idbtrans);
            $786a5f856536c5d4$var$removeTablesApi(db, [
                db.Transaction.prototype
            ]);
            $786a5f856536c5d4$var$setApiOnPlace(db, [
                db.Transaction.prototype
            ], db._storeNames, db._dbSchema);
            trans.schema = db._dbSchema;
        });
        queue.push(function(idbtrans) {
            if (db.idbdb.objectStoreNames.contains('$meta')) {
                if (Math.ceil(db.idbdb.version / 10) === version._cfg.version) {
                    db.idbdb.deleteObjectStore('$meta');
                    delete db._dbSchema.$meta;
                    db._storeNames = db._storeNames.filter(function(name) {
                        return name !== '$meta';
                    });
                } else idbtrans.objectStore('$meta').put(version._cfg.version, 'version');
            }
        });
    });
    function runQueue() {
        return queue.length ? $786a5f856536c5d4$var$DexiePromise.resolve(queue.shift()(trans.idbtrans)).then(runQueue) : $786a5f856536c5d4$var$DexiePromise.resolve();
    }
    return runQueue().then(function() {
        $786a5f856536c5d4$var$createMissingTables(globalSchema, idbUpgradeTrans);
    });
}
function $786a5f856536c5d4$var$getSchemaDiff(oldSchema, newSchema) {
    var diff = {
        del: [],
        add: [],
        change: []
    };
    var table;
    for(table in oldSchema)if (!newSchema[table]) diff.del.push(table);
    for(table in newSchema){
        var oldDef = oldSchema[table], newDef = newSchema[table];
        if (!oldDef) diff.add.push([
            table,
            newDef
        ]);
        else {
            var change = {
                name: table,
                def: newDef,
                recreate: false,
                del: [],
                add: [],
                change: []
            };
            if ('' + (oldDef.primKey.keyPath || '') !== '' + (newDef.primKey.keyPath || '') || oldDef.primKey.auto !== newDef.primKey.auto) {
                change.recreate = true;
                diff.change.push(change);
            } else {
                var oldIndexes = oldDef.idxByName;
                var newIndexes = newDef.idxByName;
                var idxName = void 0;
                for(idxName in oldIndexes)if (!newIndexes[idxName]) change.del.push(idxName);
                for(idxName in newIndexes){
                    var oldIdx = oldIndexes[idxName], newIdx = newIndexes[idxName];
                    if (!oldIdx) change.add.push(newIdx);
                    else if (oldIdx.src !== newIdx.src) change.change.push(newIdx);
                }
                if (change.del.length > 0 || change.add.length > 0 || change.change.length > 0) diff.change.push(change);
            }
        }
    }
    return diff;
}
function $786a5f856536c5d4$var$createTable(idbtrans, tableName, primKey, indexes) {
    var store = idbtrans.db.createObjectStore(tableName, primKey.keyPath ? {
        keyPath: primKey.keyPath,
        autoIncrement: primKey.auto
    } : {
        autoIncrement: primKey.auto
    });
    indexes.forEach(function(idx) {
        return $786a5f856536c5d4$var$addIndex(store, idx);
    });
    return store;
}
function $786a5f856536c5d4$var$createMissingTables(newSchema, idbtrans) {
    $786a5f856536c5d4$var$keys(newSchema).forEach(function(tableName) {
        if (!idbtrans.db.objectStoreNames.contains(tableName)) {
            if ($786a5f856536c5d4$var$debug) console.debug('Dexie: Creating missing table', tableName);
            $786a5f856536c5d4$var$createTable(idbtrans, tableName, newSchema[tableName].primKey, newSchema[tableName].indexes);
        }
    });
}
function $786a5f856536c5d4$var$deleteRemovedTables(newSchema, idbtrans) {
    [].slice.call(idbtrans.db.objectStoreNames).forEach(function(storeName) {
        return newSchema[storeName] == null && idbtrans.db.deleteObjectStore(storeName);
    });
}
function $786a5f856536c5d4$var$addIndex(store, idx) {
    store.createIndex(idx.name, idx.keyPath, {
        unique: idx.unique,
        multiEntry: idx.multi
    });
}
function $786a5f856536c5d4$var$buildGlobalSchema(db, idbdb, tmpTrans) {
    var globalSchema = {};
    var dbStoreNames = $786a5f856536c5d4$var$slice(idbdb.objectStoreNames, 0);
    dbStoreNames.forEach(function(storeName) {
        var store = tmpTrans.objectStore(storeName);
        var keyPath = store.keyPath;
        var primKey = $786a5f856536c5d4$var$createIndexSpec($786a5f856536c5d4$var$nameFromKeyPath(keyPath), keyPath || "", true, false, !!store.autoIncrement, keyPath && typeof keyPath !== "string", true);
        var indexes = [];
        for(var j = 0; j < store.indexNames.length; ++j){
            var idbindex = store.index(store.indexNames[j]);
            keyPath = idbindex.keyPath;
            var index = $786a5f856536c5d4$var$createIndexSpec(idbindex.name, keyPath, !!idbindex.unique, !!idbindex.multiEntry, false, keyPath && typeof keyPath !== "string", false);
            indexes.push(index);
        }
        globalSchema[storeName] = $786a5f856536c5d4$var$createTableSchema(storeName, primKey, indexes);
    });
    return globalSchema;
}
function $786a5f856536c5d4$var$readGlobalSchema(db, idbdb, tmpTrans) {
    db.verno = idbdb.version / 10;
    var globalSchema = db._dbSchema = $786a5f856536c5d4$var$buildGlobalSchema(db, idbdb, tmpTrans);
    db._storeNames = $786a5f856536c5d4$var$slice(idbdb.objectStoreNames, 0);
    $786a5f856536c5d4$var$setApiOnPlace(db, [
        db._allTables
    ], $786a5f856536c5d4$var$keys(globalSchema), globalSchema);
}
function $786a5f856536c5d4$var$verifyInstalledSchema(db, tmpTrans) {
    var installedSchema = $786a5f856536c5d4$var$buildGlobalSchema(db, db.idbdb, tmpTrans);
    var diff = $786a5f856536c5d4$var$getSchemaDiff(installedSchema, db._dbSchema);
    return !(diff.add.length || diff.change.some(function(ch) {
        return ch.add.length || ch.change.length;
    }));
}
function $786a5f856536c5d4$var$adjustToExistingIndexNames(db, schema, idbtrans) {
    var storeNames = idbtrans.db.objectStoreNames;
    for(var i = 0; i < storeNames.length; ++i){
        var storeName = storeNames[i];
        var store = idbtrans.objectStore(storeName);
        db._hasGetAll = 'getAll' in store;
        for(var j = 0; j < store.indexNames.length; ++j){
            var indexName = store.indexNames[j];
            var keyPath = store.index(indexName).keyPath;
            var dexieName = typeof keyPath === 'string' ? keyPath : "[" + $786a5f856536c5d4$var$slice(keyPath).join('+') + "]";
            if (schema[storeName]) {
                var indexSpec = schema[storeName].idxByName[dexieName];
                if (indexSpec) {
                    indexSpec.name = indexName;
                    delete schema[storeName].idxByName[dexieName];
                    schema[storeName].idxByName[indexName] = indexSpec;
                }
            }
        }
    }
    if (typeof navigator !== 'undefined' && /Safari/.test(navigator.userAgent) && !/(Chrome\/|Edge\/)/.test(navigator.userAgent) && $786a5f856536c5d4$var$_global.WorkerGlobalScope && $786a5f856536c5d4$var$_global instanceof $786a5f856536c5d4$var$_global.WorkerGlobalScope && [].concat(navigator.userAgent.match(/Safari\/(\d*)/))[1] < 604) db._hasGetAll = false;
}
function $786a5f856536c5d4$var$parseIndexSyntax(primKeyAndIndexes) {
    return primKeyAndIndexes.split(',').map(function(index, indexNum) {
        var _a;
        var typeSplit = index.split(':');
        var type = (_a = typeSplit[1]) === null || _a === void 0 ? void 0 : _a.trim();
        index = typeSplit[0].trim();
        var name = index.replace(/([&*]|\+\+)/g, "");
        var keyPath = /^\[/.test(name) ? name.match(/^\[(.*)\]$/)[1].split('+') : name;
        return $786a5f856536c5d4$var$createIndexSpec(name, keyPath || null, /\&/.test(index), /\*/.test(index), /\+\+/.test(index), $786a5f856536c5d4$var$isArray(keyPath), indexNum === 0, type);
    });
}
var $786a5f856536c5d4$var$Version = function() {
    function Version() {}
    Version.prototype._createTableSchema = function(name, primKey, indexes) {
        return $786a5f856536c5d4$var$createTableSchema(name, primKey, indexes);
    };
    Version.prototype._parseIndexSyntax = function(primKeyAndIndexes) {
        return $786a5f856536c5d4$var$parseIndexSyntax(primKeyAndIndexes);
    };
    Version.prototype._parseStoresSpec = function(stores, outSchema) {
        var _this = this;
        $786a5f856536c5d4$var$keys(stores).forEach(function(tableName) {
            if (stores[tableName] !== null) {
                var indexes = _this._parseIndexSyntax(stores[tableName]);
                var primKey = indexes.shift();
                if (!primKey) throw new $786a5f856536c5d4$var$exceptions.Schema('Invalid schema for table ' + tableName + ': ' + stores[tableName]);
                primKey.unique = true;
                if (primKey.multi) throw new $786a5f856536c5d4$var$exceptions.Schema('Primary key cannot be multiEntry*');
                indexes.forEach(function(idx) {
                    if (idx.auto) throw new $786a5f856536c5d4$var$exceptions.Schema('Only primary key can be marked as autoIncrement (++)');
                    if (!idx.keyPath) throw new $786a5f856536c5d4$var$exceptions.Schema('Index must have a name and cannot be an empty string');
                });
                var tblSchema = _this._createTableSchema(tableName, primKey, indexes);
                outSchema[tableName] = tblSchema;
            }
        });
    };
    Version.prototype.stores = function(stores) {
        var db = this.db;
        this._cfg.storesSource = this._cfg.storesSource ? $786a5f856536c5d4$var$extend(this._cfg.storesSource, stores) : stores;
        var versions = db._versions;
        var storesSpec = {};
        var dbschema = {};
        versions.forEach(function(version) {
            $786a5f856536c5d4$var$extend(storesSpec, version._cfg.storesSource);
            dbschema = version._cfg.dbschema = {};
            version._parseStoresSpec(storesSpec, dbschema);
        });
        db._dbSchema = dbschema;
        $786a5f856536c5d4$var$removeTablesApi(db, [
            db._allTables,
            db,
            db.Transaction.prototype
        ]);
        $786a5f856536c5d4$var$setApiOnPlace(db, [
            db._allTables,
            db,
            db.Transaction.prototype,
            this._cfg.tables
        ], $786a5f856536c5d4$var$keys(dbschema), dbschema);
        db._storeNames = $786a5f856536c5d4$var$keys(dbschema);
        return this;
    };
    Version.prototype.upgrade = function(upgradeFunction) {
        this._cfg.contentUpgrade = $786a5f856536c5d4$var$promisableChain(this._cfg.contentUpgrade || $786a5f856536c5d4$var$nop, upgradeFunction);
        return this;
    };
    return Version;
}();
function $786a5f856536c5d4$var$createVersionConstructor(db) {
    return $786a5f856536c5d4$var$makeClassConstructor($786a5f856536c5d4$var$Version.prototype, function Version(versionNumber) {
        this.db = db;
        this._cfg = {
            version: versionNumber,
            storesSource: null,
            dbschema: {},
            tables: {},
            contentUpgrade: null
        };
    });
}
function $786a5f856536c5d4$var$getDbNamesTable(indexedDB1, IDBKeyRange) {
    var dbNamesDB = indexedDB1["_dbNamesDB"];
    if (!dbNamesDB) {
        dbNamesDB = indexedDB1["_dbNamesDB"] = new $786a5f856536c5d4$export$4ece27d405df7279($786a5f856536c5d4$var$DBNAMES_DB, {
            addons: [],
            indexedDB: indexedDB1,
            IDBKeyRange: IDBKeyRange
        });
        dbNamesDB.version(1).stores({
            dbnames: "name"
        });
    }
    return dbNamesDB.table("dbnames");
}
function $786a5f856536c5d4$var$hasDatabasesNative(indexedDB1) {
    return indexedDB1 && typeof indexedDB1.databases === "function";
}
function $786a5f856536c5d4$var$getDatabaseNames(_a) {
    var indexedDB1 = _a.indexedDB, IDBKeyRange = _a.IDBKeyRange;
    return $786a5f856536c5d4$var$hasDatabasesNative(indexedDB1) ? Promise.resolve(indexedDB1.databases()).then(function(infos) {
        return infos.map(function(info) {
            return info.name;
        }).filter(function(name) {
            return name !== $786a5f856536c5d4$var$DBNAMES_DB;
        });
    }) : $786a5f856536c5d4$var$getDbNamesTable(indexedDB1, IDBKeyRange).toCollection().primaryKeys();
}
function $786a5f856536c5d4$var$_onDatabaseCreated(_a, name) {
    var indexedDB1 = _a.indexedDB, IDBKeyRange = _a.IDBKeyRange;
    !$786a5f856536c5d4$var$hasDatabasesNative(indexedDB1) && name !== $786a5f856536c5d4$var$DBNAMES_DB && $786a5f856536c5d4$var$getDbNamesTable(indexedDB1, IDBKeyRange).put({
        name: name
    }).catch($786a5f856536c5d4$var$nop);
}
function $786a5f856536c5d4$var$_onDatabaseDeleted(_a, name) {
    var indexedDB1 = _a.indexedDB, IDBKeyRange = _a.IDBKeyRange;
    !$786a5f856536c5d4$var$hasDatabasesNative(indexedDB1) && name !== $786a5f856536c5d4$var$DBNAMES_DB && $786a5f856536c5d4$var$getDbNamesTable(indexedDB1, IDBKeyRange).delete(name).catch($786a5f856536c5d4$var$nop);
}
function $786a5f856536c5d4$var$vip(fn) {
    return $786a5f856536c5d4$var$newScope(function() {
        $786a5f856536c5d4$var$PSD.letThrough = true;
        return fn();
    });
}
function $786a5f856536c5d4$var$idbReady() {
    var isSafari = !navigator.userAgentData && /Safari\//.test(navigator.userAgent) && !/Chrom(e|ium)\//.test(navigator.userAgent);
    if (!isSafari || !indexedDB.databases) return Promise.resolve();
    var intervalId;
    return new Promise(function(resolve) {
        var tryIdb = function() {
            return indexedDB.databases().finally(resolve);
        };
        intervalId = setInterval(tryIdb, 100);
        tryIdb();
    }).finally(function() {
        return clearInterval(intervalId);
    });
}
var $786a5f856536c5d4$var$_a;
function $786a5f856536c5d4$var$isEmptyRange(node) {
    return !("from" in node);
}
var $786a5f856536c5d4$export$34cb5241245008dd = function(fromOrTree, to) {
    if (this) $786a5f856536c5d4$var$extend(this, arguments.length ? {
        d: 1,
        from: fromOrTree,
        to: arguments.length > 1 ? to : fromOrTree
    } : {
        d: 0
    });
    else {
        var rv = new $786a5f856536c5d4$export$34cb5241245008dd();
        if (fromOrTree && "d" in fromOrTree) $786a5f856536c5d4$var$extend(rv, fromOrTree);
        return rv;
    }
};
$786a5f856536c5d4$var$props($786a5f856536c5d4$export$34cb5241245008dd.prototype, ($786a5f856536c5d4$var$_a = {
    add: function(rangeSet) {
        $786a5f856536c5d4$export$4876cc3130d3f820(this, rangeSet);
        return this;
    },
    addKey: function(key) {
        $786a5f856536c5d4$var$addRange(this, key, key);
        return this;
    },
    addKeys: function(keys) {
        var _this = this;
        keys.forEach(function(key) {
            return $786a5f856536c5d4$var$addRange(_this, key, key);
        });
        return this;
    },
    hasKey: function(key) {
        var node = $786a5f856536c5d4$var$getRangeSetIterator(this).next(key).value;
        return node && $786a5f856536c5d4$export$6154dcdb7d23e37b(node.from, key) <= 0 && $786a5f856536c5d4$export$6154dcdb7d23e37b(node.to, key) >= 0;
    }
}, $786a5f856536c5d4$var$_a[$786a5f856536c5d4$var$iteratorSymbol] = function() {
    return $786a5f856536c5d4$var$getRangeSetIterator(this);
}, $786a5f856536c5d4$var$_a));
function $786a5f856536c5d4$var$addRange(target, from, to) {
    var diff = $786a5f856536c5d4$export$6154dcdb7d23e37b(from, to);
    if (isNaN(diff)) return;
    if (diff > 0) throw RangeError();
    if ($786a5f856536c5d4$var$isEmptyRange(target)) return $786a5f856536c5d4$var$extend(target, {
        from: from,
        to: to,
        d: 1
    });
    var left = target.l;
    var right = target.r;
    if ($786a5f856536c5d4$export$6154dcdb7d23e37b(to, target.from) < 0) {
        left ? $786a5f856536c5d4$var$addRange(left, from, to) : target.l = {
            from: from,
            to: to,
            d: 1,
            l: null,
            r: null
        };
        return $786a5f856536c5d4$var$rebalance(target);
    }
    if ($786a5f856536c5d4$export$6154dcdb7d23e37b(from, target.to) > 0) {
        right ? $786a5f856536c5d4$var$addRange(right, from, to) : target.r = {
            from: from,
            to: to,
            d: 1,
            l: null,
            r: null
        };
        return $786a5f856536c5d4$var$rebalance(target);
    }
    if ($786a5f856536c5d4$export$6154dcdb7d23e37b(from, target.from) < 0) {
        target.from = from;
        target.l = null;
        target.d = right ? right.d + 1 : 1;
    }
    if ($786a5f856536c5d4$export$6154dcdb7d23e37b(to, target.to) > 0) {
        target.to = to;
        target.r = null;
        target.d = target.l ? target.l.d + 1 : 1;
    }
    var rightWasCutOff = !target.r;
    if (left && !target.l) $786a5f856536c5d4$export$4876cc3130d3f820(target, left);
    if (right && rightWasCutOff) $786a5f856536c5d4$export$4876cc3130d3f820(target, right);
}
function $786a5f856536c5d4$export$4876cc3130d3f820(target, newSet) {
    function _addRangeSet(target, _a) {
        var from = _a.from, to = _a.to, l = _a.l, r = _a.r;
        $786a5f856536c5d4$var$addRange(target, from, to);
        if (l) _addRangeSet(target, l);
        if (r) _addRangeSet(target, r);
    }
    if (!$786a5f856536c5d4$var$isEmptyRange(newSet)) _addRangeSet(target, newSet);
}
function $786a5f856536c5d4$export$8f43b23b5d8de905(rangeSet1, rangeSet2) {
    var i1 = $786a5f856536c5d4$var$getRangeSetIterator(rangeSet2);
    var nextResult1 = i1.next();
    if (nextResult1.done) return false;
    var a = nextResult1.value;
    var i2 = $786a5f856536c5d4$var$getRangeSetIterator(rangeSet1);
    var nextResult2 = i2.next(a.from);
    var b = nextResult2.value;
    while(!nextResult1.done && !nextResult2.done){
        if ($786a5f856536c5d4$export$6154dcdb7d23e37b(b.from, a.to) <= 0 && $786a5f856536c5d4$export$6154dcdb7d23e37b(b.to, a.from) >= 0) return true;
        $786a5f856536c5d4$export$6154dcdb7d23e37b(a.from, b.from) < 0 ? a = (nextResult1 = i1.next(b.from)).value : b = (nextResult2 = i2.next(a.from)).value;
    }
    return false;
}
function $786a5f856536c5d4$var$getRangeSetIterator(node) {
    var state = $786a5f856536c5d4$var$isEmptyRange(node) ? null : {
        s: 0,
        n: node
    };
    return {
        next: function(key) {
            var keyProvided = arguments.length > 0;
            while(state)switch(state.s){
                case 0:
                    state.s = 1;
                    if (keyProvided) while(state.n.l && $786a5f856536c5d4$export$6154dcdb7d23e37b(key, state.n.from) < 0)state = {
                        up: state,
                        n: state.n.l,
                        s: 1
                    };
                    else while(state.n.l)state = {
                        up: state,
                        n: state.n.l,
                        s: 1
                    };
                case 1:
                    state.s = 2;
                    if (!keyProvided || $786a5f856536c5d4$export$6154dcdb7d23e37b(key, state.n.to) <= 0) return {
                        value: state.n,
                        done: false
                    };
                case 2:
                    if (state.n.r) {
                        state.s = 3;
                        state = {
                            up: state,
                            n: state.n.r,
                            s: 0
                        };
                        continue;
                    }
                case 3:
                    state = state.up;
            }
            return {
                done: true
            };
        }
    };
}
function $786a5f856536c5d4$var$rebalance(target) {
    var _a, _b;
    var diff = (((_a = target.r) === null || _a === void 0 ? void 0 : _a.d) || 0) - (((_b = target.l) === null || _b === void 0 ? void 0 : _b.d) || 0);
    var r = diff > 1 ? "r" : diff < -1 ? "l" : "";
    if (r) {
        var l = r === "r" ? "l" : "r";
        var rootClone = $786a5f856536c5d4$var$__assign({}, target);
        var oldRootRight = target[r];
        target.from = oldRootRight.from;
        target.to = oldRootRight.to;
        target[r] = oldRootRight[r];
        rootClone[r] = oldRootRight[l];
        target[l] = rootClone;
        rootClone.d = $786a5f856536c5d4$var$computeDepth(rootClone);
    }
    target.d = $786a5f856536c5d4$var$computeDepth(target);
}
function $786a5f856536c5d4$var$computeDepth(_a) {
    var r = _a.r, l = _a.l;
    return (r ? l ? Math.max(r.d, l.d) : r.d : l ? l.d : 0) + 1;
}
function $786a5f856536c5d4$var$extendObservabilitySet(target, newSet) {
    $786a5f856536c5d4$var$keys(newSet).forEach(function(part) {
        if (target[part]) $786a5f856536c5d4$export$4876cc3130d3f820(target[part], newSet[part]);
        else target[part] = $786a5f856536c5d4$var$cloneSimpleObjectTree(newSet[part]);
    });
    return target;
}
function $786a5f856536c5d4$var$obsSetsOverlap(os1, os2) {
    return os1.all || os2.all || Object.keys(os1).some(function(key) {
        return os2[key] && $786a5f856536c5d4$export$8f43b23b5d8de905(os2[key], os1[key]);
    });
}
var $786a5f856536c5d4$var$cache = {};
var $786a5f856536c5d4$var$unsignaledParts = {};
var $786a5f856536c5d4$var$isTaskEnqueued = false;
function $786a5f856536c5d4$var$signalSubscribersLazily(part, optimistic) {
    $786a5f856536c5d4$var$extendObservabilitySet($786a5f856536c5d4$var$unsignaledParts, part);
    if (!$786a5f856536c5d4$var$isTaskEnqueued) {
        $786a5f856536c5d4$var$isTaskEnqueued = true;
        setTimeout(function() {
            $786a5f856536c5d4$var$isTaskEnqueued = false;
            var parts = $786a5f856536c5d4$var$unsignaledParts;
            $786a5f856536c5d4$var$unsignaledParts = {};
            $786a5f856536c5d4$var$signalSubscribersNow(parts, false);
        }, 0);
    }
}
function $786a5f856536c5d4$var$signalSubscribersNow(updatedParts, deleteAffectedCacheEntries) {
    if (deleteAffectedCacheEntries === void 0) deleteAffectedCacheEntries = false;
    var queriesToSignal = new Set();
    if (updatedParts.all) for(var _i = 0, _a = Object.values($786a5f856536c5d4$var$cache); _i < _a.length; _i++){
        var tblCache = _a[_i];
        $786a5f856536c5d4$var$collectTableSubscribers(tblCache, updatedParts, queriesToSignal, deleteAffectedCacheEntries);
    }
    else for(var key in updatedParts){
        var parts = /^idb\:\/\/(.*)\/(.*)\//.exec(key);
        if (parts) {
            var dbName = parts[1], tableName = parts[2];
            var tblCache = $786a5f856536c5d4$var$cache["idb://".concat(dbName, "/").concat(tableName)];
            if (tblCache) $786a5f856536c5d4$var$collectTableSubscribers(tblCache, updatedParts, queriesToSignal, deleteAffectedCacheEntries);
        }
    }
    queriesToSignal.forEach(function(requery) {
        return requery();
    });
}
function $786a5f856536c5d4$var$collectTableSubscribers(tblCache, updatedParts, outQueriesToSignal, deleteAffectedCacheEntries) {
    var updatedEntryLists = [];
    for(var _i = 0, _a = Object.entries(tblCache.queries.query); _i < _a.length; _i++){
        var _b = _a[_i], indexName = _b[0], entries = _b[1];
        var filteredEntries = [];
        for(var _c = 0, entries_1 = entries; _c < entries_1.length; _c++){
            var entry = entries_1[_c];
            if ($786a5f856536c5d4$var$obsSetsOverlap(updatedParts, entry.obsSet)) entry.subscribers.forEach(function(requery) {
                return outQueriesToSignal.add(requery);
            });
            else if (deleteAffectedCacheEntries) filteredEntries.push(entry);
        }
        if (deleteAffectedCacheEntries) updatedEntryLists.push([
            indexName,
            filteredEntries
        ]);
    }
    if (deleteAffectedCacheEntries) for(var _d = 0, updatedEntryLists_1 = updatedEntryLists; _d < updatedEntryLists_1.length; _d++){
        var _e = updatedEntryLists_1[_d], indexName = _e[0], filteredEntries = _e[1];
        tblCache.queries.query[indexName] = filteredEntries;
    }
}
function $786a5f856536c5d4$var$dexieOpen(db) {
    var state = db._state;
    var indexedDB1 = db._deps.indexedDB;
    if (state.isBeingOpened || db.idbdb) return state.dbReadyPromise.then(function() {
        return state.dbOpenError ? $786a5f856536c5d4$var$rejection(state.dbOpenError) : db;
    });
    state.isBeingOpened = true;
    state.dbOpenError = null;
    state.openComplete = false;
    var openCanceller = state.openCanceller;
    var nativeVerToOpen = Math.round(db.verno * 10);
    var schemaPatchMode = false;
    function throwIfCancelled() {
        if (state.openCanceller !== openCanceller) throw new $786a5f856536c5d4$var$exceptions.DatabaseClosed('db.open() was cancelled');
    }
    var resolveDbReady = state.dbReadyResolve, upgradeTransaction = null, wasCreated = false;
    var tryOpenDB = function() {
        return new $786a5f856536c5d4$var$DexiePromise(function(resolve, reject) {
            throwIfCancelled();
            if (!indexedDB1) throw new $786a5f856536c5d4$var$exceptions.MissingAPI();
            var dbName = db.name;
            var req = state.autoSchema || !nativeVerToOpen ? indexedDB1.open(dbName) : indexedDB1.open(dbName, nativeVerToOpen);
            if (!req) throw new $786a5f856536c5d4$var$exceptions.MissingAPI();
            req.onerror = $786a5f856536c5d4$var$eventRejectHandler(reject);
            req.onblocked = $786a5f856536c5d4$var$wrap(db._fireOnBlocked);
            req.onupgradeneeded = $786a5f856536c5d4$var$wrap(function(e) {
                upgradeTransaction = req.transaction;
                if (state.autoSchema && !db._options.allowEmptyDB) {
                    req.onerror = $786a5f856536c5d4$var$preventDefault;
                    upgradeTransaction.abort();
                    req.result.close();
                    var delreq = indexedDB1.deleteDatabase(dbName);
                    delreq.onsuccess = delreq.onerror = $786a5f856536c5d4$var$wrap(function() {
                        reject(new $786a5f856536c5d4$var$exceptions.NoSuchDatabase("Database ".concat(dbName, " doesnt exist")));
                    });
                } else {
                    upgradeTransaction.onerror = $786a5f856536c5d4$var$eventRejectHandler(reject);
                    var oldVer = e.oldVersion > Math.pow(2, 62) ? 0 : e.oldVersion;
                    wasCreated = oldVer < 1;
                    db.idbdb = req.result;
                    if (schemaPatchMode) $786a5f856536c5d4$var$patchCurrentVersion(db, upgradeTransaction);
                    $786a5f856536c5d4$var$runUpgraders(db, oldVer / 10, upgradeTransaction, reject);
                }
            }, reject);
            req.onsuccess = $786a5f856536c5d4$var$wrap(function() {
                upgradeTransaction = null;
                var idbdb = db.idbdb = req.result;
                var objectStoreNames = $786a5f856536c5d4$var$slice(idbdb.objectStoreNames);
                if (objectStoreNames.length > 0) try {
                    var tmpTrans = idbdb.transaction($786a5f856536c5d4$var$safariMultiStoreFix(objectStoreNames), 'readonly');
                    if (state.autoSchema) $786a5f856536c5d4$var$readGlobalSchema(db, idbdb, tmpTrans);
                    else {
                        $786a5f856536c5d4$var$adjustToExistingIndexNames(db, db._dbSchema, tmpTrans);
                        if (!$786a5f856536c5d4$var$verifyInstalledSchema(db, tmpTrans) && !schemaPatchMode) {
                            console.warn("Dexie SchemaDiff: Schema was extended without increasing the number passed to db.version(). Dexie will add missing parts and increment native version number to workaround this.");
                            idbdb.close();
                            nativeVerToOpen = idbdb.version + 1;
                            schemaPatchMode = true;
                            return resolve(tryOpenDB());
                        }
                    }
                    $786a5f856536c5d4$var$generateMiddlewareStacks(db, tmpTrans);
                } catch (e) {}
                $786a5f856536c5d4$var$connections.push(db);
                idbdb.onversionchange = $786a5f856536c5d4$var$wrap(function(ev) {
                    state.vcFired = true;
                    db.on("versionchange").fire(ev);
                });
                idbdb.onclose = $786a5f856536c5d4$var$wrap(function() {
                    db.close({
                        disableAutoOpen: false
                    });
                });
                if (wasCreated) $786a5f856536c5d4$var$_onDatabaseCreated(db._deps, dbName);
                resolve();
            }, reject);
        }).catch(function(err) {
            switch(err === null || err === void 0 ? void 0 : err.name){
                case "UnknownError":
                    if (state.PR1398_maxLoop > 0) {
                        state.PR1398_maxLoop--;
                        console.warn('Dexie: Workaround for Chrome UnknownError on open()');
                        return tryOpenDB();
                    }
                    break;
                case "VersionError":
                    if (nativeVerToOpen > 0) {
                        nativeVerToOpen = 0;
                        return tryOpenDB();
                    }
                    break;
            }
            return $786a5f856536c5d4$var$DexiePromise.reject(err);
        });
    };
    return $786a5f856536c5d4$var$DexiePromise.race([
        openCanceller,
        (typeof navigator === 'undefined' ? $786a5f856536c5d4$var$DexiePromise.resolve() : $786a5f856536c5d4$var$idbReady()).then(tryOpenDB)
    ]).then(function() {
        throwIfCancelled();
        state.onReadyBeingFired = [];
        return $786a5f856536c5d4$var$DexiePromise.resolve($786a5f856536c5d4$var$vip(function() {
            return db.on.ready.fire(db.vip);
        })).then(function fireRemainders() {
            if (state.onReadyBeingFired.length > 0) {
                var remainders_1 = state.onReadyBeingFired.reduce($786a5f856536c5d4$var$promisableChain, $786a5f856536c5d4$var$nop);
                state.onReadyBeingFired = [];
                return $786a5f856536c5d4$var$DexiePromise.resolve($786a5f856536c5d4$var$vip(function() {
                    return remainders_1(db.vip);
                })).then(fireRemainders);
            }
        });
    }).finally(function() {
        if (state.openCanceller === openCanceller) {
            state.onReadyBeingFired = null;
            state.isBeingOpened = false;
        }
    }).catch(function(err) {
        state.dbOpenError = err;
        try {
            upgradeTransaction && upgradeTransaction.abort();
        } catch (_a) {}
        if (openCanceller === state.openCanceller) db._close();
        return $786a5f856536c5d4$var$rejection(err);
    }).finally(function() {
        state.openComplete = true;
        resolveDbReady();
    }).then(function() {
        if (wasCreated) {
            var everything_1 = {};
            db.tables.forEach(function(table) {
                table.schema.indexes.forEach(function(idx) {
                    if (idx.name) everything_1["idb://".concat(db.name, "/").concat(table.name, "/").concat(idx.name)] = new $786a5f856536c5d4$export$34cb5241245008dd(-Infinity, [
                        [
                            []
                        ]
                    ]);
                });
                everything_1["idb://".concat(db.name, "/").concat(table.name, "/")] = everything_1["idb://".concat(db.name, "/").concat(table.name, "/:dels")] = new $786a5f856536c5d4$export$34cb5241245008dd(-Infinity, [
                    [
                        []
                    ]
                ]);
            });
            $786a5f856536c5d4$var$globalEvents($786a5f856536c5d4$var$DEXIE_STORAGE_MUTATED_EVENT_NAME).fire(everything_1);
            $786a5f856536c5d4$var$signalSubscribersNow(everything_1, true);
        }
        return db;
    });
}
function $786a5f856536c5d4$var$awaitIterator(iterator) {
    var callNext = function(result) {
        return iterator.next(result);
    }, doThrow = function(error) {
        return iterator.throw(error);
    }, onSuccess = step(callNext), onError = step(doThrow);
    function step(getNext) {
        return function(val) {
            var next = getNext(val), value = next.value;
            return next.done ? value : !value || typeof value.then !== 'function' ? $786a5f856536c5d4$var$isArray(value) ? Promise.all(value).then(onSuccess, onError) : onSuccess(value) : value.then(onSuccess, onError);
        };
    }
    return step(callNext)();
}
function $786a5f856536c5d4$var$extractTransactionArgs(mode, _tableArgs_, scopeFunc) {
    var i = arguments.length;
    if (i < 2) throw new $786a5f856536c5d4$var$exceptions.InvalidArgument("Too few arguments");
    var args = new Array(i - 1);
    while(--i)args[i - 1] = arguments[i];
    scopeFunc = args.pop();
    var tables = $786a5f856536c5d4$var$flatten(args);
    return [
        mode,
        tables,
        scopeFunc
    ];
}
function $786a5f856536c5d4$var$enterTransactionScope(db, mode, storeNames, parentTransaction, scopeFunc) {
    return $786a5f856536c5d4$var$DexiePromise.resolve().then(function() {
        var transless = $786a5f856536c5d4$var$PSD.transless || $786a5f856536c5d4$var$PSD;
        var trans = db._createTransaction(mode, storeNames, db._dbSchema, parentTransaction);
        trans.explicit = true;
        var zoneProps = {
            trans: trans,
            transless: transless
        };
        if (parentTransaction) trans.idbtrans = parentTransaction.idbtrans;
        else try {
            trans.create();
            trans.idbtrans._explicit = true;
            db._state.PR1398_maxLoop = 3;
        } catch (ex) {
            if (ex.name === $786a5f856536c5d4$var$errnames.InvalidState && db.isOpen() && --db._state.PR1398_maxLoop > 0) {
                console.warn('Dexie: Need to reopen db');
                db.close({
                    disableAutoOpen: false
                });
                return db.open().then(function() {
                    return $786a5f856536c5d4$var$enterTransactionScope(db, mode, storeNames, null, scopeFunc);
                });
            }
            return $786a5f856536c5d4$var$rejection(ex);
        }
        var scopeFuncIsAsync = $786a5f856536c5d4$var$isAsyncFunction(scopeFunc);
        if (scopeFuncIsAsync) $786a5f856536c5d4$var$incrementExpectedAwaits();
        var returnValue;
        var promiseFollowed = $786a5f856536c5d4$var$DexiePromise.follow(function() {
            returnValue = scopeFunc.call(trans, trans);
            if (returnValue) {
                if (scopeFuncIsAsync) {
                    var decrementor = $786a5f856536c5d4$var$decrementExpectedAwaits.bind(null, null);
                    returnValue.then(decrementor, decrementor);
                } else if (typeof returnValue.next === 'function' && typeof returnValue.throw === 'function') returnValue = $786a5f856536c5d4$var$awaitIterator(returnValue);
            }
        }, zoneProps);
        return (returnValue && typeof returnValue.then === 'function' ? $786a5f856536c5d4$var$DexiePromise.resolve(returnValue).then(function(x) {
            return trans.active ? x : $786a5f856536c5d4$var$rejection(new $786a5f856536c5d4$var$exceptions.PrematureCommit("Transaction committed too early. See http://bit.ly/2kdckMn"));
        }) : promiseFollowed.then(function() {
            return returnValue;
        })).then(function(x) {
            if (parentTransaction) trans._resolve();
            return trans._completion.then(function() {
                return x;
            });
        }).catch(function(e) {
            trans._reject(e);
            return $786a5f856536c5d4$var$rejection(e);
        });
    });
}
function $786a5f856536c5d4$var$pad(a, value, count) {
    var result = $786a5f856536c5d4$var$isArray(a) ? a.slice() : [
        a
    ];
    for(var i = 0; i < count; ++i)result.push(value);
    return result;
}
function $786a5f856536c5d4$var$createVirtualIndexMiddleware(down) {
    return $786a5f856536c5d4$var$__assign($786a5f856536c5d4$var$__assign({}, down), {
        table: function(tableName) {
            var table = down.table(tableName);
            var schema = table.schema;
            var indexLookup = {};
            var allVirtualIndexes = [];
            function addVirtualIndexes(keyPath, keyTail, lowLevelIndex) {
                var keyPathAlias = $786a5f856536c5d4$var$getKeyPathAlias(keyPath);
                var indexList = indexLookup[keyPathAlias] = indexLookup[keyPathAlias] || [];
                var keyLength = keyPath == null ? 0 : typeof keyPath === 'string' ? 1 : keyPath.length;
                var isVirtual = keyTail > 0;
                var virtualIndex = $786a5f856536c5d4$var$__assign($786a5f856536c5d4$var$__assign({}, lowLevelIndex), {
                    name: isVirtual ? "".concat(keyPathAlias, "(virtual-from:").concat(lowLevelIndex.name, ")") : lowLevelIndex.name,
                    lowLevelIndex: lowLevelIndex,
                    isVirtual: isVirtual,
                    keyTail: keyTail,
                    keyLength: keyLength,
                    extractKey: $786a5f856536c5d4$var$getKeyExtractor(keyPath),
                    unique: !isVirtual && lowLevelIndex.unique
                });
                indexList.push(virtualIndex);
                if (!virtualIndex.isPrimaryKey) allVirtualIndexes.push(virtualIndex);
                if (keyLength > 1) {
                    var virtualKeyPath = keyLength === 2 ? keyPath[0] : keyPath.slice(0, keyLength - 1);
                    addVirtualIndexes(virtualKeyPath, keyTail + 1, lowLevelIndex);
                }
                indexList.sort(function(a, b) {
                    return a.keyTail - b.keyTail;
                });
                return virtualIndex;
            }
            var primaryKey = addVirtualIndexes(schema.primaryKey.keyPath, 0, schema.primaryKey);
            indexLookup[":id"] = [
                primaryKey
            ];
            for(var _i = 0, _a = schema.indexes; _i < _a.length; _i++){
                var index = _a[_i];
                addVirtualIndexes(index.keyPath, 0, index);
            }
            function findBestIndex(keyPath) {
                var result = indexLookup[$786a5f856536c5d4$var$getKeyPathAlias(keyPath)];
                return result && result[0];
            }
            function translateRange(range, keyTail) {
                return {
                    type: range.type === 1 ? 2 : range.type,
                    lower: $786a5f856536c5d4$var$pad(range.lower, range.lowerOpen ? down.MAX_KEY : down.MIN_KEY, keyTail),
                    lowerOpen: true,
                    upper: $786a5f856536c5d4$var$pad(range.upper, range.upperOpen ? down.MIN_KEY : down.MAX_KEY, keyTail),
                    upperOpen: true
                };
            }
            function translateRequest(req) {
                var index = req.query.index;
                return index.isVirtual ? $786a5f856536c5d4$var$__assign($786a5f856536c5d4$var$__assign({}, req), {
                    query: {
                        index: index.lowLevelIndex,
                        range: translateRange(req.query.range, index.keyTail)
                    }
                }) : req;
            }
            var result = $786a5f856536c5d4$var$__assign($786a5f856536c5d4$var$__assign({}, table), {
                schema: $786a5f856536c5d4$var$__assign($786a5f856536c5d4$var$__assign({}, schema), {
                    primaryKey: primaryKey,
                    indexes: allVirtualIndexes,
                    getIndexByKeyPath: findBestIndex
                }),
                count: function(req) {
                    return table.count(translateRequest(req));
                },
                query: function(req) {
                    return table.query(translateRequest(req));
                },
                openCursor: function(req) {
                    var _a = req.query.index, keyTail = _a.keyTail, isVirtual = _a.isVirtual, keyLength = _a.keyLength;
                    if (!isVirtual) return table.openCursor(req);
                    function createVirtualCursor(cursor) {
                        function _continue(key) {
                            key != null ? cursor.continue($786a5f856536c5d4$var$pad(key, req.reverse ? down.MAX_KEY : down.MIN_KEY, keyTail)) : req.unique ? cursor.continue(cursor.key.slice(0, keyLength).concat(req.reverse ? down.MIN_KEY : down.MAX_KEY, keyTail)) : cursor.continue();
                        }
                        var virtualCursor = Object.create(cursor, {
                            continue: {
                                value: _continue
                            },
                            continuePrimaryKey: {
                                value: function(key, primaryKey) {
                                    cursor.continuePrimaryKey($786a5f856536c5d4$var$pad(key, down.MAX_KEY, keyTail), primaryKey);
                                }
                            },
                            primaryKey: {
                                get: function() {
                                    return cursor.primaryKey;
                                }
                            },
                            key: {
                                get: function() {
                                    var key = cursor.key;
                                    return keyLength === 1 ? key[0] : key.slice(0, keyLength);
                                }
                            },
                            value: {
                                get: function() {
                                    return cursor.value;
                                }
                            }
                        });
                        return virtualCursor;
                    }
                    return table.openCursor(translateRequest(req)).then(function(cursor) {
                        return cursor && createVirtualCursor(cursor);
                    });
                }
            });
            return result;
        }
    });
}
var $786a5f856536c5d4$var$virtualIndexMiddleware = {
    stack: "dbcore",
    name: "VirtualIndexMiddleware",
    level: 1,
    create: $786a5f856536c5d4$var$createVirtualIndexMiddleware
};
function $786a5f856536c5d4$var$getObjectDiff(a, b, rv, prfx) {
    rv = rv || {};
    prfx = prfx || '';
    $786a5f856536c5d4$var$keys(a).forEach(function(prop) {
        if (!$786a5f856536c5d4$var$hasOwn(b, prop)) rv[prfx + prop] = undefined;
        else {
            var ap = a[prop], bp = b[prop];
            if (typeof ap === 'object' && typeof bp === 'object' && ap && bp) {
                var apTypeName = $786a5f856536c5d4$var$toStringTag(ap);
                var bpTypeName = $786a5f856536c5d4$var$toStringTag(bp);
                if (apTypeName !== bpTypeName) rv[prfx + prop] = b[prop];
                else if (apTypeName === 'Object') $786a5f856536c5d4$var$getObjectDiff(ap, bp, rv, prfx + prop + '.');
                else if (ap !== bp) rv[prfx + prop] = b[prop];
            } else if (ap !== bp) rv[prfx + prop] = b[prop];
        }
    });
    $786a5f856536c5d4$var$keys(b).forEach(function(prop) {
        if (!$786a5f856536c5d4$var$hasOwn(a, prop)) rv[prfx + prop] = b[prop];
    });
    return rv;
}
function $786a5f856536c5d4$var$getEffectiveKeys(primaryKey, req) {
    if (req.type === 'delete') return req.keys;
    return req.keys || req.values.map(primaryKey.extractKey);
}
var $786a5f856536c5d4$var$hooksMiddleware = {
    stack: "dbcore",
    name: "HooksMiddleware",
    level: 2,
    create: function(downCore) {
        return $786a5f856536c5d4$var$__assign($786a5f856536c5d4$var$__assign({}, downCore), {
            table: function(tableName) {
                var downTable = downCore.table(tableName);
                var primaryKey = downTable.schema.primaryKey;
                var tableMiddleware = $786a5f856536c5d4$var$__assign($786a5f856536c5d4$var$__assign({}, downTable), {
                    mutate: function(req) {
                        var dxTrans = $786a5f856536c5d4$var$PSD.trans;
                        var _a = dxTrans.table(tableName).hook, deleting = _a.deleting, creating = _a.creating, updating = _a.updating;
                        switch(req.type){
                            case 'add':
                                if (creating.fire === $786a5f856536c5d4$var$nop) break;
                                return dxTrans._promise('readwrite', function() {
                                    return addPutOrDelete(req);
                                }, true);
                            case 'put':
                                if (creating.fire === $786a5f856536c5d4$var$nop && updating.fire === $786a5f856536c5d4$var$nop) break;
                                return dxTrans._promise('readwrite', function() {
                                    return addPutOrDelete(req);
                                }, true);
                            case 'delete':
                                if (deleting.fire === $786a5f856536c5d4$var$nop) break;
                                return dxTrans._promise('readwrite', function() {
                                    return addPutOrDelete(req);
                                }, true);
                            case 'deleteRange':
                                if (deleting.fire === $786a5f856536c5d4$var$nop) break;
                                return dxTrans._promise('readwrite', function() {
                                    return deleteRange(req);
                                }, true);
                        }
                        return downTable.mutate(req);
                        function addPutOrDelete(req) {
                            var dxTrans = $786a5f856536c5d4$var$PSD.trans;
                            var keys = req.keys || $786a5f856536c5d4$var$getEffectiveKeys(primaryKey, req);
                            if (!keys) throw new Error("Keys missing");
                            req = req.type === 'add' || req.type === 'put' ? $786a5f856536c5d4$var$__assign($786a5f856536c5d4$var$__assign({}, req), {
                                keys: keys
                            }) : $786a5f856536c5d4$var$__assign({}, req);
                            if (req.type !== 'delete') req.values = $786a5f856536c5d4$var$__spreadArray([], req.values, true);
                            if (req.keys) req.keys = $786a5f856536c5d4$var$__spreadArray([], req.keys, true);
                            return $786a5f856536c5d4$var$getExistingValues(downTable, req, keys).then(function(existingValues) {
                                var contexts = keys.map(function(key, i) {
                                    var existingValue = existingValues[i];
                                    var ctx = {
                                        onerror: null,
                                        onsuccess: null
                                    };
                                    if (req.type === 'delete') deleting.fire.call(ctx, key, existingValue, dxTrans);
                                    else if (req.type === 'add' || existingValue === undefined) {
                                        var generatedPrimaryKey = creating.fire.call(ctx, key, req.values[i], dxTrans);
                                        if (key == null && generatedPrimaryKey != null) {
                                            key = generatedPrimaryKey;
                                            req.keys[i] = key;
                                            if (!primaryKey.outbound) $786a5f856536c5d4$var$setByKeyPath(req.values[i], primaryKey.keyPath, key);
                                        }
                                    } else {
                                        var objectDiff = $786a5f856536c5d4$var$getObjectDiff(existingValue, req.values[i]);
                                        var additionalChanges_1 = updating.fire.call(ctx, objectDiff, key, existingValue, dxTrans);
                                        if (additionalChanges_1) {
                                            var requestedValue_1 = req.values[i];
                                            Object.keys(additionalChanges_1).forEach(function(keyPath) {
                                                if ($786a5f856536c5d4$var$hasOwn(requestedValue_1, keyPath)) requestedValue_1[keyPath] = additionalChanges_1[keyPath];
                                                else $786a5f856536c5d4$var$setByKeyPath(requestedValue_1, keyPath, additionalChanges_1[keyPath]);
                                            });
                                        }
                                    }
                                    return ctx;
                                });
                                return downTable.mutate(req).then(function(_a) {
                                    var failures = _a.failures, results = _a.results, numFailures = _a.numFailures, lastResult = _a.lastResult;
                                    for(var i = 0; i < keys.length; ++i){
                                        var primKey = results ? results[i] : keys[i];
                                        var ctx = contexts[i];
                                        if (primKey == null) ctx.onerror && ctx.onerror(failures[i]);
                                        else ctx.onsuccess && ctx.onsuccess(req.type === 'put' && existingValues[i] ? req.values[i] : primKey);
                                    }
                                    return {
                                        failures: failures,
                                        results: results,
                                        numFailures: numFailures,
                                        lastResult: lastResult
                                    };
                                }).catch(function(error) {
                                    contexts.forEach(function(ctx) {
                                        return ctx.onerror && ctx.onerror(error);
                                    });
                                    return Promise.reject(error);
                                });
                            });
                        }
                        function deleteRange(req) {
                            return deleteNextChunk(req.trans, req.range, 10000);
                        }
                        function deleteNextChunk(trans, range, limit) {
                            return downTable.query({
                                trans: trans,
                                values: false,
                                query: {
                                    index: primaryKey,
                                    range: range
                                },
                                limit: limit
                            }).then(function(_a) {
                                var result = _a.result;
                                return addPutOrDelete({
                                    type: 'delete',
                                    keys: result,
                                    trans: trans
                                }).then(function(res) {
                                    if (res.numFailures > 0) return Promise.reject(res.failures[0]);
                                    if (result.length < limit) return {
                                        failures: [],
                                        numFailures: 0,
                                        lastResult: undefined
                                    };
                                    else return deleteNextChunk(trans, $786a5f856536c5d4$var$__assign($786a5f856536c5d4$var$__assign({}, range), {
                                        lower: result[result.length - 1],
                                        lowerOpen: true
                                    }), limit);
                                });
                            });
                        }
                    }
                });
                return tableMiddleware;
            }
        });
    }
};
function $786a5f856536c5d4$var$getExistingValues(table, req, effectiveKeys) {
    return req.type === "add" ? Promise.resolve([]) : table.getMany({
        trans: req.trans,
        keys: effectiveKeys,
        cache: "immutable"
    });
}
function $786a5f856536c5d4$var$getFromTransactionCache(keys, cache, clone) {
    try {
        if (!cache) return null;
        if (cache.keys.length < keys.length) return null;
        var result = [];
        for(var i = 0, j = 0; i < cache.keys.length && j < keys.length; ++i){
            if ($786a5f856536c5d4$export$6154dcdb7d23e37b(cache.keys[i], keys[j]) !== 0) continue;
            result.push(clone ? $786a5f856536c5d4$var$deepClone(cache.values[i]) : cache.values[i]);
            ++j;
        }
        return result.length === keys.length ? result : null;
    } catch (_a) {
        return null;
    }
}
var $786a5f856536c5d4$var$cacheExistingValuesMiddleware = {
    stack: "dbcore",
    level: -1,
    create: function(core) {
        return {
            table: function(tableName) {
                var table = core.table(tableName);
                return $786a5f856536c5d4$var$__assign($786a5f856536c5d4$var$__assign({}, table), {
                    getMany: function(req) {
                        if (!req.cache) return table.getMany(req);
                        var cachedResult = $786a5f856536c5d4$var$getFromTransactionCache(req.keys, req.trans["_cache"], req.cache === "clone");
                        if (cachedResult) return $786a5f856536c5d4$var$DexiePromise.resolve(cachedResult);
                        return table.getMany(req).then(function(res) {
                            req.trans["_cache"] = {
                                keys: req.keys,
                                values: req.cache === "clone" ? $786a5f856536c5d4$var$deepClone(res) : res
                            };
                            return res;
                        });
                    },
                    mutate: function(req) {
                        if (req.type !== "add") req.trans["_cache"] = null;
                        return table.mutate(req);
                    }
                });
            }
        };
    }
};
function $786a5f856536c5d4$var$isCachableContext(ctx, table) {
    return ctx.trans.mode === 'readonly' && !!ctx.subscr && !ctx.trans.explicit && ctx.trans.db._options.cache !== 'disabled' && !table.schema.primaryKey.outbound;
}
function $786a5f856536c5d4$var$isCachableRequest(type, req) {
    switch(type){
        case 'query':
            return req.values && !req.unique;
        case 'get':
            return false;
        case 'getMany':
            return false;
        case 'count':
            return false;
        case 'openCursor':
            return false;
    }
}
var $786a5f856536c5d4$var$observabilityMiddleware = {
    stack: "dbcore",
    level: 0,
    name: "Observability",
    create: function(core) {
        var dbName = core.schema.name;
        var FULL_RANGE = new $786a5f856536c5d4$export$34cb5241245008dd(core.MIN_KEY, core.MAX_KEY);
        return $786a5f856536c5d4$var$__assign($786a5f856536c5d4$var$__assign({}, core), {
            transaction: function(stores, mode, options) {
                if ($786a5f856536c5d4$var$PSD.subscr && mode !== 'readonly') throw new $786a5f856536c5d4$var$exceptions.ReadOnly("Readwrite transaction in liveQuery context. Querier source: ".concat($786a5f856536c5d4$var$PSD.querier));
                return core.transaction(stores, mode, options);
            },
            table: function(tableName) {
                var table = core.table(tableName);
                var schema = table.schema;
                var primaryKey = schema.primaryKey, indexes = schema.indexes;
                var extractKey = primaryKey.extractKey, outbound = primaryKey.outbound;
                var indexesWithAutoIncPK = primaryKey.autoIncrement && indexes.filter(function(index) {
                    return index.compound && index.keyPath.includes(primaryKey.keyPath);
                });
                var tableClone = $786a5f856536c5d4$var$__assign($786a5f856536c5d4$var$__assign({}, table), {
                    mutate: function(req) {
                        var _a, _b;
                        var trans = req.trans;
                        var mutatedParts = req.mutatedParts || (req.mutatedParts = {});
                        var getRangeSet = function(indexName) {
                            var part = "idb://".concat(dbName, "/").concat(tableName, "/").concat(indexName);
                            return mutatedParts[part] || (mutatedParts[part] = new $786a5f856536c5d4$export$34cb5241245008dd());
                        };
                        var pkRangeSet = getRangeSet("");
                        var delsRangeSet = getRangeSet(":dels");
                        var type = req.type;
                        var _c = req.type === "deleteRange" ? [
                            req.range
                        ] : req.type === "delete" ? [
                            req.keys
                        ] : req.values.length < 50 ? [
                            $786a5f856536c5d4$var$getEffectiveKeys(primaryKey, req).filter(function(id) {
                                return id;
                            }),
                            req.values
                        ] : [], keys = _c[0], newObjs = _c[1];
                        var oldCache = req.trans["_cache"];
                        if ($786a5f856536c5d4$var$isArray(keys)) {
                            pkRangeSet.addKeys(keys);
                            var oldObjs = type === 'delete' || keys.length === newObjs.length ? $786a5f856536c5d4$var$getFromTransactionCache(keys, oldCache) : null;
                            if (!oldObjs) delsRangeSet.addKeys(keys);
                            if (oldObjs || newObjs) $786a5f856536c5d4$var$trackAffectedIndexes(getRangeSet, schema, oldObjs, newObjs);
                        } else if (keys) {
                            var range = {
                                from: (_a = keys.lower) !== null && _a !== void 0 ? _a : core.MIN_KEY,
                                to: (_b = keys.upper) !== null && _b !== void 0 ? _b : core.MAX_KEY
                            };
                            delsRangeSet.add(range);
                            pkRangeSet.add(range);
                        } else {
                            pkRangeSet.add(FULL_RANGE);
                            delsRangeSet.add(FULL_RANGE);
                            schema.indexes.forEach(function(idx) {
                                return getRangeSet(idx.name).add(FULL_RANGE);
                            });
                        }
                        return table.mutate(req).then(function(res) {
                            if (keys && (req.type === 'add' || req.type === 'put')) {
                                pkRangeSet.addKeys(res.results);
                                if (indexesWithAutoIncPK) indexesWithAutoIncPK.forEach(function(idx) {
                                    var idxVals = req.values.map(function(v) {
                                        return idx.extractKey(v);
                                    });
                                    var pkPos = idx.keyPath.findIndex(function(prop) {
                                        return prop === primaryKey.keyPath;
                                    });
                                    for(var i = 0, len = res.results.length; i < len; ++i)idxVals[i][pkPos] = res.results[i];
                                    getRangeSet(idx.name).addKeys(idxVals);
                                });
                            }
                            trans.mutatedParts = $786a5f856536c5d4$var$extendObservabilitySet(trans.mutatedParts || {}, mutatedParts);
                            return res;
                        });
                    }
                });
                var getRange = function(_a) {
                    var _b, _c;
                    var _d = _a.query, index = _d.index, range = _d.range;
                    return [
                        index,
                        new $786a5f856536c5d4$export$34cb5241245008dd((_b = range.lower) !== null && _b !== void 0 ? _b : core.MIN_KEY, (_c = range.upper) !== null && _c !== void 0 ? _c : core.MAX_KEY)
                    ];
                };
                var readSubscribers = {
                    get: function(req) {
                        return [
                            primaryKey,
                            new $786a5f856536c5d4$export$34cb5241245008dd(req.key)
                        ];
                    },
                    getMany: function(req) {
                        return [
                            primaryKey,
                            new $786a5f856536c5d4$export$34cb5241245008dd().addKeys(req.keys)
                        ];
                    },
                    count: getRange,
                    query: getRange,
                    openCursor: getRange
                };
                $786a5f856536c5d4$var$keys(readSubscribers).forEach(function(method) {
                    tableClone[method] = function(req) {
                        var subscr = $786a5f856536c5d4$var$PSD.subscr;
                        var isLiveQuery = !!subscr;
                        var cachable = $786a5f856536c5d4$var$isCachableContext($786a5f856536c5d4$var$PSD, table) && $786a5f856536c5d4$var$isCachableRequest(method, req);
                        var obsSet = cachable ? req.obsSet = {} : subscr;
                        if (isLiveQuery) {
                            var getRangeSet = function(indexName) {
                                var part = "idb://".concat(dbName, "/").concat(tableName, "/").concat(indexName);
                                return obsSet[part] || (obsSet[part] = new $786a5f856536c5d4$export$34cb5241245008dd());
                            };
                            var pkRangeSet_1 = getRangeSet("");
                            var delsRangeSet_1 = getRangeSet(":dels");
                            var _a = readSubscribers[method](req), queriedIndex = _a[0], queriedRanges = _a[1];
                            if (method === 'query' && queriedIndex.isPrimaryKey && !req.values) delsRangeSet_1.add(queriedRanges);
                            else getRangeSet(queriedIndex.name || "").add(queriedRanges);
                            if (!queriedIndex.isPrimaryKey) {
                                if (method === "count") delsRangeSet_1.add(FULL_RANGE);
                                else {
                                    var keysPromise_1 = method === "query" && outbound && req.values && table.query($786a5f856536c5d4$var$__assign($786a5f856536c5d4$var$__assign({}, req), {
                                        values: false
                                    }));
                                    return table[method].apply(this, arguments).then(function(res) {
                                        if (method === "query") {
                                            if (outbound && req.values) return keysPromise_1.then(function(_a) {
                                                var resultingKeys = _a.result;
                                                pkRangeSet_1.addKeys(resultingKeys);
                                                return res;
                                            });
                                            var pKeys = req.values ? res.result.map(extractKey) : res.result;
                                            if (req.values) pkRangeSet_1.addKeys(pKeys);
                                            else delsRangeSet_1.addKeys(pKeys);
                                        } else if (method === "openCursor") {
                                            var cursor_1 = res;
                                            var wantValues_1 = req.values;
                                            return cursor_1 && Object.create(cursor_1, {
                                                key: {
                                                    get: function() {
                                                        delsRangeSet_1.addKey(cursor_1.primaryKey);
                                                        return cursor_1.key;
                                                    }
                                                },
                                                primaryKey: {
                                                    get: function() {
                                                        var pkey = cursor_1.primaryKey;
                                                        delsRangeSet_1.addKey(pkey);
                                                        return pkey;
                                                    }
                                                },
                                                value: {
                                                    get: function() {
                                                        wantValues_1 && pkRangeSet_1.addKey(cursor_1.primaryKey);
                                                        return cursor_1.value;
                                                    }
                                                }
                                            });
                                        }
                                        return res;
                                    });
                                }
                            }
                        }
                        return table[method].apply(this, arguments);
                    };
                });
                return tableClone;
            }
        });
    }
};
function $786a5f856536c5d4$var$trackAffectedIndexes(getRangeSet, schema, oldObjs, newObjs) {
    function addAffectedIndex(ix) {
        var rangeSet = getRangeSet(ix.name || "");
        function extractKey(obj) {
            return obj != null ? ix.extractKey(obj) : null;
        }
        var addKeyOrKeys = function(key) {
            return ix.multiEntry && $786a5f856536c5d4$var$isArray(key) ? key.forEach(function(key) {
                return rangeSet.addKey(key);
            }) : rangeSet.addKey(key);
        };
        (oldObjs || newObjs).forEach(function(_, i) {
            var oldKey = oldObjs && extractKey(oldObjs[i]);
            var newKey = newObjs && extractKey(newObjs[i]);
            if ($786a5f856536c5d4$export$6154dcdb7d23e37b(oldKey, newKey) !== 0) {
                if (oldKey != null) addKeyOrKeys(oldKey);
                if (newKey != null) addKeyOrKeys(newKey);
            }
        });
    }
    schema.indexes.forEach(addAffectedIndex);
}
function $786a5f856536c5d4$var$adjustOptimisticFromFailures(tblCache, req, res) {
    if (res.numFailures === 0) return req;
    if (req.type === 'deleteRange') return null;
    var numBulkOps = req.keys ? req.keys.length : 'values' in req && req.values ? req.values.length : 1;
    if (res.numFailures === numBulkOps) return null;
    var clone = $786a5f856536c5d4$var$__assign({}, req);
    if ($786a5f856536c5d4$var$isArray(clone.keys)) clone.keys = clone.keys.filter(function(_, i) {
        return !(i in res.failures);
    });
    if ('values' in clone && $786a5f856536c5d4$var$isArray(clone.values)) clone.values = clone.values.filter(function(_, i) {
        return !(i in res.failures);
    });
    return clone;
}
function $786a5f856536c5d4$var$isAboveLower(key, range) {
    return range.lower === undefined ? true : range.lowerOpen ? $786a5f856536c5d4$export$6154dcdb7d23e37b(key, range.lower) > 0 : $786a5f856536c5d4$export$6154dcdb7d23e37b(key, range.lower) >= 0;
}
function $786a5f856536c5d4$var$isBelowUpper(key, range) {
    return range.upper === undefined ? true : range.upperOpen ? $786a5f856536c5d4$export$6154dcdb7d23e37b(key, range.upper) < 0 : $786a5f856536c5d4$export$6154dcdb7d23e37b(key, range.upper) <= 0;
}
function $786a5f856536c5d4$var$isWithinRange(key, range) {
    return $786a5f856536c5d4$var$isAboveLower(key, range) && $786a5f856536c5d4$var$isBelowUpper(key, range);
}
function $786a5f856536c5d4$var$applyOptimisticOps(result, req, ops, table, cacheEntry, immutable) {
    if (!ops || ops.length === 0) return result;
    var index = req.query.index;
    var multiEntry = index.multiEntry;
    var queryRange = req.query.range;
    var primaryKey = table.schema.primaryKey;
    var extractPrimKey = primaryKey.extractKey;
    var extractIndex = index.extractKey;
    var extractLowLevelIndex = (index.lowLevelIndex || index).extractKey;
    var finalResult = ops.reduce(function(result, op) {
        var modifedResult = result;
        var includedValues = [];
        if (op.type === 'add' || op.type === 'put') {
            var includedPKs = new $786a5f856536c5d4$export$34cb5241245008dd();
            for(var i = op.values.length - 1; i >= 0; --i){
                var value = op.values[i];
                var pk = extractPrimKey(value);
                if (includedPKs.hasKey(pk)) continue;
                var key = extractIndex(value);
                if (multiEntry && $786a5f856536c5d4$var$isArray(key) ? key.some(function(k) {
                    return $786a5f856536c5d4$var$isWithinRange(k, queryRange);
                }) : $786a5f856536c5d4$var$isWithinRange(key, queryRange)) {
                    includedPKs.addKey(pk);
                    includedValues.push(value);
                }
            }
        }
        switch(op.type){
            case 'add':
                var existingKeys_1 = new $786a5f856536c5d4$export$34cb5241245008dd().addKeys(req.values ? result.map(function(v) {
                    return extractPrimKey(v);
                }) : result);
                modifedResult = result.concat(req.values ? includedValues.filter(function(v) {
                    var key = extractPrimKey(v);
                    if (existingKeys_1.hasKey(key)) return false;
                    existingKeys_1.addKey(key);
                    return true;
                }) : includedValues.map(function(v) {
                    return extractPrimKey(v);
                }).filter(function(k) {
                    if (existingKeys_1.hasKey(k)) return false;
                    existingKeys_1.addKey(k);
                    return true;
                }));
                break;
            case 'put':
                var keySet_1 = new $786a5f856536c5d4$export$34cb5241245008dd().addKeys(op.values.map(function(v) {
                    return extractPrimKey(v);
                }));
                modifedResult = result.filter(function(item) {
                    return !keySet_1.hasKey(req.values ? extractPrimKey(item) : item);
                }).concat(req.values ? includedValues : includedValues.map(function(v) {
                    return extractPrimKey(v);
                }));
                break;
            case 'delete':
                var keysToDelete_1 = new $786a5f856536c5d4$export$34cb5241245008dd().addKeys(op.keys);
                modifedResult = result.filter(function(item) {
                    return !keysToDelete_1.hasKey(req.values ? extractPrimKey(item) : item);
                });
                break;
            case 'deleteRange':
                var range_1 = op.range;
                modifedResult = result.filter(function(item) {
                    return !$786a5f856536c5d4$var$isWithinRange(extractPrimKey(item), range_1);
                });
                break;
        }
        return modifedResult;
    }, result);
    if (finalResult === result) return result;
    finalResult.sort(function(a, b) {
        return $786a5f856536c5d4$export$6154dcdb7d23e37b(extractLowLevelIndex(a), extractLowLevelIndex(b)) || $786a5f856536c5d4$export$6154dcdb7d23e37b(extractPrimKey(a), extractPrimKey(b));
    });
    if (req.limit && req.limit < Infinity) {
        if (finalResult.length > req.limit) finalResult.length = req.limit;
        else if (result.length === req.limit && finalResult.length < req.limit) cacheEntry.dirty = true;
    }
    return immutable ? Object.freeze(finalResult) : finalResult;
}
function $786a5f856536c5d4$var$areRangesEqual(r1, r2) {
    return $786a5f856536c5d4$export$6154dcdb7d23e37b(r1.lower, r2.lower) === 0 && $786a5f856536c5d4$export$6154dcdb7d23e37b(r1.upper, r2.upper) === 0 && !!r1.lowerOpen === !!r2.lowerOpen && !!r1.upperOpen === !!r2.upperOpen;
}
function $786a5f856536c5d4$var$compareLowers(lower1, lower2, lowerOpen1, lowerOpen2) {
    if (lower1 === undefined) return lower2 !== undefined ? -1 : 0;
    if (lower2 === undefined) return 1;
    var c = $786a5f856536c5d4$export$6154dcdb7d23e37b(lower1, lower2);
    if (c === 0) {
        if (lowerOpen1 && lowerOpen2) return 0;
        if (lowerOpen1) return 1;
        if (lowerOpen2) return -1;
    }
    return c;
}
function $786a5f856536c5d4$var$compareUppers(upper1, upper2, upperOpen1, upperOpen2) {
    if (upper1 === undefined) return upper2 !== undefined ? 1 : 0;
    if (upper2 === undefined) return -1;
    var c = $786a5f856536c5d4$export$6154dcdb7d23e37b(upper1, upper2);
    if (c === 0) {
        if (upperOpen1 && upperOpen2) return 0;
        if (upperOpen1) return -1;
        if (upperOpen2) return 1;
    }
    return c;
}
function $786a5f856536c5d4$var$isSuperRange(r1, r2) {
    return $786a5f856536c5d4$var$compareLowers(r1.lower, r2.lower, r1.lowerOpen, r2.lowerOpen) <= 0 && $786a5f856536c5d4$var$compareUppers(r1.upper, r2.upper, r1.upperOpen, r2.upperOpen) >= 0;
}
function $786a5f856536c5d4$var$findCompatibleQuery(dbName, tableName, type, req) {
    var tblCache = $786a5f856536c5d4$var$cache["idb://".concat(dbName, "/").concat(tableName)];
    if (!tblCache) return [];
    var queries = tblCache.queries[type];
    if (!queries) return [
        null,
        false,
        tblCache,
        null
    ];
    var indexName = req.query ? req.query.index.name : null;
    var entries = queries[indexName || ''];
    if (!entries) return [
        null,
        false,
        tblCache,
        null
    ];
    switch(type){
        case 'query':
            var equalEntry = entries.find(function(entry) {
                return entry.req.limit === req.limit && entry.req.values === req.values && $786a5f856536c5d4$var$areRangesEqual(entry.req.query.range, req.query.range);
            });
            if (equalEntry) return [
                equalEntry,
                true,
                tblCache,
                entries
            ];
            var superEntry = entries.find(function(entry) {
                var limit = 'limit' in entry.req ? entry.req.limit : Infinity;
                return limit >= req.limit && (req.values ? entry.req.values : true) && $786a5f856536c5d4$var$isSuperRange(entry.req.query.range, req.query.range);
            });
            return [
                superEntry,
                false,
                tblCache,
                entries
            ];
        case 'count':
            var countQuery = entries.find(function(entry) {
                return $786a5f856536c5d4$var$areRangesEqual(entry.req.query.range, req.query.range);
            });
            return [
                countQuery,
                !!countQuery,
                tblCache,
                entries
            ];
    }
}
function $786a5f856536c5d4$var$subscribeToCacheEntry(cacheEntry, container, requery, signal) {
    cacheEntry.subscribers.add(requery);
    signal.addEventListener("abort", function() {
        cacheEntry.subscribers.delete(requery);
        if (cacheEntry.subscribers.size === 0) $786a5f856536c5d4$var$enqueForDeletion(cacheEntry, container);
    });
}
function $786a5f856536c5d4$var$enqueForDeletion(cacheEntry, container) {
    setTimeout(function() {
        if (cacheEntry.subscribers.size === 0) $786a5f856536c5d4$var$delArrayItem(container, cacheEntry);
    }, 3000);
}
var $786a5f856536c5d4$var$cacheMiddleware = {
    stack: 'dbcore',
    level: 0,
    name: 'Cache',
    create: function(core) {
        var dbName = core.schema.name;
        var coreMW = $786a5f856536c5d4$var$__assign($786a5f856536c5d4$var$__assign({}, core), {
            transaction: function(stores, mode, options) {
                var idbtrans = core.transaction(stores, mode, options);
                if (mode === 'readwrite') {
                    var ac_1 = new AbortController();
                    var signal = ac_1.signal;
                    var endTransaction = function(wasCommitted) {
                        return function() {
                            ac_1.abort();
                            if (mode === 'readwrite') {
                                var affectedSubscribers_1 = new Set();
                                for(var _i = 0, stores_1 = stores; _i < stores_1.length; _i++){
                                    var storeName = stores_1[_i];
                                    var tblCache = $786a5f856536c5d4$var$cache["idb://".concat(dbName, "/").concat(storeName)];
                                    if (tblCache) {
                                        var table = core.table(storeName);
                                        var ops = tblCache.optimisticOps.filter(function(op) {
                                            return op.trans === idbtrans;
                                        });
                                        if (idbtrans._explicit && wasCommitted && idbtrans.mutatedParts) for(var _a = 0, _b = Object.values(tblCache.queries.query); _a < _b.length; _a++){
                                            var entries = _b[_a];
                                            for(var _c = 0, _d = entries.slice(); _c < _d.length; _c++){
                                                var entry = _d[_c];
                                                if ($786a5f856536c5d4$var$obsSetsOverlap(entry.obsSet, idbtrans.mutatedParts)) {
                                                    $786a5f856536c5d4$var$delArrayItem(entries, entry);
                                                    entry.subscribers.forEach(function(requery) {
                                                        return affectedSubscribers_1.add(requery);
                                                    });
                                                }
                                            }
                                        }
                                        else if (ops.length > 0) {
                                            tblCache.optimisticOps = tblCache.optimisticOps.filter(function(op) {
                                                return op.trans !== idbtrans;
                                            });
                                            for(var _e = 0, _f = Object.values(tblCache.queries.query); _e < _f.length; _e++){
                                                var entries = _f[_e];
                                                for(var _g = 0, _h = entries.slice(); _g < _h.length; _g++){
                                                    var entry = _h[_g];
                                                    if (entry.res != null && idbtrans.mutatedParts) {
                                                        if (wasCommitted && !entry.dirty) {
                                                            var freezeResults = Object.isFrozen(entry.res);
                                                            var modRes = $786a5f856536c5d4$var$applyOptimisticOps(entry.res, entry.req, ops, table, entry, freezeResults);
                                                            if (entry.dirty) {
                                                                $786a5f856536c5d4$var$delArrayItem(entries, entry);
                                                                entry.subscribers.forEach(function(requery) {
                                                                    return affectedSubscribers_1.add(requery);
                                                                });
                                                            } else if (modRes !== entry.res) {
                                                                entry.res = modRes;
                                                                entry.promise = $786a5f856536c5d4$var$DexiePromise.resolve({
                                                                    result: modRes
                                                                });
                                                            }
                                                        } else {
                                                            if (entry.dirty) $786a5f856536c5d4$var$delArrayItem(entries, entry);
                                                            entry.subscribers.forEach(function(requery) {
                                                                return affectedSubscribers_1.add(requery);
                                                            });
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                                affectedSubscribers_1.forEach(function(requery) {
                                    return requery();
                                });
                            }
                        };
                    };
                    idbtrans.addEventListener('abort', endTransaction(false), {
                        signal: signal
                    });
                    idbtrans.addEventListener('error', endTransaction(false), {
                        signal: signal
                    });
                    idbtrans.addEventListener('complete', endTransaction(true), {
                        signal: signal
                    });
                }
                return idbtrans;
            },
            table: function(tableName) {
                var downTable = core.table(tableName);
                var primKey = downTable.schema.primaryKey;
                var tableMW = $786a5f856536c5d4$var$__assign($786a5f856536c5d4$var$__assign({}, downTable), {
                    mutate: function(req) {
                        var trans = $786a5f856536c5d4$var$PSD.trans;
                        if (primKey.outbound || trans.db._options.cache === 'disabled' || trans.explicit || trans.idbtrans.mode !== 'readwrite') return downTable.mutate(req);
                        var tblCache = $786a5f856536c5d4$var$cache["idb://".concat(dbName, "/").concat(tableName)];
                        if (!tblCache) return downTable.mutate(req);
                        var promise = downTable.mutate(req);
                        if ((req.type === 'add' || req.type === 'put') && (req.values.length >= 50 || $786a5f856536c5d4$var$getEffectiveKeys(primKey, req).some(function(key) {
                            return key == null;
                        }))) promise.then(function(res) {
                            var reqWithResolvedKeys = $786a5f856536c5d4$var$__assign($786a5f856536c5d4$var$__assign({}, req), {
                                values: req.values.map(function(value, i) {
                                    var _a;
                                    if (res.failures[i]) return value;
                                    var valueWithKey = ((_a = primKey.keyPath) === null || _a === void 0 ? void 0 : _a.includes('.')) ? $786a5f856536c5d4$var$deepClone(value) : $786a5f856536c5d4$var$__assign({}, value);
                                    $786a5f856536c5d4$var$setByKeyPath(valueWithKey, primKey.keyPath, res.results[i]);
                                    return valueWithKey;
                                })
                            });
                            var adjustedReq = $786a5f856536c5d4$var$adjustOptimisticFromFailures(tblCache, reqWithResolvedKeys, res);
                            tblCache.optimisticOps.push(adjustedReq);
                            queueMicrotask(function() {
                                return req.mutatedParts && $786a5f856536c5d4$var$signalSubscribersLazily(req.mutatedParts);
                            });
                        });
                        else {
                            tblCache.optimisticOps.push(req);
                            req.mutatedParts && $786a5f856536c5d4$var$signalSubscribersLazily(req.mutatedParts);
                            promise.then(function(res) {
                                if (res.numFailures > 0) {
                                    $786a5f856536c5d4$var$delArrayItem(tblCache.optimisticOps, req);
                                    var adjustedReq = $786a5f856536c5d4$var$adjustOptimisticFromFailures(tblCache, req, res);
                                    if (adjustedReq) tblCache.optimisticOps.push(adjustedReq);
                                    req.mutatedParts && $786a5f856536c5d4$var$signalSubscribersLazily(req.mutatedParts);
                                }
                            });
                            promise.catch(function() {
                                $786a5f856536c5d4$var$delArrayItem(tblCache.optimisticOps, req);
                                req.mutatedParts && $786a5f856536c5d4$var$signalSubscribersLazily(req.mutatedParts);
                            });
                        }
                        return promise;
                    },
                    query: function(req) {
                        var _a;
                        if (!$786a5f856536c5d4$var$isCachableContext($786a5f856536c5d4$var$PSD, downTable) || !$786a5f856536c5d4$var$isCachableRequest("query", req)) return downTable.query(req);
                        var freezeResults = ((_a = $786a5f856536c5d4$var$PSD.trans) === null || _a === void 0 ? void 0 : _a.db._options.cache) === 'immutable';
                        var _b = $786a5f856536c5d4$var$PSD, requery = _b.requery, signal = _b.signal;
                        var _c = $786a5f856536c5d4$var$findCompatibleQuery(dbName, tableName, 'query', req), cacheEntry = _c[0], exactMatch = _c[1], tblCache = _c[2], container = _c[3];
                        if (cacheEntry && exactMatch) cacheEntry.obsSet = req.obsSet;
                        else {
                            var promise = downTable.query(req).then(function(res) {
                                var result = res.result;
                                if (cacheEntry) cacheEntry.res = result;
                                if (freezeResults) {
                                    for(var i = 0, l = result.length; i < l; ++i)Object.freeze(result[i]);
                                    Object.freeze(result);
                                } else res.result = $786a5f856536c5d4$var$deepClone(result);
                                return res;
                            }).catch(function(error) {
                                if (container && cacheEntry) $786a5f856536c5d4$var$delArrayItem(container, cacheEntry);
                                return Promise.reject(error);
                            });
                            cacheEntry = {
                                obsSet: req.obsSet,
                                promise: promise,
                                subscribers: new Set(),
                                type: 'query',
                                req: req,
                                dirty: false
                            };
                            if (container) container.push(cacheEntry);
                            else {
                                container = [
                                    cacheEntry
                                ];
                                if (!tblCache) tblCache = $786a5f856536c5d4$var$cache["idb://".concat(dbName, "/").concat(tableName)] = {
                                    queries: {
                                        query: {},
                                        count: {}
                                    },
                                    objs: new Map(),
                                    optimisticOps: [],
                                    unsignaledParts: {}
                                };
                                tblCache.queries.query[req.query.index.name || ''] = container;
                            }
                        }
                        $786a5f856536c5d4$var$subscribeToCacheEntry(cacheEntry, container, requery, signal);
                        return cacheEntry.promise.then(function(res) {
                            return {
                                result: $786a5f856536c5d4$var$applyOptimisticOps(res.result, req, tblCache === null || tblCache === void 0 ? void 0 : tblCache.optimisticOps, downTable, cacheEntry, freezeResults)
                            };
                        });
                    }
                });
                return tableMW;
            }
        });
        return coreMW;
    }
};
function $786a5f856536c5d4$var$vipify(target, vipDb) {
    return new Proxy(target, {
        get: function(target, prop, receiver) {
            if (prop === 'db') return vipDb;
            return Reflect.get(target, prop, receiver);
        }
    });
}
var $786a5f856536c5d4$export$4ece27d405df7279 = function() {
    function Dexie(name, options) {
        var _this = this;
        this._middlewares = {};
        this.verno = 0;
        var deps = Dexie.dependencies;
        this._options = options = $786a5f856536c5d4$var$__assign({
            addons: Dexie.addons,
            autoOpen: true,
            indexedDB: deps.indexedDB,
            IDBKeyRange: deps.IDBKeyRange,
            cache: 'cloned'
        }, options);
        this._deps = {
            indexedDB: options.indexedDB,
            IDBKeyRange: options.IDBKeyRange
        };
        var addons = options.addons;
        this._dbSchema = {};
        this._versions = [];
        this._storeNames = [];
        this._allTables = {};
        this.idbdb = null;
        this._novip = this;
        var state = {
            dbOpenError: null,
            isBeingOpened: false,
            onReadyBeingFired: null,
            openComplete: false,
            dbReadyResolve: $786a5f856536c5d4$var$nop,
            dbReadyPromise: null,
            cancelOpen: $786a5f856536c5d4$var$nop,
            openCanceller: null,
            autoSchema: true,
            PR1398_maxLoop: 3,
            autoOpen: options.autoOpen
        };
        state.dbReadyPromise = new $786a5f856536c5d4$var$DexiePromise(function(resolve) {
            state.dbReadyResolve = resolve;
        });
        state.openCanceller = new $786a5f856536c5d4$var$DexiePromise(function(_, reject) {
            state.cancelOpen = reject;
        });
        this._state = state;
        this.name = name;
        this.on = $786a5f856536c5d4$var$Events(this, "populate", "blocked", "versionchange", "close", {
            ready: [
                $786a5f856536c5d4$var$promisableChain,
                $786a5f856536c5d4$var$nop
            ]
        });
        this.once = function(event, callback) {
            var fn = function() {
                var args = [];
                for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
                _this.on(event).unsubscribe(fn);
                callback.apply(_this, args);
            };
            return _this.on(event, fn);
        };
        this.on.ready.subscribe = $786a5f856536c5d4$var$override(this.on.ready.subscribe, function(subscribe) {
            return function(subscriber, bSticky) {
                Dexie.vip(function() {
                    var state = _this._state;
                    if (state.openComplete) {
                        if (!state.dbOpenError) $786a5f856536c5d4$var$DexiePromise.resolve().then(subscriber);
                        if (bSticky) subscribe(subscriber);
                    } else if (state.onReadyBeingFired) {
                        state.onReadyBeingFired.push(subscriber);
                        if (bSticky) subscribe(subscriber);
                    } else {
                        subscribe(subscriber);
                        var db_1 = _this;
                        if (!bSticky) subscribe(function unsubscribe() {
                            db_1.on.ready.unsubscribe(subscriber);
                            db_1.on.ready.unsubscribe(unsubscribe);
                        });
                    }
                });
            };
        });
        this.Collection = $786a5f856536c5d4$var$createCollectionConstructor(this);
        this.Table = $786a5f856536c5d4$var$createTableConstructor(this);
        this.Transaction = $786a5f856536c5d4$var$createTransactionConstructor(this);
        this.Version = $786a5f856536c5d4$var$createVersionConstructor(this);
        this.WhereClause = $786a5f856536c5d4$var$createWhereClauseConstructor(this);
        this.on("versionchange", function(ev) {
            if (ev.newVersion > 0) console.warn("Another connection wants to upgrade database '".concat(_this.name, "'. Closing db now to resume the upgrade."));
            else console.warn("Another connection wants to delete database '".concat(_this.name, "'. Closing db now to resume the delete request."));
            _this.close({
                disableAutoOpen: false
            });
        });
        this.on("blocked", function(ev) {
            if (!ev.newVersion || ev.newVersion < ev.oldVersion) console.warn("Dexie.delete('".concat(_this.name, "') was blocked"));
            else console.warn("Upgrade '".concat(_this.name, "' blocked by other connection holding version ").concat(ev.oldVersion / 10));
        });
        this._maxKey = $786a5f856536c5d4$var$getMaxKey(options.IDBKeyRange);
        this._createTransaction = function(mode, storeNames, dbschema, parentTransaction) {
            return new _this.Transaction(mode, storeNames, dbschema, _this._options.chromeTransactionDurability, parentTransaction);
        };
        this._fireOnBlocked = function(ev) {
            _this.on("blocked").fire(ev);
            $786a5f856536c5d4$var$connections.filter(function(c) {
                return c.name === _this.name && c !== _this && !c._state.vcFired;
            }).map(function(c) {
                return c.on("versionchange").fire(ev);
            });
        };
        this.use($786a5f856536c5d4$var$cacheExistingValuesMiddleware);
        this.use($786a5f856536c5d4$var$cacheMiddleware);
        this.use($786a5f856536c5d4$var$observabilityMiddleware);
        this.use($786a5f856536c5d4$var$virtualIndexMiddleware);
        this.use($786a5f856536c5d4$var$hooksMiddleware);
        var vipDB = new Proxy(this, {
            get: function(_, prop, receiver) {
                if (prop === '_vip') return true;
                if (prop === 'table') return function(tableName) {
                    return $786a5f856536c5d4$var$vipify(_this.table(tableName), vipDB);
                };
                var rv = Reflect.get(_, prop, receiver);
                if (rv instanceof $786a5f856536c5d4$var$Table) return $786a5f856536c5d4$var$vipify(rv, vipDB);
                if (prop === 'tables') return rv.map(function(t) {
                    return $786a5f856536c5d4$var$vipify(t, vipDB);
                });
                if (prop === '_createTransaction') return function() {
                    var tx = rv.apply(this, arguments);
                    return $786a5f856536c5d4$var$vipify(tx, vipDB);
                };
                return rv;
            }
        });
        this.vip = vipDB;
        addons.forEach(function(addon) {
            return addon(_this);
        });
    }
    Dexie.prototype.version = function(versionNumber) {
        if (isNaN(versionNumber) || versionNumber < 0.1) throw new $786a5f856536c5d4$var$exceptions.Type("Given version is not a positive number");
        versionNumber = Math.round(versionNumber * 10) / 10;
        if (this.idbdb || this._state.isBeingOpened) throw new $786a5f856536c5d4$var$exceptions.Schema("Cannot add version when database is open");
        this.verno = Math.max(this.verno, versionNumber);
        var versions = this._versions;
        var versionInstance = versions.filter(function(v) {
            return v._cfg.version === versionNumber;
        })[0];
        if (versionInstance) return versionInstance;
        versionInstance = new this.Version(versionNumber);
        versions.push(versionInstance);
        versions.sort($786a5f856536c5d4$var$lowerVersionFirst);
        versionInstance.stores({});
        this._state.autoSchema = false;
        return versionInstance;
    };
    Dexie.prototype._whenReady = function(fn) {
        var _this = this;
        return this.idbdb && (this._state.openComplete || $786a5f856536c5d4$var$PSD.letThrough || this._vip) ? fn() : new $786a5f856536c5d4$var$DexiePromise(function(resolve, reject) {
            if (_this._state.openComplete) return reject(new $786a5f856536c5d4$var$exceptions.DatabaseClosed(_this._state.dbOpenError));
            if (!_this._state.isBeingOpened) {
                if (!_this._state.autoOpen) {
                    reject(new $786a5f856536c5d4$var$exceptions.DatabaseClosed());
                    return;
                }
                _this.open().catch($786a5f856536c5d4$var$nop);
            }
            _this._state.dbReadyPromise.then(resolve, reject);
        }).then(fn);
    };
    Dexie.prototype.use = function(_a) {
        var stack = _a.stack, create = _a.create, level = _a.level, name = _a.name;
        if (name) this.unuse({
            stack: stack,
            name: name
        });
        var middlewares = this._middlewares[stack] || (this._middlewares[stack] = []);
        middlewares.push({
            stack: stack,
            create: create,
            level: level == null ? 10 : level,
            name: name
        });
        middlewares.sort(function(a, b) {
            return a.level - b.level;
        });
        return this;
    };
    Dexie.prototype.unuse = function(_a) {
        var stack = _a.stack, name = _a.name, create = _a.create;
        if (stack && this._middlewares[stack]) this._middlewares[stack] = this._middlewares[stack].filter(function(mw) {
            return create ? mw.create !== create : name ? mw.name !== name : false;
        });
        return this;
    };
    Dexie.prototype.open = function() {
        var _this = this;
        return $786a5f856536c5d4$var$usePSD($786a5f856536c5d4$var$globalPSD, function() {
            return $786a5f856536c5d4$var$dexieOpen(_this);
        });
    };
    Dexie.prototype._close = function() {
        this.on.close.fire(new CustomEvent('close'));
        var state = this._state;
        var idx = $786a5f856536c5d4$var$connections.indexOf(this);
        if (idx >= 0) $786a5f856536c5d4$var$connections.splice(idx, 1);
        if (this.idbdb) {
            try {
                this.idbdb.close();
            } catch (e) {}
            this.idbdb = null;
        }
        if (!state.isBeingOpened) {
            state.dbReadyPromise = new $786a5f856536c5d4$var$DexiePromise(function(resolve) {
                state.dbReadyResolve = resolve;
            });
            state.openCanceller = new $786a5f856536c5d4$var$DexiePromise(function(_, reject) {
                state.cancelOpen = reject;
            });
        }
    };
    Dexie.prototype.close = function(_a) {
        var _b = _a === void 0 ? {
            disableAutoOpen: true
        } : _a, disableAutoOpen = _b.disableAutoOpen;
        var state = this._state;
        if (disableAutoOpen) {
            if (state.isBeingOpened) state.cancelOpen(new $786a5f856536c5d4$var$exceptions.DatabaseClosed());
            this._close();
            state.autoOpen = false;
            state.dbOpenError = new $786a5f856536c5d4$var$exceptions.DatabaseClosed();
        } else {
            this._close();
            state.autoOpen = this._options.autoOpen || state.isBeingOpened;
            state.openComplete = false;
            state.dbOpenError = null;
        }
    };
    Dexie.prototype.delete = function(closeOptions) {
        var _this = this;
        if (closeOptions === void 0) closeOptions = {
            disableAutoOpen: true
        };
        var hasInvalidArguments = arguments.length > 0 && typeof arguments[0] !== 'object';
        var state = this._state;
        return new $786a5f856536c5d4$var$DexiePromise(function(resolve, reject) {
            var doDelete = function() {
                _this.close(closeOptions);
                var req = _this._deps.indexedDB.deleteDatabase(_this.name);
                req.onsuccess = $786a5f856536c5d4$var$wrap(function() {
                    $786a5f856536c5d4$var$_onDatabaseDeleted(_this._deps, _this.name);
                    resolve();
                });
                req.onerror = $786a5f856536c5d4$var$eventRejectHandler(reject);
                req.onblocked = _this._fireOnBlocked;
            };
            if (hasInvalidArguments) throw new $786a5f856536c5d4$var$exceptions.InvalidArgument("Invalid closeOptions argument to db.delete()");
            if (state.isBeingOpened) state.dbReadyPromise.then(doDelete);
            else doDelete();
        });
    };
    Dexie.prototype.backendDB = function() {
        return this.idbdb;
    };
    Dexie.prototype.isOpen = function() {
        return this.idbdb !== null;
    };
    Dexie.prototype.hasBeenClosed = function() {
        var dbOpenError = this._state.dbOpenError;
        return dbOpenError && dbOpenError.name === 'DatabaseClosed';
    };
    Dexie.prototype.hasFailed = function() {
        return this._state.dbOpenError !== null;
    };
    Dexie.prototype.dynamicallyOpened = function() {
        return this._state.autoSchema;
    };
    Object.defineProperty(Dexie.prototype, "tables", {
        get: function() {
            var _this = this;
            return $786a5f856536c5d4$var$keys(this._allTables).map(function(name) {
                return _this._allTables[name];
            });
        },
        enumerable: false,
        configurable: true
    });
    Dexie.prototype.transaction = function() {
        var args = $786a5f856536c5d4$var$extractTransactionArgs.apply(this, arguments);
        return this._transaction.apply(this, args);
    };
    Dexie.prototype._transaction = function(mode, tables, scopeFunc) {
        var _this = this;
        var parentTransaction = $786a5f856536c5d4$var$PSD.trans;
        if (!parentTransaction || parentTransaction.db !== this || mode.indexOf('!') !== -1) parentTransaction = null;
        var onlyIfCompatible = mode.indexOf('?') !== -1;
        mode = mode.replace('!', '').replace('?', '');
        var idbMode, storeNames;
        try {
            storeNames = tables.map(function(table) {
                var storeName = table instanceof _this.Table ? table.name : table;
                if (typeof storeName !== 'string') throw new TypeError("Invalid table argument to Dexie.transaction(). Only Table or String are allowed");
                return storeName;
            });
            if (mode == "r" || mode === $786a5f856536c5d4$var$READONLY) idbMode = $786a5f856536c5d4$var$READONLY;
            else if (mode == "rw" || mode == $786a5f856536c5d4$var$READWRITE) idbMode = $786a5f856536c5d4$var$READWRITE;
            else throw new $786a5f856536c5d4$var$exceptions.InvalidArgument("Invalid transaction mode: " + mode);
            if (parentTransaction) {
                if (parentTransaction.mode === $786a5f856536c5d4$var$READONLY && idbMode === $786a5f856536c5d4$var$READWRITE) {
                    if (onlyIfCompatible) parentTransaction = null;
                    else throw new $786a5f856536c5d4$var$exceptions.SubTransaction("Cannot enter a sub-transaction with READWRITE mode when parent transaction is READONLY");
                }
                if (parentTransaction) storeNames.forEach(function(storeName) {
                    if (parentTransaction && parentTransaction.storeNames.indexOf(storeName) === -1) {
                        if (onlyIfCompatible) parentTransaction = null;
                        else throw new $786a5f856536c5d4$var$exceptions.SubTransaction("Table " + storeName + " not included in parent transaction.");
                    }
                });
                if (onlyIfCompatible && parentTransaction && !parentTransaction.active) parentTransaction = null;
            }
        } catch (e) {
            return parentTransaction ? parentTransaction._promise(null, function(_, reject) {
                reject(e);
            }) : $786a5f856536c5d4$var$rejection(e);
        }
        var enterTransaction = $786a5f856536c5d4$var$enterTransactionScope.bind(null, this, idbMode, storeNames, parentTransaction, scopeFunc);
        return parentTransaction ? parentTransaction._promise(idbMode, enterTransaction, "lock") : $786a5f856536c5d4$var$PSD.trans ? $786a5f856536c5d4$var$usePSD($786a5f856536c5d4$var$PSD.transless, function() {
            return _this._whenReady(enterTransaction);
        }) : this._whenReady(enterTransaction);
    };
    Dexie.prototype.table = function(tableName) {
        if (!$786a5f856536c5d4$var$hasOwn(this._allTables, tableName)) throw new $786a5f856536c5d4$var$exceptions.InvalidTable("Table ".concat(tableName, " does not exist"));
        return this._allTables[tableName];
    };
    return Dexie;
}();
var $786a5f856536c5d4$var$symbolObservable = typeof Symbol !== "undefined" && "observable" in Symbol ? Symbol.observable : "@@observable";
var $786a5f856536c5d4$var$Observable = function() {
    function Observable(subscribe) {
        this._subscribe = subscribe;
    }
    Observable.prototype.subscribe = function(x, error, complete) {
        return this._subscribe(!x || typeof x === "function" ? {
            next: x,
            error: error,
            complete: complete
        } : x);
    };
    Observable.prototype[$786a5f856536c5d4$var$symbolObservable] = function() {
        return this;
    };
    return Observable;
}();
var $786a5f856536c5d4$var$domDeps;
try {
    $786a5f856536c5d4$var$domDeps = {
        indexedDB: $786a5f856536c5d4$var$_global.indexedDB || $786a5f856536c5d4$var$_global.mozIndexedDB || $786a5f856536c5d4$var$_global.webkitIndexedDB || $786a5f856536c5d4$var$_global.msIndexedDB,
        IDBKeyRange: $786a5f856536c5d4$var$_global.IDBKeyRange || $786a5f856536c5d4$var$_global.webkitIDBKeyRange
    };
} catch (e) {
    $786a5f856536c5d4$var$domDeps = {
        indexedDB: null,
        IDBKeyRange: null
    };
}
function $786a5f856536c5d4$export$6a9705d8f6f38796(querier) {
    var hasValue = false;
    var currentValue;
    var observable = new $786a5f856536c5d4$var$Observable(function(observer) {
        var scopeFuncIsAsync = $786a5f856536c5d4$var$isAsyncFunction(querier);
        function execute(ctx) {
            var wasRootExec = $786a5f856536c5d4$var$beginMicroTickScope();
            try {
                if (scopeFuncIsAsync) $786a5f856536c5d4$var$incrementExpectedAwaits();
                var rv = $786a5f856536c5d4$var$newScope(querier, ctx);
                if (scopeFuncIsAsync) rv = rv.finally($786a5f856536c5d4$var$decrementExpectedAwaits);
                return rv;
            } finally{
                wasRootExec && $786a5f856536c5d4$var$endMicroTickScope();
            }
        }
        var closed = false;
        var abortController;
        var accumMuts = {};
        var currentObs = {};
        var subscription = {
            get closed () {
                return closed;
            },
            unsubscribe: function() {
                if (closed) return;
                closed = true;
                if (abortController) abortController.abort();
                if (startedListening) $786a5f856536c5d4$var$globalEvents.storagemutated.unsubscribe(mutationListener);
            }
        };
        observer.start && observer.start(subscription);
        var startedListening = false;
        var doQuery = function() {
            return $786a5f856536c5d4$var$execInGlobalContext(_doQuery);
        };
        function shouldNotify() {
            return $786a5f856536c5d4$var$obsSetsOverlap(currentObs, accumMuts);
        }
        var mutationListener = function(parts) {
            $786a5f856536c5d4$var$extendObservabilitySet(accumMuts, parts);
            if (shouldNotify()) doQuery();
        };
        var _doQuery = function() {
            if (closed || !$786a5f856536c5d4$var$domDeps.indexedDB) return;
            accumMuts = {};
            var subscr = {};
            if (abortController) abortController.abort();
            abortController = new AbortController();
            var ctx = {
                subscr: subscr,
                signal: abortController.signal,
                requery: doQuery,
                querier: querier,
                trans: null
            };
            var ret = execute(ctx);
            Promise.resolve(ret).then(function(result) {
                hasValue = true;
                currentValue = result;
                if (closed || ctx.signal.aborted) return;
                accumMuts = {};
                currentObs = subscr;
                if (!$786a5f856536c5d4$var$objectIsEmpty(currentObs) && !startedListening) {
                    $786a5f856536c5d4$var$globalEvents($786a5f856536c5d4$var$DEXIE_STORAGE_MUTATED_EVENT_NAME, mutationListener);
                    startedListening = true;
                }
                $786a5f856536c5d4$var$execInGlobalContext(function() {
                    return !closed && observer.next && observer.next(result);
                });
            }, function(err) {
                hasValue = false;
                if (![
                    'DatabaseClosedError',
                    'AbortError'
                ].includes(err === null || err === void 0 ? void 0 : err.name)) {
                    if (!closed) $786a5f856536c5d4$var$execInGlobalContext(function() {
                        if (closed) return;
                        observer.error && observer.error(err);
                    });
                }
            });
        };
        setTimeout(doQuery, 0);
        return subscription;
    });
    observable.hasValue = function() {
        return hasValue;
    };
    observable.getValue = function() {
        return currentValue;
    };
    return observable;
}
var $786a5f856536c5d4$var$Dexie = $786a5f856536c5d4$export$4ece27d405df7279;
$786a5f856536c5d4$var$props($786a5f856536c5d4$var$Dexie, $786a5f856536c5d4$var$__assign($786a5f856536c5d4$var$__assign({}, $786a5f856536c5d4$var$fullNameExceptions), {
    delete: function(databaseName) {
        var db = new $786a5f856536c5d4$var$Dexie(databaseName, {
            addons: []
        });
        return db.delete();
    },
    exists: function(name) {
        return new $786a5f856536c5d4$var$Dexie(name, {
            addons: []
        }).open().then(function(db) {
            db.close();
            return true;
        }).catch('NoSuchDatabaseError', function() {
            return false;
        });
    },
    getDatabaseNames: function(cb) {
        try {
            return $786a5f856536c5d4$var$getDatabaseNames($786a5f856536c5d4$var$Dexie.dependencies).then(cb);
        } catch (_a) {
            return $786a5f856536c5d4$var$rejection(new $786a5f856536c5d4$var$exceptions.MissingAPI());
        }
    },
    defineClass: function() {
        function Class(content) {
            $786a5f856536c5d4$var$extend(this, content);
        }
        return Class;
    },
    ignoreTransaction: function(scopeFunc) {
        return $786a5f856536c5d4$var$PSD.trans ? $786a5f856536c5d4$var$usePSD($786a5f856536c5d4$var$PSD.transless, scopeFunc) : scopeFunc();
    },
    vip: $786a5f856536c5d4$var$vip,
    async: function(generatorFn) {
        return function() {
            try {
                var rv = $786a5f856536c5d4$var$awaitIterator(generatorFn.apply(this, arguments));
                if (!rv || typeof rv.then !== 'function') return $786a5f856536c5d4$var$DexiePromise.resolve(rv);
                return rv;
            } catch (e) {
                return $786a5f856536c5d4$var$rejection(e);
            }
        };
    },
    spawn: function(generatorFn, args, thiz) {
        try {
            var rv = $786a5f856536c5d4$var$awaitIterator(generatorFn.apply(thiz, args || []));
            if (!rv || typeof rv.then !== 'function') return $786a5f856536c5d4$var$DexiePromise.resolve(rv);
            return rv;
        } catch (e) {
            return $786a5f856536c5d4$var$rejection(e);
        }
    },
    currentTransaction: {
        get: function() {
            return $786a5f856536c5d4$var$PSD.trans || null;
        }
    },
    waitFor: function(promiseOrFunction, optionalTimeout) {
        var promise = $786a5f856536c5d4$var$DexiePromise.resolve(typeof promiseOrFunction === 'function' ? $786a5f856536c5d4$var$Dexie.ignoreTransaction(promiseOrFunction) : promiseOrFunction).timeout(optionalTimeout || 60000);
        return $786a5f856536c5d4$var$PSD.trans ? $786a5f856536c5d4$var$PSD.trans.waitFor(promise) : promise;
    },
    Promise: $786a5f856536c5d4$var$DexiePromise,
    debug: {
        get: function() {
            return $786a5f856536c5d4$var$debug;
        },
        set: function(value) {
            $786a5f856536c5d4$var$setDebug(value);
        }
    },
    derive: $786a5f856536c5d4$var$derive,
    extend: $786a5f856536c5d4$var$extend,
    props: $786a5f856536c5d4$var$props,
    override: $786a5f856536c5d4$var$override,
    Events: $786a5f856536c5d4$var$Events,
    on: $786a5f856536c5d4$var$globalEvents,
    liveQuery: $786a5f856536c5d4$export$6a9705d8f6f38796,
    extendObservabilitySet: $786a5f856536c5d4$var$extendObservabilitySet,
    getByKeyPath: $786a5f856536c5d4$var$getByKeyPath,
    setByKeyPath: $786a5f856536c5d4$var$setByKeyPath,
    delByKeyPath: $786a5f856536c5d4$var$delByKeyPath,
    shallowClone: $786a5f856536c5d4$var$shallowClone,
    deepClone: $786a5f856536c5d4$var$deepClone,
    getObjectDiff: $786a5f856536c5d4$var$getObjectDiff,
    cmp: $786a5f856536c5d4$export$6154dcdb7d23e37b,
    asap: $786a5f856536c5d4$var$asap$1,
    minKey: $786a5f856536c5d4$var$minKey,
    addons: [],
    connections: $786a5f856536c5d4$var$connections,
    errnames: $786a5f856536c5d4$var$errnames,
    dependencies: $786a5f856536c5d4$var$domDeps,
    cache: $786a5f856536c5d4$var$cache,
    semVer: $786a5f856536c5d4$var$DEXIE_VERSION,
    version: $786a5f856536c5d4$var$DEXIE_VERSION.split('.').map(function(n) {
        return parseInt(n);
    }).reduce(function(p, c, i) {
        return p + c / Math.pow(10, i * 2);
    })
}));
$786a5f856536c5d4$var$Dexie.maxKey = $786a5f856536c5d4$var$getMaxKey($786a5f856536c5d4$var$Dexie.dependencies.IDBKeyRange);
if (typeof dispatchEvent !== 'undefined' && typeof addEventListener !== 'undefined') {
    $786a5f856536c5d4$var$globalEvents($786a5f856536c5d4$var$DEXIE_STORAGE_MUTATED_EVENT_NAME, function(updatedParts) {
        if (!$786a5f856536c5d4$var$propagatingLocally) {
            var event_1;
            event_1 = new CustomEvent($786a5f856536c5d4$var$STORAGE_MUTATED_DOM_EVENT_NAME, {
                detail: updatedParts
            });
            $786a5f856536c5d4$var$propagatingLocally = true;
            dispatchEvent(event_1);
            $786a5f856536c5d4$var$propagatingLocally = false;
        }
    });
    addEventListener($786a5f856536c5d4$var$STORAGE_MUTATED_DOM_EVENT_NAME, function(_a) {
        var detail = _a.detail;
        if (!$786a5f856536c5d4$var$propagatingLocally) $786a5f856536c5d4$var$propagateLocally(detail);
    });
}
function $786a5f856536c5d4$var$propagateLocally(updateParts) {
    var wasMe = $786a5f856536c5d4$var$propagatingLocally;
    try {
        $786a5f856536c5d4$var$propagatingLocally = true;
        $786a5f856536c5d4$var$globalEvents.storagemutated.fire(updateParts);
        $786a5f856536c5d4$var$signalSubscribersNow(updateParts, true);
    } finally{
        $786a5f856536c5d4$var$propagatingLocally = wasMe;
    }
}
var $786a5f856536c5d4$var$propagatingLocally = false;
var $786a5f856536c5d4$var$bc;
var $786a5f856536c5d4$var$createBC = function() {};
if (typeof BroadcastChannel !== 'undefined') {
    $786a5f856536c5d4$var$createBC = function() {
        $786a5f856536c5d4$var$bc = new BroadcastChannel($786a5f856536c5d4$var$STORAGE_MUTATED_DOM_EVENT_NAME);
        $786a5f856536c5d4$var$bc.onmessage = function(ev) {
            return ev.data && $786a5f856536c5d4$var$propagateLocally(ev.data);
        };
    };
    $786a5f856536c5d4$var$createBC();
    if (typeof $786a5f856536c5d4$var$bc.unref === 'function') $786a5f856536c5d4$var$bc.unref();
    $786a5f856536c5d4$var$globalEvents($786a5f856536c5d4$var$DEXIE_STORAGE_MUTATED_EVENT_NAME, function(changedParts) {
        if (!$786a5f856536c5d4$var$propagatingLocally) $786a5f856536c5d4$var$bc.postMessage(changedParts);
    });
}
if (typeof addEventListener !== 'undefined') {
    addEventListener('pagehide', function(event) {
        if (!$786a5f856536c5d4$export$4ece27d405df7279.disableBfCache && event.persisted) {
            if ($786a5f856536c5d4$var$debug) console.debug('Dexie: handling persisted pagehide');
            $786a5f856536c5d4$var$bc === null || $786a5f856536c5d4$var$bc === void 0 || $786a5f856536c5d4$var$bc.close();
            for(var _i = 0, connections_1 = $786a5f856536c5d4$var$connections; _i < connections_1.length; _i++){
                var db = connections_1[_i];
                db.close({
                    disableAutoOpen: false
                });
            }
        }
    });
    addEventListener('pageshow', function(event) {
        if (!$786a5f856536c5d4$export$4ece27d405df7279.disableBfCache && event.persisted) {
            if ($786a5f856536c5d4$var$debug) console.debug('Dexie: handling persisted pageshow');
            $786a5f856536c5d4$var$createBC();
            $786a5f856536c5d4$var$propagateLocally({
                all: new $786a5f856536c5d4$export$34cb5241245008dd(-Infinity, [
                    []
                ])
            });
        }
    });
}
function $786a5f856536c5d4$export$e16d8520af44a096(value) {
    return new $786a5f856536c5d4$export$4118fdb20badc28d({
        add: value
    });
}
function $786a5f856536c5d4$export$cd7f480d6b8286c3(value) {
    return new $786a5f856536c5d4$export$4118fdb20badc28d({
        remove: value
    });
}
function $786a5f856536c5d4$export$22ef8700548ec20(a, b) {
    return new $786a5f856536c5d4$export$4118fdb20badc28d({
        replacePrefix: [
            a,
            b
        ]
    });
}
$786a5f856536c5d4$var$DexiePromise.rejectionMapper = $786a5f856536c5d4$var$mapError;
$786a5f856536c5d4$var$setDebug($786a5f856536c5d4$var$debug);


console.log("Starting app...");
const $b7ac0cf7b7632c81$var$db = new (0, $786a5f856536c5d4$export$4ece27d405df7279)('readcode-db');
const $b7ac0cf7b7632c81$var$VERSION = 2;
const $b7ac0cf7b7632c81$var$CONTENT_VERSION = '2025-10-18-rc-snomed-refresh'; // change whenever data files change
let $b7ac0cf7b7632c81$var$app = (0, $cd2a3739fedbc9f0$exports.Elm).Main.init({
    node: document.getElementById('root')
});
$b7ac0cf7b7632c81$var$db.version($b7ac0cf7b7632c81$var$VERSION).stores({
    meta: '&key',
    readcode: '++id, Readcode, Description',
    snomed: '++id, ConceptSCTID, PreferredTerm, ReadCode, ReadTerm'
}).upgrade(async (tx)=>{
    // Optional: if you want a clean slate on first run of v2
    await tx.table('readcode').clear();
    await tx.table('snomed').clear();
    await tx.table('meta').put({
        key: 'contentVersion',
        value: 'initial'
    });
});
function $b7ac0cf7b7632c81$var$parseCsv(url) {
    return new Promise((resolve, reject)=>{
        (0, (/*@__PURE__*/$parcel$interopDefault($b88ce8cf286a26cd$exports))).parse(url + `?v=${encodeURIComponent($b7ac0cf7b7632c81$var$CONTENT_VERSION)}`, {
            header: true,
            skipEmptyLines: true,
            download: true,
            complete: (results)=>{
                const rows = results.data;
                console.log(`Parsed ${rows.length} rows from ${url}`);
                resolve(rows);
            },
            error: reject
        });
    });
}
async function $b7ac0cf7b7632c81$var$ensureContentUpToDate() {
    await $b7ac0cf7b7632c81$var$db.open();
    const current = (await $b7ac0cf7b7632c81$var$db.table('meta').get('contentVersion'))?.value;
    if (current === $b7ac0cf7b7632c81$var$CONTENT_VERSION) {
        console.log('Content up-to-date.');
        $b7ac0cf7b7632c81$var$app.ports.receive_db_ready.send(true);
        return;
    }
    console.log("Updating content\u2026");
    // Load CSVs and upsert (bulkPut) atomically
    const [readcodeRows, snomedRows] = await Promise.all([
        $b7ac0cf7b7632c81$var$parseCsv('/readcode.csv'),
        $b7ac0cf7b7632c81$var$parseCsv('/snomed.csv')
    ]);
    await $b7ac0cf7b7632c81$var$db.transaction('rw', $b7ac0cf7b7632c81$var$db.readcode, $b7ac0cf7b7632c81$var$db.snomed, $b7ac0cf7b7632c81$var$db.meta, async ()=>{
        // Upsert based on stable keys
        await $b7ac0cf7b7632c81$var$db.readcode.clear(); // if you prefer full replace
        await $b7ac0cf7b7632c81$var$db.snomed.clear(); // (or skip clears to truly upsert)
        console.log("Cleared existing data");
        // bulkPut is idempotent if keys are stable
        await $b7ac0cf7b7632c81$var$db.readcode.bulkPut(readcodeRows);
        await $b7ac0cf7b7632c81$var$db.snomed.bulkPut(snomedRows);
        console.log("Inserted new data");
        await $b7ac0cf7b7632c81$var$db.meta.put({
            key: 'contentVersion',
            value: $b7ac0cf7b7632c81$var$CONTENT_VERSION
        });
        console.log("Updated content version metadata");
    }).then(()=>{
        console.log("Transaction committed");
        $b7ac0cf7b7632c81$var$app.ports.receive_db_ready.send(true);
    }).catch((err)=>{
        console.error(err.stack);
    });
}
$b7ac0cf7b7632c81$var$ensureContentUpToDate().catch((e)=>{
    console.error('Failed to update content', e);
    $b7ac0cf7b7632c81$var$app.ports.receive_db_ready.send(true); // fail-open so the app still starts
});
async function $b7ac0cf7b7632c81$var$initReadcodeDb() {
    await $b7ac0cf7b7632c81$var$ensureContentUpToDate();
}
$b7ac0cf7b7632c81$var$app.ports.send_readcode_query.subscribe(function(query) {
    $b7ac0cf7b7632c81$var$db.readcode.filter((readcode)=>{
        // filter by Readcode or Description, case insensitive
        // return true if each space-separated word in query is found in Description
        query = query.toLowerCase();
        let queryWords = query.split(" ");
        let description = readcode.Description.toLowerCase();
        return queryWords.every((word)=>description.includes(word));
    }).toArray().then(function(results) {
        $b7ac0cf7b7632c81$var$app.ports.receive_readcode.send(results);
    });
});
$b7ac0cf7b7632c81$var$app.ports.send_snomed_query.subscribe(function(query) {
    $b7ac0cf7b7632c81$var$db.snomed.filter((snomed)=>{
        // filter by preferred term or read term, case insensitive
        // strip whitespace and convert to lowercase
        // return true if each space-separated word in query is found in either preferred term or read term
        query = query.toLowerCase();
        let queryWords = query.split(" ");
        let preferredTerm = snomed.PreferredTerm.toLowerCase();
        let readTerm = snomed.ReadTerm.toLowerCase();
        return queryWords.every((word)=>preferredTerm.includes(word) || readTerm.includes(word));
    }).toArray().then(function(results) {
        $b7ac0cf7b7632c81$var$app.ports.receive_snomed.send(results);
    });
});
$b7ac0cf7b7632c81$var$app.ports.init_tooltips.subscribe(function() {
    $('[data-toggle="tooltip"]').tooltip();
    console.log("Tooltips initialized");
});


//# sourceMappingURL=public.78935db6.js.map
